import { mapGetters } from 'vuex';

export const translationMixin = {
  computed: {
    ...mapGetters('language', ['getCurrentLanguage', 'isHebrew', 'isEnglish']),
    
    // Main translation function
    t() {
      return (key, params = {}) => {
        const translations = {
          he: {
            // SingleRideWithMap translations
            mapViewForDay: `תצוגת מפה ליום ${params.day || ''}`,
            wantToEditTrip: 'רוצים לערוך את הטיול הזה?',
            copyAndEdit: 'העתיקו וערכו',
            loadingData: 'טוען נתונים...',
            loadingUploadingImages: 'מעלה תמונות',
            loadingOf: 'מתוך',
            tripPlan: 'תוכנית הטיול',
            tripMapForDay: `מפת הטיול ליום ${params.day || ''}`,
            copyrightNotice: 'המסלול מוצג לשימוש אישי בלבד. אין לשתף, לשכפל או להעתיק את תוכנו ללא אישור ממספק התוכן.',
            aiChatTitle: 'עוזר AI',
            aiChatProfileTravelers: 'הרכב המטיילים',
            aiChatProfilePace: 'קצב',
            aiChatProfileInterests: 'תחומי עניין',
            aiChatProfileAvoid: 'ממה להימנע',
            aiChatProfileBudget: 'תקציב',
            aiChatProfileConstraints: 'מגבלות',
            aiChatProfileStripPrefix: 'ה-AI יודע:',
            aiChatProfileStripEmpty: 'ספרו ל-AI על המטיילים',
            aiChatProfileDrawerTitle: 'פרופיל הטיול',
            aiChatProfileSave: 'שמור',
            aiChatProfileCancel: 'ביטול',
            aiChatProfileKeepMine: 'להשאיר את שלי',
            aiChatProfileUseAi: 'לאמץ את הצעת ה-AI',
            aiChatProfileSaveFailed: 'השמירה נכשלה, נסו שוב',
            aiChatProfileSetByYou: 'נקבע על ידך',
            aiChatProfileAiProposes: 'ה-AI מציע',
            rideInformationProfileSection: 'פרופיל הטיול',
            rideInformationProfileHint: 'מה שידוע על המטיילים — גילאים, קצב, העדפות ומגבלות. ה-AI מוסיף לכאן פרטים מהשיחה ומתחשב בהם כשהוא בונה את המסלול. אפשר לשנות כל שדה, ומה שתכתבו כאן נשאר.',
            rideInformationProfileShow: 'הצגת הפרטים',
            rideInformationProfileHide: 'הסתרת הפרטים',
            aiChatPlaceholder: 'שאלו כל דבר או הדביקו הזמנה…',
            aiChatSend: 'שלח',
            aiChatDay: 'יום',
            aiChatAdd: 'הוסף',
            aiChatAdded: 'נוסף',
            aiChatOpenButton: 'עוזר AI',
            aiChatAttachFiles: 'צירוף קבצי הזמנה',
            aiChatDropZoneTitle: 'גררו לכאן את ההזמנות שלכם',
            aiChatDropZoneHint: 'אישורי מלון, טיסה, השכרת רכב או כרטיסים. אשבץ אותם בימים הנכונים.',
            aiChatDropOverlay: 'שחררו כדי לקרוא את ההזמנות',
            aiChatFilesRejected: 'רק JPG, PNG או PDF, עד 5 מסמכים בכל פעם.',
            aiChatMove: 'הזז',
            aiChatMoved: 'הוזז',
            aiChatApplyingAll: 'מחיל...',
            aiChatResolvingPlaces: 'מאתר מקומות...',
            aiChatRemoveAll: 'הסר הכול',
            aiChatConfirmRemoveAllTitle: 'להסיר את כל הפעילויות האלה?',
            aiChatConfirmRemoveAllNote: 'לא ניתן לבטל את ההסרה.',
            aiChatRemoveAccommodation: 'הסר לינה',
            aiChatRemoveAccommodationWarning: 'הסרה תמחק גם את אישור ההזמנה והשוברים.',
            aiChatConfirmRemoveAccommodationTitle: 'להסיר את הלינה מהטיול?',
            aiChatConfirmRemoveAccommodationNote: 'אישור ההזמנה והשוברים יימחקו ולא ניתן לשחזר אותם.',
            aiChatRideDatesTitle: 'תאריכי הטיול',
            aiChatRideNewStart: 'התחלה חדשה',
            aiChatRideDatesShiftNote: 'כל הטיול יוזז במספר הימים הזה ואורך הטיול יישאר זהה.',
            aiChatRideDatesUpdate: 'עדכן תאריכים',
            aiChatRideDatesUpdated: 'עודכן',
            aiChatAddDayTitle: 'הוספת יום',
            aiChatRemoveDayTitle: 'הסרת יום',
            aiChatAddDay: 'הוסף יום',
            aiChatRemoveDay: 'הסר יום',
            aiChatNewName: 'שם חדש',
            aiChatUpdateAttraction: 'עדכון',
            aiChatAttractionUpdated: 'עודכן',
            aiChatAddNoteTitle: 'הערה ליום',
            aiChatUpdateNoteTitle: 'עדכון הערת היום',
            aiChatRemoveNoteTitle: 'הסרת הערת היום',
            aiChatSaveNote: 'שמירת הערה',
            aiChatAddRideNoteTitle: 'מידע כללי לכל הטיול',
            aiChatUpdateRideNoteTitle: 'עדכון מידע כללי',
            aiChatRemoveRideNoteTitle: 'הסרת מידע כללי',
            aiChatRideNoteSubtitle: 'שייך לכל הטיול ולא ליום מסוים — הנוסעים רואים את זה תחת "מידע כללי"',
            aiChatRideTextTitle: 'תיאור הטיול',
            aiChatRideTextReplaces: 'מחליף את התיאור שמופיע לנוסעים בראש הטיול',
            aiChatRideTextAdds: 'מתווסף בסוף התיאור שמופיע לנוסעים בראש הטיול',
            aiChatRideTextReplacesAndAdds: 'מחליף את התיאור שמופיע לנוסעים בראש הטיול ומוסיף לו שורה',
            aiChatRideTextReplacesWarning: 'התיאור הקיים שלך יימחק ויוחלף בטקסט הזה',
            aiChatRideTextChars: 'תווים',
            aiChatRideTextShowAll: 'הצג את הטקסט המלא',
            aiChatRideTextShowLess: 'הצג פחות',
            aiChatUpdateRideText: 'עדכון התיאור',
            aiChatRideTextUpdated: 'עודכן',
            aiChatRideTitleTitle: 'שם הטיול',
            aiChatRideTitleReplaces: 'מחליף את שם הטיול - בעמוד הטיול, ברשימת הטיולים שלכם ובחוברת',
            aiChatRideTitleCurrent: 'השם כרגע',
            aiChatRideTitleNew: 'השם החדש',
            aiChatRideTitleEmpty: 'לא התקבל שם חדש, ולכן אי אפשר לשמור את השינוי',
            aiChatRideTitleTooLong: `השם שהוצע ארוך מדי (מעל ${params.max || 140} תווים). בקשו מה-AI שם קצר יותר`,
            aiChatUpdateRideTitle: 'עדכון השם',
            aiChatRideTitleUpdated: 'עודכן',
            aiChatRideLanguageTitle: 'שפת הטיול',
            aiChatRideLanguageReplaces: 'משנה את שפת הטיול - שפת עמוד הטיול, החוברת והמיילים לנוסעים. התוכן עצמו לא מתורגם',
            aiChatRideLanguageCurrent: 'השפה כרגע',
            aiChatRideLanguageNew: 'השפה החדשה',
            aiChatRideLanguageEmpty: 'לא התקבלה שפה חדשה, ולכן אי אפשר לשמור את השינוי',
            aiChatRideLanguageUnknown: 'זו לא אחת השפות שאפשר לבחור לטיול. בקשו מה-AI שפה אחרת',
            aiChatRideLanguageReloadWarning: 'אחרי העדכון העמוד ייטען מחדש בשפה החדשה, והשיחה הזו תיסגר',
            aiChatUpdateRideLanguage: 'עדכון השפה',
            aiChatRideLanguageUpdated: 'עודכן',
            aiChatNoteSaved: 'נשמר',
            aiChatRemoveNote: 'הסר הערה',
            aiChatAcceptAll: 'אישור כל השינויים',
            aiChatUpdateHotel: 'עדכון המלון',
            aiChatHotelUpdated: 'עודכן',
            aiChatHotelReservationNote: 'השינוי מעדכן את הטיול בלבד — יש לעדכן גם את ההזמנה מול המלון.',
            aiChatChangesReady: 'שינויים מוכנים',
            aiChatLeftForYou: 'ממתינים לבחירה שלך',
            aiChatAcceptAllConfirmTitle: 'אישור כל השינויים יסיר את:',
            aiChatAcceptAllNotApplied: 'שינויים לא בוצעו — אפשר לנסות שוב בכפתור של כל שינוי.',
            aiChatMoveTo: 'העבר ל',
            aiChatRemove: 'הסרה',
            aiChatRemoved: 'הוסר',
            aiChatStarter1: 'תעבור על כל הטיול ותציע לי שיפורים',
            aiChatStarter2: 'תרגם לי את כל הטיול לאיטלקית',
            aiChatStarter3: 'בדוק אם סדר האתרים בכל יום הגיוני',
            aiChatStarter4: 'מצא לי מקומות מיוחדים להוסיף למסלול',
            aiChatApproveArea: 'אשר אזור',
            aiChatAreaApproved: 'אושר',
            aiChatAreaCheckIn: 'כניסה',
            aiChatAreaCheckOut: 'יציאה',
            aiChatAreaChange: 'שנה עיר...',
            aiChatChangePlace: 'שנה מיקום...',
            aiChatManualPlace: 'לא נמצא אוטומטית - יש לחפש ולבחור מיקום',
            aiChatUpdateArea: 'עדכן אזור',
            aiChatAreaUpdated: 'עודכן',
            aiChatAddHotel: 'הוסף לינה לטיול',
            aiChatHotelAdded: 'נוסף',

            // SingleRideHeader translations
            copyTripAndEdit: 'העתקת טיול ועריכה',
            editTripDetails: 'עריכת פרטי הטיול',
            duplicateTrip: 'שכפול הטיול',
            showRegistrationLink: 'קישור לשיתוף המסלול',
            shareTrip: 'שיתוף טיול',
            afterFirstAttractionOption1Title: 'הוספת פעילויות נוספות',
            afterFirstAttractionOption1Text: 'עברו ליום הרצוי ולחצו על "הוספת פעילות".\nאחרי שתסיים להוסיף את כל הפעילויות תוכל לשתף את המסלול עם הלקוח.',
            afterFirstAttractionOption1Button: 'הוספת פעילות נוספת',
            afterFirstAttractionOption2Title: 'שיתוף המסלול עם הלקוח',
            afterFirstAttractionOption2Text: 'עברו למסלול ולחצו על "קישור לשיתוף המסלול" כדי לשלוח את המסלול ללקוח.',
            afterFirstAttractionOption2Button: 'חזרה למסלול',
            afterFirstAttractionTipHeading: 'טיפ קטן',
            afterFirstAttractionTipText: 'כל פעילות שאתם מוסיפים נשמרת במערכת וניתן להשתמש בה שוב בטיולים נוספים.',
            afterFirstAttractionSuccess: 'מצוין. הוספתם פעילות למסלול.',
            afterFirstAttractionSubtitle: 'עכשיו אפשר להמשיך להוסיף פעילויות או לשלוח את המסלול ללקוח.',
            afterFirstAttractionHelpHeading: 'צריכים עזרה?',
            afterFirstAttractionHelpText: 'בתפריט העליון תמצאו אזור הדרכה עם סרטונים קצרים שמסבירים איך לעבוד עם המערכת.',
            
            // SingleRideSumary translations
            installApp: 'התקן את האפליקציה',
            moreTripsBy: 'לטיולים נוספים של',
            routeBy: 'המסלול של:',
            tripSummary: 'הטיול בקצרה',
            posterItinerary: 'מסלול הטיול',
            posterDays: 'ימים',
            posterDay: 'יום',
            // \u2066…\u2069 keeps "1–3" left-to-right; bare, RTL flips it to "3–1".
            posterDayRange: `ימים \u2066${params.from}–${params.to}\u2069`,
            showRideMap: 'הצגת מפת הטיול',
            hideRideMap: 'הסתרת המפה',
            rideSummaryMap: 'מפה',
            ridePlacesCount: params.count === 1 ? 'מקום אחד' : `${params.count} מקומות`,
            rideOpenDay: 'לפרטי היום',
            posterEdit: 'עריכת הפוסטר',
            posterEditDesign: 'עיצוב',
            posterEditDays: 'חלוקת הימים לתחנות',
            posterEditDaysHint: 'סמנו את הימים שבהם מתחילה תחנה חדשה בפוסטר',
            posterEditNewStop: 'תחנה חדשה',
            posterEditStop: `תחנה ${params.number || ''}`,
            posterEditPhotos: 'שם ותמונה לכל תחנה',
            posterEditStopName: 'שם התחנה בפוסטר',
            posterEditPhotoAuto: 'אוטומטי',
            posterEditNoPhotos: 'אין תמונות בימים האלה',
            posterEditReset: 'חזרה לאוטומטי',
            posterEditCancel: 'ביטול',
            posterEditSave: 'שמירה',
            posterEditSaving: 'שומר...',
            posterEditSaveFailed: 'השמירה נכשלה. נסו שוב.',
            generalInfo: 'מידע כללי',
            activities: 'פעילויות',
            accommodations: 'מקומות לינה',
            accommodationEditPresentedText: 'עריכת פרטי לינה',
            accommodationDetailsTitle: 'פרטי הלינה',
            accommodationRecommendationIntro: 'בהתבסס על המסלול שלך, אנו ממליצים על הלינה הבאה:',
            accommodationRecommendationPlaceLabel: 'מקום:',
            accommodationRecommendationDatesLabel: 'תאריכים:',
            accommodationDateRangeSeparator: ' עד ',
            accommodationRecommendationDatesNote: '* אם התאריכים לא תואמים את תאריך הטיול שלכם, יש לחזור למסלול הטיול, ללחוץ על "עריכת פרטי הטיול" ולעדכן את תאריך תחילת הטיול',
            accommodationChooseFromMyHotels: 'בחירה מרשימת המלונות שלי',
            accommodationHotelNameLabel: 'שם המלון',
            accommodationLocationFieldTooltip: 'לאחר המילוי הראשוני אין צורך לשנות שדה זה, אלא אם כן ברצונכם להחליף את מיקום הלינה למקום אחר.<br>לאחר המילוי ניתן לעבור על כל שאר השדות ולערוך אותם.',
            accommodationChooseSpecificPlace: 'כדי שהלינה תוצג ותנווט בצורה מדויקת, מומלץ לבחור יעד כמה שיותר ספציפי.',
            accommodationExamplesTitle: 'לדוגמה:',
            accommodationExampleSpecificHotel: 'מלון ספציפי - יש לבחור את שם המלון',
            accommodationExampleAreaVillage: 'לינה באזור / כפר מומלץ - ניתן לבחור את שם המקום או הכפר שבו מומלץ לישון',
            accommodationCheckInOutLabel: "צ'ק-אין וצ'ק-אאוט של המקום לינה",
            accommodationCheckInOutPlaceholder: "צ'ק אין   ←   צ'ק אאוט",
            accommodationFreeTextLabel: 'טקסט חופשי על מקום הלינה',
            accommodationAreaNameLabel: 'שם אזור הלינה',
            accommodationAreaNamePlaceholder: 'שם אזור הלינה',
            accommodationDeleteButton: 'מחיקת הלינה',
            accommodationNewPointMarkerName: 'נקודה חדשה',
            masterAccommodationCompareIntroLine1: 'שיניתם את פרטי המלון במסלול הזה',
            masterAccommodationCompareIntroLine2: 'רוצים לעדכן גם את המלון במאגר שלכם?',
            masterAccommodationCompareIntroLine3: 'כך תוכלו לבחור בגרסה המעודכנת במסלולים עתידיים',
            masterAccommodationCompareIntroLine4: 'מסלולים קיימים לא ישתנו',
            masterAccommodationCompareContinueRepo: 'עדכון לינה במאגר',
            masterAccommodationCompareUpdateBaseNow: 'בחירת שינויים לעדכון במאגר',
            masterAccommodationCompareRideOnly: 'שמירה ללינה זו בלבד (ללא עדכון המאגר)',
            masterAccommodationCompareRideOnlyShort: 'שמירה ללינה זו בלבד',
            masterAccommodationCompareDecisionSubtitle: 'עדכון במאגר ישפיע על לינות נוספות שישתמשו במידע זה.',
            masterAccommodationCompareDecisionHint: 'אם נוספו פרטים מותאמים או שינויים נקודתיים, ניתן לבחור אילו שינויים לעדכן.',
            masterAccommodationCompareTooltip1: 'השינויים יישמרו במאגר וישפיעו על לינות נוספות שישתמשו במידע זה.',
            masterAccommodationCompareTooltip2: 'מאפשר לבחור אילו שדות או פרטים יתעדכנו במאגר.',
            masterAccommodationCompareTooltip3: 'השינויים יישמרו רק בלינה הנוכחית, ללא עדכון המאגר.',
            masterAccommodationCompareMasterColumn: 'מלון מהמאגר שלכם',
            masterAccommodationCompareMasterColumnHint: 'הגרסה שתשמש אותכם במסלולים עתידיים',
            masterAccommodationCompareRideColumn: 'המלון במסלול (מעודכן)',
            masterAccommodationCompareRideColumnHint: 'השינויים שביצעת במסלול הנוכחי',
            masterAccommodationCompareAddress: 'כתובת',

            masterAttractionCompareIntroLine1: 'שיניתם את פרטי הפעילות במסלול הזה',
            masterAttractionCompareIntroLine2: 'רוצים לעדכן גם את הפעילות במאגר שלכם?',
            masterAttractionCompareIntroLine3: 'כך תוכלו להשתמש בגרסה המעודכנת במסלולים עתידיים',
            masterAttractionCompareIntroLine4: 'מסלולים קיימים לא ישתנו',
            masterAttractionCompareDecisionTitle: 'לעדכן גם את הפעילות במאגר?',
            masterAttractionCompareDecisionSubtitle: 'עדכון במאגר ישפיע על פעילויות נוספות שישתמשו במידע זה',
            masterAttractionCompareDecisionHint: 'אם נוספו פרטים מותאמים או שינויים נקודתיים, ניתן לבחור אילו שינויים לעדכן.',
            masterAttractionCompareRideOnlyShort: 'שמירה לפעילות זו בלבד',
            masterAttractionCompareTooltip1: 'השינויים יישמרו במאגר וישפיעו על פעילויות נוספות שישתמשו במידע זה.',
            masterAttractionCompareTooltip2: 'מאפשר לבחור אילו שדות או פרטים יתעדכנו במאגר.',
            masterAttractionCompareTooltip3: 'השינויים יישמרו רק בפעילות הנוכחית, ללא עדכון המאגר.',
            masterAttractionCompareContinueRepo: 'עדכון פעילות במאגר',
            masterAttractionCompareUpdateBaseNow: 'בחירת שינויים לעדכון במאגר',
            masterAttractionCompareRideOnly: 'שמירה לפעילות זו בלבד (ללא עדכון המאגר)',
            masterAttractionCompareMasterColumn: 'פעילות מהמאגר שלכם',
            masterAttractionCompareMasterColumnHint: 'הגרסה שתשמש אותך במסלולים עתידיים',
            masterAttractionCompareRideColumn: 'הפעילות במסלול (מעודכנת)',
            masterAttractionCompareRideColumnHint: 'השינויים שביצעת במסלול הנוכחי',
            masterAccommodationCompareCountryCity: 'מדינה ועיר',
            masterAccommodationCompareBooking: 'אישור הזמנה',
            masterAccommodationCompareStatus: 'סטטוס',
            masterAccommodationCompareEmpty: '-',
            accommodationMasterRefBanner: 'אתם עכשיו עורכים את הלינה במאגר שלכם.\nהשינויים כאן ישפיעו על הלינה שתבחרו להוסיף למסלולים בעתיד.\nאפשר להשתמש ב"החל ערכי תבנית" כדי לשמור את הערכים הקודמים.',
            attractionMasterRefBanner: 'אתם עכשיו עורכים את הפעילות במאגר שלכם.\nהשינויים כאן ישפיעו על פעילויות שתבחרו להוסיף למסלולים בעתיד.\nאפשר להשתמש ב"החל ערכי תבנית" כדי לשמור את הערכים הקודמים.',
            accommodationMasterRefTemplate: 'לינת מסלול (תבנית)',
            accommodationMasterRefUseBase: 'החל ערכי תבנית',
            nights: `${params.count} לילות`,
            oneNight: 'לילה אחד',
            
            // SingleRide translations
            day: 'יום',
            dayNumber: `יום ${params.number || ''}`,
            listView: 'רשימה',
            calendarView: 'לוח שנה',
            moreActivitiesInArea: 'לפעילויות נוספות בסביבה',
            addActivity: 'הוספת פעילות',
            addActivityHintBubble: 'לחצו כאן להוספת פעילות ליום הראשון',
            shareRideHintBubble: 'לחצו כאן לשיתוף המסלול ללקוח',
            addAccommodation: 'הוספת לינה',
            addDay: 'הוספת יום',
            moveAllActivities: 'העברת כל הפעילויות',
            moveDayAttractionsTitle: 'בחרו תאריך יעד להעברת כל הפעילויות',
            moveDayAttractionsTargetDayLabel: 'יום יעד:',
            moveDayAttractionsMoveButton: 'העבר',
            moveDayAttractionsLoadingRideData: 'טוען נתוני טיול...',
            moveDayAttractionsInvalidData: 'מידע הטיול לא תקין או שלא נבחר יום',
            moveDayAttractionsFailed: 'העברת הפעילויות נכשלה',
            exportPDF: 'יצירת PDF',
            generatingPDF: 'יוצר PDF...',
            pdfStyleChooserTitle: 'איזה קובץ ליצור?',
            pdfStyleItineraryLabel: 'מסלול מפורט',
            pdfStyleItineraryHint: 'כל הפרטים ליום הטיול — שעות, לינה, ניווט וקודי QR',
            pdfStyleBrochureLabel: 'חוברת שיווקית',
            pdfStyleBrochureHint: 'עמוד או שניים מעוצבים עם תמונות שתבחרו — להצגת הטיול ללקוחות',
            brochurePickerTitle: 'בחירת תמונות לחוברת',
            brochurePickerLoading: 'טוען את תמונות הטיול...',
            brochurePickerLoadFailed: 'לא הצלחנו לטעון את התמונות. אפשר ליצור את החוברת עם בחירה אוטומטית.',
            brochurePickerUseAutomatic: 'צור עם בחירה אוטומטית',
            brochurePickerCover: 'תמונת שער',
            brochurePickerCoverHint: 'כל תמונה מהטיול. לחצו על תמונה כדי לבחור אותה לשער.',
            brochurePickerStayHint: `לחצו כדי להוסיף או להסיר, עד ${params.max || ''}. תמונה מספר 1 תופיע בגדול.`,
            brochurePickerNoPhotos: 'אין תמונות ללינה הזו',
            brochurePickerBackToAuto: 'חזרה לבחירה האוטומטית',
            brochurePickerCancel: 'ביטול',
            brochurePickerGenerate: 'צור PDF',
            pdf_generated_successfully: 'קובץ ה-PDF נוצר בהצלחה!',
            pdf_generation_failed: 'שגיאה ביצירת קובץ ה-PDF. אנא נסה שוב.',
            pdf_generation_warning: '⚠️ יצירת PDF יכולה לקחת עד 20 דקות! אנא המתן ואל תסגור את הדפדפן. התהליך יתחיל בעוד רגע.',
            ride_data_not_loaded: 'מידע הטיול לא נטען כהלכה.',
            
            // SingleRideChecklist translations
            originalTripAccommodations: 'הזמנות הלינה ביחס לטיול המקורי:',
            myAccommodations: 'הזמנות הלינה שלי:',
            
            // Additional SingleRide translations
            deleteDay: 'מחיקת יום',
            editExtraInfo: 'עריכת מידע נוסף',
            accommodation: 'לינה:',
            addGeneralInfo: 'הוספת הערה ליום',
            addRideGeneralInfo: 'הוספת מידע כללי',
            moreDetails: 'פרטים נוספים',
            createNewActivity: 'יצירת פעילות חדשה',
            activitiesAvailableToAdd: 'פעילויות שניתן להוסיף',
            googleResults: 'תוצאות מ GOOGLE :',
            internalResultsFromFamilies: 'תוצאות מטיולים של משפחות אחרות',
            newRideAttractions: 'אטרקציות חדשות לטיול',
            alreadyInThisRide: 'כבר קיימות בטיול הזה',
            addAttraction: 'הוספת אטרקציה',
            noAttractionsFound: 'לא נמצאו אטרקציות.',
            noAttractionsAlreadyInThisRide: 'אין כרגע אטרקציות שכבר קיימות בטיול הזה.',
            website: 'אתר',
            addActivityToTrip: 'הוספת פעילות לטיול',
            navigateToDestination: 'ניווט ליעד',
            showRouteFromPreviousDestination: 'הצג מסלול מהיעד הקודם',

            // AttractionEditing translations
            attractionEditingAddFromMyList: 'הוספה מהרשימה שלי',
            attractionEditingOrChooseFromMyActivitiesList: 'או בחירה מתוך רשימת הפעילויות שלי',
            attractionViewEditTitle: 'עריכת הפעילות',
            attractionViewAddTitle: 'הכנסת פעילות נוספת',
            attractionEditingPresentedText: 'הכנסת פעילות לטיול',
            attractionEditingBackToTrip: 'חזרה לטיול',
            attractionEditingBackToAttractionsEdit: 'חזרה לעריכת פעילויות',
            attractionEditingActivityDetailsTitle: 'פרטי הפעילות',
            attractionEditingAutocompleteIntro: 'בחרו מיקום מתוך ההשלמה האוטומטית. הבחירה תמלא אוטומטית את פרטי האטרקציה (מיקום, כתובת ועוד).',
            attractionEditingTutorialsRecommendedTitle: 'מומלץ לצפות בהסבר בפעם הראשונה',
            attractionEditingTutorialVideoTitle1: 'איך להכניס פעילות למסלול?',
            accommodationTutorialsRecommendedTitle: 'מומלץ לצפות בהסבר בפעם הראשונה',
            accommodationTutorialVideoTitle: 'איך להכניס לינה למסלול?',
            shareRideTutorialsRecommendedTitle: 'מומלץ לצפות בהסבר בפעם הראשונה',
            shareRideTutorialVideoTitle: 'איך לשתף את המסלול?',
            attractionEditingLoadingVideo: 'טוען סרטון...',
            attractionEditingVideoLoadError: 'שגיאה בטעינת הסרטון',
            attractionEditingRetryVideo: 'נסה שוב',
            attractionEditingActivityLocationLabel: 'מיקום הפעילות (בחירה מהרשימה)',
            attractionEditingWhenToChangeField: 'מתי לשנות את השדה?',
            attractionEditingLocationFieldTooltip: 'לאחר המילוי הראשוני אין צורך לשנות שדה זה, אלא אם כן ברצונכם להחליף את מיקום הפעילות למקום אחר.<br>לאחר המילוי ניתן לעבור על כל שאר השדות ולערוך אותם.',
            attractionEditingAutocompletePlaceholder: 'התחילו להקליד ובחרו מקום מהרשימה',
            attractionEditingImportantToKnow: 'חשוב לדעת',
            attractionEditingChooseSpecificPlace: 'כדי שהפעילות תוצג ותנווט בצורה מדויקת, יש לבחור יעד כמה שיותר ספציפי.',
            attractionEditingExamplesTitle: 'לדוגמה:',
            attractionEditingExampleFlight: 'טיסה - שם שדה התעופה שבו נוחתים',
            attractionEditingExampleCarRental: 'השכרת רכב - שם הסניף שממנו אוספים את הרכב',
            attractionEditingExampleGuidedTour: 'סיור מודרך - האזור או נקודת המפגש של הסיור',
            attractionEditingExampleNature: 'פעילות טבע - שם המקום כפי שהוא מופיע ב-Google Maps',
            attractionEditingSelectedPlaceLabel: 'המקום שנבחר:',
            attractionEditingChangePlaceButton: 'שינוי מקום',
            attractionEditingChangePlaceTooltip: 'לחיצה על כפתור "שינוי מקום" תפתח שוב את שורת החיפוש ותוכלו לבחור מקום חדש.<br>ברגע שתבחרו, כל הפרטים יתעדכנו אוטומטית לפי המקום שבחרתם.',
            attractionEditingTitleLabel: 'כותרת',
            attractionEditingTitlePlaceholder: 'כותרת לאטרקציה',
            attractionEditingCreateContentWithAi: 'יצירת תוכן ע"י AI',
            attractionEditingDescriptionLabel: 'תיאור האטרקציה',
            attractionEditingDescriptionPlaceholder: 'תיאור האטרקציה',
            attractionEditingImageLabel: 'תמונה',
            attractionEditingUploadImage: 'העלאת תמונה',
            attractionEditingPixabayButton: 'העלאת תמונות מ Pixabay',
            pixabayPickerTitle: 'תמונות מ Pixabay',
            pixabayPickerSearchPlaceholder: 'חיפוש...',
            pixabayPickerSearchButton: 'חפש',
            pixabayPickerConfirmButton: 'בחר תמונה',
            pixabayPickerLoading: 'טוען תמונות...',
            pixabayPickerErrorGeneral: 'לא ניתן לטעון תמונות, נסה שוב',
            pixabayPickerErrorRateLimit: 'הגענו למגבלת הבקשות של Pixabay, אנא המתן מספר שניות ונסה שוב',
            pixabayPickerErrorNoResults: `לא נמצאו תמונות עבור "${params.term || ''}"`,
            pixabayPickerErrorDownload: 'שגיאה בהורדת התמונה, בחר תמונה אחרת',
            pixabayPickerRetry: 'נסה שוב',
            pixabayPickerCooldown: 'נא להמתין 3 שניות בין חיפושים',
            attractionEditingCropTitle: 'יחס תמונה למסלול (16:9)',
            attractionEditingCropHint: 'אפשרות 1 - חיתוך: גררו והתקרבו כדי לבחור את האזור שימלא את הריבוע (חלקים מחוץ לריבוע ייחתכו).',
            attractionEditingFitHint: 'אפשרות 2 - מילוי אוטומטי: נשמור את כל התמונה כפי שהיא, ובריבוע 16:9 החלקים החסרים ימולאו ברקע מטושטש מאותה תמונה.',
            attractionEditingCropModeFill: 'חיתוך (ממלא את הריבוע)',
            attractionEditingCropModeFit: 'מילוי אוטומטי (שומר את כל התמונה)',
            attractionEditingCropApply: 'שמירה',
            attractionEditingCropCancel: 'ביטול',
            attractionEditingWantToChangeLocation: 'רוצים לשנות את המיקום?',
            attractionEditingMapTooltip: 'ניתן להזיז את הסמן על המפה כדי לשנות את המיקום המדויק של הפעילות.<br>זה גם יעדכן את נקודת היעד שאליה הניווט יכוון.<br>לדוגמה: אפשר לגרור את הסמן לחניה של המקום במקום לכניסה הראשית',
            attractionEditingShowAdvancedOptions: 'הצג אפשרויות מתקדמות ▼',
            attractionEditingHideAdvancedOptions: 'הסתר אפשרויות מתקדמות ▲',
            attractionEditingCategoryLabel: 'קטגוריה',
            attractionEditingSelectCategory: 'בחר קטגוריה',
            attractionEditingSubcategoryLabel: 'תת קטגוריה',
            attractionEditingSelectSubcategory: 'בחר תת קטגוריה',
            attractionEditingAddressLabel: 'כתובת',
            attractionEditingAddressPlaceholder: 'כתובת',
            attractionEditingWebsitePlaceholder: 'לינק לאתר',
            attractionEditingNavigationAddressLabel: 'כתובת לניווט (אם שונה מהמקום)',
            attractionEditingFixFieldsLabel: 'בבקשה תתקנו את השדות הבאים :',
            attractionEditingMetaDescription: 'הוספת פעילות לטיול',
            
            // ExistingAttractionOptions modal
            existingAttractionOptionsTitle: 'יש לך את הפעילות הזאת במאגר הפעילויות שלך',
            existingAttractionOptionsViewExisting: 'לצפייה בפעילות שיש לי כבר במאגר',
            existingAttractionOptionsCreateAnyway: 'ליצור פעילות כזאת למרות שכבר יש לי',
            
            // createAttraction validations
            attractionValidationTitleRequired: 'כותרת',
            attractionValidationLocationRequired: 'אפשרויות מתקדמות -> שינוי המיקום על המפה',
            attractionValidationTitleTooLong: 'הכותרת ארוכה מידי',
            attractionValidationImageUploading: 'התמונה עדיין נטענת, אנא המתן לסיום ההעלאה',
            attractionValidationImageUrlPending: 'ממתין לקבלת קישור התמונה, אנא המתן',
            attractionValidationVideoUploading: 'הוידאו עדיין נטען, אנא המתן לסיום ההעלאה',
            attractionValidationVideoUrlPending: 'ממתין לקבלת קישור הוידאו, אנא המתן',
            attractionValidationAudioUploading: 'האודיו עדיין נטען, אנא המתן לסיום ההעלאה',
            attractionValidationAudioUrlPending: 'ממתין לקבלת קישור האודיו, אנא המתן',
            attractionValidationVoucherUploading: 'השובר/כרטיס עדיין נטען, אנא המתן לסיום ההעלאה',
            attractionValidationVoucherUrlPending: 'ממתין לקבלת קישור השובר/כרטיס, אנא המתן',
            accommodationValidationVoucherUploading: 'המסמך המצורף עדיין נטען, אנא המתן לסיום ההעלאה',
            
            // GlobalMapSerchAutoComplet
            globalMapSearchPlaceholder: 'הכנסת מיקום',
            globalMapSearchNewAttractionMarkerName: 'האטרקציה החדשה',
            searchByLocation: 'חיפוש לפי מיקום',
            typePlaceName: 'הקלד שם מקום',
            searchExampleLocations: 'לדוגמה: תל אביב, ים המלח, שמורת טבע...',
            backToTrip: 'חזרה לטיול >',
            searchAttractionsNoMatchCreateNew: 'לא מצאת פעילות מתאימה? יצירת פעילות חדשה',
            activitiesAlreadyInTrip: 'פעילויות שכבר קיימות בטיול',
            activitiesMatchSelectedDay: 'פעילויות שמתאימות ליום שנבחר',
            whatsappHereForYou: 'אני כאן בשבילכם',
            whatsappContactAlt: 'יצירת קשר בוואטסאפ',
            video: 'וידאו',
            audio: 'אודיו',
            videoTagNotSupported: 'הדפדפן שלך לא תומך בתגית וידאו.',
            audioTagNotSupported: 'הדפדפן שלך לא תומך בתגית אודיו.',
            audioFileOnly: 'אנא בחרו קובץ אודיו בלבד',
            videoFileOnly: 'אנא בחרו קובץ וידאו בלבד',
            uploadVideo: 'העלאת וידאו',
            uploadAudio: 'העלאת אודיו',
            fileSizeTooLarge: `גודל הקובץ גדול מדי. גודל הקובץ: ${params.fileSize || ''}, מקסימום מותר: ${params.maxSize || ''}`,
            audioUploadError: 'שגיאה בהעלאת האודיו: ',
            videoUploadError: 'שגיאה בהעלאת הוידאו: ',
            fileUploadError: 'שגיאה בהעלאת הקובץ: ',
            audioGetUrlError: 'שגיאה בקבלת קישור האודיו: ',
            videoGetUrlError: 'שגיאה בקבלת קישור הוידאו: ',
            fileGetUrlError: 'שגיאה בקבלת קישור הקובץ: ',
            voucher: 'מסמך מצורף',
            voucherPlural: 'מסמכים מצורפים',
            viewPdf: 'צפייה בקובץ PDF',
            uploadVoucher: 'העלאת שובר/כרטיס (תמונה או PDF)',
            voucherFileOnly: 'אנא בחרו קובץ תמונה (JPG, PNG) או מסמך PDF בלבד',
            voucherMaxReached: 'הגעתם למגבלה של 10 מסמכים מצורפים',
            voucherSavePending: 'ממתין לסיום העלאת הקובץ ולאחר מכן ישמר אוטומטית...',
            remove: 'הסרה',
            changeDate: 'שינוי מועד',
            showMore: 'הצג עוד',
            showLess: 'הצג פחות',
            editMode: 'מצב עריכה',
            viewPlace: 'לצפייה במקום',
            recommendedHotels: 'מלונות מומלצים',
            myHotelsList: 'רשימת המלונות שלי',
            bookingSearchHotels: 'כל המלונות באזור ',
            bookingWithDiscounts: ' עם הנחות של ',
            bookingUpTo: 'עד 15%',
            bookingSaveDiscount: 'הצעות המחיר הטובות ביותר ב-Booking.com',
            bookingBadgeTop: 'עד',
            bookingBadgeBottom: 'הנחה',
            viewHotelOnBooking: 'צפה במלון זה ב-Booking.com',
            enterAccommodationDetails: 'הכניסו פרטי לינה',
            topAccommodationInList: 'מקום הלינה העליון ברשימה',
            searchAccommodationsViewTrip: 'צפיה בטיול',
            searchAccommodationsMoreHotelsInArea: 'מלונות נוספים באיזור',
            searchAccommodationsAddToRide: 'הוסף לינה למסלול',
            searchAccommodationsOgDescription: 'ניתן למצוא מלונות שמטיילים אחרים שיתפו והמליצו',
            searchAccommodationsMetaDescription: 'חיפוש מלונות מומלצים לפי מיקום',
            
            // Common terms
            close: 'סגירה',
            save: 'שמירה',
            update: 'עדכון',
            cancel: 'ביטול',
            confirm: 'אישור',
            edit: 'עריכה',
            delete: 'מחיקה',
            add: 'הוספה',
            back: 'חזרה',
            next: 'הבא',
            previous: 'קודם',
            loading: 'טוען...',
            error: 'שגיאה',
            success: 'הצלחה',
            warning: 'אזהרה',
            info: 'מידע',
            calendarIconAlt: 'אייקון לוח שנה',
            openingHours: 'שעות פעילות:',
            placeReviews: 'ביקורות על המקום:',
            rideExtraInfoBannerParagraph: 'כאן תוכלו להוסיף מידע בנושאים שונים - כל אחד עם כותרת משלו.',
            rideExtraInfoSectionTitleLabel: 'הכותרת של הפיסקה',
            rideExtraInfoSectionTitlePlaceholder: 'תחבורה ציבורית ברומא',
            rideExtraInfoContentLabel: 'תוכן',
            rideExtraInfoContentPlaceholder: 'התחבורה הציבורית ברומא כוללת מטרו, אוטובוסים וחשמליות, ומכסה היטב את האתרים המרכזיים בעיר. מומלץ לרכוש כרטיס יומי או שבועי בתחנות או בקיוסקים. כדאי להוריד אפליקציה כמו Moovit כדי לבדוק זמני הגעה בזמן אמת.',
            rideExtraInfoDeleteSection: 'מחיקת הפיסקה',

            // Navbar
            home: 'דף הבית',
            about: 'אודות',
            searchRoutes: 'חיפוש מסלולים',
            myTrips: 'הטיולים שלי',
            tutorials: 'הדרכות',
            sharingUsageCostsNav: 'תמחור',
            login: 'התחברות',
            logout: 'התנתקות',
            loggedInAs: 'מחובר כ:',
            loggedInUserFallback: 'משתמש',
            rideManagerRole: 'מנהל מסלולים',
            myReferralLink: 'הקישור שלי להפניות',
            myWhatsappNumberMenuItem: 'הגדרת מספר ווצאפ שלי',
            language: 'שפה',
            hebrew: 'עברית',
            english: 'אנגלית',

            // Footer
            pages: 'דפים',
            contact: 'צור קשר',
            socialMedia: 'רשתות חברתיות',
            copyright: `© ${params.year !== undefined ? params.year : new Date().getFullYear()} Tripplanner - כל הזכויות שמורות`,
            termsOfUse: 'תקנון',
            searchTrips: 'חיפוש טיולים',
            searchVacations: 'חיפוש חופשות',
            uploadVacation: 'העלאת חופשה',
            other: 'אחר',
            goUp: 'עלה למעלה',
            copyrightWithYear: `© ${params.year || ''} Tripplanner - כל הזכויות שמורות`,

            // Cookie consent
            cookieConsentMessage: 'אנו משתמשים בקבצי עוגיות כדי לשפר את חוויית המשתמש, לשמור העדפות ולנתח שימוש באתר. בהמשך השימוש באתר, אתה מאשר את השימוש בעוגיות בהתאם למדיניות הפרטיות שלנו.',
            cookieConsentReadMore: 'קרא עוד',
            cookieConsentAgree: 'אני מסכים',

            // Home page
            homeHeroTitle: 'בואו לתכנן את החופשה המושלמת למשפחה שלכם',
            homeRideManagerKicker: 'למתכננים, סוכנים ומדריכים',
            homeRideManagerHeroTitle: 'בונים מסלולי טיול ללקוחות שלכם?',
            homeRideManagerHeroSubtitle: 'מתכנני טיולים, סוכני נסיעות או מדריכים: יש לכם עמוד ייעודי שמראה איך לבנות מסלולים, לשלוח אותם ללקוחות ולהציג הכול בצורה מקצועית וברורה.',
            homeRideManagerHeroCta: 'כניסה למערכת למתכנני טיולים',
            homeRideManagerExampleLink: 'צפו בדוגמה אמיתית של מסלול ללקוח',
            homeRideManagerBullet1: 'מתאים למתכנני טיולים וסוכני נסיעות',
            homeRideManagerBullet2: 'בניית מסלולים ושליחה ללקוחות',
            homeRideManagerBullet3: 'חוסך שעות עבודה בכל טיול',
            homeSearchPlaceholder: 'הכניסו את היעד שלכם!',
            homeWatchVacationsIntro: 'צפו במאגר החופשות שמשפחות שיתפו',
            homeWatchVacations: 'צפו בחופשות',
            homeShareVacation: 'שתפו חופשה',
            homeStartWithVacation: 'התחילו בבחירת חופשה כבסיס לתכנון',
            homeWatchVacationsDb: 'צפו במאגר החופשות',
            homeWhatCanDoTitle: 'מה אפשר לעשות ב - ',
            homeWhatCanDoIntro: 'כשיש לכם את כל המידע שאתם צריכים זה פשוט לטייל חכם. Tripplanner מפקס אתכם על התוכנית לחופשה שבאמת מתאימה למשפחה שלכם',
            homePlanningVacation: 'מתכננים חופשה',
            homePlanningVacationDesc: 'בואו להשתמש בחופשות שמשפחות אמיתיות עשו ותשתמשו בניסיון שלהם',
            homeBackFromVacation: 'חזרתם מחופשה',
            homeBackFromVacationDesc: 'חזרתם מחופשה מושלמת. זה הזמן להחזיר לקהילה ולאפשר גם לאחרים לעשות את החופשה שלכם',
            homeUploadVacation: 'העלאת חופשה',
            homeRecommendedTrips: 'מסלולים מומלצים',
            homeRecommendedTripsIntro: 'אין חכם כבעל ניסיון - טיפים ממשפחות שעשו את החופשה שאתם מתכננים לעשות. מסלולים אמיתיים של משפחות שהעלו את החופשה שלהם לאתר כדי שאתם תוכלו להשתמש בזה כבסיס לתכנון שלכם',
            homeWatchSuccessfulVacations: 'צפו בחופשות מוצלחות',
            homeWhyTripplanner: 'למה לתכנן עם ',
            homeWhyCard1Title: 'כל החופשות נעשו על ידי משפחות כמוכם',
            homeWhyCard1Desc: 'אין כמו לקבל המלצות ממשפחות שעשו את החופשה הזואת לפניכם. אין צורך להמציא את הגלגל מחדש, החופשה כבר תוכננה ונבדקה.',
            homeWhyCard2Title: 'מאגר גדול של חופשות ופעילויות',
            homeWhyCard2Desc: 'יש לנו מאגר גדול של חופשות שמשפחות העלו לאתר כדי שתוכלו להשתמש בהן. מתוך מאגר החופשות יש לנו מאגר גדול יותר של פעילויות שניתן להוסיף עבור כל חופשה שתבחרו.',
            homeWhyCard3Title: 'חלוקה ברורה של ימים לאיזורים',
            homeWhyCard3Desc: 'חלוקה ברורה של כמות הימים לכל איזור במהלך החופשה. המלצה של מקומות לינה עבור כל חלק בחופשה.',
            homeWhyCard4Title: 'דרך פשוטה לתכנן טיול',
            homeWhyCard4Desc: 'אפשר להוריד או להוסיף פעילויות ממאגר הפעילויות לחופשה שבחרתם. אפשר לשנות את אורך החופשה.',
            // How it works (home)
            homeHowTitle: 'איך מתכננים חופשה חכם',
            homeHowStep1Title: 'בחרו חופשה שאהבתם כבסיס לתכנון',
            homeHowStep1Desc: 'התכנון שלכם מתחיל בבחירת חופשה מתוך המאגר באתר, שישמש כבסיס לתכנון החופשה שלכם',
            homeHowStep2Title: 'תוסיפו או תורידו אטרקציות לחופשה שבחרתם',
            homeHowStep2Desc: 'תהנו מתכנון קל ונוח על ידי התאמת החופשה שבחרתם והוספת פעילויות מומלצות מחופשות נוספות ששותפו באתר',
            homeHowStep3Title: 'צאו לחופשה בכיף ושתפו חברים ומשפחה',
            homeHowStep3Desc: 'תהנו מחוויית חופשה מדהימה עם ליווי מהאתר במהלך הטיול. ותחזירו לקהילה על ידי הוספת החופשה שלכם למאגר באתר ושיתוף עם חברים ומשפחה!',
            homeMetaDescription: 'אתר לשיתוף טיולים וצפיה בטיולים של מטיילים ישראלים ברחבי העולם',
            homeOgDescription: 'מאגר טיול גדול של משפחות ששיתפו את המסלולים שלהם',

            // Recommended trips (home page)
            recommendedTrip1Title: 'וינה וזלצבורג',
            recommendedTrip1Location: 'אוסטריה',
            recommendedTrip1ManyDays: '14 ימים',
            recommendedTrip2Title: 'פירנאים, ברצלונה ומדריד',
            recommendedTrip2Location: 'ספרד',
            recommendedTrip2ManyDays: '11 ימים',
            recommendedTrip3Title: 'קרקוב וזקופנה',
            recommendedTrip3Location: 'דרום פולין',
            recommendedTrip3ManyDays: '14 ימים',
            recommendedTrip4Title: 'ניו-יורק',
            recommendedTrip4Location: 'ניו-יורק',
            recommendedTrip4ManyDays: '10 ימים',
            recommendedTrip5Title: 'זלצבורג וטירול',
            recommendedTrip5Location: 'אוסטריה',
            recommendedTrip5ManyDays: '14 ימים',
            recommendedTrip6Title: 'סקוטלנד/אנגליה/ויילס',
            recommendedTrip6Location: 'הממלכה המאוחדת',
            recommendedTrip6ManyDays: '19 ימים',
            recommendedTrip7Title: 'בסטאי והסביבה',
            recommendedTrip7Location: 'גרמניה',
            recommendedTrip7ManyDays: '8 ימים',
            tripsImageLoginHint: 'התחברו כדי להתחיל!',

            // Tutorials page
            tutorialsPageTitle: 'הדרכות שימוש במערכת',
            tutorialsPageDescription: 'ברוכים הבאים לעמוד ההדרכות של TripPlanner. כאן תוכלו ללמוד כיצד להשתמש בכל התכונות של המערכת באמצעות סרטוני הדרכה מפורטים.',
            videoNotSupported: 'הדפדפן שלכם לא תומך בהצגת וידאו.',
            loadingVideo: 'טוען סרטון...',
            videoLoadError: 'שגיאה בטעינת הסרטון. אנא נסו שוב מאוחר יותר.',
            backToQuestions: 'חזרה לרשימת השאלות',
            retry: 'נסה שוב',

            // User rides page
            userRidesCreateShareRoute: 'יצירת מסלול לשיתוף',
            userRidesCreateChoiceTitle: 'איך תרצו ליצור את הטיול?',
            userRidesAllMyActivities: 'כל הפעילויות שלי',
            userRidesEditProfile: 'עריכת הפרופיל שלי',
            userRidesShareTripOnSite: 'שיתוף טיול באתר',
            userRidesNoTrips: 'אין טיולים להצגה',
            userRidesTableTitle: 'כותרת',
            userRidesTableDescription: 'תיאור',
            userRidesTableDates: 'תאריכים',
            userRidesTableCategory: 'קטגוריה',
            userRidesTableActions: 'פעולות',
            userRidesBelongsToCategoryLabel: 'שייך לקטגוריה:',
            userRidesCategoryLabel: 'קטגוריה:',
            userRidesViewPrivateTrip: 'צפיה בטיול הפרטי',
            userRidesViewAndEditTrip: 'צפיה ועריכת הטיול',
            userRidesOgDescription: 'רשימת המסלולים שבחרתי או שהעלתי לאתר',
            userRidesMetaDescription: 'רשימת המסלולים שלי',

            // User rides categories (DEFAULT_CATEGORIES)
            userRidesCategoryPlanningLabel: 'טיולים בתכנון',
            userRidesCategoryPlanningDescription: 'טיולים שנמצאים בשלבי עבודה - עוד לא מוכנים לשיתוף עם לקוחות.',
            userRidesCategoryActiveLabel: 'טיולים פעילים',
            userRidesCategoryActiveDescription: 'טיולים שנמסרו ללקוח וכרגע נמצאים בשימוש במהלך החופשה.',
            userRidesCategoryClientLabel: 'טיולים ללקוחות',
            userRidesCategoryClientDescription: 'טיולים שנבנו והותאמו במיוחד עבור לקוחות - מוכנים לשימוש או שותפו בעבר.',
            userRidesCategoryTemplateLabel: 'תבניות טיול',
            userRidesCategoryTemplateDescription: 'טיולים שמורים כתבניות קבועות - בסיס לשכפול והתאמה ללקוחות שונים.',
            userRidesCategoryInactiveLabel: 'טיולים לא פעילים',
            userRidesCategoryInactiveDescription: 'טיולים שהסתיימו, בוטלו או שאינם רלוונטיים - נשמרים לצורכי תיעוד או עיון עתידי.',

            // Edit profile page
            editProfilePageTitle: 'עריכת פרופיל',
            editProfileBackToMyTrips: 'חזרה לטיולים שלי',
            editProfileDetails: 'פרטי הפרופיל',
            editProfileLoading: 'טוען...',
            editProfileLoadingData: 'טוען נתונים...',
            editProfileImageLabel: 'תמונת פרופיל',
            editProfileImageHint: 'מומלץ להשתמש בתמונה סימטרית בגודל כ900x900 פיקסלים, כדי שתוצג בצורה מיטבית בעיגול.',
            editProfileNoImage: 'אין תמונה',
            editProfileChangeImage: 'שנה תמונה',
            editProfileUploadImage: 'העלה תמונה',
            editProfileUploading: 'מעלה...',
            editProfileNameLabel: 'שם',
            editProfileNamePlaceholder: 'הכנס שם',
            editProfileTitleLabel: 'כותרת קצרה שמופיעה מתחת לשם',
            editProfileTitlePlaceholder: 'הכנס כותרת',
            editProfileAboutLabel: 'אודות (טקסט חופשי)',
            editProfileAboutPlaceholder: 'כמה מילים עליך כמתכנן טיולים - למי שמטייל עם המסלול שלך',
            editProfileWebsiteLabel: 'קישור לאתר',
            editProfileFacebookLabel: 'קישור לפייסבוק',
            editProfileInstagramLabel: 'קישור לאינסטגרם',
            editProfileSave: 'שמירה',
            editProfileSaving: 'שומר...',
            editProfileUploadError: 'שגיאה בהעלאת התמונה. אנא נסה שוב.',
            editProfileEnterName: 'אנא הזן שם',
            editProfileSuccess: 'הפרופיל עודכן בהצלחה',
            editProfileUpdateError: 'שגיאה בעדכון הפרופיל',
            editProfileUpdateErrorTryAgain: 'שגיאה בעדכון הפרופיל. אנא נסה שוב.',

            // Ride manager attraction page
            rideManagerAttractionManageCategories: 'ניהול קטגוריות',
            rideManagerAttractionTabAttractions: 'אטרקציות',
            rideManagerAttractionTabAccommodations: 'מקומות לינה',
            rideManagerAttractionName: 'שם',
            rideManagerAttractionDescription: 'תיאור',
            rideManagerAttractionHasImage: 'כולל תמונה',
            rideManagerAttractionEdit: 'עריכה',
            rideManagerAttractionEditButton: 'ערוך',

            // Admin categories page
            adminCategoriesTitle: 'קטגוריות',
            adminCategoriesAddCategory: 'הוסף קטגוריה',
            adminCategoriesSearchPlaceholder: 'חיפוש קטגוריות...',
            adminCategoriesNoCategoriesFound: 'לא נמצאו קטגוריות',
            adminCategoriesUnnamedCategory: 'קטגוריה ללא שם',
            adminCategoriesSubcategoriesCount: 'תת-קטגוריות',
            adminCategoriesUnnamedSubcategory: 'תת-קטגוריה ללא שם',
            adminCategoriesEditCategory: 'עריכת קטגוריה',
            adminCategoriesDelete: 'מחיקה',
            adminCategoriesSubcategories: 'תת-קטגוריות',
            adminCategoriesEdit: 'ערוך',
            adminCategoriesNoSubcategoriesFound: 'לא נמצאו תת-קטגוריות',
            adminCategoriesAddSubcategory: 'הוסף תת-קטגוריה',
            adminCategoriesSelectCategory: 'בחר קטגוריה לצפייה בפרטים',
            adminCategoriesConfirmDelete: 'אישור מחיקה',
            adminCategoriesConfirmDeleteMessage: 'האם אתה בטוח שברצונך למחוק את {0}?',
            adminCategoriesCannotUndo: 'לא ניתן לבטל פעולה זו.',
            adminCategoriesName: 'שם',
            adminCategoriesEnterName: 'הזן שם',
            adminCategoriesEditCategoryTitle: 'עריכת קטגוריה',
            adminCategoriesAddCategoryTitle: 'הוסף קטגוריה',
            adminCategoriesEditSubcategoryTitle: 'עריכת תת-קטגוריה',
            adminCategoriesAddSubcategoryTitle: 'הוסף תת-קטגוריה',
            adminCategoriesFailedToLoad: 'טעינת הקטגוריות נכשלה',
            adminCategoriesError: 'שגיאה',
            adminCategoriesSuccessfullyDeleted: 'נמחק בהצלחה',
            adminCategoriesSuccess: 'הצלחה',
            adminCategoriesFailedToDelete: 'המחיקה נכשלה',
            adminCategoriesNameRequired: 'נדרש להזין שם',
            adminCategoriesValidationError: 'שגיאת אימות',
            adminCategoriesSuccessfullySaved: 'נשמר בהצלחה',
            adminCategoriesFailedToSave: 'השמירה נכשלה',
            adminCategoriesThisItem: 'פריט זה',

            // Document Import
            importDocumentsTitle: 'יבוא מסמכי הזמנה',
            importRideBannerTitle: 'יצירת טיול בעזרת AI',
            importRideBannerParagraph: 'העלו אישורי טיסה, הזמנות מלון, מסלול טיול או הדביקו תוכנית קיימת. הבינה המלאכותית שלנו תנתח את המידע ותיצור ממנו את הטיול הדיגיטלי שלכם.',
            importRideAiNoticeLabel: 'חשוב לדעת:',
            importRideAiNotice: 'המסלול נוצר בעזרת בינה מלאכותית, ולכן ייתכנו טעויות או פרטים חסרים. מומלץ לבדוק את כל המידע, במיוחד תאריכים, שעות ופרטי הזמנות, לפני שיתוף המסלול עם המטיילים.',
            importRideManualLink: 'אין לכם מסמך? צרו את הטיול ידנית',
            rideInfoCreateFromDocumentLink: 'יש לכם מסמך עם פרטי הטיול? צרו את הטיול ממנו',
            startInsertRideFromDocumentTitle: 'יצירה ממסמך',
            startInsertRideFromDocumentSubtitle: 'אישורי הזמנה של טיסות ומלונות, או קובץ PDF שמתאר את כל הטיול',
            startInsertRideManualTitle: 'יצירה ידנית',
            startInsertRideManualSubtitle: 'מלאו את פרטי הטיול בעצמכם',
            importDocumentsDropZone: 'גרור לכאן כרטיסי טיסה, שוברי מלון או קובץ PDF של הטיול, או לחץ לבחירה',
            importDocumentsProcessing: 'קורא את המסמך...',
            importDocumentsProcessingHint: 'מסמכים מורכבים (כגון מסלולי טיול) עשויים לקחת עד 5 דקות',
            importDocumentsError: 'לא ניתן לקרוא מסמך זה',
            importDocumentsTooLarge: 'הקובץ גדול מדי. הגודל המקסימלי הוא 10 מגה-בייט',
            importDocumentsUnsupportedType: 'ניתן להעלות קבצי PDF, JPG או PNG בלבד',
            importDocumentsNotAccommodation: 'המסמך אינו נראה כהזמנת מלון',
            importDocumentsRideName: 'שם הנסיעה',
            importDocumentsEdit: 'ערוך',
            importDocumentsSave: 'שמור',
            importDocumentsDiscard: 'הסר',
            importDocumentsRemovePoint: 'הסר',
            importDocumentsCreate: 'צור נסיעה',
            importDocumentsAddMore: 'הוסף מסמכים נוספים',
            importDocumentsConfidenceLow: 'אנא אמת את הנתונים שחולצו',
            importDocumentsHotelName: 'שם המלון',
            importDocumentsAddress: 'כתובת',
            importDocumentsConfirmation: 'מספר אישור הזמנה',
            importDocumentsNotes: 'פרטים נוספים',
            importDocumentsCheckIn: 'צ\'ק אין',
            importDocumentsCheckOut: 'צ\'ק אאוט',
            importDocumentsMissingFields: 'מידע חסר:',
            importDocumentsPartialError: 'חלק מהלינות לא נוצרו:',
            importDocumentsGoToRide: 'עבור לנסיעה',
            importDocumentsErrorDateRange: 'אורך הנסיעה המקסימלי הוא 60 יום',
            importDocumentsDateRangeWarning: `בין ${params.start} לבין ${params.end} יש יותר מ-60 יום — אנא ערוך את תאריכי הנסיעה ידנית`,
            importDocumentsDoubleBooking: `הזמנה כפולה: ${params.nameA} ו-${params.nameB} חופפות בתאריכים — אנא ערוך את התאריכים`,
            importDocumentsLocationPrompt: 'אנא אשר את מיקום המלון ב-Google Maps',
            importDocumentsLocationConfirmed: 'מיקום אושר',
            importDocumentsChangeLocation: 'שנה',
            importDocumentsLocationRequired: 'נדרש מיקום — אנא מצא את המלון ב-Google Maps',
            importDocumentsPointLocationPrompt: 'חפש מיקום ב-Google Maps',
            importDocumentsPointLocationRequired: 'נדרש מיקום — אנא אשר ב-Google Maps',
            importDocumentsSearchingLocation: 'מחפש את המיקום...',
            importDocumentsWaitingForGoogle: 'גוגל מגביל את מספר הבקשות — ממתין ומנסה שוב...',
            importDocumentsLookingUpPlaces: `מחפש ${params.count} מתוך ${params.total} מיקומים...`,
            importDocumentsDatesMissing: 'לא נמצאו תאריכים במסמך — אנא מלאו את תאריכי הנסיעה',
            importDocumentsRideNameMissing: 'אנא הזינו שם לנסיעה',
            importDocumentsAccommodationDatesMissing: 'חסרים תאריכי צ\'ק אין / צ\'ק אאוט — לחצו על "ערוך" כדי להשלים',
            importDocumentsSuggestName: 'הצע שם',
            importDocumentsFlightDeparture: 'המראה',
            importDocumentsFlightArrival: 'נחיתה',
            importDocumentsTypeAccommodation: 'לינה',
            importDocumentsTypeFlight: 'טיסה',
            importDocumentsTypeCarRental: 'השכרת רכב',
            importDocumentsTypeAttraction: 'אטרקציה',
            importDocumentsTypeShow: 'הצגה / אירוע',
            importDocumentsTypeItinerary: 'מסלול טיול',
            importDocumentsTypeUnknown: 'מסמך לא מזוהה',
            importDocumentsOr: 'או',
            importDocumentsPasteText: 'הדבק טקסט',
            importDocumentsAnalyzeText: 'נתח טקסט',
            importDocumentsTextPlaceholder: 'הדבק כאן את פרטי הטיול — מסלול יומי, אישורי הזמנה, טיסות, מלונות וכו\'...',
            importRideTextPlaceholder: 'כבר תכננתם טיול בעזרת ChatGPT או כלי AI אחר? פשוט הדביקו כאן את התוכנית!\n\nאפשר גם להדביק מסלול יומי, אישורי הזמנה, פרטי טיסות, מלונות ועוד...',

            // Ride documents panel
            rideDocumentsOpenButton: 'הוספת מידע בעזרת AI',
            rideDocumentsPanelTitle: 'הוספת מידע לטיול בעזרת AI',
            rideDocumentsPanelDescription: 'העלו מסמכים או הדביקו טקסט, והבינה המלאכותית שלנו תנתח את המידע ותוסיף את הפרטים הרלוונטיים לטיול שלכם.',
            rideDocumentsDropZone: 'גררו לכאן אישורי טיסה, הזמנות מלון או מסלול טיול, או לחצו לבחירת קבצים.',
            rideDocumentsPasteTextLabel: 'הדבקת טקסט לניתוח AI',
            rideDocumentsTextPlaceholder: 'הדביקו כאן מסלול יומי, אישורי הזמנה, פרטי טיסות ומלונות או תוכנית טיול שהכנתם בעזרת ChatGPT או כלי AI אחר...',
            rideDocumentsAnalyzeText: 'נתח והוסף לטיול בעזרת AI',
            rideDocumentsAiNotice: 'המידע מעובד בעזרת בינה מלאכותית ועשוי להכיל טעויות. מומלץ לבדוק את הפרטים לאחר הוספתם לטיול.',
            rideDocumentsAttach: 'הוסף למסלול',
            rideDocumentsAttaching: 'מוסיף…',
            rideDocumentsNothingReady: 'עדיין לא נוספו מסמכים לניתוח',
            rideDocumentsInvalidDates: 'תאריכי השהייה במסמך אינם תקינים — תאריך היציאה חייב להיות אחרי תאריך הכניסה',
            rideDocumentsFixDocumentDates: 'תקן את תאריכי המסמך',
            rideDocumentsOutOfRange: `המסמך חורג מתאריכי המסלול ב-${params.days || 0} ימים`,
            rideDocumentsPointsOutOfRange: `${params.count || 0} מקומות במסמך זה נמצאים מחוץ לתאריכי המסלול`,
            rideDocumentsExtendRide: 'הארך את המסלול',
            rideDocumentsExtendRideHint: `המסלול יתחיל ב-${params.start || ''} ויסתיים ב-${params.end || ''}`,
            rideDocumentsDoubleBooking: `"${params.incoming || ''}" מתנגש עם לינה קיימת: "${params.existing || ''}"`,
            rideDocumentsExistingStayDates: `"${params.name || ''}" תפוס כעת מ-${params.checkIn || ''} עד ${params.checkOut || ''}`,
            rideDocumentsChangeExistingDates: 'שנה את תאריכי הלינה הקיימת',
            rideDocumentsRemoveExisting: 'הסר את הלינה הקיימת',
            rideDocumentsSkipDocument: 'דלג על המסמך הזה',
            rideDocumentsDocumentsCollide: 'שני מסמכים שהעליתם מכסים את אותם לילות',
            rideDocumentsDocumentPair: `"${params.nameA || ''}" מול "${params.nameB || ''}"`,
            rideDocumentsDocumentsCollideHint: 'תקנו את התאריכים באחד מהם או דלגו עליו כדי להמשיך',
            rideDocumentsResolveConflictsFirst: 'יש לפתור את ההתנגשויות לפני ההוספה למסלול',
            rideDocumentsExistingDatesMissing: 'יש למלא גם תאריך כניסה וגם תאריך יציאה ללינה הקיימת',
            rideDocumentsExistingDatesReversed: 'תאריך היציאה חייב להיות אחרי תאריך הכניסה',
            rideDocumentsExistingOutOfRange: `התאריכים החדשים של הלינה הקיימת נמצאים מחוץ לתאריכי המסלול (${params.start || ''} עד ${params.end || ''}) — בחרו תאריכים בתוך הטווח, או הארכת את המסלול תחילה`,
            rideDocumentsExistingStillCollides: 'התאריכים החדשים מתנגשים עם לינה אחרת בטיול — נסו תאריכים אחרים',
            rideDocumentsExistingNotAllowed: 'אין לכם הרשאה לערוך את הלינה הזו',
            rideDocumentsExistingSaveFailed: 'שמירת התאריכים החדשים נכשלה — נסו שוב',
            rideDocumentsExistingRemoveFailed: 'הסרת הלינה הקיימת נכשלה — נסו שוב',
            rideDocumentsAlreadyAttached: `${params.count || 0} מסמכים כבר נוספו לטיול ולא ייווספו שוב — תקנו את מה שנכשל ולחצו שוב`,
            rideDocumentsExistingStaysUnreadable: 'לא ניתן היה לבדוק את המסמך הזה מול הלינות הקיימות בטיול — נסו שוב',
            rideDocumentsRetryStaysCheck: 'נסו שוב',
            rideDocumentsCheckingExistingStays: 'בודקים אם יש התנגשות עם לינות קיימות בטיול…',
            rideDocumentsCardReady: 'מוכן להוספה',
            rideDocumentsAttachOne: 'הוסף מסמך אחד למסלול',
            rideDocumentsAttachMany: `הוסף ${params.count || 0} מסמכים למסלול`,
            rideDocumentsAttachThisDocument: 'הוסף מסמך זה למסלול',
            rideDocumentsWaitingOne: 'מסמך אחד ממתין לפתרון לפני שאפשר להוסיף אותו',
            rideDocumentsWaitingMany: `${params.count || 0} מסמכים ממתינים לפתרון לפני שאפשר להוסיף אותם`,
            rideDocumentsNotYetAdded: 'המסמכים עדיין לא נוספו למסלול',
            rideDocumentsAttachSuccessOne: 'נוסף מסמך אחד למסלול ✓',
            rideDocumentsAttachSuccessMany: `נוספו ${params.count || 0} מסמכים למסלול ✓`,
            rideDocumentsPartialError: 'חלק מהפריטים לא נוספו למסלול:',
            rideDocumentsNoteFailed: `ההערה "${params.name || ''}" לא נוספה למסלול — נסו שוב`,
            rideDocumentsUntitledNote: 'הערה ללא כותרת',
            rideDocumentsRetryTripInfo: 'נסו שוב להוסיף את המידע הכללי',

            // Generate ride with AI
            generateRideWithAiTitle: 'בניית טיול עם AI',
            generateRideWithAiIntro: 'בחרו את תאריכי הטיול והוסיפו מידע על המטיילים. המערכת תבנה את הטיול באופן אוטומטי מתוך מאגר האטרקציות של הניהול.',
            generateRideWithAiStartDate: 'תאריך התחלה',
            generateRideWithAiEndDate: 'תאריך סיום',
            generateRideWithAiTravelersLabel: 'מידע על המטיילים',
            generateRideWithAiTravelersPlaceholder: 'ספרו לנו על המטיילים — גילאים, הרכב הקבוצה, עם ילדים או בלי, תחומי עניין, קצב הטיול, מגבלות ניידות וכל מידע נוסף שיעזור לבנות את הטיול.',
            generateRideWithAiSubmit: 'שליחה לשרת',
            generateRideWithAiSubmitting: 'שולח...',
            generateRideWithAiBack: 'חזרה ליבוא מסמכים',
            generateRideWithAiDatesRequired: 'יש לבחור תאריך התחלה ותאריך סיום.',
            generateRideWithAiEndBeforeStart: 'תאריך הסיום חייב להיות לאחר תאריך ההתחלה או זהה לו.',
            generateRideWithAiError: 'שליחת הפרטים לשרת נכשלה. נסו שוב.',
            generateRideWithAiNoAttractions: 'לא נמצאו אטרקציות במאגר שלכם. הוסיפו אטרקציות לפני יצירת טיול עם AI.',
            generateRideWithAiDestination: 'יעד הטיול',
            generateRideWithAiDestinationPlaceholder: 'לדוגמה: בראשוב, רומניה',
            generateRideWithAiDestinationHint: 'נשתמש רק באטרקציות שלכם שנמצאות ברדיוס של 200 ק"מ מהיעד.',
            generateRideWithAiExampleRides: 'טיולים לדוגמה (רשות)',
            generateRideWithAiExampleRidesPlaceholder: 'לדוגמה: 19995, 20014',
            generateRideWithAiExampleRidesHint: 'מספרי טיולים שבניתם בעצמכם. ה-AI ילמד מהם את הסגנון והקצב שלכם — ולא ישתמש באטרקציות שלהם.',
            generateRideWithAiDestinationRequired: 'יש להזין את יעד הטיול.',
            generateRideWithAiDestinationNotFound: 'לא הצלחנו לזהות את היעד הזה. נסו לכתוב עיר או אזור אחר.',
            generateRideWithAiNoAttractionsNearby: 'לא נמצאו אטרקציות במאגר שלכם ברדיוס של 200 ק"מ מהיעד. בחרו יעד אחר או הוסיפו אטרקציות באזור הזה.',

            // Attraction enrichment panel
            enrichmentAskAi: 'הוסף מידע עם AI',
            enrichmentWorking: 'שואל את ה-AI...',
            enrichmentWorkingHint: 'זה לוקח כמה שניות.',
            enrichmentIntro: 'ה-AI מילא את השדות האלה. אפשר לשנות כל אחד מהם לפני השמירה.',
            enrichmentPoolScope: 'הפרטים האלה שייכים לאטרקציה במאגר שלכם, וישמשו בכל טיול שתיצרו איתה.',
            enrichmentManagerIntro: 'השדות הבאים הם שלכם בלבד — ה-AI אף פעם לא ממלא אותם.',
            enrichmentSavedWithAttraction: 'הפרטים יישמרו יחד עם האטרקציה.',
            enrichmentCategory: 'קטגוריה',
            enrichmentTags: 'תגיות',
            enrichmentTagsPlaceholder: 'מופרדות בפסיק: מפל, נוף, משפחתי',
            enrichmentMinAge: 'גיל מינימלי',
            enrichmentRecommendedMinAge: 'גיל מומלץ',
            enrichmentGoodFor: 'מתאים ל',
            enrichmentDuration: 'משך ביקור (דקות)',
            enrichmentPreferredTime: 'שעות מועדפות',
            enrichmentOpenMonths: 'חודשים מתאימים',
            enrichmentOpenMonthsHint: 'סמנו את כל החודשים אם המקום מתאים כל השנה. בלי סימון = לא הוגדר.',
            enrichmentIndoorOutdoor: 'מקורה / בחוץ',
            enrichmentPhysicalEffort: 'מאמץ פיזי',
            enrichmentPriority: 'עדיפות (1-5)',
            enrichmentNotesForAi: 'הערות ל-AI',
            enrichmentNotesPlaceholder: 'למשל: עדיף להגיע בבוקר לפני העומס.',
            enrichmentAge_toddlers: 'פעוטות',
            enrichmentAge_kids: 'ילדים',
            enrichmentAge_teens: 'נוער',
            enrichmentAge_adults: 'מבוגרים',
            enrichmentAge_seniors: 'גיל שלישי',
            enrichmentTime_morning: 'בוקר',
            enrichmentTime_afternoon: 'צהריים',
            enrichmentTime_evening: 'ערב',
            enrichmentEnv_indoor: 'מקורה',
            enrichmentEnv_outdoor: 'בחוץ',
            enrichmentEnv_mixed: 'משולב',
            enrichmentEffort_none: 'ללא',
            enrichmentEffort_easy: 'קל',
            enrichmentEffort_moderate: 'בינוני',
            enrichmentEffort_strenuous: 'מאומץ',
            enrichment_weather_dependent: 'תלוי מזג אוויר',
            enrichment_stroller_friendly: 'מתאים לעגלה',
            enrichment_wheelchair_friendly: 'נגיש לכיסא גלגלים',
            enrichment_booking_required: 'נדרשת הזמנה מראש',
            enrichmentError: 'לא הצלחנו לקבל מידע מה-AI. נסו שוב.',
            enrichmentNotAdmin: 'האפשרות הזו זמינה כרגע למנהל המערכת בלבד.',
            enrichmentNoPlace: 'יש להזין שם או כתובת לפני הפנייה ל-AI.',
            enrichAllButton: 'העשר את כל האטרקציות עם AI',
            enrichAllRunning: 'מעשיר...',
            enrichAllConfirm: `לשלוח ${params.count || 0} אטרקציות ל-AI? כל אטרקציה שכבר הועשרה תדולג.`,
            enrichAllStarting: 'מתחיל...',
            enrichAllProgress: `${params.processed || 0} מתוך ${params.total || 0} — ${params.enriched || 0} הועשרו, ${params.skipped || 0} דולגו, ${params.failed || 0} נכשלו`,
            enrichAllHint: 'התהליך רץ בשרת וייקח זמן. אפשר להשאיר את החלון פתוח כדי לראות התקדמות.',
            enrichAllDone: `הסתיים: ${params.enriched || 0} הועשרו, ${params.skipped || 0} דולגו, ${params.failed || 0} נכשלו, מתוך ${params.total || 0}.`,
            enrichAllError: 'ההעשרה נכשלה. בדקו את היומן של השרת.',
            generateRideWithAiBuilding: 'ה-AI בונה את הטיול שלכם...',
            generateRideWithAiBuildingHint: 'בניית הטיול עשויה לקחת עד 10 דקות. אנא השאירו את החלון פתוח.',
            generateRideWithAiTimeout: 'בניית הטיול נמשכת זמן רב מדי. נסו שוב.',
            generateRideWithAiPlanningFailed: 'ה-AI לא הצליח לבנות טיול מהאטרקציות שלכם. נסו לשנות את התאריכים או את פרטי המטיילים.',
            generateRideWithAiTravelersInfoTooLong: 'המידע על המטיילים ארוך מדי. אנא קצרו אותו ונסו שוב.',
            generateRideWithAiJobFailed: 'לא הצלחנו לבנות את הטיול. נסו שוב.',

            // Ride information page
            rideInfoPageTitle: 'פרטי הטיול',
            rideInfoSubdomainParagraph: 'נא לעדכן את התאריך של היום הראשון בטיול שלכם.',
            rideInfoParagraph: 'כאן תוכלו לשתף מידע שחשוב לדעת על המסלול - תובנות, חוויות, טיפים והמלצות שיעזרו למי שיוצא לטיול הזה.',
            rideInfoPrivateRideLabel: 'יצירת מסלול פרטי - המסלול יהיה חשוף אך ורק למשתמשים שתאשרו בעצמכם',
            publicRideManagerNoticeCritical: 'חשוב - חשיפה ציבורית',
            publicRideManagerNoticeTitle: 'המסלול הזה מוגדר כציבורי.',
            publicRideManagerNoticeBody: 'כל המידע שמופיע כאן פתוח לצפייה, ואנשים יכולים להגיע אליו גם בלי הרשאת גישה.',
            rideInfoWhiteLabelLabel: 'הצג טיול בתצוגת White Label',
            rideInfoWhiteLabelHint: 'כאשר האפשרות מסומנת, הטיול יוצג בעמוד ממותג בצבעים ובלוגו של האתר שלך.<br>כאשר אינה מסומנת, הטיול יוצג בתצוגה הרגילה בסביבה שלך בלבד.',
            rideInfoDateStartPlaceholder: 'תאריך התחלה של הטיול',
            rideInfoDateRangePlaceholder: 'תאריך התחלה וסיום',
            rideInfoTitleLabel: 'הכותרת של הטיול',
            rideInfoTitlePlaceholder: 'שבועיים בטירול עם 3 ילדים בגילאים 10,7,4',
            rideInfoAgeLabel: 'הרכב גילאי המשתתפים',
            rideInfoAgePlaceholder: 'כמות המשתתפים לפי גילאים',
            rideInfoAgeSummaryLabel: 'הרכב המשתתפים',
            rideInfoDetailsLabel: 'מידע למטיילים',
            rideInfoDetailsPlaceholder: 'בחרנו לטייל בהולנד כי...\nבחרנו לנחות בנמל התעופה סכיפהול כי...\nהתניידנו במהלך הטיול עם רכב שכור.\nמומלץ להביא בגדים חמים ומעילי גשם.\nבנוסף, הנה כמה המלצות שיכולות לשדרג את החוויה שלכם:',
            rideInfoLanguageLabel: 'שפת הטיול',
            rideInfoDesignLabel: 'עיצוב דף הטיול',
            rideInfoDesignClassic: 'קלאסי',
            rideInfoDesignClassicText: 'רשימת ימים ולינות, כמו היום',
            rideInfoDesignPoster: 'פוסטר',
            rideInfoDesignPosterText: 'ציר זמן עם תמונה גדולה לכל עצירה',
            rideInfoPhysicalDisabilitiesLabel: 'מתאים גם לאנשים עם מוגבלויות',
            rideInfoMoreInfo: 'מידע נוסף',
            rideInfoTopPageImageLabel: 'תמונת רקע לעמוד הטיול (ראש העמוד)',
            rideInfoTopPageImageAlt: 'תמונת רקע של הטיול',
            rideInfoReplaceTopImage: 'החלף תמונת רקע',
            rideInfoUploadTopImage: 'העלה תמונת רקע',
            rideInfoUploading: 'מעלה...',
            rideInfoCoverImageLabel: 'תמונת שער לשיתוף (WhatsApp / Facebook)',
            rideInfoCoverImagePreparing: 'מכין את תמונת השיתוף...',
            rideInfoCoverImageUpload: 'העלו תמונה משלכם',
            rideInfoCoverImageReplace: 'החליפו את התמונה',
            rideInfoCoverImageGuidance: 'מומלץ: תמונה לרוחב בגודל 1200×630 פיקסלים לפחות. תמונות גדולות יוקטנו אוטומטית ל‑1200 פיקסלים רוחב ולפחות מ‑300KB, כדי שיוצגו יפה ב‑WhatsApp ובפייסבוק. הגודל המינימלי הוא 200×200 פיקסלים.',
            rideInfoMediaLabel: 'וידאו / אודיו לטיול',
            rideInfoMediaHint: 'יוצג בראש עמוד הטיול, מיד אחרי הטקסט עליך ולפני פרטי הטיול.',
            rideInfoCoverImageTooSmall: 'התמונה קטנה מדי כדי להופיע בשיתוף ברשתות החברתיות',
            rideInfoCoverImageFailed: 'לא הצלחנו להכין את תמונת השיתוף. נסו תמונה אחרת.',
            rideInfoLockRideLabel: 'נעל את הטיול (מונע ממך לבצע שינויים)',
            rideInfoSaveAndContinue: 'שמור והמשך להוספת מקומות לינה',
            rideInfoSave: 'שמירה',
            rideInfoBackWithoutSave: 'חזרה לטיול ללא שמירה',
            rideInfoContinue: 'המשך',
            rideInfoTopImageHelp: 'ניתן להעלות תמונת רקע שתופיע בחלק העליון של העמוד.<br><br>גודל מומלץ: ‎1600×140 פיקסלים.<br><br>במסכים קטנים, כמו טלפונים ניידים, יוצג רק החלק המרכזי של התמונה.<br><br>הטקסט שיופיע מעל התמונה יוצג בצבע לבן ובמרכז המסך. מומלץ לבחור תמונה עם רקע כהה יחסית במרכז, כדי לשמור על קריאות טובה של הטקסט.<br><br>לא מומלץ לשלב טקסט בתוך התמונה, מאחר שחלקים ממנה עלולים להיחתך במסכים קטנים.<br><br>לאחר העלאת התמונה מומלץ לבדוק כיצד היא נראית גם במחשב וגם בטלפון, כדי לוודא שהתוצאה מוצגת בצורה מיטבית בכל המכשירים.',
            rideInfoWaitForUpload: 'אנא המתן לסיום העלאת תמונת הרקע לפני שמירת פרטי הטיול.',
            rideInfoUploadError: 'שגיאה בהעלאת התמונה. אנא נסה שוב.',
            rideInfoTitleRequired: 'אנא הזינו כותרת לטיול.',
            rideInfoDateRangeRequired: 'אנא בחרו טווח תאריכים מלא (תאריך התחלה וסיום).',
            rideInfoDateRangeMax60Days: 'טווח התאריכים חייב להיות קצר מ-60 ימים.',

            // InsertLinkToTextbox
            insertLinkAddLinkButton: 'הוספת קישור בתיאור',
            insertLinkTextPlaceholder: 'הטקסט שיוצג',
            insertLinkUrlPlaceholder: 'הכתובת: https://google.com',
            insertLinkInsertButton: 'הכנסת הלינק במיקום של הסמן בתיאור',

            // EditRideAccessKey page
            editRideAccessBannerTitle: 'פרטי הגישה למסלול הפרטי',
            editRideAccessBannerParagraph: 'ניתן להעתיק את הקישור ולשלוח ללקוח',
            editRideAccessAllowEditLabel: 'לאפשר למשתמשים לערוך את הטיול שלהם',
            editRideAccessRegistrationLinkLabel: 'לינק הרשמה למסלול',
            editRideAccessLinkBlockedWarning: 'לינק ההרשמה חסום - משתמשים חדשים אינם יכולים להצטרף.',
            editRideAccessRestoreLinkButton: 'הפעלת הלינק מחדש',
            editRideAccessCopyLinkButton: 'העתקת הקישור',
            editRideAccessSingleUseLinkButton: 'יצירת לינק חד פעמי',
            editRideAccessRedirectLabel: 'כתובת להפניית לקוח לא מורשה',
            editRideAccessRedirectPlaceholder: 'לדוגמה: https://my_website.co.il',
            editRideAccessAuthorizedUsersLabel: 'מספר המשתמשים המורשים',
            editRideAccessAuthorizedUsersHint: '0 - כמות משתמשים לא מוגבלת',
            editRideAccessAllowSaleLabel: 'לאפשר מכירה דרך החנות האישית',
            editRideAccessSaveButton: 'שמירה',
            editRideAccessBackWithoutSave: 'חזרה לטיול ללא שמירה',
            editRideAccessCopySuccessTitle: 'העתקת קישור',
            editRideAccessCopySuccessMessage: 'הקישור הועתק בהצלחה!',
            editRideAccessCopyErrorTitle: 'שגיאה',
            editRideAccessCopyErrorMessage: 'שגיאה בהעתקת הקישור',
            editRideAccessAllowSaleHelp: 'כאשר האפשרות מסומנת, ה-API יוכל למכור את המסלול דרך החנות הפרטית שלך.<br>כדי למכור בפועל, עליך לפתוח חנות ולהוסיף אליה את המסלול.<br>אין לכם חנות? פנו אל הנהלת האתר ונקים לכם אחת.',
            editRideAccessEditRideHelp: 'כאשר אפשרות זו פעילה, הלקוח יכול לערוך את המסלול שקיבל מכם, כולל הוספה של כל הפעילויות והאטרקציות שנמצאות במערכת האישית שלכם.<br><br>שימו לב: לאחר הפעלת האפשרות, הלקוח רואה את כל רשימת הפעילויות שלכם ויכול להוסיף מהן למסלול שלו.<br><br>בנוסף, מרגע שהאפשרות מופעלת רק הלקוח יכול לבצע שינויים במסלול, ואתם לא תוכלו לעדכן אותו בעצמכם.',
            editRideAccessPrepaidApproveShareTitle: 'אישור שליחת המסלול',
            editRideAccessPrepaidTripDaysLine: `המסלול כולל ${params.count} ימים`,
            editRideAccessPrepaidShareCostLine: `עלות השיתוף: ${params.amount}`,
            editRideAccessPrepaidPerDayLine: `(${params.price} ליום)`,
            editRideAccessPrepaidFirstShareLine1: '🟢 שיתוף המסלול הראשון עלינו',
            editRideAccessPrepaidFirstShareLine2: 'כדי שתוכלו להכיר את המערכת בצורה מלאה',
            editRideAccessPrepaidInsufficientBalance: 'אין מספיק יתרה בחשבון כדי להשלים את הפעולה',
            editRideAccessPrepaidContinueTermsButton: 'המשך לאישור תנאי השימוש',
            editRideAccessPrepaidApproveShareButton: 'אישור שיתוף המסלול',
            editRideAccessPrepaidCancelButton: 'ביטול',
            editRideAccessPrepaidTopUpButton: 'הגדרת אמצעי תשלום',
            editRideAccessPrepaidTopUpButtonSub: 'כדי להמשיך לשתף מסלולים, יש להגדיר אמצעי תשלום.',
            editRideAccessPrepaidWhatsAppButton: 'דברו איתנו בוואטסאפ',
            editRideAccessSaveCardBannerTitle: 'שיתוף ראשון הושלם!',
            editRideAccessSaveCardBannerText: 'כדי להמשיך לשתף מסלולים בעתיד, יש להוסיף פרטי כרטיס אשראי לחיוב חודשי.',
            editRideAccessOpenWhatsAppSupportMessage: 'היי, התחלתי להשתמש ב-TripPlanner וסיימתי את הקרדיט הראשוני.\nאשמח להמשיך לעבוד עם המערכת ולפתוח את החשבון לשימוש נוסף.',
            rideConnectedUsersTitle: 'משתמשים מחוברים',
            rideConnectedUsersEmail: 'אימייל',
            rideConnectedUsersAuthMethod: 'שיטת התחברות',
            rideConnectedUsersConnectedAt: 'תאריך חיבור',
            rideConnectedUsersAuthGoogle: 'Google',
            rideConnectedUsersAuthEmail: 'אימייל וסיסמה',
            rideConnectedUsersAuthWhatsapp: 'וואטסאפ',
            rideConnectedUsersRevokeBtn: 'בטל גישה',
            rideConnectedUsersResetPasswordBtn: 'איפוס סיסמה',
            rideConnectedUsersResetPasswordTooltip: 'שליחת מייל לאיפוס סיסמה למשתמש',
            rideConnectedUsersRevokeSuccess: 'הגישה בוטלה',
            rideConnectedUsersResetPasswordSuccess: 'אימייל לאיפוס סיסמה נשלח',
            rideConnectedUsersEmpty: 'אין משתמשים מחוברים עדיין',
            sharedRideWarningTitle: 'הטיול הזה כבר נשלח ללקוחות',
            sharedRideWarningSentTo: 'נשלח אל:',
            sharedRideWarningMore: 'ועוד',
            sharedRideWarningBody: 'כל שינוי כאן ישנה גם את הטיול שלהם. האם השינוי הוא עבור אותו לקוח?',
            sharedRideWarningSameCustomer: 'אותו לקוח - להמשיך לערוך',
            sharedRideWarningNewCustomer: 'לקוח חדש - לשכפל את הטיול',
            rideConnectedUsersBlockBtn: 'חסימת משתמש',
            blockedAccessTitle: 'הגישה למסלול נחסמה',
            blockedAccessBody: 'כדי לשחרר את הגישה, יש לפנות למי שסיפק לך את המסלול.',
            blockedAccessButton: 'חזרה לאתר',

            rideConnectedUsersBlockedBadge: 'חסום',
            rideConnectedUsersRestoreBtn: 'שחרר חסימה',
            rideConnectedUsersBlockModalTitle: 'חסימת גישה למשתמש',
            rideConnectedUsersBlockModalBody: 'האם לחסום את גישת המשתמש למסלול?',
            rideConnectedUsersBlockModalLinkCheckbox: 'חסום גם את קישור ההרשמה (ימנע מכל משתמש חדש להצטרף)',
            rideConnectedUsersBlockModalBillingNote: 'שינויים אלו אינם משפיעים על החיוב',

            rideCopiedUsersTitle: 'משתמשים עם אפשרות עריכה למסלול',
            rideCopiedUsersLoadBtn: 'טען רשימת משתמשים',
            rideCopiedUsersEmpty: 'אין משתמשים שהורידו את המסלול עדיין',
            rideCopiedUsersAuthGoogle: 'Google',
            rideCopiedUsersAuthEmail: 'אימייל וסיסמה',
            rideCopiedUsersResetPasswordBtn: 'איפוס סיסמה',
            rideCopiedUsersResetPasswordTooltip: 'שליחת מייל לאיפוס סיסמה למשתמש',
            rideCopiedUsersResetPasswordSuccess: 'אימייל לאיפוס סיסמה נשלח',
            rideConnectedUsersBlockModalConfirmBtn: 'כן, חסום',
            rideConnectedUsersBlockModalCancelBtn: 'ביטול',
            rideConnectedUsersBlockSuccess: 'המשתמש נחסם',
            rideConnectedUsersRestoreSuccess: 'הגישה שוחזרה',

            // MonthlyBillingCardSetup
            monthlyCardSetupIntro1: 'לצורך המשך שימוש במערכת ושיתוף טיולים נוספים, נדרש לשמור כרטיס אשראי לחיוב חודשי.',
            monthlyCardSetupIntro2: 'החיוב יתבצע בהתאם להיקף השימוש החודשי בלבד.',
            monthlyCardSetupTitle: 'הגדרת חיוב חודשי',
            monthlyCardSetupHint: `לצורכי אימות ואבטחת תשלום, ייתכן חיוב סמלי של ${params.amount}`,
            monthlyCardSetupSavedMessage: 'הכרטיס נשמר בהצלחה.',
            monthlyCardSetupBackToRide: 'חזרה למסלול',
            monthlyCardSetupBack: 'חזרה',
            monthlyCardSetupNotLoggedIn: 'כדי להגדיר כרטיס אשראי יש להתחבר תחילה.',
            monthlyCardSetupNotManager: 'המשתמש המחובר אינו מנהל מסלולים. יש להתנתק ולהתחבר עם משתמש מנהל המסלולים.',
            monthlyCardSetupLabelName: 'שם מלא לחשבונית',
            monthlyCardSetupLabelPhone: 'טלפון',
            monthlyCardSetupLabelCard: 'מספר כרטיס',
            monthlyCardSetupLabelExpM: 'חודש',
            monthlyCardSetupLabelExpY: 'שנה',
            monthlyCardSetupLabelCitizen: 'תעודת זהות',
            monthlyCardSetupUnsupportedAmex: 'אנחנו לא עובדים עם American Express. אנא השתמש בכרטיס Visa או Mastercard.',
            monthlyCardSetupUnsupportedDiners: 'אנחנו לא עובדים עם Diners. אנא השתמש בכרטיס Visa או Mastercard.',
            monthlyCardSetupSubmit: 'שמור כרטיס',
            monthlyCardSetupProcessing: 'מעבד…',
            monthlyCardSetupMissingSumit: 'חסרות הגדרות SUMIT בצד הלקוח (VUE_APP).',
            monthlyCardSetupSecurePayment: 'תשלום מאובטח',
            monthlyCardSetupErrorLoad: 'שגיאה בטעינה',
            monthlyCardSetupErrorSumitLoad: 'טעינת SUMIT נכשלה',
            monthlyCardSetupErrorToken: 'אסימון תשלום נכשל',
            monthlyCardSetupErrorMissingToken: 'חסר אסימון',
            monthlyCardSetupErrorName: 'הזן שם',
            monthlyCardSetupErrorPhone: 'טלפון לא תקין',
            monthlyCardSetupErrorFailed: 'נכשל',
            monthlyCardSetupErrorRequest: 'בקשה נכשלה',
            monthlyCardSetupUpdateCard: 'עדכן כרטיס',
            monthlyCardSetupSaveNewCard: 'שמור כרטיס חדש',

            // ResetRideModal
            resetRideModalButton: '⚠️ איפוס טיול',
            resetRideModalTitle: 'איפוס טיול לגרסה המקורית',
            resetRideModalConfirm: 'איפוס',
            resetRideModalCancel: 'ביטול',
            resetRideModalWarningQuestion: 'האם אתם בטוחים שברצונכם לאפס את הטיול לגרסה המקורית?',
            resetRideModalDescriptionLine1: 'פעולה זו תחזיר את הטיול למצבו המקורי לפני השינויים שביצעתם.',
            resetRideModalDescriptionLine2Strong: 'כל השינויים שביצעתם יאבדו!',
            resetRideModalIrreversible: 'פעולה זו אינה ניתנת לביטול.',

            // GeneratOneTimeAccessKey page
            generateOneTimeAccessBannerTitle: 'פרטי הגישה למסלול הפרטי',
            generateOneTimeAccessBannerParagraph: 'ניתן להעתיק את הקישור ולשלוח ללקוח',
            generateOneTimeAccessRecipientDetailsLabel: 'הכניסו את פרטי מקבל הגישה',
            generateOneTimeAccessCreateLinkButton: 'יצירת קישור חד פעמי',
            generateOneTimeAccessSingleUserLinkLabel: 'לינק הרשמה למסלול למשתמש אחד',
            generateOneTimeAccessCopyLinkButton: 'העתקת הקישור',
            generateOneTimeAccessBackToTripButton: 'חזרה לטיול',
            generateOneTimeAccessCopySuccessTitle: 'העתקת קישור',
            generateOneTimeAccessCopySuccessMessage: 'הקישור הועתק בהצלחה!',
            generateOneTimeAccessCopyErrorTitle: 'שגיאה',
            generateOneTimeAccessCopyErrorMessage: 'שגיאה בהעתקת הקישור',

            // TripCalendarView
            tripCalendarDragAttractions: 'ניתן לגרור אטרקציות מיום ליום',
            tripCalendarClickDayAddActivities: 'לחיצה על יום תאפשר להוסיף פעילויות',
            tripCalendarClickClockSetTime: 'לחיצה על השעון לקביעת השעה',
            tripCalendarBooked: 'מוזמן',
            tripCalendarNotBooked: 'לא מוזמן',

            // DayManagerOptions
            dayManagerTitle: 'ניהול יום',
            dayManagerAddAttraction: 'הוספת פעילות',
            dayManagerAddAccommodation: 'הוספת לינה',
            dayManagerAddDayAfter: 'הוסף יום אחרי',
            dayManagerDeleteDay: 'מחק יום',

            // AreYouShureRemovingDay modal
            removeDayTitle: 'בטוחים?',
            removeDayMessage: 'פעולה זו תמחוק את היום מהטיול שלכם. האם תרצו גם למחוק את כל הפעילויות של אותו היום?',
            removeDayAndAttractionsButton: 'כן, למחוק את היום ואת כל הפעילויות',
            removeDayOnlyButton: 'לא, להעביר את הפעילויות ליום הבא',
            removeDayCancelButton: 'ביטול',

            // AreYouShureRemovingAttraction modal
            removeAttractionTitle: 'בטוחים?',
            removeAttractionMessage: 'פעולה זו תמחוק את הפעילות מהטיול שלכם!',
            removeAttractionDeleteButton: 'מחיקה',
            removeAttractionCancelButton: 'ביטול',

            // UpdateAttractionTime modal
            updateAttractionTitle: 'בחרו יום ושעה חדשים לפעילות:',
            updateAttractionDayLabel: 'יום:',
            updateAttractionTimeLabel: 'שעה:',
            updateAttractionSaveButton: 'שמירה',

            // DynamicModal popups (errorNumberConverter) - Hebrew
            popup_1_text: 'זה עבד',
            popup_1_subText: 'יופי תמשיכו',
            popup_1_action: 'ננסה שוב',

            popup_2_text: 'מצטערים',
            popup_2_subText: 'משהו לא עבד טוב - נטפל בזה',
            popup_2_action: 'ננסה שוב',

            popup_3_text: 'המשתמש לא רשום אצלינו במערכת',
            popup_3_subText: 'אתם בטוחים שנרשמתם?',
            popup_3_action: 'ננסה שוב',

            popup_4_text: 'סיסמא שגויה',
            popup_4_subText: 'גם לי זה קורה מידי פעם',
            popup_4_action: 'ננסה שוב',

            popup_5_text: 'אתם כבר רשומים אצלינו באתר',
            popup_5_subText: 'גם לי זה קורה מידי פעם',
            popup_5_action: 'ננסה שוב',

            popup_userLoggedInSuccessfully_text: 'התחברתם בהצלחה',
            popup_userLoggedInSuccessfully_subText: 'עכשיו תוכלו להתחיל להשתמש במערכת ולעבוד עם המסלולים.',
            popup_userLoggedInSuccessfully_action: 'המשך',

            popup_userRegisteredSuccessfully_text: 'נרשמתם בהצלחה',
            popup_userRegisteredSuccessfully_subText: 'אתם מחוברים, אפשר להתחיל!',
            popup_userRegisteredSuccessfully_action: 'המשך',

            popup_startInsertRideLoginRequired_text: 'כדי להמשיך מנקודה זו יש להירשם למערכת',
            popup_startInsertRideLoginRequired_subText: 'אנא התחברו או הירשמו כדי ליצור מסלול.',
            popup_startInsertRideLoginRequired_action: 'התחברות או הרשמה',
            popup_pleaseLogInToEditRide_title: 'כדי שהמידע לא יאבד',
            popup_pleaseLogInToEditRide_subText: 'אנא הרשמו',
            popup_pleaseLogInToEditRide_action: 'הרשמה',

            popup_rideHaveOrderedAccommodation_text: 'אופס, יש לכם הזמנה של לינה',
            popup_rideHaveOrderedAccommodation_subText: 'לא ניתן לערוך את הימים לאחר הכנסה של פרטי לינה, ניתן למחוק את פרטי הלינה ואז לערוך.',
            popup_rideHaveOrderedAccommodation_action: 'סגירה',

            popup_fail_to_update_accommodation_text: 'אופס, משהו השתבש בעדכון',
            popup_fail_to_update_accommodation_subText: 'תבדקו בבקשה שהכול עודכן כמו שצריך או צרו איתנו קשר לתיקון.',
            popup_fail_to_update_accommodation_action: 'סגירה',

            popup_fail_to_update_attraction_text: 'אופס, משהו השתבש בעדכון הפעילות',
            popup_fail_to_update_attraction_subText: 'תבדקו בבקשה שהכול עודכן כמו שצריך או צרו איתנו קשר לתיקון.',
            popup_fail_to_update_attraction_action: 'סגירה',
            popup_fail_to_update_ride_text_text: 'לא הצלחנו לעדכן את תיאור הטיול',
            popup_fail_to_update_ride_text_subText: 'ייתכן שאין לך הרשאה לערוך את הטיול הזה. אפשר לנסות שוב או לערוך את התיאור במסך פרטי הטיול.',
            popup_fail_to_update_ride_text_action: 'סגירה',
            popup_fail_to_update_ride_title_text: 'לא הצלחנו לעדכן את שם הטיול',
            popup_fail_to_update_ride_title_subText: 'ייתכן שאין לך הרשאה לערוך את הטיול הזה. אפשר לנסות שוב או לשנות את השם במסך פרטי הטיול.',
            popup_fail_to_update_ride_title_action: 'סגירה',
            popup_invalid_title_text: 'שם הטיול לא יכול להישאר ריק',
            popup_invalid_title_subText: 'לא נמצא שם שאפשר לשמור, ולכן שום שינוי לא נשמר. בקשו מה-AI שם אחר, או כתבו אותו במסך פרטי הטיול.',
            popup_invalid_title_action: 'סגירה',
            popup_title_too_long_text: 'שם הטיול ארוך מדי',
            popup_title_too_long_subText: 'שם הטיול מוגבל ל-140 תווים, ולכן שום שינוי לא נשמר. בקשו מה-AI שם קצר יותר.',
            popup_title_too_long_action: 'סגירה',
            popup_fail_to_update_ride_language_text: 'לא הצלחנו לעדכן את שפת הטיול',
            popup_fail_to_update_ride_language_subText: 'ייתכן שאין לך הרשאה לערוך את הטיול הזה. אפשר לנסות שוב או לשנות את השפה במסך פרטי הטיול.',
            popup_fail_to_update_ride_language_action: 'סגירה',
            popup_invalid_language_text: 'לא נמצאה שפה לשמירה',
            popup_invalid_language_subText: 'לא התקבלה שפה שאפשר לשמור, ולכן שום שינוי לא נשמר. בחרו את השפה במסך פרטי הטיול.',
            popup_invalid_language_action: 'סגירה',
            popup_unknown_language_text: 'השפה הזו לא נתמכת',
            popup_unknown_language_subText: 'זו לא אחת השפות שאפשר לבחור לטיול, ולכן שום שינוי לא נשמר. בקשו מה-AI שפה אחרת או בחרו אותה במסך פרטי הטיול.',
            popup_unknown_language_action: 'סגירה',
            popup_invalid_text_text: 'לא שמרנו כלום',
            popup_invalid_text_subText: 'בתיאור הטיול לא נמצא טקסט שאפשר לשמור, ולכן שום שינוי לא נשמר - לא התיאור וגם לא שאר הפרטים שבטופס. כתבו את התיאור ונסו לשמור שוב.',
            popup_invalid_text_action: 'סגירה',

            popup_user_is_not_authorized_text: 'אופס, למשתמש אין הרשאה לעשות את זה',
            popup_user_is_not_authorized_subText: 'התנתקו בבקשה והתחברו שוב, זה אמור לעזור.',
            popup_user_is_not_authorized_action: 'סגירה',

            popup_error_no_access_to_attraction_text: 'אין לך גישה לאטרקציה זו',
            popup_error_no_access_to_attraction_subText: 'אנא בדקו שיש לכם הרשאות מתאימות או צרו קשר עם בעל הטיול.',
            popup_error_no_access_to_attraction_action: 'סגירה',

            popup_date_are_not_in_range_text: 'אופס, התאריכים לא תואמים לטיול',
            popup_date_are_not_in_range_subText: 'נסו לתקן בבקשה.',
            popup_date_are_not_in_range_action: 'סגירה',

            popup_you_Are_having_double_booking_text: 'אופס, יש כבר הזמנה על חלק מהימים',
            popup_you_Are_having_double_booking_subText: 'נסו לתקן בבקשה.',
            popup_you_Are_having_double_booking_action: 'סגירה',

            popup_uesr_is_not_authorize_to_edit_this_ride_text: 'אין לכם אפשרות לערוך את הטיול הזה',
            popup_uesr_is_not_authorize_to_edit_this_ride_subText: 'בחרו בכפתור "ערוך את הטיול" ונסו שוב.',
            popup_uesr_is_not_authorize_to_edit_this_ride_action: 'סגירה',

            popup_scroll_down_to_see_the_added_day_text: 'הוספתם יום לטיול',
            popup_scroll_down_to_see_the_added_day_subText: 'צריך לרדת קצת בעמוד כדי לראות אותו.',
            popup_scroll_down_to_see_the_added_day_action: 'סגירה',

            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_text: 'מחקתם יום מהטיול',
            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_subText: 'כל הפעילויות של אותו היום עברו ליום אחד אחרי, ניתן להוריד אותן אם רוצים.',
            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_action: 'סגירה',

            popup_uesr_is_adding_new_ride_text: 'איזה כיף שבחרתם לשתף',
            popup_uesr_is_adding_new_ride_subText: 'בואו נתחיל בהכנסת פרטים כלליים של הטיול.',
            popup_uesr_is_adding_new_ride_action: 'סגירה',

            popup_uesr_copyed_new_ride_text: 'איזה כיף שזה הטיול שבחרתם',
            popup_uesr_copyed_new_ride_subText: 'חשוב לעדכן את תאריך תחילת הטיול, ומיד אחרי תוכלו לעדכן את הטיול לפי הצרכים שלכם.',
            popup_uesr_copyed_new_ride_action: 'סגירה',

            popup_ride_reset_success_text: 'הטיול אופס בהצלחה',
            popup_ride_reset_success_subText: 'הטיול הוחזר למצבו המקורי לפני השינויים שביצעתם.',
            popup_ride_reset_success_action: 'סגירה',

            popup_ride_reset_error_text: 'שגיאה באיפוס הטיול',
            popup_ride_reset_error_subText: 'מצטערים, לא הצלחנו לאפס את הטיול. אנא נסו שנית או פנו לתמיכה.',
            popup_ride_reset_error_action: 'סגירה',

            popup_please_use_auto_compleate_text: 'השתמשו באפשרויות של המילוי האוטומטי',
            popup_please_use_auto_compleate_subText: 'בחרו את אחת האפשרויות.',
            popup_please_use_auto_compleate_action: 'סגירה',

            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_text: 'עדיין אין לנו טיול לאזור הזה',
            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_subText: 'אנחנו נשמח אם תוסיפו אותו כשתחזרו.',
            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_action: 'סגירה',

            popup_updating_the_ride_text: 'מעלה נתונים',
            popup_updating_the_ride_subText: 'אנחנו מעדכנים את הטיול שלכם.',
            popup_updating_the_ride_action: 'סגירה',

            popup_user_guide_for_editing_text: 'ידעתם שאפשר להעתיק את הטיול הזה ולערוך אותו?',
            popup_user_guide_for_editing_subText: 'אפשר להוסיף פעילויות מטיולים שמשפחות אחרות עשו באותו אזור!',
            popup_user_guide_for_editing_action: 'סגירה',

            popup_new_ride_detailes_form_text: 'יצרנו דרך נוספת וממש פשוטה להעלות טיול',
            popup_new_ride_detailes_form_subText: 'תרצו שניצור אתכם קשר להסבר?',
            popup_new_ride_detailes_form_action: 'כן',

            popup_account_exists_with_different_credential_text: 'המייל כבר רשום עם חיבור ממקור אחר',
            popup_account_exists_with_different_credential_subText: 'התחברות בעזרת המערכת שנרשמתם בפעם הראשונה.',
            popup_account_exists_with_different_credential_action: 'ננסה שוב',

            popup_email_is_not_baind_to_this_acount_text: 'אין מייל משויך לחשבון זה',
            popup_email_is_not_baind_to_this_acount_subText: 'לא ניתן להתחבר ללא מייל שמשויך לחשבון.',
            popup_email_is_not_baind_to_this_acount_action: 'ננסה שוב',

            popup_connect_me_for_adding_new_ride_text: 'כדי לקבל אפשרות לשתף את הטיול שעשיתם באתר',
            popup_connect_me_for_adding_new_ride_subText: 'יש ליצור איתנו קשר ב-052-686-7915.',
            popup_connect_me_for_adding_new_ride_action: 'סגירה',

            popup_upload_trip_adding_text_stage_text: 'יש!! העלינו את המסלול',
            popup_upload_trip_adding_text_stage_subText: 'בשלב הזה אפשר לרשום את השם שנרצה לחופשה וקצת דברים כלליים על החופשה.',
            popup_upload_trip_adding_text_stage_action: 'סגירה',

            popup_all_images_dates_are_empty_text: 'כל התמונות לא מכילות מידע על זמן הצילום',
            popup_all_images_dates_are_empty_subText: 'כדי שזה יעבוד צריך להשתמש בתמונות האמיתיות מהטלפון שצילם אותן.',
            popup_all_images_dates_are_empty_action: 'סגירה',

            popup_limiting_the_trip_duration_text: 'אורך המסלול מוגבל ל-60 יום',
            popup_limiting_the_trip_duration_subText: 'נא להעלות טיול של עד 60 יום.',
            popup_limiting_the_trip_duration_action: 'סגירה',

            popup_all_images_without_metadata_text: 'אין נתונים מהתמונות',
            popup_all_images_without_metadata_subText: 'כרגע אנו לא תומכים בתמונות שלא צולמו מהמכשיר שממנו מעלים את התמונות.',
            popup_all_images_without_metadata_action: 'סגירה',

            popup_waiting_to_get_image_info_text: 'אני מבצע עיבוד על התמונות כדי להבין איפה הן צולמו',
            popup_waiting_to_get_image_info_subText: 'זה יכול לקחת עד 30 שניות.',
            popup_waiting_to_get_image_info_action: '',

            popup_waiting_to_get_image_info_without_gps_information_text: 'אני מבצע עיבוד על התמונות כדי להבין איפה הן צולמו',
            popup_waiting_to_get_image_info_without_gps_information_subText: 'התהליך עשוי להימשך עד 30 שניות. מאחר ובתמונות שהועלו אין נתוני מיקום, זיהוי המיקום עשוי לקחת זמן רב יותר.',
            popup_waiting_to_get_image_info_without_gps_information_action: '',

            popup_api_call_failed_text: 'אירעה תקלה בתהליך הניתוח',
            popup_api_call_failed_subText: 'אנא נסו שוב מאוחר יותר. אם הבעיה נמשכת, ניתן לפנות לתמיכה בטלפון: 052-6867915.',
            popup_api_call_failed_action: '',

            popup_plese_add_the_activity_info_text: 'יש לנו טיול מוכן! עכשיו זה הזמן לתת את הטיפים למקומות',
            popup_plese_add_the_activity_info_subText: 'אתם יכולים כרגע לעבור על כל האטרקציות ולתת את הטיפים שלכם כדי לעזור למשפחות שיטיילו שם למקסם את החוויה שלהם מהמקום.',
            popup_plese_add_the_activity_info_action: 'סגירה',

            popup_plese_add_the_accommodation_dates_text: 'יש להכניס את הימים שישנתם באותו המקום',
            popup_plese_add_the_accommodation_dates_subText: 'כדי לאפשר לאחרים לדעת כמה לילות להזמין למקום זה, יש להכניס את תאריך הכניסה והיציאה ממקום לינה זה.',
            popup_plese_add_the_accommodation_dates_action: 'סגירה',

            popup_not_supporting_FB_or_instagram_browsers_text: 'לא ניתן להתחבר דרך G‑Mail בדפדפן זה',
            popup_not_supporting_FB_or_instagram_browsers_subText: 'נראה שאתם משתמשים בדפדפן של Facebook או Instagram. נא לפתוח בדפדפן רגיל כמו Safari או Chrome.',
            popup_not_supporting_FB_or_instagram_browsers_action: 'סגירה',

            popup_fail_to_add_user_to_ride_privacy_text: 'משהו השתבש בעדכון ההרשאות',
            popup_fail_to_add_user_to_ride_privacy_subText: 'אנא בדקו שהכול עודכן כהלכה. אם הבעיה נמשכת, צרו איתנו קשר ונשמח לעזור בתיקון.',
            popup_fail_to_add_user_to_ride_privacy_action: 'סגירה',

            popup_this_user_is_alrady_assign_to_this_ride_text: 'המשתמש כבר רשום לטיול זה',
            popup_this_user_is_alrady_assign_to_this_ride_subText: 'אין צורך להשתמש בלינק הנוכחי. העתקו את הלינק שמופיע בעמוד זה.',
            popup_this_user_is_alrady_assign_to_this_ride_action: 'סגירה',

            popup_user_does_not_have_permission_to_this_private_ride_text: 'מסלול זה מוגבל למשתמשים מורשים בלבד.',
            popup_user_does_not_have_permission_to_this_private_ride_subText: 'נא להירשם או להתחבר כדי לגשת למסלול זה.',
            popup_user_does_not_have_permission_to_this_private_ride_action: 'התחברות או הרשמה',

            popup_blocked_text: 'הגישה למסלול נחסמה',
            popup_blocked_subText: 'כדי לשחרר את הגישה, יש לפנות למי שסיפק לך את המסלול.',
            popup_blocked_action: 'סגירה',

            popup_ride_link_activated_text: 'הלינק הופעל מחדש',
            popup_ride_link_activated_subText: 'משתמשים חדשים יכולים כעת להצטרף דרך הלינק.',
            popup_ride_link_activated_action: 'סגירה',

            popup_key_is_not_exsist_text: 'הלינק שהוזן אינו תקין',
            popup_key_is_not_exsist_subText: 'אנא פנו למי שסיפק לכם את הלינק כדי לקבל קישור תקין.',
            popup_key_is_not_exsist_action: 'סגירה',

            popup_the_private_link_is_not_valide_text: 'הלינק שהוזן אינו תקין',
            popup_the_private_link_is_not_valide_subText: 'אנא פנו למי שסיפק לכם את הלינק כדי לקבל קישור תקין.',
            popup_the_private_link_is_not_valide_action: 'סגירה',

            popup_ritch_to_ride_limitation_text: 'הלינק הגיע למכסת משתמשים',
            popup_ritch_to_ride_limitation_subText: 'אנא פנו אל מי שסיפק לכם את הקישור כדי להגדיל את מכסת המשתמשים.',
            popup_ritch_to_ride_limitation_action: 'סגירה',

            popup_error_ride_is_not_from_subdomain_text: 'לא ניתן להעתיק את הטיול',
            popup_error_ride_is_not_from_subdomain_subText: 'הטיול שייך לקבוצה אחרת. פנו למי שסיפק לכם את הקישור.',
            popup_error_ride_is_not_from_subdomain_action: 'סגירה',

            popup_error_ride_is_not_from_the_right_user_text: 'לא ניתן להעתיק את הטיול',
            popup_error_ride_is_not_from_the_right_user_subText: 'בעלי הטיול אינם שייכים לקבוצה. יש לפנות למי שסיפק לך את הקישור.',
            popup_error_ride_is_not_from_the_right_user_action: 'סגירה',

            popup_atraction_text_box_is_not_empty_text: 'אסור לי למחוק מידע שכבר הכנסתם',
            popup_atraction_text_box_is_not_empty_subText: "נא לרוקן את הטקסט שבתיבת 'תיאור האטרקציה' ולנסות שוב.",
            popup_atraction_text_box_is_not_empty_action: 'סגירה',

            popup_the_day_and_its_activities_were_deleted_text: 'מחקתם יום ואת כל הפעילויות שבו',
            popup_the_day_and_its_activities_were_deleted_subText: 'היום וכל הפעילויות שלו הוסרו מהטיול בהצלחה.',
            popup_the_day_and_its_activities_were_deleted_action: 'סגירה',

            popup_day_activities_moved_successfully_text: 'העברתם את כל הפעילויות של היום',
            popup_day_activities_moved_successfully_subText: 'הפעילויות הועברו בהצלחה ליום שבחרתם.',
            popup_day_activities_moved_successfully_action: 'סגירה',

            popup_invalid_email_spaces_text: 'כתובת המייל לא תקינה',
            popup_invalid_email_spaces_subText: 'כתובת המייל לא יכולה להכיל רווחים.',
            popup_invalid_email_spaces_action: 'ננסה שוב',

            popup_invalid_email_format_text: 'כתובת המייל לא תקינה',
            popup_invalid_email_format_subText: 'אנא הכניסו כתובת מייל חוקית.',
            popup_invalid_email_format_action: 'ננסה שוב',

            popup_day_not_in_trip_range_text: 'אופס, יום זה לא חלק מהטיול',
            popup_day_not_in_trip_range_subText: 'בחרו יום בטווח התאריכים של הטיול.',
            popup_day_not_in_trip_range_action: 'סגירה',
            popup_fail_to_update_day_note_text: 'לא הצלחנו לעדכן את הערת היום',
            popup_fail_to_update_day_note_subText: 'ייתכן שההערה כבר שונתה או שאין לך הרשאה לערוך אותה. נסו שוב מתוך מסך היום.',
            popup_fail_to_update_day_note_action: 'סגירה',
            popup_fail_to_update_ride_note_text: 'לא הצלחנו לעדכן את המידע הכללי של הטיול',
            popup_fail_to_update_ride_note_subText: 'ייתכן שהפריט כבר שונה או שאין לך הרשאה לערוך אותו. אפשר לנסות שוב מתוך מסך הטיול.',
            popup_fail_to_update_ride_note_action: 'סגירה',

            popup_unbooked_accommodation_info_text: 'הכניסו את פרטי המלון שלכם עבור הימים הרלוונטיים',
            popup_unbooked_accommodation_info_subText: 'אנא הזינו את פרטי המלונות שהזמנתם, כדי שיופיעו בתוכנית הטיול שלכם.',
            popup_unbooked_accommodation_info_action: 'סגירה',

            popup_password_reset_email_sent_text: 'הוראות לאיפוס הסיסמה נשלחו',
            popup_password_reset_email_sent_subText: 'בדקו את תיבת הדואר האלקטרוני שלכם.',
            popup_password_reset_email_sent_action: 'סגור',

            popup_password_reset_failed_text: 'שגיאה באיפוס הסיסמה',
            popup_password_reset_failed_subText: 'אנא נסו שוב או פנו לתמיכה.',
            popup_password_reset_failed_action: 'סגור',

            popup_password_reset_success_text: 'הסיסמה עודכנה בהצלחה',
            popup_password_reset_success_subText: 'כעת תוכלו להתחבר לחשבונכם דרך הקישור המקורי שקיבלתם.',
            popup_password_reset_success_action: 'הבנתי',

            popup_please_close_tab_text: 'ניתן לסגור את הכרטיסייה',
            popup_please_close_tab_subText: 'הסיסמה עודכנה בהצלחה. אנא סגרו כרטיסייה זו וחזרו לקישור המקורי.',
            popup_please_close_tab_action: 'הבנתי',

            popup_password_too_short_text: 'הסיסמה קצרה מדי',
            popup_password_too_short_subText: 'הסיסמה חייבת להכיל לפחות 6 תווים.',
            popup_password_too_short_action: 'סגור',

            popup_passwords_dont_match_text: 'הסיסמאות אינן תואמות',
            popup_passwords_dont_match_subText: 'אנא ודאו שהזנתם את אותה סיסמה בשני השדות.',
            popup_passwords_dont_match_action: 'סגור',

            popup_password_required_text: 'סיסמה נדרשת',
            popup_password_required_subText: 'אנא הכניסו סיסמה להרשמה.',
            popup_password_required_action: 'סגור',

            popup_invalid_reset_token_text: 'קישור לא תקין',
            popup_invalid_reset_token_subText: 'קישור איפוס הסיסמה אינו תקין או שפג תוקפו.',
            popup_invalid_reset_token_action: 'חזור להתחברות',

            popup_google_oauth_user_text: 'החשבון התחבר דרך חשבון GOOGLE',
            popup_google_oauth_user_subText: 'אנא התחברו דרך חשבון ה-GMAIL שלכם.',
            popup_google_oauth_user_action: 'חזור להתחברות',

            popup_password_reset_failed_user_is_not_registered_text: 'החשבון הזה לא רשום במערכת',
            popup_password_reset_failed_user_is_not_registered_subText: 'יש להתחבר למערכת עם מייל זה.',
            popup_password_reset_failed_user_is_not_registered_action: 'חזור להתחברות',

            popup_pdf_generation_warning_text: '⚠️ יצירת PDF יכולה לקחת עד 3 דקות!',
            popup_pdf_generation_warning_subText: 'אנא המתינו ואל תסגרו את הדפדפן. התהליך יתחיל בעוד רגע.',
            popup_pdf_generation_warning_action: 'הבנתי',

            popup_pdf_generated_successfully_text: 'קובץ ה-PDF נוצר בהצלחה!',
            popup_pdf_generated_successfully_subText: 'הקובץ הורד למכשיר שלכם.',
            popup_pdf_generated_successfully_action: 'סגירה',

            popup_pdf_generation_failed_text: 'שגיאה ביצירת קובץ ה-PDF',
            popup_pdf_generation_failed_subText: 'אנא נסו שוב או פנו לתמיכה.',
            popup_pdf_generation_failed_action: 'סגירה',

            popup_pdf_rate_limited_text: 'יצירת PDF מוגבלת',
            popup_pdf_rate_limited_subText: params.seconds
              ? `ניתן ליצור PDF אחד כל 2 דקות. אפשר לנסות שוב בעוד ${params.seconds} שניות.`
              : 'ניתן ליצור PDF אחד כל 2 דקות. אנא המתן ונסה שוב.',
            popup_pdf_rate_limited_action: 'סגירה',

            popup_ride_data_not_loaded_text: 'מידע הטיול לא נטען כהלכה',
            popup_ride_data_not_loaded_subText: 'אנא רעננו את הדף ונסו שוב.',
            popup_ride_data_not_loaded_action: 'סגירה',

            popup_insufficient_balance_text: 'הקרדיט הראשוני שלך נוצל',
            popup_insufficient_balance_subText:
                'כדי להמשיך לשתף מסלולים ולפתוח את החשבון לשימוש נוסף, אפשר ליצור איתנו קשר ונשמח לעזור לך להתחיל לעבוד בצורה שוטפת.\n\nניתן להמשיך לבנות ולערוך מסלולים ללא הגבלה',
            popup_insufficient_balance_action: 'צרו קשר בווצאפ',

            popup_contact_form_success_text: 'הודעתכם נשלחה בהצלחה!',
            popup_contact_form_success_subText: 'נחזור אליכם בהקדם האפשרי.',
            popup_contact_form_success_action: 'אישור',

            popup_contact_form_error_text: 'שגיאה בשליחת ההודעה',
            popup_contact_form_error_subText: 'אנא נסו שוב מאוחר יותר או צרו קשר בדרך אחרת.',
            popup_contact_form_error_action: 'אישור',

            popup_name_required_text: 'שם מלא נדרש',
            popup_name_required_subText: 'אנא הכניסו את שמכם המלא.',
            popup_name_required_action: 'אישור',
            popup_phone_required_text: 'מספר טלפון נדרש',
            popup_phone_required_subText: 'אנא הזינו מספר טלפון כדי שנוכל לחזור אליכם.',
            popup_phone_required_action: 'אישור',
            popup_phone_invalid_text: 'מספר טלפון לא תקין',
            popup_phone_invalid_subText: 'נא להזין 8–15 ספרות, כולל קידומת בינלאומית אם נדרש (למשל +1, +44, +972).',
            popup_phone_invalid_action: 'אישור',

            popup_message_required_text: 'הודעה נדרשת',
            popup_message_required_subText: 'אנא הכניסו את תוכן ההודעה שלכם.',
            popup_message_required_action: 'אישור',

            popup_gui_version_outdated_text: 'המערכת עודכנה ונדרש רענון של העמוד כדי להמשיך לעבוד.',
            popup_gui_version_outdated_subText: 'העמוד יתרענן אוטומטית בעוד כ-7 שניות.\nייתכן שחלק מהשינויים האחרונים לא נשמרו.',
            popup_gui_version_outdated_action: 'הבנתי',

            popup_master_accommodation_already_exists_text: 'שינית את המלון למלון אחר שכבר קיים במאגר שלך',
            popup_master_accommodation_already_exists_subText: 'כדי למנוע דריסה של פרטים קיימים, לא בוצע עדכון אוטומטי\n\nאם ברצונך לעדכן את המלון, ניתן לעשות זאת ישירות דרך מאגר המלונות',
            popup_master_accommodation_already_exists_action: 'סגירה',

            // Login Modal translations
            loginOrRegisterQuickly: 'התחברות או הרשמה מהירה',
            or: 'או',
            loginTitle: 'התחברות',
            emailPlaceholder: 'אימייל',
            passwordPlaceholder: 'סיסמא',
            forgotPassword: 'שכחת סיסמה?',
            loginButton: 'התחברו',
            notRegisteredYet: 'עדיין לא רשומים?',
            registerButton: 'הרשמו',
            accessWith: 'התחברות / הרשמה',
            continueWithGoogle: 'המשיכו עם Google',
            continueWithFacebook: 'המשיכו עם Facebook',
            socialLoginAgreement: 'על ידי התחברות עם הרשת החברתית שלי, אני מסכים לקשר את החשבון שלי בהתאם ל',
            privacyPolicy: 'מדיניות הפרטיות',
            continueButton: 'המשך',
            orContinueWithEmail: 'או המשך עם אימייל',
            checkingAccount: 'בודקים את החשבון שלכם...',
            loginOAuthHintGoogle: 'המשיכו עם Google כדי לגשת לחשבון שלכם',
            loginOAuthHintFacebook: 'המשיכו עם Facebook כדי לגשת לחשבון שלכם',
            loginOAuthHintGeneric: 'המשיכו עם חשבון חברתי כדי לגשת לחשבון שלכם',

            // Registration Modal translations
            quickRegistration: 'הרשמה מהירה',
            orRegisterWith: 'או הרשמו עם',
            usernamePlaceholder: 'שם משתמש',
            confirmPasswordPlaceholder: 'סיסמא פעם נוספת',
            readTerms: 'קראתי את התקנון',
            agreeToTerms: 'על ידי המשך התהליך אני מסכים לתנאי השימוש ולמדינויות הפרטיות של האתר',

            // Terms of Use translations
            termsOfUseTitle: 'תנאי שימוש באתר TripPlanner',
            backToPrevious: 'חזור לדף הקודם',
            
            // Update Notification translations
            updateRequired: 'התחברות מחדש',
            updateRequiredMessage: 'ביצענו עדכון אבטחה חשוב, ולכן נדרש להתחבר מחדש. תודה על הסבלנות!',
            loginAgain: 'התחבר מחדש',
            termsIntro: 'אתר TripPlanner.co.il הוא פלטפורמה שיתופית לשיתוף טיולים, המלצות ותכנים הקשורים לתכנון טיולים בארץ ובחו"ל. באמצעות העלאת תכנים לאתר, המשתמש מצהיר ומאשר כי כל תוכן שפורסם על ידו באתר חשוף לציבור הרחב ומותר לשימוש חופשי על ידי משתמשים אחרים - לצפייה, השראה או לצורכי תכנון טיולים.',
            sharingTripsTitle: 'שיתוף טיולים ותכנים',
            sharingTripsContent: 'מטרת האתר היא לאפשר שיתוף של חוויות טיול עם הקהילה. לכן, כל טיול, תמונה, תגובה או תוכן אחר שמועלה לאתר נחשב תוכן ציבורי. אין להעלות תכנים פרטיים או אישיים שאינך מעוניין שייחשפו. המשתמש מוותר מראש על כל דרישה לתמלוגים, הגבלת שימוש או בעלות בלעדית על תכנים שפורסמו על ידו.',
            notProfessionalAdviceTitle: 'TripPlanner אינו ייעוץ מקצועי',
            notProfessionalAdviceContent: 'התכנים באתר נכתבים ונאספים על ידי גולשים ואינם מהווים ייעוץ מקצועי או תחליף לשירות תיירות מוסמך. כל שימוש בתוכן - לרבות המלצות, מסלולים, מקומות לינה ותחבורה - נעשה באחריות המשתמש בלבד.',
            professionalServicesTitle: 'שירותים מקצועיים באתר',
            professionalServicesContent: 'לצד תוכן שמועלה על ידי משתמשים פרטיים, TripPlanner מאפשר גם לספקים מקצועיים לשתף טיולים עם לקוחותיהם בלבד. טיולים אלה נגישים רק לקהל הספציפי של הספק (למשל לקוחות בתשלום) ואינם גלויים לציבור הרחב. הספק המקצועי אחראי באופן מלא לתוכן, למידע המוצג ולשירותים הנלווים לטיולים מסוג זה.',
            clientViewingTitle: 'צפייה בתכנים על ידי לקוחות של מתכננים מקצועיים',
            clientViewingContent1: 'לקוחות אשר קיבלו קישור אישי לצפייה במסלול טיול ממתכנן טיולים מקצועי כפופים אף הם לתנאי שימוש אלו. כל שימוש בתוכן המוצג להם - לרבות תכנון טיול בפועל, הסתמכות על המלצות או מידע - נעשה באחריותם בלבד.',
            clientViewingContent2: 'האתר מהווה פלטפורמה טכנולוגית בלבד ואינו צד לקשר שבין המתכנן ללקוח. כל אחריות לתוכן, שירותים, זמינות, מחירים או התאמה אישית חלה על המתכנן המקצועי בלבד.',
            noContentGuaranteeTitle: 'אין התחייבות לשמירת תכנים',
            noContentGuaranteeContent1: 'החברה שומרת לעצמה את הזכות למחוק, לשנות, לערוך או להעביר תכנים באתר לפי שיקול דעתה הבלעדי, לרבות תכנים שהוזנו על ידי משתמשים.',
            noContentGuaranteeContent2: 'החברה אינה מתחייבת לשמור גיבוי או להבטיח שמירה של תכנים לטווח ארוך, בכל צורה שהיא.',
            marketingContentTitle: 'תכנים שיווקיים ופרסום',
            marketingContentContent: 'ייתכן וחלק מהתכנים באתר כוללים מידע שיווקי, פרסומות, או תכנים ממומנים. כל פרסום הוא באחריות המפרסם בלבד, והאתר אינו צד לעסקאות שייחתמו בעקבות פרסום זה.',
            liabilityLimitationTitle: 'הגבלת אחריות',
            liabilityLimitationContent: 'המידע באתר ניתן כמות שהוא (AS IS). האתר אינו אחראי לדיוק, שלמות או עדכניות המידע, ואינו מתחייב לכך שהשימוש באתר יתאים לצרכיך. האחריות לשימוש בתכנים היא על המשתמש בלבד. TripPlanner לא תישא באחריות לכל נזק ישיר או עקיף שייגרם כתוצאה משימוש באתר או מהסתמכות על תכנים בו.',
            siteUsageTitle: 'שימוש באתר',
            siteUsageContent: 'אין לעשות באתר שימוש לצרכים מסחריים, פוגעניים, בלתי חוקיים או כאלה שמפרים את פרטיותם או זכויותיהם של אחרים. החברה שומרת לעצמה את הזכות להסיר תכנים ו/או לחסום משתמשים ללא צורך בהודעה מוקדמת.',
            copyrightTitle: 'זכויות יוצרים וקניין רוחני',
            copyrightContent: 'כל הזכויות על עיצוב האתר, הלוגו, מערכת ההפעלה והקוד שמרכיבים את TripPlanner שמורות לחברה בלבד. אין להעתיק, לשכפל, או לעשות כל שימוש מסחרי ללא אישור בכתב.',
            accessibilityTitle: 'נגישות',
            accessibilityContent1: 'אתר TripPlanner שואף לספק חוויית גלישה נגישה לכלל המשתמשים, לרבות אנשים עם מוגבלות. האתר פועל בהתאם להנחיות הנגישות לרמה AA של תקן W3C (WCAG 2.0), וכולל התאמות נגישות במבנה האתר, בתכנים, ובאפשרויות הניווט.',
            accessibilityContent2: 'ניתן להגדיל את הטקסט או לשנות את צבעי המסך באמצעות כלים המובנים בדפדפן (כגון Zoom או תוספים לנגישות). האתר אינו כולל כרגע רכיב נגישות גרפי ייעודי, אך אנו פועלים לשפר זאת בהמשך.',
            accessibilityContent3: 'במידה ונתקלתם בקושי נגישות או בתקלה, ניתן לפנות אלינו, ונעשה כמיטב יכולתנו על מנת לתקן זאת בהקדם.',
            changesTitle: 'שינויים באתר ובתקנון',
            changesContent: 'החברה רשאית לעדכן מעת לעת את תנאי השימוש, את מבנה האתר, התכנים והשירותים בו, או את מדיניות הפרטיות - לפי שיקול דעתה הבלעדי וללא הודעה מוקדמת.',
            contactTitle: 'פנייה אלינו',
            contactContent: 'בכל שאלה או בקשה ניתן לפנות אלינו בדוא"ל:',
            lastUpdated: 'עודכן לאחרונה: יולי 2025',

            // AttractionManagerOptions modal
            attractionManagerTitlePrefix: 'מה תרצה לעשות עם',
            attractionManagerEdit: 'עריכה',
            attractionManagerUpdateDate: 'עדכון מועד',
            attractionManagerRemove: 'הסרה',

            // Privacy Policy page
            ppIntro: 'אתר TripPlanner.co.il ("האתר") מתייחס בכובד ראש לפרטיות המשתמשים. מסמך זה מפרט את מדיניות השימוש במידע הנאסף באתר.',
            ppInfoCollection: 'איסוף מידע',
            ppInfoCollectionContent: 'במהלך השימוש באתר אנו עשויים לאסוף מידע הכולל פרטים מזהים (כגון כתובת דוא"ל), מידע טכני (כגון כתובת IP, סוג דפדפן, מערכת הפעלה), ומידע אנליטי (כגון דפי ביקור, זמן שהייה באתר).',
            ppInfoUse: 'שימוש במידע',
            ppInfoUseContent: 'המידע שנאסף משמש לצורך:',
            ppInfoUseItem1: 'שיפור חוויית המשתמש',
            ppInfoUseItem2: 'התאמה אישית של תכנים',
            ppInfoUseItem3: 'סטטיסטיקות פנימיות',
            ppInfoUseItem4: 'שמירה על אבטחת האתר',
            ppCookies: 'שימוש בעוגיות (Cookies)',
            ppCookiesContent1: 'האתר עושה שימוש בקבצי Cookie וטכנולוגיות דומות (כגון localStorage) לצורך תפקוד תקין של האתר, ניתוח תעבורה, שיפור השירות והתאמה אישית.',
            ppCookiesContent2: 'ניתן למחוק או לחסום את הקבצים הללו דרך הגדרות הדפדפן.',
            ppExternalServices: 'שירותים חיצוניים',
            ppExternalServicesContent1: 'האתר עושה שימוש בשירות Hotjar לצורך ניתוח התנהגות משתמשים וביצוע שיפורים. בנוסף, ייתכן שימוש בשירותים חיצוניים אחרים כגון Google Analytics.',
            ppExternalServicesContent2: 'כל שירות כפוף לתנאי השימוש והפרטיות של הספק.',
            ppDataSecurity: 'שמירה ואבטחת מידע',
            ppDataSecurityContent: 'אנו נוקטים באמצעים סבירים לשמירה על אבטחת המידע, אך אין ביכולתנו להבטיח הגנה מוחלטת.',
            ppPolicyChanges: 'שינויים במדיניות',
            ppPolicyChangesContent: 'מדיניות זו עשויה להתעדכן מעת לעת. נעדכן את העמוד עם תאריך עדכון מתאים.',
            ppContactHeading: 'צור קשר',
            ppContactContent: 'בכל שאלה או בקשה ניתן לפנות אלינו באמצעות טופס יצירת קשר באתר.',
            ppLastUpdated: 'עודכן לאחרונה: מרץ 2025',

            // PrivatePageLanding translations
            privateTripTitle: 'המסלול האישי שלך',
            privateTripSubtitle: 'התחברו או הירשמו כדי לצפות במסלול האישי שלכם.',
            welcomeToPrivateTrip: 'ברוכים הבאים למסלול האישי שלכם!',
            noPermissionMessage: 'עבור חשבון זה לא קיימת הרשאה למסלול זה. ניתן לרכוש את המסלול בקישור המצורף.',
            loginToViewTrip: 'כדי להיכנס ולצפות בפרטי המסלול, אנא התחברו או הירשמו.',
            afterLoginMessage: 'לאחר ההתחברות, תועברו אוטומטית לעמוד המסלול שלכם, בו תמצאו את כל המידע שתכננו במיוחד עבורכם',
            purchaseTrip: 'רכישת המסלול',
            loginOrRegister: 'להרשמה או התחברות',
            
            // AssignToRide translations
            welcomeToPrivateTripWithEmoji: 'ברוכים הבאים למסלול האישי שלכם! 😊',
            loginToViewTripHere: 'כדי להיכנס ולצפות בפרטי המסלול, התחברו או הירשמו ממש כאן.',
            saveLinkMessage: 'כדי שתוכלו לחזור למסלול גם בהמשך, לחצו על כפתור "קבלת הלינק לטיול שלכם" ושמרו את הקישור אצלכם.',
            afterLinkMessage: 'אחרי זה, לחצו על "מעבר למסלול" ותעברו לעמוד שבו מחכה לכם כל התכנון שלנו. שלחנו לכם גם מייל עם הקישור האישי - שווה לשמור אותו.',
            scheduleConsultingMeeting: 'לקביעת פגישה נוחה להתאמת המסלול לצרכים שלי',
            getTripLinkButton: 'לחצו כאן לקבלת הלינק לטיול שלכם',
            goToTrip: 'מעבר למסלול',
            
            // CopyPrivateLink translations
            saveTripLinkTitle: 'שמירת הלינק לטיול שלך',
            congratulationsRegistered: 'ברכות! נרשמתה בהצלחה לצפייה בטיול שלך.',
            importantToSaveLink: 'חשוב לשמור את הלינק לטיול כדי שתוכל לחזור אליו בקלות בעתיד.',
            copyLink: 'העתק קישור',
            linkCopiedSuccess: 'הקישור הועתק בהצלחה!',
            copyLinkTitle: 'העתקת קישור',
            errorCopyingLink: 'שגיאה בהעתקת הקישור',
            shareRideHeader: 'שמירת הלינק לטיול שלך',
            shareRideText: 'ברכות! נרשמת בהצלחה לצפייה בטיול שלך. חשוב לשמור את הלינק לטיול כדי שתוכל לחזור אליו בקלות בעתיד.',
            shareRideWhatsAppTitle: 'שתף טיול',
            shareRideWhatsAppDescription: 'היי! אני משתף איתך את הלינק לצפייה בטיול שלי. שמור אותו לגישה מהירה:',
            shareAttractionHeader: 'שליחת הפעילות לחברים',
            shareAttractionText: 'האדם הצופה בטיול זה לא יוכל לערוך או לשנות את הטיול שלכם, הוא יוכל רק לצפות בטיול ואים הוא ממש יאהב הוא יוכל להעתיק את הטיול ולערוך אחד אחר עבורו',
            shareAttractionWhatsAppTitle: 'בנית טיול משפחתי.',
            shareAttractionWhatsAppDescription: 'יש כאן בסיס לטיול שניתן להתאים לרצונות שלנו',
            startInsertRideWhatsappShareButton: 'שלחו קישור למחשב (WhatsApp)',
            startInsertRideCopyWelcomeLinkLine: 'או העתיקו את הקישור',
            startInsertRideWhatsappShareMessageLine1: 'היי, אני מתחיל לעבוד עם TripPlanner',
            startInsertRideWhatsappShareMessageLine2: 'זה הקישור להמשך העבודה מהמחשב:',

            // PaymentHowItWorks page
            paymentHowMetaTitle: 'איך עובד השיתוף ועלות השימוש | TripPlanner',
            paymentHowMetaDescription: 'מנוי חודשי של ₪25 לשימוש במערכת, בנוסף לתשלום לפי שימוש בעת שיתוף מסלולים עם לקוחות. עד 4 לקוחות בכל שיתוף.',
            paymentHowEyebrow: 'שקיפות מלאה · מנוי חודשי + תשלום לפי שימוש',
            paymentHowHeroTitle: 'איך עובד השיתוף והתמחור',
            paymentHowHeroLeadCreate: 'תשלום חודשי קבוע של ₪25 מעניק גישה למערכת.',
            paymentHowHeroLeadPay: 'בנוסף, משלמים רק על מסלולים שבוחרים לשתף עם לקוחות.',
            paymentHowPriceTitle: 'כמה זה עולה',
            paymentHowPricePerDayValue: '5 ₪',
            paymentHowPerRouteDay: 'לכל יום במסלול',
            paymentHowMinCostNote: 'עלות מינימלית לשיתוף: ₪15 (3 ימים)',
            paymentHowAccessTitle: 'גישה למערכת',
            paymentHowAccessItem1: '₪25 לחודש',
            paymentHowAccessItem2: 'גישה מלאה לכל יכולות המערכת',
            paymentHowAccessItem3: 'משלמים רק על מסלולים שמשתפים עם לקוחות',
            paymentHowExampleTitle: 'לדוגמה',
            paymentHowExampleSub: 'חישוב פשוט, בלי הפתעות',
            paymentHowExamplePriceByDays: 'מחיר לפי ימים במסלול',
            paymentHowRouteDaysLabel: 'ימים במסלול',
            paymentHowPerDayLabel: 'ליום',
            paymentHowExamplePerDayValue: '5 ₪',
            paymentHowExampleDaysResultValue: '20 ₪',
            paymentHowExampleDaysCaption: 'מסלול של 4 ימים - 20 ₪',
            paymentHowExampleAbove4Clients: 'מעל 4 לקוחות',
            paymentHowExampleExtraIntroPrefix: 'עד 4 לקוחות כלולים בשיתוף. לקוחות נוספים:',
            paymentHowExampleScenarioPrefix: 'לדוגמה: שיתוף עם',
            paymentHowExampleScenarioSuffix: 'לקוחות',
            paymentHowExtraClientsLabel: 'לקוחות נוספים',
            paymentHowExamplePerClientValue: '10 ₪',
            paymentHowPerClientLabel: 'ללקוח',
            paymentHowExampleExtraResultValue: '20 ₪',
            paymentHowExampleExtraClientsCaption: '6 לקוחות - 4 הראשונים = 2 לקוחות בתוספת',
            paymentHowExampleTotalLabel: 'סה״כ לדוגמה (4 ימים + 6 לקוחות)',
            paymentHowExampleTotalValue: '20 ₪ + 20 ₪ = 40 ₪',
            paymentHowClientsTitle: 'שיתוף עם לקוחות',
            paymentHowClientsUpTo4: 'ניתן לשתף את המסלול עם עד 4 לקוחות',
            paymentHowClientsWantMore: 'רוצים לשתף עם יותר?',
            paymentHowClientsExtraPrefix: 'ניתן להוסיף לקוחות נוספים בתוספת של',
            paymentHowClientsPerClientValue: '10 ₪',
            paymentHowEasyStartTitle: 'התחלה קלה',
            paymentHowEasyStartHighlight: 'שיתוף המסלול הראשון עלינו',
            paymentHowEasyStartText: 'כדי שתוכלו להכיר את המערכת בצורה מלאה',
            paymentHowCtaTitle: 'מוכנים להתחיל?',
            paymentHowCtaText: 'בנו מסלול במערכת מתי שנוח לכם, ושתפו עם לקוחות כשאתם מוכנים.',
            paymentHowCtaButton: 'התחילו ליצור מסלול',
            // PricingPlans page (/pricing) - presentation only, plan numbers come from common/pricingPlans.js
            pricingPlansMetaTitle: 'מסלולים ומחירים | TripPlanner',
            pricingPlansMetaDescription: 'מסלולי TripPlanner לסוכני נסיעות: Free, Smart, Pro ו-Business. מנוי חודשי בנוסף לתשלום לפי ימי טיול משותפים, בקשות AI ושליחת עדכוני WhatsApp למטיילים.',
            pricingPlansHeroTitle: 'מסלול שמתאים בדיוק לעסק שלכם',
            pricingPlansHeroSubtitle: 'בחרו את המסלול שמתאים לכם, ותיהנו ממערכת מקצועית לבניית מסלולי טיול, כלי AI מתקדמים ושליחת עדכונים אוטומטיים למטיילים.',
            pricingPlansCardsTitle: 'המסלולים שלנו',
            pricingPlansRecommended: 'מומלץ',
            pricingPlansPerMonth: 'לחודש',
            pricingPlansSharedDayCharge: `בתוספת ${params.price || ''} לכל יום טיול משותף`,
            pricingPlansDescFree: 'מתחילים לבנות מסלולים ללא התחייבות חודשית',
            pricingPlansDescSmart: 'בונים מסלולים מהר יותר בעזרת AI',
            pricingPlansDescPro: 'מלווים את המטיילים אוטומטית ב-WhatsApp',
            pricingPlansDescBusiness: 'הפתרון המלא לסוכנויות עם מיתוג אישי',
            pricingPlansCardItinerary: 'יצירת מסלולים דיגיטליים',
            pricingPlansCardBanner: 'באנר אישי עם פרטי הסוכן',
            pricingPlansCardAi: `${params.count || ''} בקשות AI לכל יום טיול`,
            pricingPlansCardWhatsappPerTrip: `${params.count || ''} הודעה ב-WhatsApp למטייל לכל הטיול`,
            pricingPlansCardWhatsappPerTripDay: `${params.count || ''} הודעות WhatsApp למטייל לכל יום טיול`,
            pricingPlansCardTripDesignsIncluded: 'בחירת עיצוב לעמוד הטיול',
            pricingPlansCardTripDesignsNotIncluded: 'ללא בחירת עיצוב לעמוד הטיול',
            pricingPlansCardWhiteLabelIncluded: 'White Label מלא – צבעים, לוגו ותת-דומיין ממותגים',
            pricingPlansCardWhiteLabelNotIncluded: 'ללא White Label',
            pricingPlansCta: `לפרטים על ${params.plan || ''}`,
            pricingPlansCtaNote: 'הכפתורים פותחים שיחת WhatsApp עם הצוות שלנו – ללא חיוב וללא שינוי בחשבון שלכם.',
            pricingPlansCtaWhatsappMessage: `היי, אשמח לשמוע עוד על מסלול ${params.plan || ''} של TripPlanner`,
            pricingPlansCompareTitle: 'השוואת מסלולים',
            pricingPlansCompareFeature: 'מה כלול',
            pricingPlansCompareScrollHint: 'החליקו לצדדים כדי לראות את כל המסלולים',
            pricingPlansRowMonthly: 'מנוי חודשי',
            pricingPlansRowSharedDay: 'מחיר לכל יום טיול משותף',
            pricingPlansRowItinerary: 'יצירת מסלול דיגיטלי',
            pricingPlansRowBanner: 'באנר אישי עם פרטי הסוכן',
            pricingPlansRowAi: 'בקשות AI לכל יום טיול',
            pricingPlansRowWhatsapp: 'הודעות WhatsApp למטייל',
            pricingPlansRowTripDesigns: 'בחירת עיצוב לעמוד הטיול',
            pricingPlansRowWhiteLabel: 'White Label מלא',
            pricingPlansWhatsappPerTrip: `${params.count || ''} לכל הטיול`,
            pricingPlansWhatsappPerTripDay: `${params.count || ''} לכל יום טיול`,
            pricingPlansIncluded: 'כלול',
            pricingPlansNotIncluded: 'לא כלול',
            pricingPlansWhatsappNoteTitle: 'איך מחושבת מכסת הודעות ה-WhatsApp?',
            pricingPlansWhatsappNotePerTrip: `ב-${params.plans || ''} כל מטייל רשום מקבל הודעת WhatsApp אחת לכל הטיול – כדי שתוכלו להתנסות ביכולת.`,
            pricingPlansWhatsappNotePerTripDay: `ב-${params.plans || ''} המכסה לכל מטייל מחושבת לפי אורך הטיול: מספר ההודעות בטבלה כפול מספר ימי הטיול. לדוגמה, בטיול של ${params.days || ''} ימים ב-${params.plan || ''}, כל מטייל יכול לקבל עד ${params.count || ''} הודעות לאורך הטיול.`,
            pricingPlansAiNote: `בקשות ה-AI מיועדות לסוכן ומחושבות לפי מספר ימי הטיול. לדוגמה, מסלול של ${params.days || ''} ימים ב-${params.plan || ''} כולל ${params.count || ''} בקשות AI.`,
            pricingPlansAnd: ' וב-',
            pricingPlansBrandingTitle: 'באנר אישי או White Label?',
            pricingPlansBrandingSubtitle: 'עברו בין התצוגות וראו מה משתנה כשהמערכת כולה עוברת למיתוג שלכם.',
            pricingPlansBannerTitle: 'באנר אישי עם פרטי הסוכן',
            pricingPlansBannerBadge: 'כלול בכל המסלולים',
            pricingPlansBannerText: 'בראש עמוד המסלול מוצג באנר עם הפרטים שלכם, כך שהמטיילים יודעים מי תכנן עבורם את הטיול. שאר העמוד נשאר במיתוג TripPlanner.',
            pricingPlansWhiteLabelTitle: 'White Label מלא',
            pricingPlansWhiteLabelBadge: `${params.plan || ''} בלבד`,
            pricingPlansWhiteLabelText: 'המערכת כולה במיתוג של הסוכנות: צבעי הסוכנות, הלוגו שלכם ותת-דומיין ממותג.',
            pricingPlansDemoToggleLabel: 'השוואה בין התצוגות',
            pricingPlansDemoTabRegular: 'תצוגה רגילה',
            pricingPlansDemoTabWhiteLabel: 'White Label',
            pricingPlansDemoTripTitle: 'צפון איטליה והדולומיטים',
            pricingPlansDemoTripMeta: '7 ימים · 4 מטיילים',
            pricingPlansDemoAgentName: 'מאיה תיירות',
            pricingPlansDemoAgentTitle: 'תכנון חופשות ומסלולים בהתאמה אישית',
            pricingPlansDemoDay: `יום ${params.day || ''}`,
            pricingPlansDemoDay1: 'מילאנו ואגם קומו',
            pricingPlansDemoDay2: "סצ'דה, הדולומיטים",
            pricingPlansDemoDay3: 'אגם בראייס',
            pricingPlansDemoNavigate: 'ניווט',
            pricingPlansDemoPointLogoTitle: 'הלוגו שלכם',
            pricingPlansDemoPointLogoText: 'הלוגו של הסוכנות מחליף את הלוגו של TripPlanner בראש כל עמוד.',
            pricingPlansDemoPointColorsTitle: 'הצבעים שלכם',
            pricingPlansDemoPointColorsText: 'הכותרות, הכפתורים וימי הטיול נצבעים בצבעי המותג שלכם.',
            pricingPlansDemoPointClosedTitle: 'מערכת סגורה',
            pricingPlansDemoPointClosedText: 'אין תפריט ואין קישורים לאתר שלנו – המטיילים נשארים אצלכם, וזה מרגיש 100% כמו תוכנה של החברה שלכם.',
            pricingPlansDemoExampleNote: 'בדוגמה: White Label של מאיה תיירות.',
            pricingPlansExampleTitle: 'דוגמה לחישוב',
            pricingPlansExampleSubtitle: `טיול של ${params.days || ''} ימים עם ${params.travelers || ''} מטיילים רשומים`,
            pricingPlansExampleRowTripCharge: 'חיוב שימוש עבור הטיול',
            pricingPlansExampleRowAi: 'בקשות AI',
            pricingPlansExampleRowWhatsappPerTraveler: 'הודעות WhatsApp למטייל',
            pricingPlansExampleRowWhatsappTotal: 'סה״כ הודעות WhatsApp',
            pricingPlansExampleNote: `חיוב השימוש (${params.days || ''} ימים × ${params.price || ''} = ${params.total || ''}, כולל עד ${params.users || ''} משתמשים) אינו כולל את המנוי החודשי, שמשולם בנפרד.`,
            pricingPlansFaqTitle: 'שאלות נפוצות',
            pricingPlansFaq1Q: 'האם יש התחייבות חודשית?',
            pricingPlansFaq1A: `מסלול ${params.freePlan || ''} הוא ללא מנוי חודשי – משלמים רק לפי ימי טיול משותפים. שאר המסלולים כוללים מנוי חודשי, בנוסף לחיוב לפי ימי טיול משותפים.`,
            pricingPlansFaqSwitchQ: 'האם אפשר לעבור בין מסלולים?',
            pricingPlansFaqSwitchA: 'בהחלט! תוכלו לשדרג או לשנות את מסלול המנוי שלכם בכל עת, בהתאם לצורכי העסק.\n\nשדרוג מסלול נכנס לתוקף באופן מיידי, ומעבר למסלול נמוך יותר מתבצע בתחילת מחזור החיוב הבא.',
            pricingPlansFaq2Q: 'איך מחושב התשלום עבור ימי הטיול?',
            pricingPlansFaq2A: `בכל המסלולים משלמים ${params.price || ''} עבור כל יום בטיול שמשותף עם מטיילים, ולפחות ${params.min || ''} לטיול. כל טיול כולל עד ${params.users || ''} משתמשים, ועל כל משתמש נוסף משלמים ${params.userPrice || ''} – חיוב חד-פעמי לטיול, לא חודשי ולא יומי. החיוב הזה נפרד מהמנוי החודשי. לדוגמה, טיול של ${params.days || ''} ימים עם ${params.extraUsersExample || ''} משתמשים: ${params.total || ''}.`,
            pricingPlansFaq3Q: 'איך מחושבת מכסת בקשות ה-AI?',
            pricingPlansFaq3A: `בקשות ה-AI מיועדות לסוכן, לעבודה על המסלול. המכסה מחושבת לפי מספר ימי הטיול: מספר הבקשות לכל יום טיול במסלול שלכם, כפול מספר הימים. לדוגמה, מסלול של ${params.days || ''} ימים ב-${params.plan || ''} כולל ${params.count || ''} בקשות AI.`,
            pricingPlansFaq4Q: 'איך מחושבת מכסת הודעות WhatsApp?',
            pricingPlansFaq4A: `ב-${params.perTripPlans || ''} כל מטייל רשום מקבל הודעה אחת לכל הטיול, כדי להתנסות ביכולת. ב-${params.perDayPlans || ''} המכסה לכל מטייל מחושבת לפי אורך הטיול – מספר ההודעות לכל יום טיול כפול מספר ימי הטיול. לדוגמה, בטיול של ${params.days || ''} ימים ב-${params.plan || ''}: עד ${params.count || ''} הודעות לכל מטייל.`,
            pricingPlansFaq5Q: 'מה ההבדל בין באנר אישי ל-White Label?',
            pricingPlansFaq5A: `באנר אישי, הכלול בכל המסלולים, מציג את פרטי הסוכן בראש עמוד המסלול.\n\nWhite Label מלא, הכלול רק במסלול ${params.plan || ''}, מאפשר להציג את המערכת במיתוג הסוכנות שלכם, כולל צבעים, לוגו ותת-דומיין ממותג. בנוסף, המטיילים נהנים מחוויית צפייה ממוקדת במסלול ששלחתם להם, ללא תפריטי ניווט לעמודים אחרים באתר TripPlanner.`,
            pricingPlansBottomCtaTitle: 'רוצים לשמוע עוד?',
            pricingPlansBottomCtaText: 'נשמח לעזור לכם לבחור את המסלול שמתאים לעסק שלכם.',
            pricingPlansBottomCtaButton: 'דברו איתנו ב-WhatsApp',
            pricingPlansBottomCtaMessage: 'היי, אשמח לשמוע עוד על המסלולים של TripPlanner',
            pricingPlansCardTripTerms: `מינימום ${params.min || ''} לטיול · עד ${params.users || ''} משתמשים כלולים`,
            pricingPlansRowMinTrip: 'מינימום לתשלום עבור טיול',
            pricingPlansRowIncludedUsers: 'משתמשים כלולים בטיול',
            pricingPlansRowAdditionalUser: 'כל משתמש נוסף בטיול',
            pricingPlansTripRulesNote: `כל טיול כולל עד ${params.users || ''} משתמשים. עבור כל משתמש נוסף תחויבו ב-${params.price || ''}. עלות המינימום לטיול היא ${params.min || ''}.`,
            pricingPlansTripPriceTitle: 'כמה עולה שיתוף טיול?',
            pricingPlansTripPriceSubtitle: 'החישוב זהה בכל המסלולים, ואינו כולל את המנוי החודשי.',
            pricingPlansTripPriceColTrip: 'טיול',
            pricingPlansTripPriceColCalc: 'חישוב',
            pricingPlansTripPriceColTotal: 'לתשלום',
            pricingPlansTripDaysOne: 'יום אחד',
            pricingPlansTripDaysMany: `${params.days || ''} ימים`,
            pricingPlansTripUsers: `${params.users || ''} משתמשים`,
            pricingPlansCalcMinimum: `מינימום ${params.min || ''}`,
            pricingPlansCalcDays: `${params.days || ''} ימים × ${params.price || ''}`,
            pricingPlansCalcExtraUserOne: `משתמש נוסף × ${params.price || ''}`,
            pricingPlansCalcExtraUsers: `${params.count || ''} משתמשים נוספים × ${params.price || ''}`,
            welcomeRideHeroTitle: 'בנו מסלולי טיול דיגיטליים ללקוחות שלכם',
            welcomeRideHeroSubtitle: 'TripPlanner מאפשר למתכנני טיולים, מדריכים וסוכני נסיעות להציג מסלולים בצורה מקצועית וברורה, כך שהלקוחות שלכם יכולים להשתמש במסלול בקלות מהטלפון שלהם.',
            welcomeRideHeroCta: 'התחילו ליצור מסלול',
            welcomeRideHowItWorksTitle: 'איך זה עובד',
            welcomeRideStep1Title: 'יוצרים טיול',
            welcomeRideStep1Line1: 'פותחים טיול חדש ובוחרים את התאריכים.',
            welcomeRideStep1Line2: 'מוסיפים לכל יום את המקומות והפעילויות המתאימות.',
            welcomeRideStep1Line3: 'מספיק לכתוב את שם המקום - המערכת מביאה מידע אוטומטית, ואפשר להוסיף תיאור למקום עם AI.',
            welcomeRideStep2Title: 'שולחים את המסלול ללקוח',
            welcomeRideStep2Line1: 'כאשר המסלול מוכן ניתן לשלוח אותו ללקוח בצורה דיגיטלית נוחה לשימוש מהטלפון.',
            welcomeRideStep2Line2: 'הלקוח מקבל מסלול ברור עם סדר ימים, פעילויות וקישורי ניווט לכל יעד.',
            welcomeRideStep2Line3: 'המסלול נשאר בשליטה שלכם והלקוח לא יכול להעביר אותו הלאה.',
            welcomeRideStep3Title: 'משתמשים בתוכן שוב ושוב',
            welcomeRideStep3Line1: 'כל טיול וכל פעילות שהוספתם נשמרים במערכת.',
            welcomeRideStep3Line2: 'כך ניתן לבנות במהירות מסלולים חדשים ללקוחות נוספים ולהשתמש בפעילויות שכבר הכנסתם בעבר.',
            welcomeRideStep3Line3: 'עם הזמן נוצרת לכם ספרייה של פעילויות ומסלולים שמקצרת משמעותית את זמן העבודה.',
            welcomeRideExampleTitle: 'כך יכולים להיראות המסלולים שלכם',
            welcomeRideExampleIntro: 'כאשר אתם שולחים מסלול ללקוח, הוא מקבל עמוד מסודר וברור עם כל ימי הטיול, הפעילויות וקישורי ניווט לכל יעד.',
            welcomeRideExampleSubtitle: 'כך נראה מסלול כפי שהלקוח רואה אותו בטלפון:',
            welcomeRideExampleBtn: 'צפו במסלול לדוגמה',
            welcomeRideAudienceTitle: 'למי המערכת מתאימה',
            welcomeRideAudiencePill1: 'מתכנני טיולים',
            welcomeRideAudiencePill2: 'מדריכי טיולים',
            welcomeRideAudiencePill3: 'סוכני נסיעות',
            welcomeRideAudiencePill4: 'יוצרי תוכן בתחום הטיולים',
            welcomeRideAudienceTagline: 'כל מי שבונה מסלולים ורוצה להציג אותם ללקוחות בצורה מקצועית ונוחה לשימוש.',
            welcomeRideWhyTitle: 'למה לעבוד עם TripPlanner',
            welcomeRideBenefit1: 'הלקוח מקבל מסלול ברור ונוח מהטלפון',
            welcomeRideBenefit2: 'אפשר לערוך ולעדכן את המסלול גם אחרי שליחה',
            welcomeRideBenefit3: 'אין צורך לשלוח קבצי PDF מסורבלים',
            welcomeRideBenefit4: 'הלקוח לא יכול להעביר את המסלול הלאה',
            welcomeRidePricingText: 'אפשר להתחיל ליצור מסלול ולהתנסות במערכת ללא תשלום.',
            welcomeRidePricingLink: 'המסלולים והמחירים שלנו',
            welcomeRidePricingCta: 'התחילו ליצור מסלול',

            // ReferralPage translations
            referralPageTitle: 'הפנו חברים ל-TripPlanner',
            referralPageExplanation: 'שתפו את הקישור הזה. כאשר מישהו נרשם דרכו, הוא יירשם כמופנה על ידכם.',
            referralPageLinkLabel: 'הקישור האישי שלכם',
            referralPageCopyBtn: 'העתיקו קישור',
            referralPageCopied: 'הועתק!',
            referralStepCopyTitle: 'שלב 1 - העתיקו את הקישור שלכם',
            referralStepShareTitle: 'שלב 2 - שתפו עם חברים',
            referralPageHelperText: 'מי שנרשם דרך הקישור הזה יסומן כמופנה על ידכם.',
            referralRewardText: 'על כל משתמש שמצטרף דרככם, תקבלו 10% מהתשלומים שלו למשך 12 חודשים ממועד ההצטרפות שלו. לאחר מכן, לא יינתן תגמול נוסף עבור אותו משתמש.',
            referralCopySuccessText: 'הקישור מוכן ונמצא בלוח ההעתקה שלכם.',
            referralCopyErrorText: 'לא הצלחנו להעתיק אוטומטית. סמנו את הקישור והעתיקו ידנית.',
            referralHeroCta: 'שתפו עכשיו',
            referralShareVia: 'שתפו ישירות דרך',
            referralShareWhatsapp: 'וואטסאפ',
            referralShareWhatsappMessage: `היי! רוצה להזמין אותך להצטרף ל-TripPlanner דרך הקישור שלי:\n${params.link || ''}`,
            referralShareFacebook: 'פייסבוק',

            // StartInsertRide page
            startInsertRideMobileHint: 'להתחלה נוחה יותר, מומלץ לעבור למחשב ליצירת המסלול הראשון',
            startInsertRideTitle: 'ברוכים הבאים ל TripPlanner',
            startInsertRideSubtitle: 'בואו ניצור את המסלול הראשון שלכם',

            businessBasicAgreementModalTitle: 'הסכם שימוש לעסקים - TripPlanner',
            businessBasicAgreementHeroEyebrow: 'השימוש במערכת כפוף לתנאי השימוש',
            businessBasicAgreementHeroHint: 'חל על כל סוגי העסקים ומודלי התמחור - יש לקרוא בעיון לפני אישור',
            businessBasicAgreementVersionLabel: 'גרסה v2.0',
            businessBasicAgreementPhoneLabel: 'מספר טלפון ליצירת קשר',
            businessBasicAgreementPhonePlaceholder: '050-0000000',
            businessBasicAgreementPhoneHint: 'נדרש למסמך זה 8-15 ספרות, ניתן להזין מספר בינלאומי עם +',
            businessBasicAgreementPhoneRequired: 'נא להזין מספר טלפון',
            businessBasicAgreementPhoneInvalid: 'נא להזין מספר תקין (8-15 ספרות, בינלאומי כולל)',
            businessBasicAgreementAckTitle: 'אישור תנאי השימוש',
            businessBasicAgreementCheckbox: 'קראתי ואני מאשר/ת את תנאי השימוש של TripPlanner.',
            updatedTermsTitle: 'עדכון תנאי השימוש של TripPlanner',
            updatedTermsBody1: 'עדכנו את תנאי השימוש שלנו כדי להתאים אותם לשירותים וליכולות החדשות של המערכת.',
            updatedTermsBody2: 'כדי להמשיך להשתמש ב-TripPlanner, נבקש ממך לעיין בתנאים המעודכנים ולאשר אותם.',
            updatedTermsCheckbox: 'קראתי ואני מסכים/ה לתנאי השימוש המעודכנים.',
            updatedTermsAcceptButton: 'אישור והמשך למערכת',
            updatedTermsNotNow: 'לא עכשיו',
            updatedTermsReadTerms: 'לקריאת תנאי השימוש המעודכנים',
            updatedTermsHideTerms: 'הסתרת תנאי השימוש',
            updatedTermsShareGateTitle: 'נדרש אישור תנאי השימוש המעודכנים',
            updatedTermsShareGateBody: 'כדי לשתף טיול, יש לעיין בתנאי השימוש המעודכנים ולאשר אותם.',
            updatedTermsShareGateButton: 'לעיון ואישור התנאים',
            businessBasicAgreementAiCheckbox: 'ידוע לי ששימוש בכלי ה-AI עשוי לכלול העברת מידע מהטיול וממסמכים שהעליתי לספקי AI חיצוניים, כמפורט בהסכם.',
            businessBasicAgreementCheckboxRequired: 'יש לסמן את שתי תיבות האישור כדי להמשיך.',
            businessBasicAgreementAccept: 'אישור והמשך',
            businessBasicAgreementClose: 'סגירה',
            agreementSignPageLoading: 'טוען את מסמך ההסכם...',
            agreementSignPageNotLoggedIn: 'יש להתחבר למערכת כדי לחתום על ההסכם.',
            agreementSignPageInvalidToken: 'הקישור אינו תקין או שפג תוקפו.',
            agreementSignPageAlreadySigned: 'חתמת כבר על הסכם זה. תודה!',
            agreementSignPageSuccessTitle: 'ההסכם נחתם בהצלחה',
            agreementSignPageSuccessBody: 'תודה! אישורך נרשם במערכת.',
            agreementSignPageErrorTitle: 'שגיאה בשמירת ההסכם',
            agreementSignPageErrorBody: 'אנא נסה שוב. אם הבעיה נמשכת, צור קשר עם הספק.',
            popup_record_user_agreement_failed_text: 'לא ניתן לשמור את אישור ההסכם',
            popup_record_user_agreement_failed_subText: 'אנא נסו שוב בעוד רגע. אם הבעיה נמשכת, צרו קשר עם התמיכה.',
            popup_record_user_agreement_failed_action: 'סגירה',
            popup_make_user_ride_manager_failed_text: 'לא ניתן לפתוח הרשאות מנהל מסלול',
            popup_make_user_ride_manager_failed_subText: 'אנא נסו שוב או צרו קשר עם התמיכה.',
            popup_make_user_ride_manager_failed_action: 'סגירה',
            popup_business_basic_agreement_required_text: 'נדרש אישור הסכם השימוש לעסקים',
            popup_business_basic_agreement_required_subText: 'יש לאשר את תנאי השימוש לפני פתיחת הרשאות מנהל מסלול.',
            popup_business_basic_agreement_required_action: 'סגירה',
            popup_business_basic_agreement_phone_required_text: 'חסר מספר טלפון',
            popup_business_basic_agreement_phone_required_subText: 'יש להזין מספר טלפון כדי לאשר את ההסכם.',
            popup_business_basic_agreement_phone_required_action: 'סגירה',
            popup_business_basic_agreement_phone_invalid_text: 'מספר טלפון לא תקין',
            popup_business_basic_agreement_phone_invalid_subText: 'נא להזין 8-15 ספרות (מספר בינלאומי כולל).',
            popup_business_basic_agreement_phone_invalid_action: 'סגירה',

            // AfterFirstRide page
            afterFirstRideSuccess: 'מעולה, יצרתם טיול חדש.',
            afterFirstRideTitle: 'הוספת פעילויות למסלול',
            afterFirstRideSubtitle: 'הטיול נוצר. כעת אפשר להוסיף פעילויות ולשלוח את המסלול ללקוח.',
            afterFirstRideStepsHeading: 'תהליך הוספת פעילות:',
            afterFirstRideStep1Label: 'נכנסים למסלול ובוחרים יום',
            afterFirstRideStep2Label: 'לוחצים על "הוספת פעילות" וכותבים את שם המקום',
            afterFirstRideStep3Label: 'המערכת מביאה מידע מהרשת על המקום באופן אוטומטי',
            afterFirstRideVideoHeading: 'רוצים לראות איך עושים את זה?',
            afterFirstRideVideoNoSupport: 'הדפדפן שלכם לא תומך בהצגת וידאו.',
            afterFirstRideCta: 'מעבר למסלול שלי',

            // About page
            aboutPageTitle: 'אודות TripPlanner',
            aboutLead: 'אם אתם בונים מסלולי טיול ללקוחות, TripPlanner נבנתה בדיוק עבורכם',
            aboutBody1: 'TripPlanner היא מערכת מקצועית למתכנני טיולים, סוכני נסיעות ומדריכים, שמאפשרת לבנות, לנהל ולשתף מסלולי טיול ללקוחות בצורה מסודרת ונוחה לשימוש מהטלפון.',
            aboutBody2: 'המערכת מרכזת את כל פרטי הטיול במקום אחד ומאפשרת ללקוח גישה פשוטה וברורה לכל המידע לאורך החופשה.',
            aboutBody3: 'כל מסלול כולל חלוקה לפי ימים, הצגה על גבי מפה, ניווט בלחיצה לכל יעד ומידע על מקומות לינה ופעילויות.',
            aboutBody4: 'בנוסף ניתן להוסיף לכל נקודה במסלול תמונה, וידאו או אודיו, ולהעלות וואוצ\'רים ומסמכים רלוונטיים.',
            aboutBody5: 'כך ניתן לבנות מסלולים מודרכים עם הסבר ברור לכל מקום.',
            aboutBody6: 'המערכת מאפשרת עבודה יעילה באמצעות שכפול מסלולים והתאמה אישית לכל לקוח, ושליחה פשוטה של קישור אחד שמרכז את כל המידע שהלקוח צריך.',
            aboutBody7: 'כל המסלולים נשמרים באופן פרטי ומאובטח ונגישים רק לך וללקוחות שלך.',
            aboutBody8: 'TripPlanner פותחה מתוך צורך אמיתי בשטח, כדי לעזור למתכנני טיולים לעבוד בצורה מסודרת, יעילה ונוחה יותר מול הלקוחות שלהם.',
            aboutBody9: 'המערכת נבנית ומתפתחת באופן שוטף בהתאם לצרכים שעולים מהמשתמשים.',
            aboutContactTitle: 'פרטי התקשרות',
            aboutPhoneLabel: 'טלפון',
            aboutPhoneNumber: '052-686-7915',
            aboutEmailLabel: 'אימייל',
            aboutAddressLabel: 'כתובת',
            aboutAddress: 'סלעית 4588500',
            // src/components/Accommodation.vue
            accommodationCheckInMatchesTrip: 'תאריך צ\'ק אין תואם לטיול שלכם',
            accommodationCheckOutMatchesTrip: 'תאריך צ\'ק אאוט תואם לטיול שלכם',
            accommodationEditTitle: 'עריכת הלינה',
            accommodationAddDetailsTitle: 'הוספת פרטי הלינה',
            // src/components/AddAccommodationButton.vue
            addAccommodationAiButton: 'הוספת לינה ב AI',
            clearSuggestedAccommodations: 'הסרת הצעות לינה',
            removeSuggestedAccommodation: 'הסרת הצעת לינה',
            // src/components/AddAtractionButton.vue
            addAttractionAiButton: 'הוספת פעילות ב AI',
            // src/components/BaseFromImage.vue
            baseFromImageAutoDetect: 'זיהוי אוטומטי',
            baseFromImageManualSelect: 'בחירת מקום ידנית',
            baseFromImageEnterPlaceName: 'הכניסו את שם המקום',
            baseFromImageNoGpsWarning: '** התמונה לא מכילה נתוני מיקום, ולכן לא נוכל לעזור באיתור המקום. יש לבחור את שם המקום באופן ידני.',
            baseFromImageNoDateWarning: '** התמונה לא מכילה את זמן הצילום ולכן בסוף התהליך יש לשייך אותה ליום המתאים.',
            baseFromImageMapInstructions: 'ניתן לבחור את המקום על ידי לחיצה על המקום במפה שמציין את מיקום האטרקציה שצולמה או הכנסת את שם המקום בתיבת הטקסט',
            baseFromImageSelectFromList: 'נא לבחור מקום מהרשימה או להכניס ידנית',
            baseFromImageSkipImage: 'דלג על תמונה זו',
            baseFromImageAddAndEditLater: 'הוספת תמונה ועריכתה בהמשך',
            baseFromImageNoGpsAddLater: 'תמונה זו לא מכילה נתוני מיקום, הוספת תמונה ועריכתה בהמשך',
            // src/components/BookingImageLabel.vue
            bookingLabelSave15: 'חסכו 15% על שהייה',
            bookingLabelNewYearDeal: 'מבצע תחילת שנה ל-2025',
            bookingLabelToDeals: 'למבצעים',
            // src/components/Cards/ImageCard.vue
            imageCardIsThisPrefix: 'האים זה ',
            imageCardIsThisPlace: `האים זה ${params.name || ''}?`,
            imageCardPhotoTaken: 'צולם ב-',
            imageCardAccommodationDateLabel: "אנא בחרו את תאריכי הצ'ק-אין והצ'ק-אאוט של המקום לינה",
            yesLabel: 'כן',
            noLabel: 'לא',
            imageCardIfNotCorrect: 'אים זה לא המקום שקשר לתמונה,',
            imageCardChooseManually: 'בחרו ידנית את מקום התמונה',
            imageCardCouldNotDetect: 'לא הצלחתי לזהות את המיקום של התמונה.\nנא לבחור אותו באופן ידני.',
            // src/components/CollaboratorsWith.vue
            collaboratorsWithLabel: 'בשיתוף עם:',
            // src/components/CreateAttraction.vue
            createAttractionNameLabel: 'שם הפעילות',
            createAttractionEditTitle: 'עריכת האטרקציה',
            createAttractionAddToTrip: 'הוספת האטרקציה לטיול',
            // src/components/GlobalRides.vue
            globalRidesListTitle: 'רשימת הטיולים',
            globalRidesViewAndEdit: 'צפה וערוך טיול זה',
            globalRidesAdultsCount: `מבוגרים : ${params.count || ''}`,
            globalRidesTeensCount: `נערים : ${params.count || ''}`,
            globalRidesChildrenCount: `ילדים : ${params.count || ''}`,
            globalRidesAccessibility: `מתאים לאנשים עם מוגבלות : ${params.value || ''}`,
            // src/components/HowItWorks.vue
            howItWorksTitle: 'איך זה עובד?',
            howItWorksStepChoose: 'בוחרים טיול ששותף',
            howItWorksStepAsBase: 'בתור בסיס',
            howItWorksStepAddRemove: 'הוסיפו/הסירו פעילויות',
            howItWorksStepExisting: 'קיימות לטיול',
            howItWorksStepEnjoy: 'תהנו מהטיול',
            howItWorksStepShare: 'ושתפו משפחות',
            // src/components/HowItWorksNewNewCss.vue
            howItWorksSmartTitle: 'איך מתכננים חופשה חכם?',
            howItWorksNewStep3Title: 'צאו לחופשה בכיף ושתפו חברים ומשפחה',
            howItWorksNewStep3Desc: 'תהנו מחוויית חופשה מדהימה עם ליווי מהאתר במהלך הטיול. ותחזירו לקהילה על ידי הוספת החופשה שלכם למאגר באתר ושיתוף עם חברים ומשפחה',
            howItWorksNewStep2Title: 'תוסיפו או תורידו אטרקציות לחופשה שבחרתם',
            howItWorksNewStep2Desc: 'תהנו מתכנון קל ונוח על ידי התאמת החופשה שבחרתם והוספת פעילויות מומלצות מחופשות נוספות ששותפו באתר',
            howItWorksNewStep1Title: 'בחרו חופשה שאהבתם כבסיס לתכנון',
            howItWorksNewStep1Desc: 'התכנון שלכם מתחיל בבחירת חופשה מתוך המאגר באתר, שישמש כבסיס לתכנון החופשה שלכם',
            howItWorksNewViewBtn: 'צפו בחופשות מוצלחות',
            // src/components/InnerNav.vue
            innerNavTripAttractions: 'האטרקציות של הטיול',
            innerNavShareTrip: 'שיתוף הטיול',
            // src/components/InstructionCard.vue
            instructionInterestedInPlanning: 'מעוניינים לתכנן טיול?',
            instructionPickSharedAsStart: 'בוחרים טיול ששותף בתור נקודת התחלה',
            instructionAfterPickAddRemove: 'בחרתם טיול? ניתן להוסיף או להסיר פעילויות קיימות לטיול',
            instructionEnjoyAndShare: 'עכשיו כל מה שנשאר זה להנות מהטיול וכמובן לשתף',
            instructionCardStep3: 'נהנים מהטיול ומשתפים משפחות',
            instructionCardStep2: 'מוסיפים/מסירים פעילויות קיימות לטיול',
            instructionCardStep1: 'בוחרים טיול ששותף בתור בסיס',
            instructionCardViewBtn: 'צפו במסלולי טיול',
            // src/components/InstructionCard1.vue
            instruction1LargeRepoTitle: 'מאגר גדול של אטרקציות וטיולים',
            instruction1LargeRepoBody: 'בסיס גדול של טיולים ושל אטרקציות שאנשים עשו ובוחרים לשתף',
            instruction1ByOtherTravelersTitle: 'כל הטיולים בוצעו ע"י מטיילים אחרים',
            instruction1ByOtherTravelersBody: 'אין כמו המלצות ממטילים שכבר עשו את המסלול, כל המסלולים בוצעו ע"י מטילים  ',
            instruction1EasyEditTitle: 'עריכה קלה של הטיול',
            instruction1EasyEditBody: 'ניתן להוסיף או להוריד אטרקציות לאחר בחירת טיול ',
            instruction1EasyHotelTitle: 'הזמנה קלה ונוחה של מלונות',
            instruction1EasyHotelBody: 'הזמנת מלונות לכל הטיול במקום אחד',
            // src/components/LanguageToggle.vue
            languageToggleLabel: 'English',
            // src/components/LocationCard.vue
            locationCardRecommendedTrips: 'טיולים מומלצים',
            locationCardFlachauTwoWeeks: 'Flachau -  שבועיים באוסטריה',
            locationCardCarinthiaTwoWeeks: 'Carinthia -  שבועיים באוסטריה',
            locationCardSalzburgTirolTwoWeeks: 'שבועיים באוסטריה- אזור זלצבורג וטירול',
            locationCardViennaSalzburg11Days: 'וינה וזלצבורג 11 ימים',
            locationCardAustria10Days: 'אוסטריה - זלצבורג ווינה ב-10 ימים',
            locationCardPolandTatraTwoWeeks: 'טיול שבועיים לדרום פולין והרי הטטרה בסלובקיה',
            locationCardAustria9Days: 'אוסטריה - זלצבורג ווינה ב-9 ימים',
            viewTripRoutes: 'צפו במסלולי טיול',
            // src/components/Modals/ConfirmForceAddDay.vue
            confirmForceActiveAccommodationTitle: 'הזמנת לינה פעילה',
            confirmForceActiveAccommodationBody: 'יש לכם הזמנת פעילה של לינה בתאריכים אלה או בימים עוקבים בתוכנית.\n\nאם תמשיכו, תאריכי הלינה יתעדכנו באופן אוטומטי בתצוגה של המערכת לפי השינויים שתתבצעו.',
            noteLabel: 'שימו לב:',
            confirmForceAddDayWarning: 'פעולה זו על אחריותכם!',
            confirmForceAddDayConfirm: 'כן, אני מבין - המשך',
            // src/components/Modals/ConfirmRemoveDayWithExtraInfo.vue
            confirmRemoveDayIrreversible: 'פעולה זו בלתי הפיכה!',
            confirmRemoveDayRiskConfirm: 'כן, אני מבין את הסיכונים - המשך',
            confirmRemoveDayWithExtraInfoTitle: 'אזהרה חשובה',
            confirmRemoveDayWithExtraInfoBody: 'מחיקת היום תגרום לאיבוד לצמיתות של כל המידע הכללי הקשור ליום זה, כולל טקסטים והסברים נלווים.',
            confirmRemoveDaySureQuestion: 'האם אתם בטוחים שברצונכם להמשיך?',
            // src/components/Modals/ContactForm.vue
            contactFormTitle: 'צור קשר',
            contactFormSubtitle: 'נשמח לשמוע מכם ולעזור לכם להבין איך TripPlanner יכולה לעזור לעסק שלכם',
            contactFormFullName: 'שם מלא',
            contactFormPhoneLabel: 'מספר טלפון (חובה)',
            contactFormEmailLabel: 'כתובת אימייל',
            contactFormHelpPlaceholder: 'איך נוכל לעזור לכם? ספרו לנו על הצרכים שלכם...',
            contactFormSending: 'שולח...',
            contactFormSendMessage: 'שלח הודעה',
            // src/components/Modals/DynamicModal.vue
            dynamicModalCreditFinishedMessage: 'היי, התחלתי להשתמש ב-TripPlanner וסיימתי את הקרדיט הראשוני.\nאשמח להמשיך לעבוד עם המערכת ולפתוח את החשבון לשימוש נוסף.',
            // src/components/Modals/InsufficientBalanceModal.vue
            insufficientBalanceTitle: 'הקרדיט הראשוני שלך נוצל',
            insufficientWhatsapp: 'צרו קשר בווצאפ',
            insufficientCallUs: 'או להתקשר אלינו: 052-686-7915',
            insufficientBalanceMessage: 'כדי להמשיך לשתף מסלולים ולפתוח את החשבון לשימוש נוסף, אפשר ליצור איתנו קשר ונשמח לעזור לך להתחיל לעבוד בצורה שוטפת. ניתן להמשיך לבנות ולערוך מסלולים ללא הגבלה.',
            // src/components/Modals/LoginForm.vue
            loginConnectViaEmail: 'ליימ תועצמאב רבחתה',
            loginEmailLabel: 'ליימ',
            loginForgotPassword: '?חכש',
            loginPasswordLabel: 'אמסיס',
            loginSubmitButton: 'תורבחתה',
            loginNoAccount: 'ןובשח ךל ןיא?',
            loginRegisterLink: 'םשריה',
            loginErrorMessage: 'המסיס וא שמתשמ םשב האיגש',
            // src/components/Modals/MainRegistration.vue
            mainRegistrationEnterPassword: 'אנא הכנסו סיסמה להרשמה',
            mainRegistrationPasswordMismatch: 'הסיסמאות אינן תואמות. אנא וודא שהזנת את אותה סיסמה בשני השדות',
            // src/components/Modals/Modals.vue
            modalsPickTripBeforeEdit: 'אנא רחב בטיול לפני עריכתו',
            modalsMustChooseDesiredTrip: 'יוצרה לויטה תא רוחבל ךילע ,לויטה יונישב ךישמהל תנמ לע',
            modalsChooseTheTrip: 'לויטה תא רוחבל',
            modalsPleaseRegisterToContinue: 'אנא המשריה ומשכשנ להמשיך',
            modalsRegisterVia: 'תועצמאב םשריה',
            modalsOr: 'ֹוא',
            modalsShareTrip: 'לויט ףתשל',
            modalsShareDescription: 'כל מי שיש לו את הרושיק יכול לראות את תוכניתך אך לא יראה את האירועים, ההערות, הקבצים המצורפים וההזמנות המותאמות אישית שלך',
            modalsCopyPublicLink: 'העתק רושיק ציבורי',
            modalsShareViaEmail: 'שתף רושיק באמצעות ל"אוד',
            // src/components/Modals/OldSignup.vue
            oldSignupPrivacyAndTermsOf: 'לש תויטרפה תוינידמלו שומישה',
            oldSignupAgreeToTerms: 'יאנתל םיכסמ',
            // src/components/Modals/PleaseAddTheRideToYourList.vue
            pleaseAddRideToSaveChangesTitle: 'כדי שנוכל לשמור לכם את השינויים',
            pleaseAddRideToListText: 'יש להוסיף את הטיול לרשימת הטיולים שלי',
            addThisRideToMyList: 'הוספת טיול זה לטיול שלי',
            // src/components/Modals/Pop-ups/PopUpTemplate.vue
            popupTemplateResetKeyword: 'איפוס',
            // src/components/Modals/ResetForm.vue
            resetFormPasswordReset: 'אמסיס סופיא',
            resetFormEnterEmailDescription: 'הזן את כתובת האימייל שלך ואנחנו נשלח לך קישור לאיפוס סיסמת Tripplanner שלך.',
            resetFormSendLink: 'תשלח קישור',
            resetFormToRegister: 'םשריהל',
            resetFormToSignIn: 'תורבחתהל',
            // src/components/Modals/ResetPassword.vue
            resetPasswordTitle: 'איפוס סיסמה',
            resetPasswordEmailPlaceholder: 'הזן את כתובת האימייל שלך',
            resetPasswordSendLink: 'שלח קישור לאיפוס סיסמה',
            resetPasswordBackToLogin: 'חזרה להתחברות',
            // src/components/Modals/ShareRide.vue
            shareRideToFriendsTitle: 'שליחת הטיול לחברים',
            shareRideToFriendsBody: 'יש כאן טיול מגניב שניתן להעתיק אליכם לחשבון ואז לערוך אותו',
            shareRideFamilyTripTitle: 'בנית טיול משפחתי.',
            shareRideFamilyTripDescription: 'יש כאן בסיס לטיול שניתן להתאים לרצונות שלנו',
            // src/components/Modals/SignupForm.vue
            signupRegisterViaEmail: 'ליימ תועצמאב םשריה',
            signupPasswordAgain: 'תפסונ םעפ אמסיס',
            signupUsername: 'שמתשמ םש',
            signupRead: 'יתארק',
            signupAlreadyHaveAccount: 'ןובשח ךל שי רבכ ?',
            // src/components/PartnershipSection.vue
            partnershipWith: 'בשיתוף עם',
            // src/components/RideInformation.vue
            rideInformationTitle: 'פרטי טיול',
            rideInformationTripTitle: 'כותרת הטיול',
            rideInformationFreeText: 'טקסט חופשי על הטיול',
            rideInformationAdultsCount: 'מספר המבוגרים',
            rideInformationTeensCount: 'מספר הנערים',
            rideInformationChildrenCount: 'מספר הילדים',
            rideInformationAccessibility: 'מתאים לאנשים עם מוגבלות?',
            rideInformationDepartureDate: 'תאריך יציאה',
            rideInformationReturnDate: 'תאריך חזרה',
            rideInformationCreateTrip: 'יצירת הטיול',
            rideInformationEditTrip: 'עריכת הטיול',
            // src/components/SearchBar.vue
            searchBarEnterLocation: 'הזנת מיקום',
            searchBarSearchButton: 'חפשו טיול',
            searchBarAccessible: 'מתאים לאנשים עם מוגבלות',
            searchBarDaysLabel: 'ימים',
            searchBarPeopleLabel: 'אנשים',
            // src/components/SearchBar.vue (dropdown, commented-out section)
            searchBarDefaultSelection: '2 מבוגרים 2 ילדים',
            searchBarAdults: 'מבוגרים',
            searchBarTeens: 'נערים',
            searchBarChildren: 'ילדים',
            // src/components/Cards/ResultOfSearchCard.vue
            resultCardDays: 'ימים',
            resultCardViewRoute: 'צפיה במסלול החופשה',
            // src/components/Modals/DoYouWantToAddThisPointToRide.vue
            doYouWantModalQuestion: 'התמונה שצילמתם נלקחה מהמקום שבחרתם במפה?',
            doYouWantModalDescription: 'פעולה זואת תוסיף את התמונה שצילמתם בתור הנקודה שבחרתם במפה',
            doYouWantModalNo: 'לא זה לא המקום',
            doYouWantModalYes: 'כן זה המקום',
            // src/components/SerchAttractionCategories.vue
            serchCategoriesFromGoogle: 'פעילויות מומלצות מ Google',
            serchCategoriesFromOtherTrips: 'פעילויות מומלצות מטיולים אחרים',
            // src/components/SingleRideChecklist.vue
            checklistViewBooking: 'צפיה בהזמנה',
            checklistBookingRegistered: 'ההזמנה רשומה במערכת',
            checklistFindAccommodation: 'מציאת מקום לינה',
            // src/components/SingleRide.vue
            singleRideVideoFallback: 'וידאו',
            singleRideAudioFallback: 'אודיו',
            // src/components/SingleRideSumary.vue
            singleRideSumaryOneTraveler: 'מטייל אחד',
            singleRideSumaryTravelers: 'מטיילים',
            // src/components/UserRides.vue
            userRidesAddCompletedTrip: '+הכנסת פרטי טיול שכבר נעשה+',
            userRidesMyRides: 'הטיולים שלי',
            userRidesViewAndEdit: 'צפה וערוך טיול זה',
            // src/views/About.vue
            aboutMetaDescription: 'מערכת מקצועית למתכנני טיולים לבנייה, ניהול ושיתוף מסלולים עם לקוחות',
            // src/views/AddAccommodationFromImage.vue
            addAccommodationPlaceTitle: 'הוספת מקום לינה',
            // src/views/AddAccommodationsImage.vue
            addAccommodationsImageInstructions: 'נתחיל בהעלאת התמונות. כמו בתהליך הקודם, יש להעלות תמונה אחת מכל המקומות שבהם ישנתם. אם המלון שלכם לא היה מומלץ, מומלץ להעלות תמונה מהאזור ולציין באיזה אזור כדאי לישון במקום לציין את שם המלון.',
            addAccommodationsImageSubtitle: 'הוספת מקום לינה - כך שמי שיעתיק מכם את הטיול יוכל לדעת באיזה אזור מומלץ לישון ולקבל המלצה.',
            addAccommodationsImageButton: 'הוספת מקומות לינה',
            // src/views/AddAtractionsImage.vue
            addAttractionsImageHeroTitle: 'יצירת טיול בצורה אוטומטית על ידי העלאת תמונות מהטיול',
            addAttractionsImageAutoEntry: 'הכנסה אוטומטית של הטיול',
            addAttractionsImageRulesIntro: 'כדאי ליצור את הטיול יש ללכת לאלבום התמונות בטלפון ולהעלות את התמונות מהטיול לפי הכללים הבאים:',
            addAttractionsImageRuleOnePhotoEach: 'יש להעלות תמונה אחת בלבד מכל אטרקציה.',
            addAttractionsImageRuleAllAtOnce: 'מומלץ להעלות את כל התמונות בבת אחת.',
            addAttractionsImageRuleGps: 'חובה שהתמונות יכילו נתוני מיקום (GPS).',
            addAttractionsImageRuleLocationOn: 'ודאו ששיתוף המיקום פעיל בעת העלאת התמונות.',
            addAttractionsImageRuleAnyPlace: 'התמונות יכולות לכלול כל מקום שתרצו להמליץ עליו למטיילים הבאים: מסעדה, שפת אגם, או כל מקום מעניין אחר.',
            addAttractionsImageAddAttractions: 'הוספת אטרקציות',
            addAttractionsImageUploadAll: 'העלו את כל התמונות (אחת מכל אטרקציה)',
            // src/views/Attraction.vue
            attractionFreeText: 'טקסט חופשי על הפעילות',
            // src/views/DeleteUser.vue
            deleteUserTitle: 'מחיקת משתמש',
            deleteUserPhone: 'טלפון : 052-686-7915',
            deleteUserEmail: 'אימייל:     avshalom@tripplanner.co.il',
            deleteUserAddress: 'Salit 4588500  כתובת:',
            // src/views/DeleteUser.vue (additional)
            deleteUserInstructionLine1: 'כדי למחוק משתמש יש לשלוח מייל',
            deleteUserInstructionLine2: 'ולבקש להוריד את הפרטים שלכם',
            // src/views/DigitalGuideInfo.vue
            digitalGuideToRecommendedTrips: 'לטיולים המומלצים',
            digitalGuideMetaDescription: 'מסלול דיגיטלי בנייד עם מפה ואטרקציות',
            digitalGuideNavInterfaceAlt: 'ממשק ניווט של מסלול דיגיטלי',
            digitalGuideWhatIsTitle: 'מה זה מסלול דיגיטלי?',
            // src/views/EditingAtractionsUniqnes.vue
            editingAttractionsDisplayTitle: 'עריכת פעילויות לתצוגה',
            // src/views/FeaturedRideDetail.vue
            featuredRideDetailTripNumberLabel: 'מספר טיול:',
            featuredRideDetailTripNumberWithId: `מספר טיול: ${params.id || ''}`,
            featuredRideDetailDescriptionTitle: 'תיאור הטיול',
            featuredRideDetailDescriptionBinding: 'תיאור הטיול',
            featuredRideDetailPurchaseTrip: 'רכישת טיול',
            featuredRideDetailBackToList: 'חזרה לרשימת המסלולים',
            featuredRideDetailNotFoundTitle: 'טיול לא נמצא',
            featuredRideDetailNotFoundBinding: 'טיול לא נמצא',
            featuredRideDetailNotFoundBody: 'הטיול המבוקש לא נמצא במערכת.',
            featuredRideDetailNotFoundBodyBinding: 'הטיול המבוקש לא נמצא במערכת.',
            featuredRideDetailBackShort: 'חזרה לרשימה',
            featuredRideDetailMetaTitle: 'מסלול טיול - TripPlanner',
            featuredRideDetailMetaTitleShort: 'מסלול טיול',
            featuredRideDetailMetaDescription: 'פרטי מסלול טיול ב-TripPlanner',
            // src/views/FeaturedRidesLanding.vue
            featuredRidesLandingHeaderBinding: 'טיולים מומלצים',
            featuredRidesLandingSubtitle: 'גלו את הטיולים שלנו - מסלולים מוכנים ומתוכננים במיוחד עבורכם',
            featuredRidesLandingConsultingBinding: 'ייעוץ ותכנון טיול אישי',
            consultingAndPersonalPlanning: 'ייעוץ ותכנון טיול אישי',
            forMoreDetails: 'לפרטים נוספים',
            digitalItineraries: 'מסלולים דיגיטליים',
            digitalItinerariesStrong: '<strong>מסלולים דיגיטליים</strong>',
            managerWithIndex: `מנהל ${params.index || ''}`,
            topDestinations: 'יעדים מובילים',
            allDestinations: 'כל היעדים',
            // src/views/HomePage.vue
            homePageFamiliesShareTrips: 'משפחות משתפות טיולים - אתם בוחרים מה מתאים לכם',
            homePageWhereTo: '?לאן טסים',
            homePageWhatYouCanDo: 'מה אפשר לעשות בTrip Planner',
            homePageShareTrip: 'שתפו טיול',
            homePagePlanTrip: 'תכננו טיול',
            homePageRecentlySharedTrips: 'טיולים ששותפו לאחרונה',
            homePageWhyChoose: 'למה לבחור בTrip Planner',
            homePageBreadcrumb: 'עמוד הבית',
            homePageSharedByAvshalom: 'שותף ע״י אבשלום כץ',
            homePageSharedByAshchar: 'שותף ע״י אשכר ארבליך-בריפמן',
            homePagePolandSlovakiaTrip: 'שבועיים בדרום פולין והרי הטטרה בסלובקיה',
            homePageSharedByAvshalomWithSpace: 'שותף ע״י אבשלום כץ ',
            homePagePeopleReversed: 'םישנא',
            homePageEnterLocationReversed: 'םוקימ ןזה',
            homePageDaysReversed: 'םימי',
            homePageDays: 'ימים',
            homePageHeroTitle1: 'טסים לחו"ל?',
            homePageHeroTitle2: 'צפו במאגר הטיולים',
            homePageShareTripBtn: 'שיתוף טיול',
            homePageViewBtn: 'לצפייה',
            homePageGreatTripQuestion: 'תכננתם טיול אדיר? שתפו אותו',
            homePageOthersBrokeHead: 'אחרים כבר שברו ת\'ראש במקומכם, העתיקו וערכו',
            homePageSearchRoutes: 'חיפוש מסלולים',
            homePageRecommendationsBody: 'אין כמו המלצות ממטיילים שכבר עשו את המסלול, כל המסלולים בוצעו ע"י מטיילים',
            homePageLargeRepoBody: 'בסיס גדול של טיולים ושל אטרקציות שאנשים עשו ובוחרים לשתף',
            homePageEasyHotelBooking: 'הזמנה קלה ונוחה של מלונות',
            homePageEasyHotelBookingBody: 'הזמנת מלונות לכל הטיול במקום אחד',
            homePageEasyTripEditing: 'עריכה קלה של הטיול',
            homePageEasyTripEditingBody: 'ניתן להוסיף או להוריד אטרקציות לאחר בחירת טיול',
            homePageViewTripRoutes: 'צפו במסלולי טיול',
            homePageOpenTextAustria: 'אחרי אינספור חיפושים, קריאות וחקר, הצלחנו להרכיב את הטיול שיהיה מושלם עבור משפחתנו באוסטריה. החלטנו על אזור טיול (חבל זלצבורג) ועל מקום לינה שממנו יצאנו לטיול כוכב. מזג האוויר היה הפכפך. בוינה חם במהלך היום, קריר יותר במהלך הלילה, בחבל זלצבורג ובטיולים בהם עלינו להרים היה קר וגם גשום לעיתים.',
            homePageOpenTextSalzburgTirol: 'הי, אני אשכר (ארבליך-בריפמן) ואני סופרת ילדים ונוער ומנחת סדנאות כתיבה אינטרנטיות לילדים. מעבר לכך, אני נשואה ואמא לשלוש בנות. המשפחה שלנו חובבת מושבעת של טיולים. בחרתי לחלוק איתכם ולשתף אתכם בטיולנו לאוסטריה.',
            homePageOpenTextPolandSlovakia: 'טיול משפחתי שחיכינו לו הרבה זמן (הטיול הראשון מאז הקורונה). זוג הורים + ארבעה ילדים ביגלאי 4-11. אוהבים טבע, אטרקציות ומסלולים קלילים, כך שאחרי הרבה מחשבה החלטנו לטייל בדרום פולין ולשלב גיחות לסלובקיה (בפועל היינו שם שלושה ימים)...',
            homePageTravelersChooseSubtitle: 'משפחות משתפות טיולים - אתם בוחרים מה מתאים לכם',
            homePageShareTripBtnSimple: 'שתפו טיול',
            homePageIconboxTravelersTitle: 'כל הטיולים בוצעו ע"י מטיילים אחרים',
            homePageIconboxLargeRepoTitle: 'מאגר גדול של אטרקציות וטיולים',
            homePageFooterHome: 'עמוד הבית',
            homePageFooterAbout: 'אודות',
            homePageFooterSearch: 'חיפוש טיולים',
            homePageFooterTerms: 'תקנון',
            homePageFooterContact: 'יצירת קשר',
            // src/views/HomePageNew.vue
            homePageNewMetaTitle: 'TripPlanner | תכנון מסלולי טיול',
            // src/views/InsertNewRideFromGooglePhotos.vue
            insertNewRideAddTitle: 'הוספת טיול חדש',
            insertNewRideExplainerVideo: 'סרטון הסבר',
            insertNewRideContinueToTrip: 'המשיכו לטיול שלכם',
            insertNewRideWelcomeLine1: 'אנו שמחים שבחרתם לעזור לקהילה שלנו לתכנן טיול ליעד נוסף ע"י הוספת מסלול הטיול שלכם.',
            insertNewRideWelcomeLine2: 'הוספת מסלול לאתר היא פעולה פשוטה שנעשית בשלושה שלבים.',
            insertNewRideStep1: 'יוצרים אלבום תמונות עם תמונה אחת מכל מקום בטיול -',
            insertNewRideStep2: 'משתפים את האלבום עם המיקום דרך אימייל: avshalom@tripplanner.co.il או ב -',
            insertNewRideStep3: 'הטיול יווצר באופן אוטומטי ואתם תוכלו להוסיף את החוויות שלכם',
            // src/views/LandingForPlanners.vue
            landingPlannersMetaTitle: 'דף נחיתה למתכנני טיולים',
            landingPlannersHeroQuestion: 'בונים מסלולי טיול ללקוחות?',
            landingPlannersHowItLooks: 'כך נראה המסלול שהלקוחות שלכם יקבלו',
            landingPlannersPreviousImage: 'תמונה קודמת',
            landingPlannersNextImage: 'תמונה הבאה',
            landingPlannersGoToImage: `עבור לתמונה ${params.index || ''}`,
            landingPlannersSampleItinerary: 'דוגמה למסלול',
            landingPlannersOpenSample: 'פתחו מסלול לדוגמה',
            landingPlannersSendDetails: 'שליחת פרטים',
            landingPlannersAlternativeContact: 'אפשרות חלופית ליצירת קשר',
            landingPlannersOpenWhatsApp: 'פתחו WhatsApp כדי לשלוח הודעה',
            landingPlannersToSummary: 'לסיכום',
            landingPlannersProtectYourContent: 'שמירה על התוכן שלכם',
            landingPlannersProtectYourContentBody: 'כל מסלול מוגן ואינו ניתן להעברה לאחרים, אלא רק למי שאתם מגדירים.',
            landingPlannersProfessionalLook: 'מראה מקצועי וממותג',
            landingPlannersProfessionalLookBody: 'המסלול מוצג בעיצוב נקי עם לוגו וצבעי העסק שלכם.',
            landingPlannersAllInOnePlace: 'הכל במקום אחד',
            landingPlannersAllInOnePlaceBody: 'לינה, אטרקציות, מפות, הערות אישיות וקישורים. הכל במקום אחד מאורגן וברור.',
            landingPlannersEasyClientAccess: 'גישה קלה ללקוחות',
            landingPlannersEasyClientAccessBody: 'שולחים קישור, הלקוח פותח בדפדפן בטלפון. אין צורך להוריד אפליקציה.',
            landingPlannersRealTimeSaving: 'חיסכון אמיתי בזמן',
            landingPlannersRealTimeSavingBody: 'בונים מסלול פעם אחת, מעתיקים אותו בלחיצה, ומתאימים לכל לקוח בקלות.',
            landingPlannersOfflineConvenience: 'נוחות גם באופליין',
            landingPlannersOfflineConvenienceBody: 'המידע נשמר כך שגם בזמן טיול בלי קליטה הכל עדיין זמין.',
            landingPlannersFullViewAlt: 'תצוגת מסלול מלאה - כל הטיול במבט אחד',
            landingPlannersDailyDetailAlt: 'פירוט יומי לכל יום - היעדים במפה עם ניווט בלחיצה',
            landingPlannersAllActivitiesAlt: 'כל הפעילויות בטיול - מסודרות לפי ימים',
            landingPlannersDayMapAlt: 'מפת היום - כל נקודות העניין במקום אחד',
            landingPlannersDirectNavAlt: 'ניווט ישיר ליעדים דרך Google Maps',
            landingPlannersWhatsAppMessage: 'היי! אשמח לקבוע פגישת היכרות קצרה לגבי TripPlanner. מתי נוח לך?',
            landingPlannersMessageSentSuccess: 'תודה! ההודעה נשלחה בהצלחה. נחזור אליכם בהקדם.',
            landingPlannersMessageSentError: 'אירעה שגיאה בשליחת ההודעה. אנא נסו שוב מאוחר יותר.',
            landingPlannersEnterName: 'אנא הזינו את שמכם',
            landingPlannersEnterPhone: 'אנא הזינו מספר טלפון',
            landingPlannersEnterValidPhone: 'אנא הזינו מספר טלפון תקין (8-15 ספרות, בינלאומי כולל)',
            landingPlannersConfirmPrivacy: 'אנא אשרו את מדיניות הפרטיות',
            landingPlannersEmailNoSpaces: 'כתובת האימייל לא יכולה להכיל רווחים',
            landingPlannersEnterValidEmail: 'אנא הזינו כתובת אימייל תקינה',
            landingPlannersHeroSubtitle: 'TripPlanner היא מערכת שמאפשרת לכם להכניס את המסלולים שאתם בונים ולהציג אותם ללקוחות בצורה דיגיטלית, אינטראקטיבית וברורה, שחוסכת לכם שעות עבודה בכל תכנון.',
            landingPlannersWhatIsTitlePrefix: 'מה זה',
            landingPlannersWhatIsTitleSuffix: '?',
            landingPlannersWhatIsBody1: 'TripPlanner היא פלטפורמה דיגיטלית וכלי עבודה למתכנני טיולים, מדריכים וסוכנים, שמרכזת את כל פרטי הטיול במקום אחד ומציגה אותם ללקוח בצורה ברורה ונוחה לשימוש.',
            landingPlannersWhatIsBody2: 'המסלול כולל מפות, ניווט, שעות פתיחה, לינה, פעילויות והמלצות, והכל נגיש מהטלפון במהלך הטיול.',
            landingPlannersHowItLooksSub: 'כל הטיול מרוכז במקום אחד, ברור ונוח לשימוש מהטלפון',
            landingPlannersBenefitsTitle: 'היתרונות שתקבלו משימוש ב-TripPlanner',
            landingPlannersBenefitsIntro: 'הכלים שיעזרו לכם לעבוד מהר יותר, להציג מסלולים בצורה מקצועית יותר, ולתת ללקוחות חוויית טיול ברורה ונוחה.',
            landingPlannersLeaveDetails: 'השאירו פרטים',
            landingPlannersDemoExplainer: 'כך נראה המסלול שהלקוחות שלכם מקבלים ומשתמשים בו במהלך הטיול:',
            landingPlannersDemoFooter: 'הכל מסודר לפי ימים עם מפה, ניווט והפעילויות של כל יום.',
            landingPlannersInterestedQuestion: 'רוצים לראות אם TripPlanner מתאימה לכם?',
            landingPlannersInterestedSub: 'השאירו פרטים ונחזור אליכם לקביעת פגישת היכרות קצרה.',
            landingPlannersContactUsTitle: 'צור קשר',
            landingPlannersContactUsSubtitle: 'נשמח לשמוע מכם ולעזור לכם להבין איך TripPlanner יכולה לעזור לעסק שלכם',
            landingPlannersFormFullName: 'שם מלא',
            landingPlannersFormPhone: 'מספר טלפון (חובה)',
            landingPlannersFormEmail: 'כתובת אימייל',
            landingPlannersFormMessage: 'איך נוכל לעזור לכם? ספרו לנו על הצרכים שלכם...',
            landingPlannersFormAcceptPrefix: 'קראתי ואני מאשר/ת את',
            landingPlannersFormPrivacyPolicyLink: 'מדיניות הפרטיות',
            landingPlannersFormSending: 'שולח...',
            landingPlannersFormSubmit: 'שליחת פרטים',
            landingPlannersAlsoSendWhatsApp: 'אפשר גם לשלוח לנו הודעה ב-WhatsApp',
            landingPlannersSendWhatsApp: 'שלחו ב-WhatsApp',
            landingPlannersClosingBody1: 'TripPlanner נבנתה במיוחד עבור מתכנני טיולים מקצועיים. היא עוזרת לכם להיראות טוב יותר, לעבוד חכם יותר, ולהעניק ללקוחות חוויה מדויקת ונעימה יותר. הלקוחות שלכם ירגישו את ההבדל ואתם תרגישו את זה בזמן שאתם חוסכים בכל תכנון.',
            landingPlannersClosingBody2: 'TripPlanner אינה בונה את המסלול במקומכם. היא כלי עבודה שמציג בצורה ברורה ונוחה את הידע והניסיון המקצועי שלכם.',
            // src/views/LandingForPlannersNoFlight.vue
            landingPlannersNoFlightHero: 'בונים מסלולי טיול ללקוחות אבל כרגע פחות עמוס?',
            landingPlannersNoFlightHeroSub1Line1: 'המצב הבטחוני יצר תקופה שקטה יותר ביומנים',
            landingPlannersNoFlightHeroSub1Line2: 'וזו בדיוק ההזדמנות להכין תשתית חכמה לעסק שלכם ליום שאחרי',
            landingPlannersNoFlightHeroSub2Line1: 'כשהשמיים ייפתחו והביקוש יחזור',
            landingPlannersNoFlightHeroSub2Line2: 'מי שיהיה מוכן מראש יוכל לתת יותר מסלולים, יותר מהר, ובאיכות גבוהה יותר',
            landingPlannersNoFlightHeroSub3Line1: 'TripPlanner מאפשרת לכם לבנות את המסלולים שלכם עכשיו',
            landingPlannersNoFlightHeroSub3Line2: 'ולחסוך שעות עבודה כשיגיע העומס',
            landingPlannersNoFlightWhatIsBody1Line1: 'TripPlanner היא מערכת עבודה למתכנני טיולים, מדריכים וסוכנים',
            landingPlannersNoFlightWhatIsBody1Line2: 'שמאפשרת לכם לבנות מסלולים בצורה מסודרת עכשיו',
            landingPlannersNoFlightWhatIsBody1Line3: 'ולהשתמש בהם שוב ושוב כשלקוחות חוזרים לטוס',
            landingPlannersNoFlightWhatIsBody2Line1: 'המערכת מרכזת את כל פרטי הטיול במקום אחד',
            landingPlannersNoFlightWhatIsBody2Line2: 'ומציגה אותם ללקוח בצורה דיגיטלית, ברורה ונוחה לשימוש מהטלפון',
            landingPlannersNoFlightCampaignWhyNowTitle: 'למה דווקא עכשיו להתחיל לעבוד עם TripPlanner?',
            landingPlannersNoFlightWhatsAppMessage: 'היי, קראתי אצלכם על ניצול התקופה השקטה ביומן כדי להתכונן לכשהביקוש יחזור, ורציתי לשמוע עוד על TripPlanner. מתאים לקבוע שיחה קצרה?',
            // src/views/OfflineRideRecovery.vue
            offlineRecoveryNotice: 'מצב תצוגה לא מקוון - ייתכן שהמידע אינו מעודכן',
            offlineRecoveryActivitiesLabel: 'פעילויות:',
            offlineRecoveryAccommodationLabel: 'מקום לינה:',
            offlineCheckingConnectivity: 'בודק חיבור לאינטרנט...',
            offlineDayLabel: 'יום',
            offlineNavigateGoogleMaps: 'ניווט ב-Google Maps',
            // src/views/PaymentPage.vue
            paymentPageSampleProduct: 'מוצר לדוגמה',
            paymentPageSampleProductDesc: 'תיאור המוצר - זהו מוצר לדוגמה עבור בדיקת תהליך התשלום',
            paymentPageCompletePayment: 'השלימו את התשלום',
            // src/views/PaymentSuccess.vue
            paymentStatusTitle: 'סטטוס תשלום',
            // src/views/PrivateConsultingInfo.vue
            consultingHeroBinding: 'ייעוץ ותכנון טיול אישי',
            consultingBackToRecommended: 'חזרה לטיולים המומלצים',
            consultingCtaContactBinding: 'צרו קשר לייעוץ ותכנון טיול אישי',
            consultingCtaContactPlural: 'צרו קשר לייעוץ ותכנון טיול אישי',
            consultingCtaWhatsAppBinding: 'צור קשר ב-WhatsApp לייעוץ ותכנון טיול אישי',
            consultingCtaWhatsApp: 'צור קשר ב-WhatsApp לייעוץ ותכנון טיול אישי',
            consultingWhatsAppMessage: 'שלום! אני מעוניין/ת בייעוץ ותכנון טיול אישי',
            // src/views/RequestPasswordReset.vue
            requestPasswordResetTitle: 'בקשת איפוס סיסמה',
            requestPasswordResetSendLink: 'שלח קישור לאיפוס',
            // src/views/ResetPasswordPage.vue
            resetPasswordPageEnterNew: 'הזן את הסיסמה החדשה שלך',
            resetPasswordPageNewPassword: 'סיסמה חדשה',
            resetPasswordPageConfirmPassword: 'אימות סיסמה',
            resetPasswordPageUpdate: 'עדכן סיסמה',
            // src/views/RideChecklist.vue
            rideChecklistAccommodations: 'מקומות הלינה',
            // src/views/SearchAccommodationWithMap.vue
            searchAccommodationMetaTitleWithLocation: `לינה ב${params.location || ''} | TripPlanner`,
            searchAccommodationMetaTitle: 'חיפוש לינה | TripPlanner',
            searchAccommodationMetaDescription: `מקומות לינה ב${params.location || ''} שמטיילים המליצו עליהם ב-TripPlanner`,
            // src/views/SearchRide.vue
            searchRideFindPerfectTrip: 'מצא את החופשה המושלמת',
            searchRideAccessibilityFilter: 'מתאים לאנשים עם מוגבלות תנועה',
            searchRideChildren: 'ילדים',
            searchRideTeens: 'נערים',
            // src/views/SingleMapWithAllSearchOnMap.vue
            showPoints: 'הצגת הנקודות',
            searchRideAdults: 'בוגרים',
            searchRideAnd: ' ו',
            searchRideMetaTitleWithLocation: `מסלולי טיול ואטרקציות ב${params.location || ''} | TripPlanner`,
            searchRideMetaTitle: 'חיפוש מסלולי טיול ואטרקציות | TripPlanner',
            searchRideMetaDescriptionWithLocation: `גלה מסלולי טיול ואטרקציות ב${params.location || ''} - מסלולים שמטיילים העלו ל-TripPlanner. מצא השראה לטיול הבא שלך ב${params.location || ''}`,
            searchRideMetaDescription: 'חיפוש מסלולי טיול ואטרקציות - מצא מסלולים שמטיילים אחרים שיתפו ב-TripPlanner',
            searchRideSearchTitle: 'חיפוש מסלולי טיול',
            searchRideHeaderWithLocation: `מסלולי טיול ואטרקציות ב${params.location || ''}`,
            searchRideMetaKeywordsWithLocation: `${params.location || ''}, מסלולי טיול, אטרקציות, ${params.location || ''} trips, ${params.location || ''} attractions, TripPlanner`,
            searchRideMetaKeywords: 'מסלולי טיול, אטרקציות, TripPlanner',
            searchRideNoResultsText: 'מצטערים, כרגע אין לנו חופשות שמשפחות שיתפו למיקום זה. נשמח אם תוכלו לעזור להעשיר את מאגר החופשות המשותפות ולהוסיף את החופשה לאתר עם חזרתכם לארץ.',
            // src/views/SingleRideWithMap.vue
            singleRideMetaTitle: 'מסלול טיול | TripPlanner',
            singleRideMetaTitleSuffix: ' - מסלול טיול | TripPlanner',
            singleRideBreadcrumbTitle: 'מסלול טיול',
            // src/views/StoreForPlanners.vue
            storeForPlannersMetaTitle: 'דף נחיתה למכירת מסלולים דיגיטליים',
            storeForPlannersCustomItineraries: 'להכין מסלולים מותאמים אישית ללקוחות שלכם',
            storeForPlannersShelfProduct: 'או ליצור מסלולים למטיילים שרוצים לטייל לבד ולרכוש מסלול כמוצר מדף',
            storeForPlannersWhatClientGets: 'מה הלקוח מקבל אחרי הרכישה?',
            storeForPlannersAllInOneClear: 'כל הטיול מרוכז במקום אחד, ברור ונוח לשימוש מהטלפון',
            storeForPlannersWhatIsStore: 'מה זה חנות המסלולים?',
            storeForPlannersHowToSell: 'כך אתם יכולים למכור מסלולים',
            storeForPlannersHowItLooksInPractice: 'כך זה נראה בפועל',
            storeForPlannersSampleClientItinerary: 'דוגמה למסלול שהלקוח מקבל:',
            storeForPlannersSampleStore: 'דוגמה לחנות מסלולים:',
            storeForPlannersReadAndApprove: 'קראתי ואני מאשר/ת את',
            storeForPlannersWantToSeeFit: 'רוצים לראות אם TripPlanner מתאימה לכם?',
            storeForPlannersWhatsAppCta: 'שלחו לנו הודעה ב-WhatsApp',
            storeForPlannersLeaveDetails: 'השאירו פרטים',
            storeForPlannersFeatureDailyClear: 'פירוט יומי ברור של המסלול',
            storeForPlannersFeatureMap: 'כל היעדים מוצגים על מפה',
            storeForPlannersFeatureNav: 'ניווט ישיר לכל יעד בלחיצה',
            storeForPlannersFeatureNoApp: 'הכל נגיש מהטלפון, בלי צורך להוריד אפליקציה',
            storeForPlannersStepCreate: 'יוצרים מסלול במערכת',
            storeForPlannersStepCreateBody: 'בונים את המסלול פעם אחת עם כל נקודות העניין, המפות וההסברים.',
            storeForPlannersStepPublish: 'מפרסמים אותו בחנות המסלולים שלכם',
            storeForPlannersStepPublishBody: 'המסלול הופך למוצר דיגיטלי שהלקוחות יכולים לרכוש.',
            storeForPlannersStepClientAccess: 'הלקוח מקבל גישה מידית למסלול',
            storeForPlannersStepClientAccessBody: 'לאחר הרכישה הלקוח מקבל קישור אישי למסלול ומשתמש בו לאורך כל הטיול.',
            storeForPlannersBenefitDigital: 'מסלול דיגיטלי במקום קובץ',
            storeForPlannersBenefitDigitalBody: 'במקום לשלוח מסמכים או קבצי PDF, הלקוח מקבל מערכת מסלול ברורה ונוחה לשימוש במהלך הטיול.',
            storeForPlannersBenefitReusable: 'מסלול שנבנה פעם אחת ונמכר שוב ושוב',
            storeForPlannersBenefitReusableBody: 'כל מסלול שאתם יוצרים במערכת יכול להפוך למוצר דיגיטלי שניתן למכור שוב ושוב.',
            storeForPlannersBenefitClearExp: 'חוויית טיול ברורה ללקוח',
            storeForPlannersBenefitClearExpBody: 'המסלול מסודר לפי ימים עם מפות, ניווט והפעילויות של כל יום.',
            storeForPlannersBenefitNoHassle: 'בלי התעסקות עם שליחת המסלול',
            storeForPlannersBenefitNoHassleBody: 'לא צריך לשלוח קבצים או לעדכן כל לקוח בנפרד. הלקוח מקבל גישה למסלול מיד לאחר הרכישה.',
            storeForPlannersBenefitYouControl: 'התוכן נשאר בשליטה שלכם',
            storeForPlannersBenefitYouControlBody: 'כל מסלול נשלח בקישור אישי ללקוח ולא ניתן להעברה לאחרים.',
            storeForPlannersWhatsAppMessage: 'היי! אשמח לקבוע פגישת היכרות קצרה לגבי פתיחת חנות מסלולים דיגיטליים. מתי נוח לך?',
            storeForPlannersMeetingRequestSubject: 'בקשת פגישה - חנות מסלולים דיגיטליים',
            storeForPlannersHeroTitle: 'בונים מסלולי טיול ללקוחות?',
            storeForPlannersHeroLead: 'TripPlanner היא מערכת שמאפשרת לכם ליצור מסלולי טיול דיגיטליים ולהציג אותם בצורה מקצועית וברורה.',
            storeForPlannersHeroTwoWays: 'אפשר להשתמש בה בשתי דרכים:',
            storeForPlannersHeroAlsoSell: 'בנוסף, ניתן להציע את המסלולים שיצרתם למכירה דרך חנות מסלולים משלכם.',
            storeForPlannersHeroDisclaimer: 'TripPlanner היא כלי עבודה שמאפשר לכם להציג את הידע והניסיון המקצועי שלכם בצורה ברורה ומרשימה, כך שהלקוחות שלכם מבינים בדיוק איך הטיול שלהם נראה.\nבניגוד למסמכים או קבצי PDF, המסלול נשלח בקישור אישי ללקוח ונשאר בשליטה שלכם.',
            storeForPlannersClientEmphasis: 'הלקוח לא מקבל קובץ או רשימת המלצות.<br>הוא מקבל מערכת טיול מלאה שמלווה אותו לאורך כל הטיול.',
            storeForPlannersClientConclusion: 'כך הלקוח יודע בכל רגע לאן ללכת ומה לעשות.',
            storeForPlannersClientConclusionSecondary: 'כל מסלול שאתם יוצרים פעם אחת יכול להפוך למוצר דיגיטלי שניתן למכור שוב ושוב, בלי לשלוח קבצים ובלי להתעסק עם לקוחות.',
            storeForPlannersIntroText1: 'TripPlanner מאפשרת לכם להציע את המסלולים שיצרתם למכירה דרך חנות מסלולים משלכם.',
            storeForPlannersIntroText2: 'כל מסלול שאתם בונים במערכת יכול להפוך למוצר דיגיטלי שהלקוחות רוכשים ומקבלים מיד גישה אליו.',
            storeForPlannersIntroText3: 'כך מסלול שנבנה פעם אחת יכול להימכר שוב ושוב, בלי לשלוח קבצים ובלי להתעסק עם שליחת המסלול לכל לקוח.',
            storeForPlannersBenefitsCentralTitle: 'יתרונות מרכזיים',
            storeForPlannersContactSubtitle: 'נשמח לשמוע מכם ולעזור לכם להבין איך TripPlanner יכולה לעזור לעסק שלכם',
            storeForPlannersContactFormAudience: 'הטופס מיועד למתכנני טיולים, מדריכים וסוכני נסיעות שמעוניינים ליצור מסלולים דיגיטליים ללקוחות או למטיילים עצמאיים.',
            storeForPlannersCtaLead1: 'השאירו פרטים ונחזור אליכם להסבר קצר על המערכת ולבדוק איך היא יכולה להשתלב בעבודה שלכם.',
            storeForPlannersCtaLead2: 'או שלחו לנו הודעה ב-WhatsApp ונשמח לעזור.',
            storeForPlannersContactTitle: 'צור קשר',
            storeForPlannersFullName: 'שם מלא',
            storeForPlannersPhonePlaceholder: 'מספר טלפון (חובה)',
            storeForPlannersEmailPlaceholder: 'כתובת אימייל',
            storeForPlannersMessagePlaceholder: 'איך נוכל לעזור לכם? ספרו לנו על הצרכים שלכם...',
            storeForPlannersSending: 'שולח...',
            storeForPlannersSendDetails: 'שליחת פרטים',
            storeForPlannersPrevImage: 'תמונה קודמת',
            storeForPlannersNextImage: 'תמונה הבאה',
            storeForPlannersSlideLabel: `עבור לתמונה ${params.slideNumber || ''}`,
            storeForPlannersScreenshot1: 'תצוגת מסלול מלאה - כל הטיול במבט אחד',
            storeForPlannersScreenshot2: 'פירוט יומי לכל יום - היעדים במפה עם ניווט בלחיצה',
            storeForPlannersScreenshot3: 'כל הפעילויות בטיול - מסודרות לפי ימים',
            storeForPlannersScreenshot4: 'מפת היום - כל נקודות העניין במקום אחד',
            storeForPlannersScreenshot5: 'ניווט ישיר ליעדים דרך Google Maps',
            storeForPlannersContactSuccess: 'תודה! ההודעה נשלחה בהצלחה. נחזור אליכם בהקדם.',
            storeForPlannersContactError: 'אירעה שגיאה בשליחת ההודעה. אנא נסו שוב מאוחר יותר.',
            storeForPlannersValidateName: 'אנא הזינו את שמכם',
            storeForPlannersValidatePhone: 'אנא הזינו מספר טלפון',
            storeForPlannersValidatePhoneFormat: 'אנא הזינו מספר טלפון תקין (8-15 ספרות, בינלאומי כולל)',
            storeForPlannersValidatePrivacy: 'אנא אשרו את מדיניות הפרטיות',
            storeForPlannersValidateEmailSpaces: 'כתובת האימייל לא יכולה להכיל רווחים',
            storeForPlannersValidateEmailFormat: 'אנא הזינו כתובת אימייל תקינה',
            // src/views/Tutorials.vue
            tutorialsAddActivity: 'איך להכניס פעילות למסלול?',
            tutorialsAddAccommodation: 'איך להכניס לינה למסלול?',
            tutorialsShareRide: 'איך לשתף את המסלול?',
            tutorialsCreateNewItinerary: 'איך ליצור מסלול חדש במערכת?',
            tutorialsAddActivityWithLocation: 'איך להכניס פעילות עם מיקום מדויק למסלול?',
            tutorialsInsertLinksInText: 'איך להכניס לינקים בתוך הטקסט?',
            tutorialsAddDayInfo: 'איך מוסיפים מידע כללי על יום מסויים בטיול?',
            tutorialsReorderActivitiesInDay: 'איך אני יכול לשנות את הסדר של הפעילויות בתוך יום מסויים?',
            tutorialsAddTripGeneralInfo: 'איך מוסיפים פרטים של מידע כללי על הטיול?',
            tutorialsCopyItineraryForClient: 'איך אני מעתיק מסלול ומתאים אותו ללקוח חדש?',
            tutorialsAddFromMyActivities: 'איך להוסיף פעילות מאוסף הפעילויות שהכנסתי למערכת?',
            tutorialsEditDayInCalendar: 'עריכה של יום בתצוגה של לוח שנה',
            tutorialsManageItinerariesFolders: 'איך אני יכול לנהל את המסלולים בתקיות שונות?',
            tutorialsEditFromMyActivitiesRepo: 'איך אני מבצע עריכה של פעילויות שנמצאות במאגר הפעילויות שלי?',
            tutorialsGeneralExplanation: 'הסבר כללי על המערכת',
            tutorialsPageMetaTitle: 'הדרכות שימוש במערכת - TripPlanner',
            tutorialsPageMetaDescription: 'למד כיצד להשתמש במערכת TripPlanner - הדרכות מפורטות לכל התכונות',
            whatsappInviteTitle: 'הזמנה בוואטסאפ',
            whatsappInviteExplain: 'שלחו את הקישור למטיילים. בלחיצה ייפתח אצלם וואטסאפ עם הודעה מוכנה, וברגע שישלחו אותה הם יצורפו לטיול ויקבלו את הקישור אליו.',
            whatsappInviteCopy: 'העתיקו את הקישור',
            whatsappInviteCopied: 'הקישור הועתק',
            whatsappInviteCopyFailed: 'לא הצלחנו להעתיק את הקישור',
            whatsappInviteCode: 'קוד הצטרפות',
            waConversationsTitle: 'שיחות וואטסאפ',
            waConversationsRefresh: 'רענון',
            waConversationsRefreshing: 'מרענן…',
            waConversationsSubtitle: 'כל ההתכתבות עם מטייל — מה שהוא שלח ומה ששלחנו לו.',
            waConversationsSearchPlaceholder: 'מספר טלפון, לדוגמה 972526867915',
            waConversationsSearchButton: 'חיפוש',
            waConversationsLoading: 'טוענים…',
            waConversationsNoContacts: 'עדיין לא התקבלו הודעות וואטסאפ.',
            waConversationsNoName: 'ללא שם',
            waConversationsOptedOut: 'ביטלו קבלת הודעות',
            waConversationsPickOne: 'בחרו איש קשר מהרשימה או חפשו לפי מספר טלפון.',
            waConversationsEmptyThread: 'אין הודעות עם המספר הזה.',
            waConversationsError: 'לא הצלחנו לטעון את השיחה.',
            waDemoSendButton: 'שליחת תוכנית היום של ההדגמה',
            waDemoSendSending: 'שולחים…',
            waDemoSendConfirm: 'לשלוח לאיש הקשר הזה את הודעת תוכנית היום של ההדגמה — אותה הודעה שהוא היה מקבל בלחיצה על "המשך הדגמה"?',
            waDemoSendSent: 'ההודעה נשלחה.',
            waDemoSendAlreadySent: 'ההודעה כבר נשלחה לאיש הקשר הזה בעבר — לא נשלח עותק נוסף.',
            waDemoSendNoActivities: 'ביום ההדגמה אין פעילויות, ולכן לא נשלח דבר. יש להוסיף פעילויות ליום הזה במסלול ההדגמה.',
            waDemoSendNoDate: 'למסלול ההדגמה אין תאריכים, ולכן לא נשלח דבר.',
            waDemoSendOptedOut: 'איש הקשר ביטל קבלת הודעות.',
            waDemoSendNoTemplate: 'אין תבנית מאושרת ליום הזה, ולכן לא נשלח דבר.',
            waDemoSendNotDemo: 'המספר הזה לא רשום למסלול הדגמה.',
            waDemoSendFailed: 'השליחה נכשלה.',
            whatsappInviteRegistered: 'נרשמו עד כה',
            whatsappInviteUnlimited: 'ללא הגבלה',
            whatsappInviteNotConfigured: 'מספר הוואטסאפ של המערכת לא מוגדר. פנו לתמיכה.',
            whatsappInviteNeedsKey: 'צרו קודם קישור הרשמה לטיול הזה.',
            whatsappInviteError: 'לא הצלחנו ליצור את ההזמנה',
            whatsappInviteNoticeTitle: 'שימו לב:',
            whatsappInviteBillingNotice: 'כל מטייל שנרשם דרך WhatsApp נספר ומחויב בדיוק כמו מטייל שנרשם דרך האתר.',
            whatsappInviteAccessNotice: 'הקישור למסלול אינו דורש התחברות, ולכן כל מי שהקישור מועבר אליו יוכל לצפות במסלול.',
            whatsappInvitePricingNotice: 'בשלב זה השימוש בשירותי WhatsApp כלול ללא תשלום נוסף. ייתכן שבעתיד השירות יהיה כרוך בתשלום נוסף.',
            whatsappLoginLoading: 'מתחברים לטיול שלכם…',
            whatsappLoginFailed: 'הקישור הזה כבר לא תקף. אנא פנו למדריך שלכם.',
            whatsappInviteGenerateButton: 'צרו קישור הזמנה לוואטסאפ',
            whatsappInviteNotCreatedYet: 'עוד לא נוצר קישור הזמנה בוואטסאפ לטיול הזה.',
            whatsappInviteUnsupportedKeyAction: 'סוג קישור ההרשמה של הטיול הזה לא נתמך בוואטסאפ. פנו לתמיכה.',
            whatsappInviteShareNotApproved: 'יש לשלם קודם על שיתוף הטיול הזה. לאחר התשלום תוכלו ליצור קישור הזמנה לוואטסאפ.',
            whatsappInviteInactiveKey: 'קישור ההרשמה של הטיול הזה חסום. שחררו אותו קודם, ואז אפשר ליצור הזמנה בוואטסאפ.',
            whatsappReminderTitle: 'הודעות אוטומטיות בוואטסאפ',
            whatsappReminderExplain: 'הודעות אלו נשלחות אוטומטית למטיילים שנרשמו בוואטסאפ.',
            managerAlertTitle: 'חיבור הוואטסאפ שלך',
            managerAlertExplain: 'כדי לקבל הודעות מהמערכת יש לחבר את הוואטסאפ שלך פעם אחת בלבד. החיבור ישמש אותך בכל הטיולים.',
            managerAlertLinkExplain: 'לחצו על הכפתור ושלחו את ההודעה שתיפתח בוואטסאפ.',
            managerAlertLinkButton: 'חיבור לוואטסאפ',
            managerAlertOpenWhatsapp: 'חיבור הוואטסאפ שלי',
            managerAlertCodeLabel: 'קוד החיבור שלך',
            managerAlertManualTitle: 'או לחיבור ידני',
            managerAlertManualExplain: 'שלחו את הקוד הבא בהודעת וואטסאפ למספר המערכת:',
            managerAlertSystemNumber: 'מספר הוואטסאפ של המערכת:',
            managerAlertCopy: 'העתקת ההודעה',
            managerAlertCopied: 'ההודעה הועתקה',
            managerAlertCopyFailed: 'לא הצלחנו להעתיק. אפשר לשלוח את הקוד שמופיע כאן בהודעה רגילה.',
            managerAlertRecheck: 'שלחתי — בדקו שוב',
            managerAlertLinkedAs: 'מחובר למספר',
            managerAlertUnlink: 'ביטול החיבור',
            managerAlertChangeNumber: 'שינוי המספר',
            managerAlertError: 'הפעולה נכשלה. נסו שוב.',
            managerAlertOptedOut: 'נשלחה בקשת הסרה למספר העסקי, ולכן וואטסאפ אינו מעביר את ההודעות.',
            managerAlertOptedOutResume: 'שליחת כל הודעה למספר העסקי בוואטסאפ תחדש אותן.',
            managerAlertUnlinkConfirm: 'לבטל את החיבור? ההודעות שהגדרתם נשמרות, אבל לא יישלחו אליכם עד שתחברו מחדש.',
            managerAlertUnlinkConfirmYes: 'כן, בטלו את החיבור',
            managerAlertUnlinkCancel: 'השארת החיבור',
            whatsappReminderPreviewToggle: 'הצגת דוגמה לתזכורת',
            whatsappReminderEnable: 'שלחו תזכורת יום לפני הטיול',
            whatsappDailyItineraryEnable: 'שלחו את תוכנית היום שאחרי, בכל ערב של הטיול',
            whatsappDailyItineraryExplain: 'בכל ערב המטיילים יקבלו בוואטסאפ את התוכנית ליום המחרת – הפעילויות המתוכננות וקישור ניווט לכל מקום.\n\nההודעה נשלחת לכל מטייל בנפרד, בכל ערב במהלך הטיול.',
            whatsappDailyItineraryPreviewToggle: 'הצגת דוגמה לתוכנית היומית',
            whatsappDailyItineraryPreview: 'כך תיראה ההודעה (לדוגמה):',
            // Each '⁦...⁩' pair wrapping a "1." / "2." / "3." below is
            // an LRI (LEFT-TO-RIGHT ISOLATE) / PDI (POP DIRECTIONAL ISOLATE) pair
            // -- invisible, do not delete as stray characters. Without it, a line
            // like "1. 09:00 – קולוסיאום" shows the ordinal flipped to ".1" in
            // the browser: "1." has no strong-direction character of its own, so
            // the RTL paragraph's bidi reordering (Unicode UAX#9 rule L2) swaps
            // the digit and the period when it reverses the line, even though the
            // digits inside "09:00" survive intact (a same-direction multi-digit
            // run gets reversed twice -- once as its own embedded run, once with
            // the paragraph -- which cancels out; "1." does not get that same
            // protection because the period isn't classified the same way as the
            // digit). Isolating just "1." forces it to be treated as its own
            // small left-to-right run, the same trick that keeps "09:00" intact,
            // so it now survives the paragraph-level reversal too.
            // Tried first, and found NOT sufficient on its own: setting
            // direction/dir="rtl" and unicode-bidi:isolate on the containing
            // element (still needed, and kept, for the block as a whole), and
            // prefixing the line with a RIGHT-TO-LEFT MARK the way
            // travelerblog/whatsapp/itinerary.py's _RTL_MARK prefixes real
            // template parameters -- neither changed this specific glyph-order
            // artifact in browser testing. The real WhatsApp app does not need
            // this: there, "1. " is static template text rendered by Meta's own
            // client, not by a browser evaluating a JS template string, so it
            // never hits this particular browser bidi edge case.
            whatsappDailyItineraryPreviewBody: 'שלום דנה,\n\nהנה התוכנית שלכם למחר, יום שלישי 13.10:\n\n⁦1.⁩ 09:00 – קולוסיאום\n📍 ניווט: https://www.google.com/maps/dir/?api=1&destination=41.89,12.49\n\n⁦2.⁩ 11:30 – פורום רומאנום\n📍 ניווט: https://www.google.com/maps/dir/?api=1&destination=41.89,12.48\n\n⁦3.⁩ 13:00 – ארוחת צהריים בטרסטוורה\n📍 ניווט: https://www.google.com/maps/dir/?api=1&destination=41.88,12.46\n\nלצפייה במסלול המלא:\nhttps://tripplanner.co.il/wa_login/...\n\nרוצים לקבל כאן ב-WhatsApp את כל הפרטים על המקומות שתבקרו בהם מחר? השיבו להודעה.',
            whatsappDailyItineraryPreviewNote: 'זוהי דוגמה בלבד — ההודעה בפועל תציג את הפעילויות של אותו יום עצמו. מוצגות עד 6 פעילויות; ביום עם יותר מ-6 פעילויות ההודעה מציינת זאת ומציגה את 6 הראשונות.',
            whatsappReminderHour: 'שעת שליחה',
            whatsappReminderTimezone: 'אזור זמן',
            whatsappReminderTimezoneAuto: 'לפי המיקום בכל יום',
            whatsappReminderTimezoneAutoExample: 'ביום הראשון: {zone}',
            whatsappReminderTimezoneGroup_common: 'נפוץ',
            whatsappReminderTimezoneGroup_europe: 'אירופה',
            whatsappReminderTimezoneGroup_asia: 'אסיה',
            whatsappReminderTimezoneGroup_americas: 'אמריקה',
            whatsappReminderTimezoneGroup_africaOceania: 'אפריקה ואוקיאניה',
            whatsappReminderPreview: 'כך תיראה ההודעה:',
            whatsappReminderPreviewBody: 'היי {name}, הטיול שלך {title} מתחיל מחר 🎒 כל הפרטים והמסלול כאן: {link} נסיעה טובה!',
            whatsappReminderPreviewNote: 'נוסח ההודעה מאושר מראש על ידי וואטסאפ ולא ניתן לשינוי.',
            whatsappReminderNoTemplate: 'אין עדיין תבנית מאושרת לשפת הטיול הזה, כך שתזכורות לא יישלחו.',
            whatsappReminderError: 'לא הצלחנו לשמור את ההגדרות',
            whatsappReminderBadTimezone: 'אזור זמן לא מוכר',
            organizerMessageAddButton: 'תזמון הודעת WhatsApp',
            organizerMessageBeforeTripTitle: 'הודעות מתוכננות לפני הטיול',
            organizerMessageAfterTripTitle: 'הודעות מתוכננות אחרי הטיול',
            organizerMessageCreateButton: 'יצירת הודעה מתוכננת',
            organizerMessageDateLabel: 'תאריך ההודעה',
            organizerMessageDateHelp: 'אפשר לבחור כל תאריך מהיום ועד שבוע אחרי הטיול.',
            organizerMessageAddTitle: 'הוספת הודעה למטיילים',
            organizerMessageEditTitle: 'עריכת הודעה',
            organizerMessageBodyLabel: 'תוכן ההודעה',
            organizerMessageBodyPlaceholder: 'כתבו כאן את ההודעה שתישלח למטיילים בוואטסאפ',
            organizerMessageTimeLabel: 'שעת שליחה',
            organizerMessageTimeHelp: 'ההודעה תישלח בטווח של עד כ-10 דקות מהשעה שנבחרה',
            organizerMessageTimezoneLabel: 'אזור זמן',
            organizerMessageTimezoneDefault: 'לפי השעון המקומי של היום הזה',
            organizerMessageTimezoneManagerHelp: 'הודעה אליכם נשלחת לפי שעון ישראל, אלא אם תבחרו אזור זמן אחר.',
            whatsappDemoReturnButton: 'חזרה לוואטסאפ להמשך ההדגמה',
            whatsappDemoReturnHint: 'נמשיך בצ\'אט ונשלח לכם את הודעת היום של הטיול',
            organizerMessageSaveButton: 'שמירה',
            organizerMessageCancelButton: 'ביטול',
            organizerMessageEditAction: 'עריכת הודעה',
            organizerMessageDeleteAction: 'מחיקת הודעה',
            organizerMessageDeleteConfirm: 'להסיר את ההודעה הזו? לא ניתן לשלוח אותה שוב אחרי מחיקה.',
            organizerMessageSaveError: 'לא ניתן היה לשמור את ההודעה',
            organizerMessageDeleteError: 'לא ניתן היה להסיר את ההודעה',
            organizerMessageErrorEmptyBody: 'יש לכתוב תוכן להודעה',
            organizerMessageErrorBodyTooLong: 'ההודעה ארוכה מהמותר (4096 תווים לכל היותר)',
            organizerMessageErrorInvalidSendTime: 'שעת השליחה אינה תקינה',
            organizerMessageErrorInvalidTargetDate: 'תאריך היום אינו תקין',
            organizerMessageErrorDateOutsideWindow: 'התאריך הזה מחוץ לטווח התאריכים הניתן לשליחת הודעות לטיול הזה',
            organizerMessageErrorInvalidTimezone: 'אזור הזמן שנבחר אינו מוכר',
            organizerMessageErrorForbidden: 'אין לכם הרשאה לבצע פעולה זו',
            organizerMessageErrorNotFound: 'ההודעה לא נמצאה, אולי היא נמחקה כבר',
            organizerRecipientLabel: 'למי לשלוח',
            organizerRecipientTravellers: 'לכל המטיילים הרשומים',
            organizerRecipientManager: 'אליי בלבד (מנהל הטיול)',
            organizerRecipientTravellersShort: 'לכל המטיילים',
            organizerRecipientManagerShort: 'אליי בלבד',
            organizerRecipientHelp: 'לא ניתן לשנות את הנמען לאחר השמירה.',
            organizerRecipientFixedHelp: 'הנמען נקבע ביצירת ההודעה ולא ניתן לשנותו.',
            organizerRecipientFixedError: 'לא ניתן לשנות את הנמען של הודעה שנשמרה.',
            organizerRecipientNotLinkedHint: 'הוואטסאפ שלכם עדיין לא מחובר, ולכן הודעה אליכם לא תישלח.',
            organizerRecipientLinkNowLink: 'לחיבור הוואטסאפ שלי',
            organizerRecipientNotLinkedError: 'כדי לשלוח הודעה אליך, יש לחבר קודם את הוואטסאפ שלך בהגדרות הוואטסאפ של הטיול.',
            organizerRecipientNotManagerError: 'רק מנהל הטיול יכול לקבוע הודעה לעצמו, ואינך מנהל הטיול הזה.',
            organizerMessageDateRequiredError: 'יש לבחור תאריך להודעה.',
            organizerMessageWasSent: 'נשלחה',
            organizerMessageMissed: 'לא נשלחה – המועד חלף',
            whatsappLoginAlreadySignedIn: `אתם מחוברים כרגע כ-${params.email || ''}`,
            whatsappLoginSwitchExplain: 'פתיחת הטיול הזה תנתק אתכם מהחשבון הנוכחי ותחבר אתכם כמטייל שקיבל את הקישור.',
            whatsappLoginOpenTrip: 'פתחו את הטיול',
            whatsappLoginStaySignedIn: 'הישארו מחוברים לחשבון הנוכחי',
            sharedImagesTitle: 'תמונות משותפות למקומות',
            sharedImagesLoading: 'טוען תמונות...',
            sharedImagesLoadError: 'לא ניתן לטעון את התמונות, נסו שוב',
            sharedImagesRetry: 'נסו שוב',
            sharedImagesEmpty: 'אין תמונות לבדיקה',
            sharedImagesLoadMore: 'טען עוד',
            sharedImagesApprove: 'אשר',
            sharedImagesReject: 'דחה',
            sharedImagesApproved: 'מאושרת',
            sharedImagesPending: 'ממתינה',
            sharedImagesRejected: 'נדחתה',
            sharedImagesActionFailed: 'הפעולה נכשלה, נסו שוב'
          },
          en: {
            // SingleRideWithMap translations
            mapViewForDay: `Map view for day ${params.day || ''}`,
            wantToEditTrip: 'Want to edit this trip?',
            copyAndEdit: 'Copy and Edit',
            loadingData: 'Loading data...',
            loadingUploadingImages: 'Uploading images',
            loadingOf: 'of',
            tripPlan: 'Trip Plan',
            tripMapForDay: `Trip map for day ${params.day || ''}`,
            copyrightNotice: 'This itinerary is displayed for personal use only. Do not share, duplicate, or copy its content without permission from the content provider.',
            aiChatTitle: 'AI Assistant',
            aiChatProfileTravelers: 'Travelers',
            aiChatProfilePace: 'Pace',
            aiChatProfileInterests: 'Interests',
            aiChatProfileAvoid: 'Avoid',
            aiChatProfileBudget: 'Budget',
            aiChatProfileConstraints: 'Constraints',
            aiChatProfileStripPrefix: 'The AI knows:',
            aiChatProfileStripEmpty: 'Tell the AI about the travelers',
            aiChatProfileDrawerTitle: 'Trip profile',
            aiChatProfileSave: 'Save',
            aiChatProfileCancel: 'Cancel',
            aiChatProfileKeepMine: 'Keep mine',
            aiChatProfileUseAi: "Use AI's suggestion",
            aiChatProfileSaveFailed: 'Saving failed, please try again',
            aiChatProfileSetByYou: 'Set by you',
            aiChatProfileAiProposes: 'AI suggests',
            rideInformationProfileSection: 'Trip profile',
            rideInformationProfileHint: 'What is known about the travelers — ages, pace, preferences and limitations. The AI adds details here as they come up in the chat, and takes them into account when it plans. You can change any field, and what you write here stays.',
            rideInformationProfileShow: 'Show details',
            rideInformationProfileHide: 'Hide details',
            aiChatPlaceholder: 'Ask anything or paste a booking…',
            aiChatSend: 'Send',
            aiChatDay: 'Day',
            aiChatAdd: 'Add',
            aiChatAdded: 'Added',
            aiChatOpenButton: 'AI assistant',
            aiChatAttachFiles: 'Attach booking files',
            aiChatDropZoneTitle: 'Drop your bookings here',
            aiChatDropZoneHint: "Hotel, flight, car rental or ticket confirmations. I'll add them to the right days.",
            aiChatDropOverlay: 'Drop to read your bookings',
            aiChatFilesRejected: 'Only JPG, PNG or PDF, up to 5 documents at a time.',
            aiChatMove: 'Move',
            aiChatMoved: 'Moved',
            aiChatApplyingAll: 'Applying...',
            aiChatResolvingPlaces: 'Finding places...',
            aiChatRemoveAll: 'Remove all',
            aiChatConfirmRemoveAllTitle: 'Remove all these activities?',
            aiChatConfirmRemoveAllNote: 'This cannot be undone.',
            aiChatRemoveAccommodation: 'Remove accommodation',
            aiChatRemoveAccommodationWarning: 'Removing also deletes its booking confirmation and vouchers.',
            aiChatConfirmRemoveAccommodationTitle: 'Remove this accommodation from the trip?',
            aiChatConfirmRemoveAccommodationNote: 'Its booking confirmation and vouchers are deleted and cannot be recovered.',
            aiChatRideDatesTitle: 'Trip dates',
            aiChatRideNewStart: 'New start',
            aiChatRideDatesShiftNote: 'The whole trip shifts by this many days; its length stays the same.',
            aiChatRideDatesUpdate: 'Update dates',
            aiChatRideDatesUpdated: 'Updated',
            aiChatAddDayTitle: 'Add a day',
            aiChatRemoveDayTitle: 'Remove a day',
            aiChatAddDay: 'Add day',
            aiChatRemoveDay: 'Remove day',
            aiChatNewName: 'New name',
            aiChatUpdateAttraction: 'Update',
            aiChatAttractionUpdated: 'Updated',
            aiChatAddNoteTitle: 'Note for the day',
            aiChatUpdateNoteTitle: 'Update day note',
            aiChatRemoveNoteTitle: 'Remove day note',
            aiChatSaveNote: 'Save note',
            aiChatAddRideNoteTitle: 'General information for the whole trip',
            aiChatUpdateRideNoteTitle: 'Update general information',
            aiChatRemoveRideNoteTitle: 'Remove general information',
            aiChatRideNoteSubtitle: 'Belongs to the whole trip, not to one day — travellers see it under "General Information"',
            aiChatRideTextTitle: 'Trip description',
            aiChatRideTextReplaces: 'Replaces the description travellers read at the top of the trip',
            aiChatRideTextAdds: 'Added to the end of the description travellers read at the top of the trip',
            aiChatRideTextReplacesAndAdds: 'Replaces the description travellers read at the top of the trip, then adds a line',
            aiChatRideTextReplacesWarning: 'Your current description will be deleted and replaced by this text',
            aiChatRideTextChars: 'characters',
            aiChatRideTextShowAll: 'Show the full text',
            aiChatRideTextShowLess: 'Show less',
            aiChatUpdateRideText: 'Update description',
            aiChatRideTextUpdated: 'Updated',
            aiChatRideTitleTitle: 'Trip name',
            aiChatRideTitleReplaces: 'Replaces the name of the trip — on the trip page, in your trip list and in the brochure',
            aiChatRideTitleCurrent: 'Name now',
            aiChatRideTitleNew: 'New name',
            aiChatRideTitleEmpty: 'No new name came through, so this change cannot be saved',
            aiChatRideTitleTooLong: `The suggested name is too long (over ${params.max || 140} characters). Ask the AI for a shorter one`,
            aiChatUpdateRideTitle: 'Update name',
            aiChatRideTitleUpdated: 'Updated',
            aiChatRideLanguageTitle: 'Trip language',
            aiChatRideLanguageReplaces: 'Changes the language of the trip — the trip page, the brochure and the emails to travellers. The content itself is not translated',
            aiChatRideLanguageCurrent: 'Language now',
            aiChatRideLanguageNew: 'New language',
            aiChatRideLanguageEmpty: 'No new language came through, so this change cannot be saved',
            aiChatRideLanguageUnknown: 'That is not one of the languages a trip can be set to. Ask the AI for another one',
            aiChatRideLanguageReloadWarning: 'After the update the page reloads in the new language, and this conversation closes',
            aiChatUpdateRideLanguage: 'Update language',
            aiChatRideLanguageUpdated: 'Updated',
            aiChatNoteSaved: 'Saved',
            aiChatRemoveNote: 'Remove note',
            aiChatAcceptAll: 'Accept all changes',
            aiChatUpdateHotel: 'Update hotel',
            aiChatHotelUpdated: 'Updated',
            aiChatHotelReservationNote: 'This changes the trip only — please update your reservation with the hotel too.',
            aiChatChangesReady: 'changes ready',
            aiChatLeftForYou: 'waiting for your choice',
            aiChatAcceptAllConfirmTitle: 'Accepting all changes will remove:',
            aiChatAcceptAllNotApplied: "changes weren't applied — you can retry each one with its own button.",
            aiChatMoveTo: 'Move to',
            aiChatRemove: 'Remove',
            aiChatRemoved: 'Removed',
            aiChatStarter1: 'Go over the whole trip and suggest improvements',
            aiChatStarter2: 'Translate the whole trip into Italian',
            aiChatStarter3: "Check whether each day's order of stops makes sense",
            aiChatStarter4: 'Find me special places to add to the itinerary',
            aiChatApproveArea: 'Approve area',
            aiChatAreaApproved: 'Approved',
            aiChatAreaCheckIn: 'Check-in',
            aiChatAreaCheckOut: 'Check-out',
            aiChatAreaChange: 'Change city...',
            aiChatChangePlace: 'Change place...',
            aiChatManualPlace: 'Not found automatically — please search and select a location',
            aiChatUpdateArea: 'Update area',
            aiChatAreaUpdated: 'Updated',
            aiChatAddHotel: 'Add accommodation',
            aiChatHotelAdded: 'Added',

            // SingleRideHeader translations
            copyTripAndEdit: 'Copy Trip and Edit',
            editTripDetails: 'Edit Trip Details',
            duplicateTrip: 'Duplicate Trip',
            showRegistrationLink: 'Link to share the trip',
            shareTrip: 'Share Trip',
            afterFirstAttractionOption1Title: 'Adding more activities',
            afterFirstAttractionOption1Text: 'Go to the desired day and click "Add activity".\nAfter you finish adding all the activities you can share the trip with the customer.',
            afterFirstAttractionOption1Button: 'Add another activity',
            afterFirstAttractionOption2Title: 'Sharing the trip with the customer',
            afterFirstAttractionOption2Text: 'Go to the trip and click "Link to share the trip" to send the trip to the customer.',
            afterFirstAttractionOption2Button: 'Return to trip',
            afterFirstAttractionTipHeading: 'Quick tip',
            afterFirstAttractionTipText: 'Every activity you add is saved in the system and can be used again in future trips.',
            afterFirstAttractionSuccess: 'Great. You added an activity to the route.',
            afterFirstAttractionSubtitle: 'Now you can keep adding activities or send the route to the client.',
            afterFirstAttractionHelpHeading: 'Need help?',
            afterFirstAttractionHelpText: 'In the top menu you will find a help section with short videos that explain how to use the system.',
            
            // SingleRideSumary translations
            installApp: 'Install the App',
            moreTripsBy: 'More trips by',
            routeBy: 'Route by:',
            tripSummary: 'Trip Summary',
            posterItinerary: 'Travel itinerary',
            posterDays: 'Days',
            posterDay: 'Day',
            posterDayRange: `Days ${params.from}–${params.to}`,
            showRideMap: 'Show trip map',
            hideRideMap: 'Hide map',
            rideSummaryMap: 'Map',
            ridePlacesCount: params.count === 1 ? '1 place' : `${params.count} places`,
            rideOpenDay: 'Open this day',
            posterEdit: 'Edit poster',
            posterEditDesign: 'Design',
            posterEditDays: 'Split the days into stops',
            posterEditDaysHint: 'Mark the days where a new poster stop begins',
            posterEditNewStop: 'New stop',
            posterEditStop: `Stop ${params.number || ''}`,
            posterEditPhotos: 'A name and photo for each stop',
            posterEditStopName: 'The stop\'s name on the poster',
            posterEditPhotoAuto: 'Automatic',
            posterEditNoPhotos: 'No photos on these days',
            posterEditReset: 'Back to automatic',
            posterEditCancel: 'Cancel',
            posterEditSave: 'Save',
            posterEditSaving: 'Saving...',
            posterEditSaveFailed: 'Saving failed. Please try again.',
            generalInfo: 'General Information',
            activities: 'Activities',
            accommodations: 'Accommodations',
            accommodationEditPresentedText: 'Edit accommodation details',
            accommodationDetailsTitle: 'Accommodation details',
            accommodationRecommendationIntro: 'Based on your trip, we recommend the following accommodation:',
            accommodationRecommendationPlaceLabel: 'Place:',
            accommodationRecommendationDatesLabel: 'Dates:',
            accommodationDateRangeSeparator: ' to ',
            accommodationRecommendationDatesNote: '* If the dates don’t match your trip dates, please go back to the trip, click "Edit trip details", and update the trip start date.',
            accommodationChooseFromMyHotels: 'Choose from my hotels list',
            accommodationHotelNameLabel: 'Hotel name',
            accommodationLocationFieldTooltip: 'After the initial fill, there is no need to change this field unless you want to replace the accommodation location with another place.<br>After filling it, you can review and edit all the other fields.',
            accommodationChooseSpecificPlace: 'For accurate display and navigation, it’s recommended to choose as specific a destination as possible.',
            accommodationExamplesTitle: 'For example:',
            accommodationExampleSpecificHotel: 'A specific hotel - choose the hotel name',
            accommodationExampleAreaVillage: 'Staying in an area / recommended village - you can choose the place or village name',
            accommodationCheckInOutLabel: 'Accommodation check-in and check-out',
            accommodationCheckInOutPlaceholder: 'Check-in   →   Check-out',
            accommodationFreeTextLabel: 'Free text about the accommodation',
            accommodationAreaNameLabel: 'Accommodation area name',
            accommodationAreaNamePlaceholder: 'Accommodation area name',
            accommodationDeleteButton: 'Delete accommodation',
            accommodationNewPointMarkerName: 'New point',
            masterAccommodationCompareIntroLine1: 'You changed the hotel details on this route.',
            masterAccommodationCompareIntroLine2: 'Do you also want to update the hotel in your catalog?',
            masterAccommodationCompareIntroLine3: 'You can then pick the updated version on future routes.',
            masterAccommodationCompareIntroLine4: 'Existing routes will not change.',
            masterAccommodationCompareContinueRepo: 'Update accommodation in catalog',
            masterAccommodationCompareUpdateBaseNow: 'Select changes to update in catalog',
            masterAccommodationCompareRideOnly: 'Save for this accommodation only (without updating the catalog)',
            masterAccommodationCompareRideOnlyShort: 'Save for this accommodation only',
            masterAccommodationCompareDecisionSubtitle: 'Updating the catalog will affect other accommodations that use this information.',
            masterAccommodationCompareDecisionHint: 'If custom details or specific changes were added, you can choose which changes to update.',
            masterAccommodationCompareTooltip1: 'Changes will be saved to the catalog and will affect other accommodations that use this information.',
            masterAccommodationCompareTooltip2: 'Allows you to choose which fields or details will be updated in the catalog.',
            masterAccommodationCompareTooltip3: 'Changes will be saved only to the current accommodation, without updating the catalog.',
            masterAccommodationCompareMasterColumn: 'Hotel from your catalog',
            masterAccommodationCompareMasterColumnHint: 'The version you will use on future routes',
            masterAccommodationCompareRideColumn: 'Hotel on the route (updated)',
            masterAccommodationCompareRideColumnHint: 'Changes you made on the current route',
            masterAccommodationCompareAddress: 'Address',

            masterAttractionCompareIntroLine1: 'You changed the activity details on this route.',
            masterAttractionCompareIntroLine2: 'Do you also want to update the activity in your catalog?',
            masterAttractionCompareIntroLine3: 'You can then pick the updated version on future routes.',
            masterAttractionCompareIntroLine4: 'Existing routes will not change.',
            masterAttractionCompareDecisionTitle: 'Also update the activity in your catalog?',
            masterAttractionCompareDecisionSubtitle: 'Updating the catalog will affect other activities that use this information',
            masterAttractionCompareDecisionHint: 'If custom details or specific changes were added, you can choose which changes to update.',
            masterAttractionCompareRideOnlyShort: 'Save for this activity only',
            masterAttractionCompareTooltip1: 'Changes will be saved to the catalog and will affect other activities that use this information.',
            masterAttractionCompareTooltip2: 'Allows you to choose which fields or details will be updated in the catalog.',
            masterAttractionCompareTooltip3: 'Changes will be saved only to the current activity, without updating the catalog.',
            masterAttractionCompareContinueRepo: 'Update activity in catalog',
            masterAttractionCompareUpdateBaseNow: 'Select changes to update in catalog',
            masterAttractionCompareRideOnly: 'Save for this activity only (without updating the catalog)',
            masterAttractionCompareMasterColumn: 'Activity from your catalog',
            masterAttractionCompareMasterColumnHint: 'The version you will use on future routes',
            masterAttractionCompareRideColumn: 'Activity on the route (updated)',
            masterAttractionCompareRideColumnHint: 'Changes you made on the current route',
            masterAccommodationCompareCountryCity: 'Country and city',
            masterAccommodationCompareBooking: 'Booking confirmation',
            masterAccommodationCompareStatus: 'Status',
            masterAccommodationCompareEmpty: '-',
            accommodationMasterRefBanner: 'You are now editing the accommodation in your catalog.\nChanges here will affect the accommodation you choose to add to future routes.\nYou can use "Apply template" to keep the previous values.',
            attractionMasterRefBanner: 'You are now editing the activity in your catalog.\nChanges here will affect activities you choose to add to future routes.\nYou can use "Apply template" to keep the previous values.',
            accommodationMasterRefTemplate: 'Template (master)',
            accommodationMasterRefUseBase: 'Apply template',
            nights: `${params.count} nights`,
            oneNight: 'One night',
            
            // SingleRide translations
            day: 'Day',
            dayNumber: `Day ${params.number || ''}`,
            listView: 'List',
            calendarView: 'Calendar',
            moreActivitiesInArea: 'More activities in the area',
            addActivity: 'Add Activity',
            addActivityHintBubble: 'Click here to add an activity to the first day',
            shareRideHintBubble: 'Click here to share the trip with the customer',
            addAccommodation: 'Add Accommodation',
            addDay: 'Add Day',
            moveAllActivities: 'Move All Activities',
            moveDayAttractionsTitle: 'Choose a target date to move all activities',
            moveDayAttractionsTargetDayLabel: 'Target day:',
            moveDayAttractionsMoveButton: 'Move',
            moveDayAttractionsLoadingRideData: 'Loading trip data...',
            moveDayAttractionsInvalidData: 'Invalid trip data or day not selected',
            moveDayAttractionsFailed: 'Failed to move activities',
            exportPDF: 'Export to PDF',
            generatingPDF: 'Generating PDF...',
            pdfStyleChooserTitle: 'Which file would you like?',
            pdfStyleItineraryLabel: 'Detailed itinerary',
            pdfStyleItineraryHint: 'Everything for the road — times, hotels, navigation and QR codes',
            pdfStyleBrochureLabel: 'Marketing brochure',
            pdfStyleBrochureHint: 'One or two designed pages with photos you choose — to show customers the trip',
            brochurePickerTitle: 'Choose the brochure photos',
            brochurePickerLoading: 'Loading the trip photos...',
            brochurePickerLoadFailed: "We couldn't load the photos. You can still create the brochure with the automatic choice.",
            brochurePickerUseAutomatic: 'Create with automatic choice',
            brochurePickerCover: 'Cover photo',
            brochurePickerCoverHint: 'Any photo from the trip. Click one to use it as the cover.',
            brochurePickerStayHint: `Click to add or remove, up to ${params.max || ''}. Photo number 1 is shown large.`,
            brochurePickerNoPhotos: 'No photos for this stay',
            brochurePickerBackToAuto: 'Back to automatic choice',
            brochurePickerCancel: 'Cancel',
            brochurePickerGenerate: 'Create PDF',
            pdf_generated_successfully: 'PDF file generated successfully!',
            pdf_generation_failed: 'Error generating PDF file. Please try again.',
            pdf_generation_warning: '⚠️ PDF generation can take up to 20 minutes! Please wait and do not close your browser. The process will start in a moment.',
            ride_data_not_loaded: 'Trip data is not loaded properly.',
            
            // SingleRideChecklist translations
            originalTripAccommodations: 'Accommodation bookings relative to the original trip:',
            myAccommodations: 'My accommodation bookings:',
            
            // Additional SingleRide translations
            deleteDay: 'Delete Day',
            editExtraInfo: 'Edit Additional Info',
            accommodation: 'Accommodation:',
            addGeneralInfo: 'Add note for the day',
            addRideGeneralInfo: 'Add general info',
            moreDetails: 'More Details',
            createNewActivity: 'Create new activity',
            activitiesAvailableToAdd: 'Activities you can add',
            googleResults: 'Results from Google:',
            internalResultsFromFamilies: 'Results from other families\' trips',
            newRideAttractions: 'New ride attractions',
            alreadyInThisRide: 'Already in this ride',
            addAttraction: 'Add attraction',
            noAttractionsFound: 'No attractions found.',
            noAttractionsAlreadyInThisRide: 'There are no attractions already in this ride right now.',
            website: 'Website',
            addActivityToTrip: 'Add activity to trip',
            navigateToDestination: 'Navigate',
            showRouteFromPreviousDestination: 'Route from previous stop',

            // AttractionEditing translations
            attractionEditingAddFromMyList: 'Add from my list',
            attractionEditingOrChooseFromMyActivitiesList: 'Or choose from my activities list',
            attractionViewEditTitle: 'Edit activity',
            attractionViewAddTitle: 'Add another activity',
            attractionEditingPresentedText: 'Add activity to trip',
            attractionEditingBackToTrip: 'Back to trip',
            attractionEditingBackToAttractionsEdit: 'Back to editing activities',
            attractionEditingActivityDetailsTitle: 'Activity details',
            attractionEditingAutocompleteIntro: 'Choose a place from autocomplete. Your choice will automatically fill the activity details (location, address, and more).',
            attractionEditingTutorialsRecommendedTitle: 'Recommended to watch the explanation the first time',
            attractionEditingTutorialVideoTitle1: 'How to add an activity to the itinerary?',
            attractionEditingLoadingVideo: 'Loading video...',
            accommodationTutorialsRecommendedTitle: 'Recommended to watch the explanation the first time',
            accommodationTutorialVideoTitle: 'How to add accommodation to the trip?',
            shareRideTutorialsRecommendedTitle: 'Recommended to watch the explanation the first time',
            shareRideTutorialVideoTitle: 'How to share the trip?',
            attractionEditingVideoLoadError: 'Error loading the video',
            attractionEditingRetryVideo: 'Try again',
            attractionEditingActivityLocationLabel: 'Activity location (select from list)',
            attractionEditingWhenToChangeField: 'When should I change this field?',
            attractionEditingLocationFieldTooltip: 'After the initial fill, there is no need to change this field unless you want to replace the activity location with another place.<br>After filling it, you can review and edit all the other fields.',
            attractionEditingAutocompletePlaceholder: 'Start typing and choose a place from the list',
            attractionEditingImportantToKnow: 'Good to know',
            attractionEditingChooseSpecificPlace: 'To ensure accurate display and navigation, choose the most specific destination possible.',
            attractionEditingExamplesTitle: 'For example:',
            attractionEditingExampleFlight: 'Flight - the airport you land at',
            attractionEditingExampleCarRental: 'Car rental - the branch where you pick up the car',
            attractionEditingExampleGuidedTour: 'Guided tour - the area or meeting point of the tour',
            attractionEditingExampleNature: 'Nature activity - the place name as shown in Google Maps',
            attractionEditingSelectedPlaceLabel: 'Selected place:',
            attractionEditingChangePlaceButton: 'Change place',
            attractionEditingChangePlaceTooltip: 'Clicking "Change place" will reopen the search field and let you pick a new place.<br>Once you select it, all details will update automatically based on the new place.',
            attractionEditingTitleLabel: 'Title',
            attractionEditingTitlePlaceholder: 'Activity title',
            attractionEditingCreateContentWithAi: 'Generate content with AI',
            attractionEditingDescriptionLabel: 'Activity description',
            attractionEditingDescriptionPlaceholder: 'Activity description',
            attractionEditingImageLabel: 'Image',
            attractionEditingUploadImage: 'Upload image',
            attractionEditingPixabayButton: 'Upload Images from Pixabay',
            pixabayPickerTitle: 'Images from Pixabay',
            pixabayPickerSearchPlaceholder: 'Search...',
            pixabayPickerSearchButton: 'Search',
            pixabayPickerConfirmButton: 'Select Image',
            pixabayPickerLoading: 'Loading images...',
            pixabayPickerErrorGeneral: 'Could not load images, try again',
            pixabayPickerErrorRateLimit: 'We\'ve reached Pixabay\'s request limit, please wait a few seconds and try again',
            pixabayPickerErrorNoResults: `No images found for "${params.term || ''}"`,
            pixabayPickerErrorDownload: 'Error downloading image, please select another',
            pixabayPickerRetry: 'Try again',
            pixabayPickerCooldown: 'Please wait 3 seconds between searches',
            attractionEditingCropTitle: 'Image ratio for trip view (16:9)',
            attractionEditingCropHint: 'Option 1 - Crop: drag and zoom to choose the area that will fill the 16:9 box (parts outside the box will be cropped).',
            attractionEditingFitHint: 'Option 2 - Auto fill: keep the full image as-is, and the empty parts of the 16:9 box will be filled with a blurred background from the same image.',
            attractionEditingCropModeFill: 'Crop (fill the box)',
            attractionEditingCropModeFit: 'Auto fill (keep full image)',
            attractionEditingCropApply: 'Apply',
            attractionEditingCropCancel: 'Cancel',
            attractionEditingWantToChangeLocation: 'Want to change the location?',
            attractionEditingMapTooltip: 'You can drag the marker on the map to set the exact location of the activity.<br>This will also update the destination point for navigation.<br>For example, drag the marker to the parking lot instead of the main entrance.',
            attractionEditingShowAdvancedOptions: 'Show advanced options ▼',
            attractionEditingHideAdvancedOptions: 'Hide advanced options ▲',
            attractionEditingCategoryLabel: 'Category',
            attractionEditingSelectCategory: 'Select category',
            attractionEditingSubcategoryLabel: 'Subcategory',
            attractionEditingSelectSubcategory: 'Select subcategory',
            attractionEditingAddressLabel: 'Address',
            attractionEditingAddressPlaceholder: 'Address',
            attractionEditingWebsitePlaceholder: 'Website link',
            attractionEditingNavigationAddressLabel: 'Navigation address (if different from the place)',
            attractionEditingFixFieldsLabel: 'Please fix the following fields:',
            attractionEditingMetaDescription: 'Add activity to trip',
            
            // ExistingAttractionOptions modal
            existingAttractionOptionsTitle: 'You already have this activity in your activities library',
            existingAttractionOptionsViewExisting: 'View the existing activity in my library',
            existingAttractionOptionsCreateAnyway: 'Create it anyway (even though I already have one)',
            
            // createAttraction validations
            attractionValidationTitleRequired: 'Title',
            attractionValidationLocationRequired: 'Advanced options -> change the location on the map',
            attractionValidationTitleTooLong: 'The title is too long',
            attractionValidationImageUploading: 'The image is still uploading. Please wait for it to finish.',
            attractionValidationImageUrlPending: 'Waiting for the image link. Please wait.',
            attractionValidationVideoUploading: 'The video is still uploading. Please wait for it to finish.',
            attractionValidationVideoUrlPending: 'Waiting for the video link. Please wait.',
            attractionValidationAudioUploading: 'The audio is still uploading. Please wait for it to finish.',
            attractionValidationAudioUrlPending: 'Waiting for the audio link. Please wait.',
            attractionValidationVoucherUploading: 'The voucher/ticket is still uploading. Please wait for it to finish.',
            attractionValidationVoucherUrlPending: 'Waiting for the voucher/ticket link. Please wait.',
            accommodationValidationVoucherUploading: 'The attached document is still uploading. Please wait for it to finish.',
            
            // GlobalMapSerchAutoComplet
            globalMapSearchPlaceholder: 'Enter a location',
            globalMapSearchNewAttractionMarkerName: 'New attraction',
            searchByLocation: 'Search by location',
            typePlaceName: 'Type a place name',
            searchExampleLocations: 'For example: Tel Aviv, Dead Sea, nature reserve...',
            backToTrip: '< Back to trip',
            searchAttractionsNoMatchCreateNew: "Didn't find a matching activity? Create a new activity",
            activitiesAlreadyInTrip: 'Activities already in the trip',
            activitiesMatchSelectedDay: 'Activities that match the selected day',
            whatsappHereForYou: 'I’m here for you',
            whatsappContactAlt: 'WhatsApp contact',
            video: 'Video',
            audio: 'Audio',
            videoTagNotSupported: 'Your browser does not support the video tag.',
            audioTagNotSupported: 'Your browser does not support the audio tag.',
            audioFileOnly: 'Please select an audio file only',
            videoFileOnly: 'Please select a video file only',
            uploadVideo: 'Upload video',
            uploadAudio: 'Upload audio',
            fileSizeTooLarge: `File size is too large. File size: ${params.fileSize || ''}, maximum allowed: ${params.maxSize || ''}`,
            audioUploadError: 'Error uploading audio: ',
            videoUploadError: 'Error uploading video: ',
            fileUploadError: 'Error uploading file: ',
            audioGetUrlError: 'Error getting audio download URL: ',
            videoGetUrlError: 'Error getting video download URL: ',
            fileGetUrlError: 'Error getting file download URL: ',
            voucher: 'Attached Document',
            voucherPlural: 'Attached Documents',
            viewPdf: 'View PDF file',
            uploadVoucher: 'Upload voucher/ticket (image or PDF)',
            voucherFileOnly: 'Please select an image (JPG, PNG) or a PDF document only',
            voucherMaxReached: 'You have reached the limit of 10 attached documents',
            voucherSavePending: 'Waiting for file upload to finish, will save automatically...',
            remove: 'Remove',
            changeDate: 'Change Date',
            showMore: 'Show More',
            showLess: 'Show Less',
            editMode: 'Edit Mode',
            viewPlace: 'View place',
            recommendedHotels: 'Recommended hotels',
            myHotelsList: 'My hotels list',
            bookingSearchHotels: 'All hotels in ',
            bookingWithDiscounts: ' with discounts of ',
            bookingUpTo: 'up to 15%',
            bookingSaveDiscount: 'Best prices on Booking.com',
            bookingBadgeTop: 'up to',
            bookingBadgeBottom: 'off',
            viewHotelOnBooking: 'View this hotel on Booking.com',
            enterAccommodationDetails: 'Enter accommodation details',
            topAccommodationInList: 'Top accommodation in the list',
            searchAccommodationsViewTrip: 'View trip',
            searchAccommodationsMoreHotelsInArea: 'More hotels in the area',
            searchAccommodationsAddToRide: 'Add accommodation to trip',
            searchAccommodationsOgDescription: 'Find hotels that other travelers shared and recommended',
            searchAccommodationsMetaDescription: 'Search recommended hotels by location',
            
            // Common terms
            close: 'Close',
            save: 'Save',
            update: 'Update',
            cancel: 'Cancel',
            confirm: 'Confirm',
            edit: 'Edit',
            delete: 'Delete',
            add: 'Add',
            back: 'Back',
            next: 'Next',
            previous: 'Previous',
            loading: 'Loading...',
            error: 'Error',
            success: 'Success',
            warning: 'Warning',
            info: 'Info',
            calendarIconAlt: 'Calendar icon',
            openingHours: 'Opening hours:',
            placeReviews: 'Reviews:',
            rideExtraInfoBannerParagraph: 'Here you can add information on different topics, each with its own title.',
            rideExtraInfoSectionTitleLabel: 'Section title',
            rideExtraInfoSectionTitlePlaceholder: 'Public transportation in Rome',
            rideExtraInfoContentLabel: 'Content',
            rideExtraInfoContentPlaceholder: 'Public transportation in Rome includes metro, buses, and trams, and covers the main attractions very well. It is recommended to buy a daily or weekly pass at stations or kiosks. You can also use an app like Moovit to check real-time arrival updates.',
            rideExtraInfoDeleteSection: 'Delete section',

            // Navbar
            home: 'Home',
            about: 'About',
            searchRoutes: 'Search Routes',
            myTrips: 'My Trips',
            tutorials: 'Tutorials',
            sharingUsageCostsNav: 'Pricing',
            login: 'Login',
            logout: 'Logout',
            loggedInAs: 'Logged in as:',
            loggedInUserFallback: 'User',
            rideManagerRole: 'Ride Manager',
            myReferralLink: 'My referral link',
            myWhatsappNumberMenuItem: 'Set my WhatsApp number',
            language: 'Language',
            hebrew: 'Hebrew',
            english: 'English',

            // Footer
            pages: 'Pages',
            contact: 'Contact',
            socialMedia: 'Social Media',
            copyright: `© ${params.year !== undefined ? params.year : new Date().getFullYear()} Tripplanner - All rights reserved`,
            termsOfUse: 'Terms of Use',
            searchTrips: 'Search trips',
            searchVacations: 'Search vacations',
            uploadVacation: 'Upload vacation',
            other: 'Other',
            goUp: 'Go Up',
            copyrightWithYear: `© ${params.year || ''} Tripplanner - All rights reserved`,

            // Cookie consent
            cookieConsentMessage: 'We use cookies to improve your experience, save preferences and analyze site usage. By continuing to use the site, you consent to the use of cookies in accordance with our privacy policy.',
            cookieConsentReadMore: 'Read more',
            cookieConsentAgree: 'I agree',

            // Home page
            homeHeroTitle: 'Let\'s plan the perfect family vacation',
            homeRideManagerKicker: 'For planners, agents & guides',
            homeRideManagerHeroTitle: 'Building trip itineraries for your clients?',
            homeRideManagerHeroSubtitle: 'Trip planners, travel agents, and guides: a dedicated page that shows you how to build itineraries, share them with clients, and present everything in a clear, professional way.',
            homeRideManagerHeroCta: 'Enter the trip planner system',
            homeRideManagerExampleLink: 'View a real example itinerary for a client',
            homeRideManagerBullet1: 'Suitable for trip planners and travel agents',
            homeRideManagerBullet2: 'Build itineraries and send them to clients',
            homeRideManagerBullet3: 'Saves hours of work on every trip',
            homeSearchPlaceholder: 'Enter your destination!',
            homeWatchVacationsIntro: 'Browse vacations shared by families',
            homeWatchVacations: 'Browse vacations',
            homeShareVacation: 'Share a vacation',
            homeStartWithVacation: 'Start by choosing a vacation as your planning base',
            homeWatchVacationsDb: 'Browse the vacation collection',
            homeWhatCanDoTitle: 'What you can do with ',
            homeWhatCanDoIntro: 'When you have all the information you need, traveling smart is easy. Tripplanner keeps you focused on the vacation plan that really fits your family.',
            homePlanningVacation: 'Planning a vacation',
            homePlanningVacationDesc: 'Use real vacations that real families have done and benefit from their experience',
            homeBackFromVacation: 'Back from vacation',
            homeBackFromVacationDesc: 'You\'re back from a great vacation. It\'s time to give back to the community and let others enjoy your trip too.',
            homeUploadVacation: 'Upload a vacation',
            homeRecommendedTrips: 'Recommended trips',
            homeRecommendedTripsIntro: 'Nothing beats experience - tips from families who did the vacation you\'re planning. Real itineraries from families who shared their trips so you can use them as your planning base.',
            homeWatchSuccessfulVacations: 'Browse successful vacations',
            homeWhyTripplanner: 'Why plan with ',
            homeWhyCard1Title: 'All vacations are made by families like you',
            homeWhyCard1Desc: 'There\'s nothing like getting recommendations from families who did the vacation before you. No need to reinvent the wheel - the trip is already planned and tried.',
            homeWhyCard2Title: 'Large database of vacations and activities',
            homeWhyCard2Desc: 'We have a large collection of vacations that families have uploaded so you can use them. From that collection we have an even larger set of activities you can add to any vacation you choose.',
            homeWhyCard3Title: 'Clear day-by-day breakdown by area',
            homeWhyCard3Desc: 'A clear breakdown of how many days in each area during your vacation. Accommodation recommendations for each part of the trip.',
            homeWhyCard4Title: 'A simple way to plan your trip',
            homeWhyCard4Desc: 'You can remove or add activities from the activity database to the vacation you chose. You can change the length of your vacation.',
            // How it works (home)
            homeHowTitle: 'How to plan a vacation the smart way',
            homeHowStep1Title: 'Choose a vacation you like as your base',
            homeHowStep1Desc: 'Your planning starts by picking a vacation from the site\'s collection to use as the base for your own trip.',
            homeHowStep2Title: 'Add or remove activities from your chosen vacation',
            homeHowStep2Desc: 'Enjoy easy, convenient planning by customizing your chosen vacation and adding recommended activities from other vacations shared on the site.',
            homeHowStep3Title: 'Go on vacation and share with friends and family',
            homeHowStep3Desc: 'Enjoy an amazing vacation with the site alongside you during the trip. Give back to the community by adding your vacation to the collection and sharing with friends and family!',
            homeMetaDescription: 'Trip sharing site - browse trips shared by Israeli travelers around the world',
            homeOgDescription: 'A large collection of trips shared by families',

            // Recommended trips (home page)
            recommendedTrip1Title: 'Vienna and Salzburg',
            recommendedTrip1Location: 'Austria',
            recommendedTrip1ManyDays: '14 days',
            recommendedTrip2Title: 'Pyrenees, Barcelona and Madrid',
            recommendedTrip2Location: 'Spain',
            recommendedTrip2ManyDays: '11 days',
            recommendedTrip3Title: 'Krakow and Zakopane',
            recommendedTrip3Location: 'Southern Poland',
            recommendedTrip3ManyDays: '14 days',
            recommendedTrip4Title: 'New York',
            recommendedTrip4Location: 'New York',
            recommendedTrip4ManyDays: '10 days',
            recommendedTrip5Title: 'Salzburg and Tyrol',
            recommendedTrip5Location: 'Austria',
            recommendedTrip5ManyDays: '14 days',
            recommendedTrip6Title: 'Scotland / England / Wales',
            recommendedTrip6Location: 'United Kingdom',
            recommendedTrip6ManyDays: '19 days',
            recommendedTrip7Title: 'Bastei and surroundings',
            recommendedTrip7Location: 'Germany',
            recommendedTrip7ManyDays: '8 days',
            tripsImageLoginHint: 'Log in to get started!',

            // Tutorials page
            tutorialsPageTitle: 'System Usage Tutorials',
            tutorialsPageDescription: 'Welcome to the TripPlanner tutorials page. Here you can learn how to use all the system features through detailed tutorial videos.',
            videoNotSupported: 'Your browser does not support video playback.',
            loadingVideo: 'Loading video...',
            videoLoadError: 'Error loading video. Please try again later.',
            backToQuestions: 'Back to Questions',
            retry: 'Retry',

            // User rides page
            userRidesCreateShareRoute: 'Create a trip to share',
            userRidesCreateChoiceTitle: 'How would you like to create the trip?',
            userRidesAllMyActivities: 'All my activities',
            userRidesEditProfile: 'Edit my profile',
            userRidesShareTripOnSite: 'Share a trip on the site',
            userRidesNoTrips: 'No trips to show',
            userRidesTableTitle: 'Title',
            userRidesTableDescription: 'Description',
            userRidesTableDates: 'Dates',
            userRidesTableCategory: 'Category',
            userRidesTableActions: 'Actions',
            userRidesBelongsToCategoryLabel: 'Belongs to category:',
            userRidesCategoryLabel: 'Category:',
            userRidesViewPrivateTrip: 'View private trip',
            userRidesViewAndEditTrip: 'View and edit trip',
            userRidesOgDescription: 'List of trips I chose or uploaded to the site',
            userRidesMetaDescription: 'My trips list',

            // User rides categories (DEFAULT_CATEGORIES)
            userRidesCategoryPlanningLabel: 'Planning trips',
            userRidesCategoryPlanningDescription: 'Trips that are still being worked on - not yet ready to share with clients.',
            userRidesCategoryActiveLabel: 'Active trips',
            userRidesCategoryActiveDescription: 'Trips delivered to the client and currently in use during the vacation.',
            userRidesCategoryClientLabel: 'Client trips',
            userRidesCategoryClientDescription: 'Trips that were built and tailored specifically for clients - ready for use or shared in the past.',
            userRidesCategoryTemplateLabel: 'Trip templates',
            userRidesCategoryTemplateDescription: 'Trips saved as reusable templates - a base for duplicating and customizing for different clients.',
            userRidesCategoryInactiveLabel: 'Inactive trips',
            userRidesCategoryInactiveDescription: 'Trips that are finished, canceled or no longer relevant - kept for documentation or future reference.',

            // Edit profile page
            editProfilePageTitle: 'Edit profile',
            editProfileBackToMyTrips: 'Back to my trips',
            editProfileDetails: 'Profile details',
            editProfileLoading: 'Loading...',
            editProfileLoadingData: 'Loading data...',
            editProfileImageLabel: 'Profile picture',
            editProfileImageHint: 'We recommend using a symmetrical image about 900x900 pixels so it displays well in a circle.',
            editProfileNoImage: 'No image',
            editProfileChangeImage: 'Change image',
            editProfileUploadImage: 'Upload image',
            editProfileUploading: 'Uploading...',
            editProfileNameLabel: 'Name',
            editProfileNamePlaceholder: 'Enter name',
            editProfileTitleLabel: 'Short title that appears below the name',
            editProfileTitlePlaceholder: 'Enter title',
            editProfileAboutLabel: 'About (free text)',
            editProfileAboutPlaceholder: 'A few words about you as a trip planner - for those traveling with your itinerary',
            editProfileWebsiteLabel: 'Website link',
            editProfileFacebookLabel: 'Facebook link',
            editProfileInstagramLabel: 'Instagram link',
            editProfileSave: 'Save',
            editProfileSaving: 'Saving...',
            editProfileUploadError: 'Error uploading image. Please try again.',
            editProfileEnterName: 'Please enter name',
            editProfileSuccess: 'Profile updated successfully',
            editProfileUpdateError: 'Error updating profile',
            editProfileUpdateErrorTryAgain: 'Error updating profile. Please try again.',

            // Ride manager attraction page
            rideManagerAttractionManageCategories: 'Manage categories',
            rideManagerAttractionTabAttractions: 'Attractions',
            rideManagerAttractionTabAccommodations: 'Accommodations',
            rideManagerAttractionName: 'Name',
            rideManagerAttractionDescription: 'Description',
            rideManagerAttractionHasImage: 'Has image',
            rideManagerAttractionEdit: 'Edit',
            rideManagerAttractionEditButton: 'Edit',

            // Admin categories page
            adminCategoriesTitle: 'Categories',
            adminCategoriesAddCategory: 'Add Category',
            adminCategoriesSearchPlaceholder: 'Search categories...',
            adminCategoriesNoCategoriesFound: 'No categories found',
            adminCategoriesUnnamedCategory: 'Unnamed Category',
            adminCategoriesSubcategoriesCount: 'subcategories',
            adminCategoriesUnnamedSubcategory: 'Unnamed Subcategory',
            adminCategoriesEditCategory: 'Edit Category',
            adminCategoriesDelete: 'Delete',
            adminCategoriesSubcategories: 'Subcategories',
            adminCategoriesEdit: 'Edit',
            adminCategoriesNoSubcategoriesFound: 'No subcategories found',
            adminCategoriesAddSubcategory: 'Add Subcategory',
            adminCategoriesSelectCategory: 'Select a category to view details',
            adminCategoriesConfirmDelete: 'Confirm Delete',
            adminCategoriesConfirmDeleteMessage: 'Are you sure you want to delete {0}?',
            adminCategoriesCannotUndo: 'This action cannot be undone.',
            adminCategoriesName: 'Name',
            adminCategoriesEnterName: 'Enter name',
            adminCategoriesEditCategoryTitle: 'Edit Category',
            adminCategoriesAddCategoryTitle: 'Add Category',
            adminCategoriesEditSubcategoryTitle: 'Edit Subcategory',
            adminCategoriesAddSubcategoryTitle: 'Add Subcategory',
            adminCategoriesFailedToLoad: 'Failed to load categories',
            adminCategoriesError: 'Error',
            adminCategoriesSuccessfullyDeleted: 'Successfully deleted',
            adminCategoriesSuccess: 'Success',
            adminCategoriesFailedToDelete: 'Failed to delete',
            adminCategoriesNameRequired: 'Name is required',
            adminCategoriesValidationError: 'Validation Error',
            adminCategoriesSuccessfullySaved: 'Successfully saved',
            adminCategoriesFailedToSave: 'Failed to save',
            adminCategoriesThisItem: 'this item',

            // Document Import
            importDocumentsTitle: 'Import Booking Documents',
            importRideBannerTitle: 'Create a Trip with AI',
            importRideBannerParagraph: 'Upload flight confirmations, hotel reservations, travel itineraries, or paste an existing trip plan. Our AI will analyze the information and use it to create your digital trip.',
            importRideAiNoticeLabel: 'Important:',
            importRideAiNotice: 'This itinerary is generated using AI and may contain errors or missing information. Please review all details, especially dates, times, and booking information, before sharing it with travelers.',
            importRideManualLink: 'No document? Create the trip manually',
            rideInfoCreateFromDocumentLink: 'Have a document with the trip details? Create the trip from it',
            startInsertRideFromDocumentTitle: 'Create from a document',
            startInsertRideFromDocumentSubtitle: 'Flight and hotel booking confirmations, or a PDF describing the whole trip',
            startInsertRideManualTitle: 'Create manually',
            startInsertRideManualSubtitle: 'Fill in the trip details yourself',
            importDocumentsDropZone: 'Drop flight tickets, hotel vouchers or a trip PDF here, or click to browse',
            importDocumentsProcessing: 'Reading your document...',
            importDocumentsProcessingHint: 'Complex documents (e.g. itineraries) may take up to 5 minutes',
            importDocumentsError: 'Could not read this document',
            importDocumentsTooLarge: 'This file is too large. The maximum size is 10MB',
            importDocumentsUnsupportedType: 'Only PDF, JPG or PNG files can be uploaded',
            importDocumentsNotAccommodation: 'This file does not look like a hotel booking',
            importDocumentsRideName: 'Trip name',
            importDocumentsEdit: 'Edit',
            importDocumentsSave: 'Save',
            importDocumentsDiscard: 'Discard',
            importDocumentsRemovePoint: 'Remove',
            importDocumentsCreate: 'Create trip',
            importDocumentsAddMore: 'Add more documents',
            importDocumentsConfidenceLow: 'Please verify the extracted data',
            importDocumentsHotelName: 'Hotel name',
            importDocumentsAddress: 'Address',
            importDocumentsConfirmation: 'Booking confirmation number',
            importDocumentsNotes: 'Additional details',
            importDocumentsCheckIn: 'Check-in',
            importDocumentsCheckOut: 'Check-out',
            importDocumentsMissingFields: 'Missing info:',
            importDocumentsPartialError: 'Some accommodations could not be created:',
            importDocumentsGoToRide: 'Go to Ride',
            importDocumentsErrorDateRange: 'the max ride length is 60 days',
            importDocumentsDateRangeWarning: `Between ${params.start} and ${params.end} is more than 60 days — please adjust the ride dates manually`,
            importDocumentsDoubleBooking: `Double booking: ${params.nameA} and ${params.nameB} have overlapping dates — please edit the dates`,
            importDocumentsLocationPrompt: 'Please confirm the hotel location on Google Maps',
            importDocumentsLocationConfirmed: 'Location confirmed',
            importDocumentsChangeLocation: 'Change',
            importDocumentsLocationRequired: 'Location required — please find the hotel on Google Maps',
            importDocumentsPointLocationPrompt: 'Search for location on Google Maps',
            importDocumentsPointLocationRequired: 'Location required — please confirm on Google Maps',
            importDocumentsSearchingLocation: 'Looking for the location...',
            importDocumentsWaitingForGoogle: 'Google is limiting requests — waiting and trying again...',
            importDocumentsLookingUpPlaces: `Looking up ${params.count} of ${params.total} locations...`,
            importDocumentsDatesMissing: 'No dates found in the document — please fill in the trip dates',
            importDocumentsRideNameMissing: 'Please enter a name for the trip',
            importDocumentsAccommodationDatesMissing: 'Check-in / check-out dates are missing — press "Edit" to fill them in',
            importDocumentsSuggestName: 'Suggest name',
            importDocumentsFlightDeparture: 'Departure',
            importDocumentsFlightArrival: 'Arrival',
            importDocumentsTypeAccommodation: 'Accommodation',
            importDocumentsTypeFlight: 'Flight',
            importDocumentsTypeCarRental: 'Car Rental',
            importDocumentsTypeAttraction: 'Attraction',
            importDocumentsTypeShow: 'Show / Event',
            importDocumentsTypeItinerary: 'Itinerary',
            importDocumentsTypeUnknown: 'Unknown Document',
            importDocumentsOr: 'or',
            importDocumentsPasteText: 'Paste text',
            importDocumentsAnalyzeText: 'Analyze text',
            importDocumentsTextPlaceholder: 'Paste your trip details here — daily itinerary, booking confirmations, flights, hotels, etc...',
            importRideTextPlaceholder: 'Already planned your trip with ChatGPT or another AI tool? Just paste the plan here!\n\nYou can also paste a daily itinerary, booking confirmations, flight details, hotels and more...',

            // Ride documents panel
            rideDocumentsOpenButton: 'Add Information with AI',
            rideDocumentsPanelTitle: 'Add Trip Information with AI',
            rideDocumentsPanelDescription: 'Upload documents or paste text, and our AI will analyze the information and add the relevant details to your trip.',
            rideDocumentsDropZone: 'Drag flight confirmations, hotel reservations, or travel itineraries here, or click to select files.',
            rideDocumentsPasteTextLabel: 'Paste Text for AI Analysis',
            rideDocumentsTextPlaceholder: 'Paste a daily itinerary, booking confirmations, flight and hotel details, or a trip plan created with ChatGPT or another AI tool...',
            rideDocumentsAnalyzeText: 'Analyze & Add to Trip with AI',
            rideDocumentsAiNotice: 'The information is processed using AI and may contain errors. Please review the details after they are added to your trip.',
            rideDocumentsAttach: 'Add to trip',
            rideDocumentsAttaching: 'Adding…',
            rideDocumentsNothingReady: 'No documents added for analysis yet',
            rideDocumentsInvalidDates: 'The dates on this document are not valid — check-out must come after check-in',
            rideDocumentsFixDocumentDates: 'Fix the document dates',
            rideDocumentsOutOfRange: `This document runs ${params.days || 0} days outside the trip dates`,
            rideDocumentsPointsOutOfRange: `${params.count || 0} places in this document fall outside the trip dates`,
            rideDocumentsExtendRide: 'Extend the trip',
            rideDocumentsExtendRideHint: `The trip would run from ${params.start || ''} to ${params.end || ''}`,
            rideDocumentsDoubleBooking: `"${params.incoming || ''}" collides with an existing stay: "${params.existing || ''}"`,
            rideDocumentsExistingStayDates: `"${params.name || ''}" currently covers ${params.checkIn || ''} to ${params.checkOut || ''}`,
            rideDocumentsChangeExistingDates: 'Change the existing stay\'s dates',
            rideDocumentsRemoveExisting: 'Remove the existing stay',
            rideDocumentsSkipDocument: 'Skip this document',
            rideDocumentsDocumentsCollide: 'Two documents you uploaded cover the same nights',
            rideDocumentsDocumentPair: `"${params.nameA || ''}" vs "${params.nameB || ''}"`,
            rideDocumentsDocumentsCollideHint: 'Fix the dates on one of them, or skip it, to continue',
            rideDocumentsResolveConflictsFirst: 'Resolve the conflicts above before adding to the trip',
            rideDocumentsExistingDatesMissing: 'The existing stay needs both a check-in and a check-out date',
            rideDocumentsExistingDatesReversed: 'Check-out must come after check-in',
            rideDocumentsExistingOutOfRange: `Those new dates fall outside the trip (${params.start || ''} to ${params.end || ''}) — pick dates inside it, or extend the trip first`,
            rideDocumentsExistingStillCollides: 'Those new dates collide with another stay on this trip — try different ones',
            rideDocumentsExistingNotAllowed: 'You are not allowed to edit this stay',
            rideDocumentsExistingSaveFailed: 'Could not save the new dates — please try again',
            rideDocumentsExistingRemoveFailed: 'Could not remove the existing stay — please try again',
            rideDocumentsAlreadyAttached: `${params.count || 0} document(s) already went onto the trip and will not be added again — fix what failed and press Attach again`,
            rideDocumentsExistingStaysUnreadable: 'Could not check this document against the trip\'s existing stays — try again',
            rideDocumentsRetryStaysCheck: 'Try again',
            rideDocumentsCheckingExistingStays: 'Checking this trip\'s existing stays for conflicts…',
            rideDocumentsCardReady: 'Ready to add',
            rideDocumentsAttachOne: 'Add 1 document to the trip',
            rideDocumentsAttachMany: `Add ${params.count || 0} documents to the trip`,
            rideDocumentsAttachThisDocument: 'Add this document to the trip',
            rideDocumentsWaitingOne: '1 document is waiting to be resolved before it can be added',
            rideDocumentsWaitingMany: `${params.count || 0} documents are waiting to be resolved before they can be added`,
            rideDocumentsNotYetAdded: 'Nothing has been added to the trip yet',
            rideDocumentsAttachSuccessOne: '1 document added to the trip ✓',
            rideDocumentsAttachSuccessMany: `${params.count || 0} documents added to the trip ✓`,
            rideDocumentsPartialError: 'Some items could not be added to the trip:',
            rideDocumentsNoteFailed: `The note "${params.name || ''}" was not added to the trip — please try again`,
            rideDocumentsUntitledNote: 'Untitled note',
            rideDocumentsRetryTripInfo: 'Try adding the trip information again',

            // Generate ride with AI
            generateRideWithAiTitle: 'Build a Ride with AI',
            generateRideWithAiIntro: 'Pick the trip dates and add some information about the travelers. The system will build the ride automatically from the admin attractions pool.',
            generateRideWithAiStartDate: 'Start date',
            generateRideWithAiEndDate: 'End date',
            generateRideWithAiTravelersLabel: 'Traveler information',
            generateRideWithAiTravelersPlaceholder: 'Tell us about the travelers — ages, group composition, with or without kids, interests, preferred pace, mobility limits, and anything else that helps build the ride.',
            generateRideWithAiSubmit: 'Send to server',
            generateRideWithAiSubmitting: 'Sending...',
            generateRideWithAiBack: 'Back to document import',
            generateRideWithAiDatesRequired: 'Please choose both a start date and an end date.',
            generateRideWithAiEndBeforeStart: 'The end date must be the same as or after the start date.',
            generateRideWithAiError: 'Could not send the details to the server. Please try again.',
            generateRideWithAiNoAttractions: 'No attractions were found in your pool. Add attractions before building a ride with AI.',
            generateRideWithAiDestination: 'Trip destination',
            generateRideWithAiDestinationPlaceholder: 'For example: Brasov, Romania',
            generateRideWithAiDestinationHint: 'We will only use your attractions within 200 km of this destination.',
            generateRideWithAiExampleRides: 'Example rides (optional)',
            generateRideWithAiExampleRidesPlaceholder: 'For example: 19995, 20014',
            generateRideWithAiExampleRidesHint: 'Ride numbers you built yourself. The AI learns your style and pacing from them — it will not use their attractions.',
            generateRideWithAiDestinationRequired: 'Please enter the trip destination.',
            generateRideWithAiDestinationNotFound: 'We could not find that destination. Try a different city or region.',
            generateRideWithAiNoAttractionsNearby: 'No attractions in your pool are within 200 km of that destination. Pick another destination or add attractions in that area.',

            // Attraction enrichment panel
            enrichmentAskAi: 'Add AI information',
            enrichmentWorking: 'Asking the AI...',
            enrichmentWorkingHint: 'This takes a few seconds.',
            enrichmentIntro: 'The AI filled these in. Change anything you like before saving.',
            enrichmentPoolScope: 'These details belong to the attraction in your pool, and apply to every trip that uses it.',
            enrichmentManagerIntro: 'These two are yours alone — the AI never fills them in.',
            enrichmentSavedWithAttraction: 'These details are saved together with the attraction.',
            enrichmentCategory: 'Category',
            enrichmentTags: 'Tags',
            enrichmentTagsPlaceholder: 'Comma separated: waterfall, scenic, family',
            enrichmentMinAge: 'Minimum age',
            enrichmentRecommendedMinAge: 'Recommended age',
            enrichmentGoodFor: 'Good for',
            enrichmentDuration: 'Visit length (minutes)',
            enrichmentPreferredTime: 'Best time of day',
            enrichmentOpenMonths: 'Good months',
            enrichmentOpenMonthsHint: 'Tick every month if it is good all year. Nothing ticked means not specified.',
            enrichmentIndoorOutdoor: 'Indoor / outdoor',
            enrichmentPhysicalEffort: 'Physical effort',
            enrichmentPriority: 'Priority (1-5)',
            enrichmentNotesForAi: 'Notes for the AI',
            enrichmentNotesPlaceholder: 'For example: better in the morning before the crowds.',
            enrichmentAge_toddlers: 'Toddlers',
            enrichmentAge_kids: 'Kids',
            enrichmentAge_teens: 'Teens',
            enrichmentAge_adults: 'Adults',
            enrichmentAge_seniors: 'Seniors',
            enrichmentTime_morning: 'Morning',
            enrichmentTime_afternoon: 'Afternoon',
            enrichmentTime_evening: 'Evening',
            enrichmentEnv_indoor: 'Indoor',
            enrichmentEnv_outdoor: 'Outdoor',
            enrichmentEnv_mixed: 'Mixed',
            enrichmentEffort_none: 'None',
            enrichmentEffort_easy: 'Easy',
            enrichmentEffort_moderate: 'Moderate',
            enrichmentEffort_strenuous: 'Strenuous',
            enrichment_weather_dependent: 'Weather dependent',
            enrichment_stroller_friendly: 'Stroller friendly',
            enrichment_wheelchair_friendly: 'Wheelchair friendly',
            enrichment_booking_required: 'Booking required',
            enrichmentError: 'Could not get information from the AI. Please try again.',
            enrichmentNotAdmin: 'This option is currently available to the system admin only.',
            enrichmentNoPlace: 'Enter a name or address before asking the AI.',
            enrichAllButton: 'Enrich all attractions with AI',
            enrichAllRunning: 'Enriching...',
            enrichAllConfirm: `Send ${params.count || 0} attractions to the AI? Anything already enriched is skipped.`,
            enrichAllStarting: 'Starting...',
            enrichAllProgress: `${params.processed || 0} of ${params.total || 0} — ${params.enriched || 0} enriched, ${params.skipped || 0} skipped, ${params.failed || 0} failed`,
            enrichAllHint: 'This runs on the server and takes a while. Keep this window open to watch progress.',
            enrichAllDone: `Finished: ${params.enriched || 0} enriched, ${params.skipped || 0} skipped, ${params.failed || 0} failed, out of ${params.total || 0}.`,
            enrichAllError: 'Enrichment failed. Check the server log.',
            generateRideWithAiBuilding: 'The AI is building your ride...',
            generateRideWithAiBuildingHint: 'Building the ride can take up to 10 minutes. Please keep this window open.',
            generateRideWithAiTimeout: 'Building the ride is taking too long. Please try again.',
            generateRideWithAiPlanningFailed: 'The AI could not build a ride from your attractions. Try different dates or traveler details.',
            generateRideWithAiTravelersInfoTooLong: 'The traveler information is too long. Please shorten it and try again.',
            generateRideWithAiJobFailed: 'We could not build the ride. Please try again.',

            // Ride information page
            rideInfoPageTitle: 'Trip details',
            rideInfoSubdomainParagraph: 'Please update the date of the first day of your trip.',
            rideInfoParagraph: 'Here you can share important information about the itinerary - insights, experiences, tips and recommendations that will help those going on this trip.',
            rideInfoPrivateRideLabel: 'Create private trip - The trip will be visible only to users you approve yourself',
            publicRideManagerNoticeCritical: 'Critical - public visibility',
            publicRideManagerNoticeTitle: 'This trip is set as public.',
            publicRideManagerNoticeBody: 'All information shown here is open for viewing, and people can access it even without access authorization.',
            rideInfoWhiteLabelLabel: 'Display trip in White Label view',
            rideInfoWhiteLabelHint: 'When checked, the trip will be displayed on a branded page with your site\'s colors and logo.<br>When unchecked, the trip will be displayed in the standard view in your environment only.',
            rideInfoDateStartPlaceholder: 'Trip start date',
            rideInfoDateRangePlaceholder: 'Start and end date',
            rideInfoTitleLabel: 'Trip title',
            rideInfoTitlePlaceholder: 'Two weeks in Tyrol with 3 children aged 10, 7, 4',
            rideInfoAgeLabel: 'Age composition of participants',
            rideInfoAgePlaceholder: 'Number of participants by age',
            rideInfoAgeSummaryLabel: 'Participants',
            rideInfoDetailsLabel: 'Information for travelers',
            rideInfoDetailsPlaceholder: 'We chose to travel to Holland because...\nWe chose to land at Schiphol Airport because...\nWe got around during the trip with a rental car.\nWe recommend bringing warm clothes and raincoats.\nHere are some recommendations that can enhance your experience:',
            rideInfoLanguageLabel: 'Trip language',
            rideInfoDesignLabel: 'Trip page design',
            rideInfoDesignClassic: 'Classic',
            rideInfoDesignClassicText: 'Days and stays as a list, as today',
            rideInfoDesignPoster: 'Poster',
            rideInfoDesignPosterText: 'A timeline with a big photo for every stop',
            rideInfoPhysicalDisabilitiesLabel: 'Suitable for people with disabilities',
            rideInfoMoreInfo: 'More info',
            rideInfoTopPageImageLabel: 'Trip page background image (page header)',
            rideInfoTopPageImageAlt: 'Trip background image',
            rideInfoReplaceTopImage: 'Replace background image',
            rideInfoUploadTopImage: 'Upload background image',
            rideInfoUploading: 'Uploading...',
            rideInfoCoverImageLabel: 'Cover photo for sharing (WhatsApp / Facebook)',
            rideInfoCoverImagePreparing: 'Preparing the share image...',
            rideInfoCoverImageUpload: 'Upload your own photo',
            rideInfoCoverImageReplace: 'Replace the photo',
            rideInfoCoverImageGuidance: 'Recommended: a landscape photo of at least 1200×630 px. Larger photos are automatically resized to 1200 px wide and under 300KB so they display well on WhatsApp and Facebook. The minimum is 200×200 px.',
            rideInfoMediaLabel: 'Trip video / audio',
            rideInfoMediaHint: 'Shown at the top of the trip page, right after the text about you and before the trip details.',
            rideInfoCoverImageTooSmall: 'This photo is too small to appear when shared on social networks',
            rideInfoCoverImageFailed: 'We could not prepare the share image. Please try another photo.',
            rideInfoLockRideLabel: 'Lock the trip (prevents you from making changes)',
            rideInfoSaveAndContinue: 'Save and continue to add accommodations',
            rideInfoSave: 'Save',
            rideInfoBackWithoutSave: 'Back to trip without saving',
            rideInfoContinue: 'Continue',
            rideInfoTopImageHelp: 'You can upload a background image that will appear at the top of the page.<br><br>Recommended size: 1600×140 pixels.<br><br>On small screens, such as mobile phones, only the center of the image will be displayed.<br><br>The text above the image will be displayed in white and centered. We recommend choosing an image with a relatively dark background in the center for good text readability.<br><br>It is not recommended to include text within the image, as parts of it may be cropped on small screens.<br><br>After uploading the image, we recommend checking how it looks on both computer and phone to ensure it displays well on all devices.',
            rideInfoWaitForUpload: 'Please wait for the background image upload to finish before saving trip details.',
            rideInfoUploadError: 'Error uploading image. Please try again.',
            rideInfoTitleRequired: 'Please enter a trip title.',
            rideInfoDateRangeRequired: 'Please select a full date range (start and end date).',
            rideInfoDateRangeMax60Days: 'The selected date range must be less than 60 days.',

            // InsertLinkToTextbox
            insertLinkAddLinkButton: 'Add link in description',
            insertLinkTextPlaceholder: 'The text to display',
            insertLinkUrlPlaceholder: 'The URL: https://google.com',
            insertLinkInsertButton: 'Insert link at cursor position in description',

            // TripCalendarView
            tripCalendarDragAttractions: 'You can drag attractions from day to day',
            tripCalendarClickDayAddActivities: 'Click on a day to add activities',
            tripCalendarClickClockSetTime: 'Click on the clock to set the time',
            tripCalendarBooked: 'Booked',
            tripCalendarNotBooked: 'Not booked',

            // EditRideAccessKey page
            editRideAccessBannerTitle: 'Private trip access details',
            editRideAccessBannerParagraph: 'You can copy the link and send it to your client',
            editRideAccessAllowEditLabel: 'Allow users to edit their trip',
            editRideAccessRegistrationLinkLabel: 'Registration link for the trip',
            editRideAccessLinkBlockedWarning: 'The registration link is blocked - new users cannot join.',
            editRideAccessRestoreLinkButton: 'Re-activate link',
            editRideAccessCopyLinkButton: 'Copy link',
            editRideAccessSingleUseLinkButton: 'Create single-use link',
            editRideAccessRedirectLabel: 'Redirect URL for unauthorized users',
            editRideAccessRedirectPlaceholder: 'Example: https://my_website.co.il',
            editRideAccessAuthorizedUsersLabel: 'Number of authorized users',
            editRideAccessAuthorizedUsersHint: '0 - unlimited number of users',
            editRideAccessAllowSaleLabel: 'Allow sale via your personal shop',
            editRideAccessSaveButton: 'Save',
            editRideAccessBackWithoutSave: 'Back to trip without saving',
            editRideAccessCopySuccessTitle: 'Link copied',
            editRideAccessCopySuccessMessage: 'The link was copied successfully!',
            editRideAccessCopyErrorTitle: 'Error',
            editRideAccessCopyErrorMessage: 'Error copying the link',
            editRideAccessAllowSaleHelp: 'When this option is enabled, the API can sell the trip via your private shop.<br>To actually sell, you need to open a shop and add this trip to it.<br>Don’t have a shop? Contact the site admins and we will create one for you.',
            editRideAccessEditRideHelp: 'When this option is enabled, the client can edit the trip they received from you, including adding any of the activities and attractions from your personal system.<br><br>Note: After enabling this option, the client sees your full list of activities and can add them to their trip.<br><br>In addition, once this option is enabled, only the client can change the trip - you will no longer be able to edit it yourself.',
            editRideAccessPrepaidApproveShareTitle: 'Approve sending the route',
            editRideAccessPrepaidTripDaysLine: `The route includes ${params.count} days`,
            editRideAccessPrepaidShareCostLine: `Sharing cost: ${params.amount}`,
            editRideAccessPrepaidPerDayLine: `(${params.price} per day)`,
            editRideAccessPrepaidFirstShareLine1: '🟢 First route share is on us',
            editRideAccessPrepaidFirstShareLine2: 'So you can explore the system fully',
            editRideAccessPrepaidInsufficientBalance: 'Not enough balance in your account to complete this action',
            editRideAccessPrepaidContinueTermsButton: 'Continue to terms of use approval',
            editRideAccessPrepaidApproveShareButton: 'Approve route sharing',
            editRideAccessPrepaidCancelButton: 'Cancel',
            editRideAccessPrepaidTopUpButton: 'Set up payment method',
            editRideAccessPrepaidTopUpButtonSub: 'To continue sharing rides, please set up a payment method.',
            editRideAccessPrepaidWhatsAppButton: 'Contact us on WhatsApp',
            editRideAccessSaveCardBannerTitle: 'First share done!',
            editRideAccessSaveCardBannerText: 'To continue sharing rides in the future, please save your card for monthly billing.',
            editRideAccessOpenWhatsAppSupportMessage: 'Hi, I started using TripPlanner and have used up my initial credit.\nI would love to continue using the system and reopen the account for further use.',
            rideConnectedUsersTitle: 'Connected Users',
            rideConnectedUsersEmail: 'Email',
            rideConnectedUsersAuthMethod: 'Login Method',
            rideConnectedUsersConnectedAt: 'Connected On',
            rideConnectedUsersAuthGoogle: 'Google',
            rideConnectedUsersAuthEmail: 'Email & Password',
            rideConnectedUsersAuthWhatsapp: 'WhatsApp',
            rideConnectedUsersRevokeBtn: 'Revoke Access',
            rideConnectedUsersResetPasswordBtn: 'Reset Password',
            rideConnectedUsersResetPasswordTooltip: 'Send a password reset email to the user',
            rideConnectedUsersRevokeSuccess: 'Access revoked',
            rideConnectedUsersResetPasswordSuccess: 'Password reset email sent',
            rideConnectedUsersEmpty: 'No users connected yet',
            sharedRideWarningTitle: 'This trip was already sent to customers',
            sharedRideWarningSentTo: 'Sent to:',
            sharedRideWarningMore: 'more',
            sharedRideWarningBody: 'Any change here also changes their trip. Is this change for the same customer?',
            sharedRideWarningSameCustomer: 'Same customer: keep editing',
            sharedRideWarningNewCustomer: 'New customer: duplicate the trip',
            rideConnectedUsersBlockBtn: 'Block User',
            blockedAccessTitle: 'Access to this trip has been blocked',
            blockedAccessBody: 'To restore access, please contact the person who provided the trip.',
            blockedAccessButton: 'Back to website',

            rideConnectedUsersBlockedBadge: 'Blocked',
            rideConnectedUsersRestoreBtn: 'Restore Access',
            rideConnectedUsersBlockModalTitle: 'Block User Access',
            rideConnectedUsersBlockModalBody: 'Do you want to block this user\'s access to the ride?',
            rideConnectedUsersBlockModalLinkCheckbox: 'Also block the registration link (prevents any new user from joining)',
            rideConnectedUsersBlockModalBillingNote: 'These changes do not affect billing',

            rideCopiedUsersTitle: 'Users with route editing access',
            rideCopiedUsersLoadBtn: 'Load users list',
            rideCopiedUsersEmpty: 'No users have downloaded this route yet',
            rideCopiedUsersAuthGoogle: 'Google',
            rideCopiedUsersAuthEmail: 'Email & Password',
            rideCopiedUsersResetPasswordBtn: 'Reset Password',
            rideCopiedUsersResetPasswordTooltip: 'Send a password reset email to the user',
            rideCopiedUsersResetPasswordSuccess: 'Password reset email sent',
            rideConnectedUsersBlockModalConfirmBtn: 'Yes, block',
            rideConnectedUsersBlockModalCancelBtn: 'Cancel',
            rideConnectedUsersBlockSuccess: 'User blocked',
            rideConnectedUsersRestoreSuccess: 'Access restored',

            // MonthlyBillingCardSetup
            monthlyCardSetupIntro1: 'To continue using the platform and sharing more trips, please save a credit card for monthly billing.',
            monthlyCardSetupIntro2: 'Charges are based solely on your monthly usage.',
            monthlyCardSetupTitle: 'Monthly Billing Setup',
            monthlyCardSetupHint: `For verification and payment security, a nominal charge of ${params.amount} may apply.`,
            monthlyCardSetupSavedMessage: 'Your card was saved successfully.',
            monthlyCardSetupBackToRide: 'Return to ride',
            monthlyCardSetupBack: 'Back',
            monthlyCardSetupNotLoggedIn: 'To set up a credit card, please log in first.',
            monthlyCardSetupNotManager: 'The logged-in user is not a ride manager. Please sign out and log in with the ride manager account.',
            monthlyCardSetupLabelName: 'Full name for invoice',
            monthlyCardSetupLabelPhone: 'Phone',
            monthlyCardSetupLabelCard: 'Card number',
            monthlyCardSetupLabelExpM: 'MM',
            monthlyCardSetupLabelExpY: 'YYYY',
            monthlyCardSetupLabelCitizen: 'National ID',
            monthlyCardSetupUnsupportedAmex: 'We don\'t accept American Express. Please use a Visa or Mastercard.',
            monthlyCardSetupUnsupportedDiners: 'We don\'t accept Diners Club. Please use a Visa or Mastercard.',
            monthlyCardSetupSubmit: 'Save card',
            monthlyCardSetupProcessing: 'Processing…',
            monthlyCardSetupMissingSumit: 'SUMIT is not configured in the frontend (VUE_APP_*).',
            monthlyCardSetupSecurePayment: 'Secure Payment',
            monthlyCardSetupErrorLoad: 'Failed to load',
            monthlyCardSetupErrorSumitLoad: 'Failed to load SUMIT script',
            monthlyCardSetupErrorToken: 'Tokenization failed',
            monthlyCardSetupErrorMissingToken: 'Missing payment token',
            monthlyCardSetupErrorName: 'Enter your name',
            monthlyCardSetupErrorPhone: 'Invalid phone',
            monthlyCardSetupErrorFailed: 'Failed',
            monthlyCardSetupErrorRequest: 'Request failed',
            monthlyCardSetupUpdateCard: 'Update Card',
            monthlyCardSetupSaveNewCard: 'Save New Card',

            // ResetRideModal
            resetRideModalButton: '⚠️ Reset trip',
            resetRideModalTitle: 'Reset trip to the original version',
            resetRideModalConfirm: 'Reset',
            resetRideModalCancel: 'Cancel',
            resetRideModalWarningQuestion: 'Are you sure you want to reset the trip to the original version?',
            resetRideModalDescriptionLine1: 'This action will restore the trip to its original state before your changes.',
            resetRideModalDescriptionLine2Strong: 'All your changes will be lost!',
            resetRideModalIrreversible: 'This action cannot be undone.',

            // GeneratOneTimeAccessKey page
            generateOneTimeAccessBannerTitle: 'Private trip access details',
            generateOneTimeAccessBannerParagraph: 'You can copy the link and send it to your client',
            generateOneTimeAccessRecipientDetailsLabel: 'Enter recipient details',
            generateOneTimeAccessCreateLinkButton: 'Generate single-use link',
            generateOneTimeAccessSingleUserLinkLabel: 'Registration link for one user',
            generateOneTimeAccessCopyLinkButton: 'Copy link',
            generateOneTimeAccessBackToTripButton: 'Back to trip',
            generateOneTimeAccessCopySuccessTitle: 'Link copied',
            generateOneTimeAccessCopySuccessMessage: 'The link was copied successfully!',
            generateOneTimeAccessCopyErrorTitle: 'Error',
            generateOneTimeAccessCopyErrorMessage: 'Error copying the link',

            // DayManagerOptions
            dayManagerTitle: 'Manage day',
            dayManagerAddAttraction: 'Add activity',
            dayManagerAddAccommodation: 'Add accommodation',
            dayManagerAddDayAfter: 'Add day after',
            dayManagerDeleteDay: 'Delete day',

            // AreYouShureRemovingDay modal
            removeDayTitle: 'Are you sure?',
            removeDayMessage: 'This action will remove the day from your trip. Do you also want to delete all activities for that day?',
            removeDayAndAttractionsButton: 'Yes, delete the day and all activities',
            removeDayOnlyButton: 'No, move the activities to the next day',
            removeDayCancelButton: 'Cancel',

            // AreYouShureRemovingAttraction modal
            removeAttractionTitle: 'Are you sure?',
            removeAttractionMessage: 'This action will delete the activity from your trip!',
            removeAttractionDeleteButton: 'Delete',
            removeAttractionCancelButton: 'Cancel',

            // UpdateAttractionTime modal
            updateAttractionTitle: 'Choose a new day and time for the activity:',
            updateAttractionDayLabel: 'Day:',
            updateAttractionTimeLabel: 'Time:',
            updateAttractionSaveButton: 'Save',

            // DynamicModal popups (errorNumberConverter) - English
            popup_1_text: 'It worked',
            popup_1_subText: 'Great, keep going',
            popup_1_action: 'Try again',

            popup_2_text: 'Sorry',
            popup_2_subText: 'Something did not work well - we will take care of it',
            popup_2_action: 'Try again',

            popup_3_text: 'User is not registered in our system',
            popup_3_subText: 'Are you sure you signed up?',
            popup_3_action: 'Try again',

            popup_4_text: 'Wrong password',
            popup_4_subText: 'Happens to everyone sometimes',
            popup_4_action: 'Try again',

            popup_5_text: 'You are already registered',
            popup_5_subText: 'Happens to everyone sometimes',
            popup_5_action: 'Try again',

            popup_userLoggedInSuccessfully_text: 'Logged in successfully',
            popup_userLoggedInSuccessfully_subText: 'You can now copy a trip and edit the itinerary according to your needs.',
            popup_userLoggedInSuccessfully_action: 'Continue',

            popup_userRegisteredSuccessfully_text: 'Registered successfully',
            popup_userRegisteredSuccessfully_subText: "You're logged in, let's get started!",
            popup_userRegisteredSuccessfully_action: 'Continue',

            popup_startInsertRideLoginRequired_text: 'To continue from this point you need to be registered',
            popup_startInsertRideLoginRequired_subText: 'Please log in or register to create a trip.',
            popup_startInsertRideLoginRequired_action: 'Log in or register',
            popup_pleaseLogInToEditRide_title: 'So you do not lose your information',
            popup_pleaseLogInToEditRide_subText: 'Please sign up',
            popup_pleaseLogInToEditRide_action: 'Sign up',

            popup_rideHaveOrderedAccommodation_text: 'Oops, you already have a booked accommodation',
            popup_rideHaveOrderedAccommodation_subText: 'Days cannot be edited after adding accommodation details. You can delete the accommodation and then edit.',
            popup_rideHaveOrderedAccommodation_action: 'Close',

            popup_fail_to_update_accommodation_text: 'Oops, something went wrong during the update',
            popup_fail_to_update_accommodation_subText: 'Please check that everything was updated correctly or contact us for assistance.',
            popup_fail_to_update_accommodation_action: 'Close',

            popup_fail_to_update_attraction_text: 'Oops, something went wrong updating the activity',
            popup_fail_to_update_attraction_subText: 'Please check that everything was updated correctly or contact us for assistance.',
            popup_fail_to_update_attraction_action: 'Close',
            popup_fail_to_update_ride_text_text: "We couldn't update the trip description",
            popup_fail_to_update_ride_text_subText: 'You may not have permission to edit this trip. Please try again, or edit the description from the trip information screen.',
            popup_fail_to_update_ride_text_action: 'Close',
            popup_fail_to_update_ride_title_text: "We couldn't update the trip name",
            popup_fail_to_update_ride_title_subText: 'You may not have permission to edit this trip. Please try again, or change the name from the trip information screen.',
            popup_fail_to_update_ride_title_action: 'Close',
            popup_invalid_title_text: 'A trip cannot be left without a name',
            popup_invalid_title_subText: 'We could not find a name to save, so nothing was changed. Ask the AI for another name, or write it on the trip information screen.',
            popup_invalid_title_action: 'Close',
            popup_title_too_long_text: 'That trip name is too long',
            popup_title_too_long_subText: 'A trip name is limited to 140 characters, so nothing was changed. Ask the AI for a shorter one.',
            popup_title_too_long_action: 'Close',
            popup_fail_to_update_ride_language_text: "We couldn't update the trip language",
            popup_fail_to_update_ride_language_subText: 'You may not have permission to edit this trip. Please try again, or change the language from the trip information screen.',
            popup_fail_to_update_ride_language_action: 'Close',
            popup_invalid_language_text: 'No language to save',
            popup_invalid_language_subText: 'We could not find a language to save, so nothing was changed. Choose the language on the trip information screen.',
            popup_invalid_language_action: 'Close',
            popup_unknown_language_text: 'That language is not supported',
            popup_unknown_language_subText: 'That is not one of the languages a trip can be set to, so nothing was changed. Ask the AI for another one, or choose it on the trip information screen.',
            popup_unknown_language_action: 'Close',
            popup_invalid_text_text: "Nothing was saved",
            popup_invalid_text_subText: 'We could not find any text to save in the trip description, so nothing was saved — not the description and not the other details on the form. Write the description and save again.',
            popup_invalid_text_action: 'Close',

            popup_user_is_not_authorized_text: 'Oops, this user is not authorized to perform this action',
            popup_user_is_not_authorized_subText: 'Please log out and log back in - that should help.',
            popup_user_is_not_authorized_action: 'Close',

            popup_error_no_access_to_attraction_text: 'You do not have access to this attraction',
            popup_error_no_access_to_attraction_subText: 'Please check that you have the correct permissions or contact the trip owner.',
            popup_error_no_access_to_attraction_action: 'Close',

            popup_date_are_not_in_range_text: 'Oops, the dates do not match the trip range',
            popup_date_are_not_in_range_subText: 'Please adjust the dates.',
            popup_date_are_not_in_range_action: 'Close',

            popup_you_Are_having_double_booking_text: 'Oops, there is already a booking on some of these days',
            popup_you_Are_having_double_booking_subText: 'Please adjust the dates.',
            popup_you_Are_having_double_booking_action: 'Close',

            popup_uesr_is_not_authorize_to_edit_this_ride_text: 'You cannot edit this trip',
            popup_uesr_is_not_authorize_to_edit_this_ride_subText: 'Click "Edit trip" and try again.',
            popup_uesr_is_not_authorize_to_edit_this_ride_action: 'Close',

            popup_scroll_down_to_see_the_added_day_text: 'You added a day to the trip',
            popup_scroll_down_to_see_the_added_day_subText: 'Scroll down a bit on the page to see it.',
            popup_scroll_down_to_see_the_added_day_action: 'Close',

            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_text: 'You deleted a day from the trip',
            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_subText: 'All activities from that day were moved to the following day. You can move them back if needed.',
            popup_the_day_wewre_delited_and_the_activites_pushed_to_the_next_day_action: 'Close',

            popup_uesr_is_adding_new_ride_text: 'Great that you chose to share',
            popup_uesr_is_adding_new_ride_subText: 'Let’s start by entering the general trip details.',
            popup_uesr_is_adding_new_ride_action: 'Close',

            popup_uesr_copyed_new_ride_text: 'Great choice of trip',
            popup_uesr_copyed_new_ride_subText: 'Make sure to update the trip start date. After that you can adjust the itinerary to your needs.',
            popup_uesr_copyed_new_ride_action: 'Close',

            popup_ride_reset_success_text: 'Trip was reset successfully',
            popup_ride_reset_success_subText: 'The trip was restored to its original state before your edits.',
            popup_ride_reset_success_action: 'Close',

            popup_ride_reset_error_text: 'Error resetting trip',
            popup_ride_reset_error_subText: 'Sorry, we could not reset the trip. Please try again or contact support.',
            popup_ride_reset_error_action: 'Close',

            popup_please_use_auto_compleate_text: 'Please use the autocomplete suggestions',
            popup_please_use_auto_compleate_subText: 'Choose one of the options from the list.',
            popup_please_use_auto_compleate_action: 'Close',

            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_text: 'We do not yet have a trip for this area',
            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_subText: 'We would love it if you add your trip when you return.',
            popup_sorry_we_dont_have_this_ride_please_add_it_at_your_return_action: 'Close',

            popup_updating_the_ride_text: 'Uploading data',
            popup_updating_the_ride_subText: 'We are updating your trip.',
            popup_updating_the_ride_action: 'Close',

            popup_user_guide_for_editing_text: 'Did you know you can copy this trip and edit it?',
            popup_user_guide_for_editing_subText: 'You can add activities from trips other families did in the same area!',
            popup_user_guide_for_editing_action: 'Close',

            popup_new_ride_detailes_form_text: 'We created another very simple way to upload a trip',
            popup_new_ride_detailes_form_subText: 'Would you like us to contact you with an explanation?',
            popup_new_ride_detailes_form_action: 'Yes',

            popup_account_exists_with_different_credential_text: 'This email is already registered with a different login method',
            popup_account_exists_with_different_credential_subText: 'Please log in using the method you used the first time.',
            popup_account_exists_with_different_credential_action: 'Try again',

            popup_email_is_not_baind_to_this_acount_text: 'No email is associated with this account',
            popup_email_is_not_baind_to_this_acount_subText: 'You cannot log in without an email linked to the account.',
            popup_email_is_not_baind_to_this_acount_action: 'Try again',

            popup_connect_me_for_adding_new_ride_text: 'To get the option to share your trip on the site',
            popup_connect_me_for_adding_new_ride_subText: 'Please contact us at +972-52-686-7915.',
            popup_connect_me_for_adding_new_ride_action: 'Close',

            popup_upload_trip_adding_text_stage_text: 'Yes! We uploaded your itinerary',
            popup_upload_trip_adding_text_stage_subText: 'Now you can give the trip a name and add a short general description.',
            popup_upload_trip_adding_text_stage_action: 'Close',

            popup_all_images_dates_are_empty_text: 'All images are missing capture time information',
            popup_all_images_dates_are_empty_subText: 'To make this work, you need to use the original photos from the phone that took them.',
            popup_all_images_dates_are_empty_action: 'Close',

            popup_limiting_the_trip_duration_text: 'Trip length is limited to 60 days',
            popup_limiting_the_trip_duration_subText: 'Please upload a trip up to 60 days long.',
            popup_limiting_the_trip_duration_action: 'Close',

            popup_all_images_without_metadata_text: 'No metadata found in images',
            popup_all_images_without_metadata_subText: 'Currently we do not support images that were not taken on the same device used to upload them.',
            popup_all_images_without_metadata_action: 'Close',

            popup_waiting_to_get_image_info_text: 'We are processing the images to understand where they were taken',
            popup_waiting_to_get_image_info_subText: 'This can take up to 30 seconds.',
            popup_waiting_to_get_image_info_action: '',

            popup_waiting_to_get_image_info_without_gps_information_text: 'We are processing the images to understand where they were taken',
            popup_waiting_to_get_image_info_without_gps_information_subText: 'This may take up to 30 seconds. Because the uploaded images do not contain location data, detection may take longer.',
            popup_waiting_to_get_image_info_without_gps_information_action: '',

            popup_api_call_failed_text: 'An error occurred during the analysis process',
            popup_api_call_failed_subText: 'Please try again later. If the problem persists, contact support at +972-52-686-7915.',
            popup_api_call_failed_action: '',

            popup_plese_add_the_activity_info_text: 'Your trip is ready! Now is the time to add your tips',
            popup_plese_add_the_activity_info_subText: 'You can go over all the attractions and add your tips to help other families get the most out of their visit.',
            popup_plese_add_the_activity_info_action: 'Close',

            popup_plese_add_the_accommodation_dates_text: 'Please enter the dates you stayed at this place',
            popup_plese_add_the_accommodation_dates_subText: 'So that others know how many nights to book, you need to enter check-in and check-out dates for this accommodation.',
            popup_plese_add_the_accommodation_dates_action: 'Close',

            popup_not_supporting_FB_or_instagram_browsers_text: 'Cannot sign in with G‑Mail in this browser',
            popup_not_supporting_FB_or_instagram_browsers_subText: 'It looks like you are using the Facebook or Instagram in-app browser. Please open the link in a regular browser such as Safari or Chrome.',
            popup_not_supporting_FB_or_instagram_browsers_action: 'Close',

            popup_fail_to_add_user_to_ride_privacy_text: 'Something went wrong while updating permissions',
            popup_fail_to_add_user_to_ride_privacy_subText: 'Please check that everything was updated correctly. If the problem persists, contact us and we will be happy to help.',
            popup_fail_to_add_user_to_ride_privacy_action: 'Close',

            popup_this_user_is_alrady_assign_to_this_ride_text: 'This user is already assigned to this trip',
            popup_this_user_is_alrady_assign_to_this_ride_subText: 'There is no need to use this link again. Copy the link shown on this page instead.',
            popup_this_user_is_alrady_assign_to_this_ride_action: 'Close',

            popup_user_does_not_have_permission_to_this_private_ride_text: 'This trip is restricted to authorized users only.',
            popup_user_does_not_have_permission_to_this_private_ride_subText: 'Please sign up or log in to access this trip.',
            popup_user_does_not_have_permission_to_this_private_ride_action: 'Login or register',

            popup_blocked_text: 'Access to this trip has been blocked',
            popup_blocked_subText: 'To restore access, please contact the person who provided the trip.',
            popup_blocked_action: 'Close',

            popup_ride_link_activated_text: 'Link re-activated',
            popup_ride_link_activated_subText: 'New users can now join through the link.',
            popup_ride_link_activated_action: 'Close',

            popup_key_is_not_exsist_text: 'The link you entered is not valid',
            popup_key_is_not_exsist_subText: 'Please contact the person who gave you the link and ask for a valid link.',
            popup_key_is_not_exsist_action: 'Close',

            popup_the_private_link_is_not_valide_text: 'The link you entered is not valid',
            popup_the_private_link_is_not_valide_subText: 'Please contact the person who gave you the link and ask for a valid link.',
            popup_the_private_link_is_not_valide_action: 'Close',

            popup_ritch_to_ride_limitation_text: 'This link has reached its user limit',
            popup_ritch_to_ride_limitation_subText: 'Please contact the person who gave you the link to increase the user limit.',
            popup_ritch_to_ride_limitation_action: 'Close',

            popup_error_ride_is_not_from_subdomain_text: 'Cannot copy this trip',
            popup_error_ride_is_not_from_subdomain_subText: 'The trip belongs to a different group. Please contact the person who gave you the link.',
            popup_error_ride_is_not_from_subdomain_action: 'Close',

            popup_error_ride_is_not_from_the_right_user_text: 'Cannot copy this trip',
            popup_error_ride_is_not_from_the_right_user_subText: 'The trip owners do not belong to this group. Please contact the person who gave you the link.',
            popup_error_ride_is_not_from_the_right_user_action: 'Close',

            popup_atraction_text_box_is_not_empty_text: 'I am not allowed to delete information you already entered',
            popup_atraction_text_box_is_not_empty_subText: 'Please clear the text in the "Attraction description" box and try again.',
            popup_atraction_text_box_is_not_empty_action: 'Close',

            popup_the_day_and_its_activities_were_deleted_text: 'You deleted a day and all its activities',
            popup_the_day_and_its_activities_were_deleted_subText: 'The day and all of its activities were successfully removed from the trip.',
            popup_the_day_and_its_activities_were_deleted_action: 'Close',

            popup_day_activities_moved_successfully_text: 'You moved all activities for this day',
            popup_day_activities_moved_successfully_subText: 'The activities were successfully moved to the day you selected.',
            popup_day_activities_moved_successfully_action: 'Close',

            popup_invalid_email_spaces_text: 'Email address is not valid',
            popup_invalid_email_spaces_subText: 'The email address cannot contain spaces.',
            popup_invalid_email_spaces_action: 'Try again',

            popup_invalid_email_format_text: 'Email address is not valid',
            popup_invalid_email_format_subText: 'Please enter a valid email address.',
            popup_invalid_email_format_action: 'Try again',

            popup_day_not_in_trip_range_text: 'Oops, this day is not part of the trip',
            popup_day_not_in_trip_range_subText: 'Please choose a day within the trip date range.',
            popup_day_not_in_trip_range_action: 'Close',
            popup_fail_to_update_day_note_text: "We couldn't update the day note",
            popup_fail_to_update_day_note_subText: 'The note may have changed, or you may not have permission to edit it. Please try again from the day view.',
            popup_fail_to_update_day_note_action: 'Close',
            popup_fail_to_update_ride_note_text: "We couldn't update the trip's general information",
            popup_fail_to_update_ride_note_subText: 'The item may have changed, or you may not have permission to edit it. Please try again from the trip page.',
            popup_fail_to_update_ride_note_action: 'Close',

            popup_unbooked_accommodation_info_text: 'Enter your hotel details for the relevant days',
            popup_unbooked_accommodation_info_subText: 'Please enter the details of the hotels you booked so they will appear in your trip plan.',
            popup_unbooked_accommodation_info_action: 'Close',

            popup_password_reset_email_sent_text: 'Password reset instructions sent',
            popup_password_reset_email_sent_subText: 'Check your email inbox.',
            popup_password_reset_email_sent_action: 'Close',

            popup_password_reset_failed_text: 'Error resetting password',
            popup_password_reset_failed_subText: 'Please try again or contact support.',
            popup_password_reset_failed_action: 'Close',

            popup_password_reset_success_text: 'Password updated successfully',
            popup_password_reset_success_subText: 'You can now log in to your account using the original link you received.',
            popup_password_reset_success_action: 'Got it',

            popup_please_close_tab_text: 'You can close this tab',
            popup_please_close_tab_subText: 'The password was updated successfully. Please close this tab and return to the original link.',
            popup_please_close_tab_action: 'Got it',

            popup_password_too_short_text: 'Password is too short',
            popup_password_too_short_subText: 'The password must be at least 6 characters long.',
            popup_password_too_short_action: 'Close',

            popup_passwords_dont_match_text: 'Passwords do not match',
            popup_passwords_dont_match_subText: 'Please make sure you entered the same password in both fields.',
            popup_passwords_dont_match_action: 'Close',

            popup_password_required_text: 'Password is required',
            popup_password_required_subText: 'Please enter a password to register.',
            popup_password_required_action: 'Close',

            popup_invalid_reset_token_text: 'Invalid link',
            popup_invalid_reset_token_subText: 'The password reset link is invalid or has expired.',
            popup_invalid_reset_token_action: 'Back to login',

            popup_google_oauth_user_text: 'This account is connected through GOOGLE',
            popup_google_oauth_user_subText: 'Please log in using your Gmail account.',
            popup_google_oauth_user_action: 'Back to login',

            popup_password_reset_failed_user_is_not_registered_text: 'This account is not registered in the system',
            popup_password_reset_failed_user_is_not_registered_subText: 'You need to log in to the system with this email.',
            popup_password_reset_failed_user_is_not_registered_action: 'Back to login',

            popup_pdf_generation_warning_text: '⚠️ Creating the PDF can take up to 3 minutes!',
            popup_pdf_generation_warning_subText: 'Please wait and do not close the browser. The process will start shortly.',
            popup_pdf_generation_warning_action: 'Got it',

            popup_pdf_generated_successfully_text: 'PDF file created successfully!',
            popup_pdf_generated_successfully_subText: 'The file has been downloaded to your device.',
            popup_pdf_generated_successfully_action: 'Close',

            popup_pdf_generation_failed_text: 'Error creating PDF file',
            popup_pdf_generation_failed_subText: 'Please try again or contact support.',
            popup_pdf_generation_failed_action: 'Close',

            popup_pdf_rate_limited_text: 'PDF Generation Limited',
            popup_pdf_rate_limited_subText: params.seconds
              ? `You can generate one PDF every 2 minutes. You can try again in ${params.seconds} seconds.`
              : 'You can generate one PDF every 2 minutes. Please wait and try again.',
            popup_pdf_rate_limited_action: 'Close',

            popup_ride_data_not_loaded_text: 'Trip data did not load correctly',
            popup_ride_data_not_loaded_subText: 'Please refresh the page and try again.',
            popup_ride_data_not_loaded_action: 'Close',

            popup_insufficient_balance_text: 'Your starting credit has been used',
            popup_insufficient_balance_subText:
                'To keep sharing itineraries and unlock your account for continued use, contact us and we will be glad to help you work smoothly.\n\nYou can continue building and editing itineraries without limit.',
            popup_insufficient_balance_action: 'Contact us on WhatsApp',

            popup_contact_form_success_text: 'Your message has been sent successfully!',
            popup_contact_form_success_subText: 'We will get back to you as soon as possible.',
            popup_contact_form_success_action: 'OK',

            popup_contact_form_error_text: 'Error sending message',
            popup_contact_form_error_subText: 'Please try again later or contact us in another way.',
            popup_contact_form_error_action: 'OK',

            popup_name_required_text: 'Full name is required',
            popup_name_required_subText: 'Please enter your full name.',
            popup_name_required_action: 'OK',
            popup_phone_required_text: 'Phone number is required',
            popup_phone_required_subText: 'Please enter a phone number so we can reach you.',
            popup_phone_required_action: 'OK',
            popup_phone_invalid_text: 'Invalid phone number',
            popup_phone_invalid_subText: 'Enter 8-15 digits, including country code if needed (e.g. +1, +44, +972).',
            popup_phone_invalid_action: 'OK',

            popup_message_required_text: 'Message is required',
            popup_message_required_subText: 'Please enter the content of your message.',
            popup_message_required_action: 'OK',

            popup_gui_version_outdated_text: 'The system has been updated and a page refresh is required to continue.',
            popup_gui_version_outdated_subText: 'The page will refresh automatically in about 7 seconds.\nSome recent changes may not have been saved.',
            popup_gui_version_outdated_action: 'Got it',

            popup_master_accommodation_already_exists_text: 'You changed the hotel to one that already exists in your catalog',
            popup_master_accommodation_already_exists_subText: 'To avoid overwriting existing details, no automatic update was performed.\n\nTo update the hotel, you can do so directly through the hotel catalog.',
            popup_master_accommodation_already_exists_action: 'Close',

            // Login Modal translations
            loginOrRegisterQuickly: 'Login or Quick Registration',
            or: 'or',
            loginTitle: 'Login',
            emailPlaceholder: 'Email',
            passwordPlaceholder: 'Password',
            forgotPassword: 'Forgot password?',
            loginButton: 'Login',
            notRegisteredYet: 'Not registered yet?',
            registerButton: 'Register',
            accessWith: 'ACCESS WITH',
            continueWithGoogle: 'Continue with Google',
            continueWithFacebook: 'Continue with Facebook',
            socialLoginAgreement: 'By logging in with my social login, I agree to link my account in accordance with the',
            privacyPolicy: 'Privacy Policy',
            continueButton: 'Continue',
            orContinueWithEmail: 'Or continue with email',
            checkingAccount: 'Checking your account...',
            loginOAuthHintGoogle: 'Continue with Google to access your account',
            loginOAuthHintFacebook: 'Continue with Facebook to access your account',
            loginOAuthHintGeneric: 'Continue with your social account to access your account',

            // Registration Modal translations
            quickRegistration: 'Quick Registration',
            orRegisterWith: 'or register with',
            usernamePlaceholder: 'Username',
            confirmPasswordPlaceholder: 'Confirm Password',
            readTerms: 'I have read the terms',
            agreeToTerms: 'By continuing this process I agree to the terms of use and privacy policies of the site',

            // Terms of Use translations
            termsOfUseTitle: 'TripPlanner Website Terms of Use',
            backToPrevious: 'Back to Previous Page',
            termsIntro: 'The TripPlanner.co.il website is a collaborative platform for sharing trips, recommendations and content related to trip planning in Israel and abroad. By uploading content to the site, the user declares and confirms that all content published by them on the site is exposed to the general public and is permitted for free use by other users - for viewing, inspiration or trip planning purposes.',
            sharingTripsTitle: 'Sharing Trips and Content',
            sharingTripsContent: 'The purpose of the site is to enable sharing of travel experiences with the community. Therefore, any trip, photo, comment or other content uploaded to the site is considered public content. Do not upload private or personal content that you do not want to be exposed. The user waives in advance any claim for royalties, usage restrictions or exclusive ownership of content published by them.',
            notProfessionalAdviceTitle: 'TripPlanner is Not Professional Advice',
            notProfessionalAdviceContent: 'The content on the site is written and collected by users and does not constitute professional advice or a substitute for a licensed tourism service. Any use of content - including recommendations, routes, accommodation and transportation - is done at the user\'s sole responsibility.',
            professionalServicesTitle: 'Professional Services on the Site',
            professionalServicesContent: 'Alongside content uploaded by private users, TripPlanner also allows professional providers to share trips with their clients only. These trips are accessible only to the provider\'s specific audience (e.g., paying customers) and are not visible to the general public. The professional provider is fully responsible for the content, information displayed and services associated with such trips.',
            clientViewingTitle: 'Content Viewing by Clients of Professional Planners',
            clientViewingContent1: 'Clients who received a personal link to view a trip itinerary from a professional trip planner are also subject to these terms of use. Any use of the content shown to them - including actual trip planning, relying on recommendations or information - is done at their sole responsibility.',
            clientViewingContent2: 'The site serves as a technological platform only and is not a party to the relationship between the planner and the client. All responsibility for content, services, availability, prices or personal customization rests with the professional planner only.',
            noContentGuaranteeTitle: 'No Commitment to Content Preservation',
            noContentGuaranteeContent1: 'The company reserves the right to delete, modify, edit or transfer content on the site at its sole discretion, including content entered by users.',
            noContentGuaranteeContent2: 'The company does not commit to keeping backups or ensuring long-term preservation of content in any form.',
            marketingContentTitle: 'Marketing Content and Advertising',
            marketingContentContent: 'Some of the content on the site may include marketing information, advertisements, or sponsored content. All advertising is the sole responsibility of the advertiser, and the site is not a party to transactions concluded as a result of such advertising.',
            liabilityLimitationTitle: 'Limitation of Liability',
            liabilityLimitationContent: 'The information on the site is provided as is (AS IS). The site is not responsible for the accuracy, completeness or timeliness of the information, and does not commit that the use of the site will suit your needs. The responsibility for using the content rests with the user alone. TripPlanner will not be liable for any direct or indirect damage caused as a result of using the site or relying on content therein.',
            siteUsageTitle: 'Site Usage',
            siteUsageContent: 'The site should not be used for commercial, harmful, illegal purposes or those that violate the privacy or rights of others. The company reserves the right to remove content and/or block users without the need for prior notice.',
            copyrightTitle: 'Copyright and Intellectual Property',
            copyrightContent: 'All rights to the site design, logo, operating system and code that make up TripPlanner are reserved to the company only. Do not copy, duplicate, or make any commercial use without written permission.',
            accessibilityTitle: 'Accessibility',
            accessibilityContent1: 'The TripPlanner website strives to provide an accessible browsing experience for all users, including people with disabilities. The site operates according to W3C (WCAG 2.0) AA level accessibility guidelines, and includes accessibility adaptations in the site structure, content, and navigation options.',
            accessibilityContent2: 'You can enlarge text or change screen colors using tools built into the browser (such as Zoom or accessibility add-ons). The site does not currently include a dedicated graphic accessibility component, but we are working to improve this in the future.',
            accessibilityContent3: 'If you encounter an accessibility difficulty or malfunction, you can contact us, and we will do our best to fix it as soon as possible.',
            changesTitle: 'Changes to the Site and Regulations',
            changesContent: 'The company may update from time to time the terms of use, the structure of the site, the content and services therein, or the privacy policy - at its sole discretion and without prior notice.',

            // AttractionManagerOptions modal
            attractionManagerTitlePrefix: 'What would you like to do with',
            attractionManagerEdit: 'Edit',
            attractionManagerUpdateDate: 'Update date',
            attractionManagerRemove: 'Remove',
            contactTitle: 'Contact Us',
            contactContent: 'For any question or request, you can contact us by email:',

            // Privacy Policy page
            ppIntro: 'The TripPlanner.co.il website ("the Site") takes user privacy seriously. This document outlines the policy for use of information collected on the site.',
            ppInfoCollection: 'Information Collection',
            ppInfoCollectionContent: 'During use of the site we may collect information including identifying details (such as email address), technical information (such as IP address, browser type, operating system), and analytical information (such as pages visited, time spent on the site).',
            ppInfoUse: 'Use of Information',
            ppInfoUseContent: 'The information collected is used for:',
            ppInfoUseItem1: 'Improving user experience',
            ppInfoUseItem2: 'Personalization of content',
            ppInfoUseItem3: 'Internal statistics',
            ppInfoUseItem4: 'Maintaining site security',
            ppCookies: 'Use of Cookies',
            ppCookiesContent1: 'The site uses Cookie files and similar technologies (such as localStorage) for proper site operation, traffic analysis, service improvement and personalization.',
            ppCookiesContent2: 'You can delete or block these files through your browser settings.',
            ppExternalServices: 'External Services',
            ppExternalServicesContent1: 'The site uses the Hotjar service for user behavior analysis and improvements. In addition, other external services such as Google Analytics may be used.',
            ppExternalServicesContent2: 'Each service is subject to its provider\'s terms of use and privacy policy.',
            ppDataSecurity: 'Data Storage and Security',
            ppDataSecurityContent: 'We take reasonable measures to maintain the security of information, but we cannot guarantee absolute protection.',
            ppPolicyChanges: 'Policy Changes',
            ppPolicyChangesContent: 'This policy may be updated from time to time. We will update this page with the appropriate update date.',
            ppContactHeading: 'Contact',
            ppContactContent: 'For any questions or requests, you can contact us via the contact form on the site.',
            ppLastUpdated: 'Last updated: March 2025',
            
            // Update Notification translations
            updateRequired: 'Security Update',
            updateRequiredMessage: 'According to security update you should relogin. Thanks',
            loginAgain: 'Login Again',
            
            // PrivatePageLanding translations
            privateTripTitle: 'Your Personal Trip',
            privateTripSubtitle: 'Login or register to view your personal trip.',
            welcomeToPrivateTrip: 'Welcome to your personal trip!',
            noPermissionMessage: 'This account does not have permission to access this trip. You can purchase the trip using the link provided.',
            loginToViewTrip: 'To access and view trip details, please login or register.',
            afterLoginMessage: 'After logging in, you will be automatically redirected to your trip page, where you will find all the information we planned especially for you',
            purchaseTrip: 'Purchase Trip',
            loginOrRegister: 'Register or Login',
            
            // AssignToRide translations
            welcomeToPrivateTripWithEmoji: 'Welcome to your personal trip! 😊',
            loginToViewTripHere: 'To access and view trip details, login or register right here.',
            saveLinkMessage: 'To be able to return to the trip later, click the "Get Your Trip Link" button and save the link.',
            afterLinkMessage: 'After that, click "Go to Trip" and you will be taken to the page where all our planning awaits you. We also sent you an email with the personal link - worth saving it.',
            scheduleConsultingMeeting: 'Schedule a convenient meeting to customize the trip to my needs',
            getTripLinkButton: 'Click here to get your trip link',
            goToTrip: 'Go to Trip',
            
            // CopyPrivateLink translations
            saveTripLinkTitle: 'Save the link to your trip',
            congratulationsRegistered: 'Congratulations! You have successfully registered to view your trip.',
            importantToSaveLink: 'It\'s important to save the link to the trip so you can easily return to it in the future.',
            copyLink: 'Copy Link',
            linkCopiedSuccess: 'Link copied successfully!',
            copyLinkTitle: 'Copy Link',
            errorCopyingLink: 'Error copying link',
            shareRideHeader: 'Save the link to your trip',
            shareRideText: 'Congratulations! You have successfully registered to view your trip. It\'s important to save the link to the trip so you can easily return to it in the future.',
            shareRideWhatsAppTitle: 'Share Trip',
            shareRideWhatsAppDescription: 'Hi! I\'m sharing with you the link to view my trip. Save it for quick access:',
            shareAttractionHeader: 'Send Activity to Friends',
            shareAttractionText: 'The person viewing this trip will not be able to edit or change your trip, they can only view the trip and if they really like it, they can copy the trip and edit another one for themselves',
            shareAttractionWhatsAppTitle: 'Building a Family Trip.',
            shareAttractionWhatsAppDescription: 'Here is a trip base that can be adapted to our wishes',
            startInsertRideWhatsappShareButton: 'Send link to computer (WhatsApp)',
            startInsertRideCopyWelcomeLinkLine: 'Or copy the link',
            startInsertRideWhatsappShareMessageLine1: 'Hi, I am getting started with TripPlanner',
            startInsertRideWhatsappShareMessageLine2: 'Here is the link to continue working from a computer:',

            // PaymentHowItWorks page
            paymentHowMetaTitle: 'How sharing and usage costs work | TripPlanner',
            paymentHowMetaDescription: '₪25 monthly subscription for using the system, plus per-use charges when sharing routes with clients. Up to 4 clients per sharing.',
            paymentHowEyebrow: 'Full transparency · Monthly subscription + per use',
            paymentHowHeroTitle: 'How sharing and pricing work',
            paymentHowHeroLeadCreate: 'A fixed monthly payment of ₪25 grants access to the system.',
            paymentHowHeroLeadPay: 'In addition, pay per use when sharing routes with clients.',
            paymentHowPriceTitle: 'How much does it cost',
            paymentHowPricePerDayValue: '5 ₪',
            paymentHowPerRouteDay: 'per route day',
            paymentHowMinCostNote: 'Minimum sharing cost: ₪15 (3 days)',
            paymentHowAccessTitle: 'System Access',
            paymentHowAccessItem1: '$9 per month',
            paymentHowAccessItem2: 'Full access to all system features',
            paymentHowAccessItem3: 'Pay only for routes you share with clients',
            paymentHowExampleTitle: 'Example',
            paymentHowExampleSub: 'Simple calculation, no surprises',
            paymentHowExamplePriceByDays: 'Price by route days',
            paymentHowRouteDaysLabel: 'route days',
            paymentHowPerDayLabel: 'per day',
            paymentHowExamplePerDayValue: '$2',
            paymentHowExampleDaysResultValue: '$8',
            paymentHowExampleDaysCaption: 'A 4-day route costs $8',
            paymentHowExampleAbove4Clients: 'More than 4 clients',
            paymentHowExampleExtraIntroPrefix: 'Up to 4 clients are included in sharing. Extra clients:',
            paymentHowExampleScenarioPrefix: 'For example: sharing with',
            paymentHowExampleScenarioSuffix: 'clients',
            paymentHowExtraClientsLabel: 'extra clients',
            paymentHowExamplePerClientValue: '$4',
            paymentHowPerClientLabel: 'per client',
            paymentHowExampleExtraResultValue: '$8',
            paymentHowExampleExtraClientsCaption: '6 clients - first 4 = 2 additional clients',
            paymentHowExampleTotalLabel: 'Total example (4 days + 6 clients)',
            paymentHowExampleTotalValue: '$8 + $8 = $16',
            paymentHowClientsTitle: 'Sharing with clients',
            paymentHowClientsUpTo4: 'You can share the route with up to 4 clients',
            paymentHowClientsWantMore: 'Want to share with more?',
            paymentHowClientsExtraPrefix: 'You can add extra clients for',
            paymentHowClientsPerClientValue: '$4',
            paymentHowEasyStartTitle: 'Easy start',
            paymentHowEasyStartHighlight: 'Your first shared route is on us',
            paymentHowEasyStartText: 'So you can get to know the system fully',
            paymentHowCtaTitle: 'Ready to get started?',
            paymentHowCtaText: 'Build routes in the system whenever it suits you, and share them with clients when you are ready.',
            paymentHowCtaButton: 'Start creating a route',
            // PricingPlans page (/pricing) - presentation only, plan numbers come from common/pricingPlans.js
            pricingPlansMetaTitle: 'Plans and pricing | TripPlanner',
            pricingPlansMetaDescription: 'TripPlanner plans for travel agents: Free, Smart, Pro and Business. A monthly subscription plus a charge per shared trip day, AI requests and automatic WhatsApp updates for travelers.',
            pricingPlansHeroTitle: 'A plan that fits your business exactly',
            pricingPlansHeroSubtitle: 'Choose the plan that suits you and enjoy a professional itinerary builder, advanced AI tools and automatic updates sent to your travelers.',
            pricingPlansCardsTitle: 'Our plans',
            pricingPlansRecommended: 'Recommended',
            pricingPlansPerMonth: '/ month',
            pricingPlansSharedDayCharge: `plus ${params.price || ''} per shared trip day`,
            pricingPlansDescFree: 'Start building itineraries with no monthly commitment',
            pricingPlansDescSmart: 'Build itineraries faster with AI',
            pricingPlansDescPro: 'Accompany your travelers automatically on WhatsApp',
            pricingPlansDescBusiness: 'The complete solution for agencies, with your own branding',
            pricingPlansCardItinerary: 'Digital itinerary creation',
            pricingPlansCardBanner: 'Personal banner with agent details',
            pricingPlansCardAi: `${params.count || ''} AI requests per trip day`,
            pricingPlansCardWhatsappPerTrip: `${params.count || ''} WhatsApp message per traveler for the whole trip`,
            pricingPlansCardWhatsappPerTripDay: `${params.count || ''} WhatsApp messages per traveler per trip day`,
            pricingPlansCardTripDesignsIncluded: 'Choose your trip page design',
            pricingPlansCardTripDesignsNotIncluded: 'No choice of trip page design',
            pricingPlansCardWhiteLabelIncluded: 'Full White Label – your colors, logo and branded subdomain',
            pricingPlansCardWhiteLabelNotIncluded: 'No White Label',
            pricingPlansCta: `Ask about ${params.plan || ''}`,
            pricingPlansCtaNote: 'These buttons open a WhatsApp chat with our team – no charge and no change to your account.',
            pricingPlansCtaWhatsappMessage: `Hi, I'd like to hear more about the TripPlanner ${params.plan || ''} plan`,
            pricingPlansCompareTitle: 'Compare plans',
            pricingPlansCompareFeature: 'Feature',
            pricingPlansCompareScrollHint: 'Swipe sideways to see all plans',
            pricingPlansRowMonthly: 'Monthly subscription',
            pricingPlansRowSharedDay: 'Price per shared trip day',
            pricingPlansRowItinerary: 'Digital itinerary creation',
            pricingPlansRowBanner: 'Personal agent information banner',
            pricingPlansRowAi: 'AI requests per trip day',
            pricingPlansRowWhatsapp: 'WhatsApp messages per traveler',
            pricingPlansRowTripDesigns: 'Choice of trip page designs',
            pricingPlansRowWhiteLabel: 'Full White Label branding',
            pricingPlansWhatsappPerTrip: `${params.count || ''} per entire trip`,
            pricingPlansWhatsappPerTripDay: `${params.count || ''} per trip day`,
            pricingPlansIncluded: 'Included',
            pricingPlansNotIncluded: 'Not included',
            pricingPlansWhatsappNoteTitle: 'How is the WhatsApp allowance calculated?',
            pricingPlansWhatsappNotePerTrip: `On ${params.plans || ''}, each registered traveler gets one WhatsApp message for the entire trip – so you can try the feature.`,
            pricingPlansWhatsappNotePerTripDay: `On ${params.plans || ''}, each traveler's allowance is based on trip length: the number in the table multiplied by the number of trip days. For example, on a ${params.days || ''}-day trip on ${params.plan || ''}, each traveler can receive up to ${params.count || ''} messages over the trip.`,
            pricingPlansAiNote: `AI requests are for the travel agent and are calculated by the number of trip days. For example, a ${params.days || ''}-day itinerary on ${params.plan || ''} includes ${params.count || ''} AI requests.`,
            pricingPlansAnd: ' and ',
            pricingPlansBrandingTitle: 'Personal banner or White Label?',
            pricingPlansBrandingSubtitle: 'Switch between the views to see what changes when the whole system carries your brand.',
            pricingPlansBannerTitle: 'Personal banner with agent details',
            pricingPlansBannerBadge: 'Included in all plans',
            pricingPlansBannerText: 'A banner with your details appears at the top of the itinerary page, so travelers know who planned their trip. The rest of the page keeps the TripPlanner branding.',
            pricingPlansWhiteLabelTitle: 'Full White Label',
            pricingPlansWhiteLabelBadge: `${params.plan || ''} only`,
            pricingPlansWhiteLabelText: 'The whole system carries your agency brand: your agency colors, your logo and a branded subdomain.',
            pricingPlansDemoToggleLabel: 'Compare the views',
            pricingPlansDemoTabRegular: 'Standard view',
            pricingPlansDemoTabWhiteLabel: 'White Label',
            pricingPlansDemoTripTitle: 'Northern Italy & the Dolomites',
            pricingPlansDemoTripMeta: '7 days · 4 travelers',
            pricingPlansDemoAgentName: 'Maya Tours',
            pricingPlansDemoAgentTitle: 'Tailor-made vacations and itineraries',
            pricingPlansDemoDay: `Day ${params.day || ''}`,
            pricingPlansDemoDay1: 'Milan and Lake Como',
            pricingPlansDemoDay2: 'Seceda, the Dolomites',
            pricingPlansDemoDay3: 'Lake Braies',
            pricingPlansDemoNavigate: 'Navigate',
            pricingPlansDemoPointLogoTitle: 'Your logo',
            pricingPlansDemoPointLogoText: "Your agency's logo replaces the TripPlanner logo at the top of every page.",
            pricingPlansDemoPointColorsTitle: 'Your colors',
            pricingPlansDemoPointColorsText: 'Headers, buttons and trip days take on your brand colors.',
            pricingPlansDemoPointClosedTitle: 'A closed system',
            pricingPlansDemoPointClosedText: "No menu and no links to our site – travelers stay with you, and it feels 100% like your own company's software.",
            pricingPlansDemoExampleNote: "Shown here: Maya Tours' White Label.",
            pricingPlansExampleTitle: 'Example calculation',
            pricingPlansExampleSubtitle: `A ${params.days || ''}-day trip with ${params.travelers || ''} registered travelers`,
            pricingPlansExampleRowTripCharge: 'Trip usage charge',
            pricingPlansExampleRowAi: 'AI requests',
            pricingPlansExampleRowWhatsappPerTraveler: 'WhatsApp messages per traveler',
            pricingPlansExampleRowWhatsappTotal: 'Total WhatsApp messages',
            pricingPlansExampleNote: `The usage charge (${params.days || ''} days × ${params.price || ''} = ${params.total || ''}, up to ${params.users || ''} users included) does not include the monthly subscription, which is billed separately.`,
            pricingPlansFaqTitle: 'Frequently asked questions',
            pricingPlansFaq1Q: 'Is there a monthly commitment?',
            pricingPlansFaq1A: `The ${params.freePlan || ''} plan has no monthly subscription – you only pay per shared trip day. The other plans include a monthly subscription, in addition to the charge per shared trip day.`,
            pricingPlansFaqSwitchQ: 'Can I switch between plans?',
            pricingPlansFaqSwitchA: 'Absolutely! You can upgrade or change your subscription plan at any time to match your business needs.\n\nUpgrades take effect immediately, while downgrades take effect at the beginning of your next billing cycle.',
            pricingPlansFaq2Q: 'How is the trip-day charge calculated?',
            pricingPlansFaq2A: `On every plan you pay ${params.price || ''} for each day of a trip that is shared with travelers, with a minimum of ${params.min || ''} per trip. Each trip includes up to ${params.users || ''} users; each additional user costs ${params.userPrice || ''} – a one-time charge per trip, not monthly or daily. This charge is separate from the monthly subscription. For example, a ${params.days || ''}-day trip with ${params.extraUsersExample || ''} users: ${params.total || ''}.`,
            pricingPlansFaq3Q: 'How is the AI request allowance calculated?',
            pricingPlansFaq3A: `AI requests are for the travel agent, for working on the itinerary. The allowance is based on trip length: your plan's requests per trip day, multiplied by the number of days. For example, a ${params.days || ''}-day itinerary on ${params.plan || ''} includes ${params.count || ''} AI requests.`,
            pricingPlansFaq4Q: 'How is the WhatsApp message allowance calculated?',
            pricingPlansFaq4A: `On ${params.perTripPlans || ''}, each registered traveler gets one message for the entire trip, so you can try the feature. On ${params.perDayPlans || ''}, each traveler's allowance is based on trip length – the messages per trip day multiplied by the number of trip days. For example, on a ${params.days || ''}-day trip on ${params.plan || ''}: up to ${params.count || ''} messages per traveler.`,
            pricingPlansFaq5Q: "What's the difference between a personal banner and White Label?",
            pricingPlansFaq5A: `A personal banner, included in all plans, displays the travel agent's details at the top of the itinerary page.\n\nFull White Label, available exclusively with the ${params.plan || ''} plan, allows you to present the platform with your agency's branding, including its colors, logo, and branded subdomain. Travelers also enjoy a focused viewing experience centered on the itinerary you share with them, without navigation menus linking to other TripPlanner pages.`,
            pricingPlansBottomCtaTitle: 'Want to hear more?',
            pricingPlansBottomCtaText: "We'll be happy to help you choose the right plan for your business.",
            pricingPlansBottomCtaButton: 'Talk to us on WhatsApp',
            pricingPlansBottomCtaMessage: "Hi, I'd like to hear more about TripPlanner's plans",
            pricingPlansCardTripTerms: `${params.min || ''} minimum per trip · up to ${params.users || ''} users included`,
            pricingPlansRowMinTrip: 'Minimum trip charge',
            pricingPlansRowIncludedUsers: 'Users included per trip',
            pricingPlansRowAdditionalUser: 'Each additional user',
            pricingPlansTripRulesNote: `Each trip includes up to ${params.users || ''} users. Each additional user is charged ${params.price || ''}. The minimum charge per trip is ${params.min || ''}.`,
            pricingPlansTripPriceTitle: 'How much does sharing a trip cost?',
            pricingPlansTripPriceSubtitle: 'The calculation is the same on every plan and does not include the monthly subscription.',
            pricingPlansTripPriceColTrip: 'Trip',
            pricingPlansTripPriceColCalc: 'Calculation',
            pricingPlansTripPriceColTotal: 'To pay',
            pricingPlansTripDaysOne: '1 day',
            pricingPlansTripDaysMany: `${params.days || ''} days`,
            pricingPlansTripUsers: `${params.users || ''} users`,
            pricingPlansCalcMinimum: `minimum ${params.min || ''}`,
            pricingPlansCalcDays: `${params.days || ''} days × ${params.price || ''}`,
            pricingPlansCalcExtraUserOne: `1 additional user × ${params.price || ''}`,
            pricingPlansCalcExtraUsers: `${params.count || ''} additional users × ${params.price || ''}`,
            welcomeRideHeroTitle: 'Build digital travel itineraries for your clients',
            welcomeRideHeroSubtitle: 'TripPlanner helps travel planners, guides, and travel agents present itineraries in a clear, professional way, so your clients can use the route easily from their phone.',
            welcomeRideHeroCta: 'Start creating a route',
            welcomeRideHowItWorksTitle: 'How it works',
            welcomeRideStep1Title: 'Create a trip',
            welcomeRideStep1Line1: 'Open a new trip and choose the dates.',
            welcomeRideStep1Line2: 'Add the relevant places and activities for each day.',
            welcomeRideStep1Line3: 'Just type the place name - the system pulls information automatically, and you can add an AI-generated description.',
            welcomeRideStep2Title: 'Send the route to the client',
            welcomeRideStep2Line1: 'When the route is ready, you can send it to the client in a digital format that is easy to use from their phone.',
            welcomeRideStep2Line2: 'The client gets a clear route with day order, activities, and navigation links for each destination.',
            welcomeRideStep2Line3: 'The route stays under your control and the client cannot forward it.',
            welcomeRideStep3Title: 'Reuse your content again and again',
            welcomeRideStep3Line1: 'Every trip and activity you add is saved in the system.',
            welcomeRideStep3Line2: 'This lets you quickly build new routes for additional clients and reuse activities you already entered.',
            welcomeRideStep3Line3: 'Over time, you build a library of activities and routes that significantly shortens your work time.',
            welcomeRideExampleTitle: 'This is how your routes can look',
            welcomeRideExampleIntro: 'When you send a route to a client, they get a clean and clear page with all trip days, activities, and navigation links for every destination.',
            welcomeRideExampleSubtitle: 'This is how a route looks on the client phone:',
            welcomeRideExampleBtn: 'View example route',
            welcomeRideAudienceTitle: 'Who is this system for',
            welcomeRideAudiencePill1: 'Trip planners',
            welcomeRideAudiencePill2: 'Tour guides',
            welcomeRideAudiencePill3: 'Travel agents',
            welcomeRideAudiencePill4: 'Travel content creators',
            welcomeRideAudienceTagline: 'Anyone who builds routes and wants to present them to clients in a professional, easy-to-use way.',
            welcomeRideWhyTitle: 'Why work with TripPlanner',
            welcomeRideBenefit1: 'The client gets a clear, mobile-friendly route',
            welcomeRideBenefit2: 'You can edit and update the route even after sending',
            welcomeRideBenefit3: 'No need to send bulky PDF files',
            welcomeRideBenefit4: 'The client cannot forward the route',
            welcomeRidePricingText: 'You can start building routes and try the system for free.',
            welcomeRidePricingLink: 'Our plans and pricing',
            welcomeRidePricingCta: 'Start creating a route',

            // ReferralPage translations
            referralPageTitle: 'Refer friends to TripPlanner',
            referralPageExplanation: 'Share this link. When someone registers through it, they will be recorded as referred by you.',
            referralPageLinkLabel: 'Your personal link',
            referralPageCopyBtn: 'Copy link',
            referralPageCopied: 'Copied!',
            referralStepCopyTitle: 'Step 1 - Copy your link',
            referralStepShareTitle: 'Step 2 - Share with friends',
            referralPageHelperText: 'Anyone who signs up with this link will be recorded as referred by you.',
            referralRewardText: 'For each user who joins through your link, you will receive 10% of their payments for 12 months from their join date. After that, no additional reward will be granted for that same user.',
            referralCopySuccessText: 'Link copied and ready to paste.',
            referralCopyErrorText: 'Automatic copy failed. Please select the link and copy it manually.',
            referralHeroCta: 'Share now',
            referralShareVia: 'Share directly via',
            referralShareWhatsapp: 'WhatsApp',
            referralShareWhatsappMessage: `Hey! I want to invite you to join TripPlanner using my referral link:\n${params.link || ''}`,
            referralShareFacebook: 'Facebook',

            // StartInsertRide page
            startInsertRideMobileHint: 'For a smoother start, we recommend switching to a computer to create your first route',
            startInsertRideTitle: 'Welcome to TripPlanner',
            startInsertRideSubtitle: 'Let’s create your first route',

            businessBasicAgreementModalTitle: 'TripPlanner - Business terms of service',
            businessBasicAgreementHeroEyebrow: 'Use of the system is subject to these terms',
            businessBasicAgreementHeroHint: 'Applies to all business accounts and pricing plans - please read carefully before accepting',
            businessBasicAgreementVersionLabel: 'Version v2.0',
            businessBasicAgreementPhoneLabel: 'Contact phone number',
            businessBasicAgreementPhonePlaceholder: '+1 415 555 0100',
            businessBasicAgreementPhoneHint: 'Required for this agreement: 8-15 digits. International format is OK (e.g. +44, +972, +1).',
            businessBasicAgreementPhoneRequired: 'Please enter your phone number',
            businessBasicAgreementPhoneInvalid: 'Enter a valid number (8-15 digits, international OK)',
            businessBasicAgreementAckTitle: 'Acceptance of the Terms of Use',
            businessBasicAgreementCheckbox: 'I have read and accept the TripPlanner Terms of Use.',
            updatedTermsTitle: 'Updated TripPlanner Terms of Service',
            updatedTermsBody1: "We've updated our Terms of Service to reflect the latest features and services available on our platform.",
            updatedTermsBody2: 'To continue using TripPlanner, please review and accept the updated terms.',
            updatedTermsCheckbox: 'I have read and agree to the updated Terms of Service.',
            updatedTermsAcceptButton: 'Accept & Continue',
            updatedTermsNotNow: 'Not now',
            updatedTermsReadTerms: 'Read the updated terms',
            updatedTermsHideTerms: 'Hide the terms',
            updatedTermsShareGateTitle: 'Please accept the updated Terms of Service',
            updatedTermsShareGateBody: 'To share a trip, please review and accept the updated Terms of Service.',
            updatedTermsShareGateButton: 'Review & accept the terms',
            businessBasicAgreementAiCheckbox: 'I understand that using the AI tools may involve transferring information from the trip and from documents I uploaded to external AI providers, as detailed in the agreement.',
            businessBasicAgreementCheckboxRequired: 'Please check both boxes to continue.',
            businessBasicAgreementAccept: 'Accept and continue',
            businessBasicAgreementClose: 'Close',
            agreementSignPageLoading: 'Loading agreement document...',
            agreementSignPageNotLoggedIn: 'You must be logged in to sign the agreement.',
            agreementSignPageInvalidToken: 'This link is invalid or has expired.',
            agreementSignPageAlreadySigned: 'You have already signed this agreement. Thank you!',
            agreementSignPageSuccessTitle: 'Agreement signed successfully',
            agreementSignPageSuccessBody: 'Thank you! Your acceptance has been recorded.',
            agreementSignPageErrorTitle: 'Error saving agreement',
            agreementSignPageErrorBody: 'Please try again. If the problem persists, contact the provider.',
            popup_record_user_agreement_failed_text: 'We could not save your agreement',
            popup_record_user_agreement_failed_subText: 'Please try again in a moment. If the problem continues, contact support.',
            popup_record_user_agreement_failed_action: 'Close',
            popup_make_user_ride_manager_failed_text: 'Could not enable route manager permissions',
            popup_make_user_ride_manager_failed_subText: 'Please try again or contact support.',
            popup_make_user_ride_manager_failed_action: 'Close',
            popup_business_basic_agreement_required_text: 'Business terms acceptance is required',
            popup_business_basic_agreement_required_subText: 'Please accept the business terms of use before route manager permissions are enabled.',
            popup_business_basic_agreement_required_action: 'Close',
            popup_business_basic_agreement_phone_required_text: 'Phone number is required',
            popup_business_basic_agreement_phone_required_subText: 'Enter a phone number to complete this agreement.',
            popup_business_basic_agreement_phone_required_action: 'Close',
            popup_business_basic_agreement_phone_invalid_text: 'Invalid phone number',
            popup_business_basic_agreement_phone_invalid_subText: 'Use 8-15 digits (international numbers allowed).',
            popup_business_basic_agreement_phone_invalid_action: 'Close',

            // AfterFirstRide page
            afterFirstRideSuccess: 'Great, you created a new trip.',
            afterFirstRideTitle: 'Adding activities to the route',
            afterFirstRideSubtitle: 'The trip is ready. Now you can add activities and send the route to the client.',
            afterFirstRideStepsHeading: 'How to add an activity:',
            afterFirstRideStep1Label: 'Open the route and choose a day',
            afterFirstRideStep2Label: 'Click "Add activity" and type the place name',
            afterFirstRideStep3Label: 'The system automatically pulls information from the web about the place',
            afterFirstRideVideoHeading: 'Want to see how it is done?',
            afterFirstRideVideoNoSupport: 'Your browser does not support video playback.',
            afterFirstRideCta: 'Go to my route',

            // About page
            aboutPageTitle: 'About TripPlanner',
            aboutLead: 'If you build trip itineraries for your clients, TripPlanner was built for you.',
            aboutBody1: 'TripPlanner is a professional system for trip planners, travel agents, and guides. It lets you build, manage, and share trip itineraries with clients in an organized way, easy to use on the phone.',
            aboutBody2: 'The system keeps all trip details in one place and gives your client simple, clear access to everything they need throughout their vacation.',
            aboutBody3: 'Each itinerary is organized by day, shown on a map, includes one-tap navigation to every stop, and information on places to stay and things to do.',
            aboutBody4: 'You can also add a photo, video, or audio to each stop on the route, and upload vouchers and other relevant documents.',
            aboutBody5: 'That way you can create guided itineraries with a clear explanation for every place.',
            aboutBody6: 'The system supports efficient work by duplicating itineraries and tailoring them for each client, and simple sharing through one link that brings together everything the client needs.',
            aboutBody7: 'All itineraries are stored privately and securely, and are accessible only to you and your clients.',
            aboutBody8: 'TripPlanner was developed from real field needs, to help trip planners work in a more organized, efficient, and comfortable way with their clients.',
            aboutBody9: 'The system is built and improved continuously based on feedback from users.',
            aboutContactTitle: 'Contact details',
            aboutPhoneLabel: 'Phone',
            aboutPhoneNumber: '+972-52-686-7915',
            aboutEmailLabel: 'Email',
            aboutAddressLabel: 'Address',
            aboutAddress: 'Salit 4588500',

            lastUpdated: 'Last updated: July 2025',
            // src/components/Accommodation.vue
            accommodationCheckInMatchesTrip: 'Check-in date matches your trip',
            accommodationCheckOutMatchesTrip: 'Check-out date matches your trip',
            accommodationEditTitle: 'Edit Accommodation',
            accommodationAddDetailsTitle: 'Add Accommodation Details',
            // src/components/AddAccommodationButton.vue
            addAccommodationAiButton: 'Add Accommodation with AI',
            clearSuggestedAccommodations: 'Remove suggested accommodations',
            removeSuggestedAccommodation: 'Remove suggestion',
            // src/components/AddAtractionButton.vue
            addAttractionAiButton: 'Add Activity with AI',
            // src/components/BaseFromImage.vue
            baseFromImageAutoDetect: 'Automatic detection',
            baseFromImageManualSelect: 'Manual place selection',
            baseFromImageEnterPlaceName: 'Enter the place name',
            baseFromImageNoGpsWarning: '** The image does not contain location data, so we cannot help locate the place. Please select the place name manually.',
            baseFromImageNoDateWarning: '** The image does not contain the time of shooting, so at the end of the process you need to assign it to the appropriate day.',
            baseFromImageMapInstructions: 'You can select the place by clicking on the location on the map that indicates where the photographed attraction is, or by entering the place name in the text box',
            baseFromImageSelectFromList: 'Please select a place from the list or enter manually',
            baseFromImageSkipImage: 'Skip this image',
            baseFromImageAddAndEditLater: 'Add image and edit later',
            baseFromImageNoGpsAddLater: 'This image does not contain location data, add image and edit later',
            // src/components/BookingImageLabel.vue
            bookingLabelSave15: 'Save 15% on your stay',
            bookingLabelNewYearDeal: 'New Year deal for 2025',
            bookingLabelToDeals: 'To deals',
            // src/components/Cards/ImageCard.vue
            imageCardIsThisPrefix: 'Is this ',
            imageCardIsThisPlace: `Is this ${params.name || ''}?`,
            imageCardPhotoTaken: 'Taken at',
            imageCardAccommodationDateLabel: "Please select the check-in and check-out dates for the accommodation",
            yesLabel: 'Yes',
            noLabel: 'No',
            imageCardIfNotCorrect: 'If this is not the place linked to the image,',
            imageCardChooseManually: 'manually choose the image location',
            imageCardCouldNotDetect: 'I could not detect the location of the image.\nPlease select it manually.',
            // src/components/CollaboratorsWith.vue
            collaboratorsWithLabel: 'In partnership with:',
            // src/components/CreateAttraction.vue
            createAttractionNameLabel: 'Activity name',
            createAttractionEditTitle: 'Edit Attraction',
            createAttractionAddToTrip: 'Add attraction to trip',
            // src/components/GlobalRides.vue
            globalRidesListTitle: 'Trips list',
            globalRidesViewAndEdit: 'View and edit this trip',
            globalRidesAdultsCount: `Adults: ${params.count || ''}`,
            globalRidesTeensCount: `Teens: ${params.count || ''}`,
            globalRidesChildrenCount: `Children: ${params.count || ''}`,
            globalRidesAccessibility: `Accessible for people with disabilities: ${params.value || ''}`,
            // src/components/HowItWorks.vue
            howItWorksTitle: 'How does it work?',
            howItWorksStepChoose: 'Pick a shared trip',
            howItWorksStepAsBase: 'as a base',
            howItWorksStepAddRemove: 'Add or remove activities',
            howItWorksStepExisting: 'in the trip',
            howItWorksStepEnjoy: 'Enjoy the trip',
            howItWorksStepShare: 'and share with families',
            // src/components/HowItWorksNewNewCss.vue
            howItWorksSmartTitle: 'How do you plan a vacation smart?',
            howItWorksNewStep3Title: 'Go on vacation with fun and share with friends and family',
            howItWorksNewStep3Desc: 'Enjoy an amazing vacation experience with site support during the trip. Give back to the community by adding your vacation to the site database and sharing with friends and family',
            howItWorksNewStep2Title: 'Add or remove attractions from the vacation you chose',
            howItWorksNewStep2Desc: 'Enjoy easy and convenient planning by customizing the vacation you chose and adding recommended activities from other vacations shared on the site',
            howItWorksNewStep1Title: 'Choose a vacation you liked as a planning base',
            howItWorksNewStep1Desc: 'Your planning starts by choosing a vacation from the site database, which will serve as the base for planning your vacation',
            howItWorksNewViewBtn: 'View successful vacations',
            // src/components/InnerNav.vue
            innerNavTripAttractions: 'Trip attractions',
            innerNavShareTrip: 'Share trip',
            // src/components/InstructionCard.vue
            instructionInterestedInPlanning: 'Want to plan a trip?',
            instructionPickSharedAsStart: 'Pick a shared trip as your starting point',
            instructionAfterPickAddRemove: 'Picked a trip? You can add or remove existing activities in the trip',
            instructionEnjoyAndShare: 'Now all that\'s left is to enjoy the trip and of course share it',
            instructionCardStep3: 'Enjoy the trip and share with families',
            instructionCardStep2: 'Add/remove existing activities from the trip',
            instructionCardStep1: 'Choose a shared trip as a base',
            instructionCardViewBtn: 'View trip routes',
            // src/components/InstructionCard1.vue
            instruction1LargeRepoTitle: 'Large library of attractions and trips',
            instruction1LargeRepoBody: 'A large base of trips and attractions that people have done and choose to share',
            instruction1ByOtherTravelersTitle: 'All trips were done by other travelers',
            instruction1ByOtherTravelersBody: 'There is nothing like recommendations from travelers who have already done the route. All routes were done by travelers.',
            instruction1EasyEditTitle: 'Easy trip editing',
            instruction1EasyEditBody: 'You can add or remove attractions after choosing a trip',
            instruction1EasyHotelTitle: 'Easy and convenient hotel booking',
            instruction1EasyHotelBody: 'Book hotels for the whole trip in one place',
            // src/components/LanguageToggle.vue
            languageToggleLabel: 'עברית',
            // src/components/LocationCard.vue
            locationCardRecommendedTrips: 'Recommended trips',
            locationCardFlachauTwoWeeks: 'Flachau - Two weeks in Austria',
            locationCardCarinthiaTwoWeeks: 'Carinthia - Two weeks in Austria',
            locationCardSalzburgTirolTwoWeeks: 'Two weeks in Austria - Salzburg and Tyrol region',
            locationCardViennaSalzburg11Days: 'Vienna and Salzburg, 11 days',
            locationCardAustria10Days: 'Austria - Salzburg and Vienna in 10 days',
            locationCardPolandTatraTwoWeeks: 'Two-week trip to southern Poland and the Tatra Mountains in Slovakia',
            locationCardAustria9Days: 'Austria - Salzburg and Vienna in 9 days',
            viewTripRoutes: 'View trip routes',
            // src/components/Modals/ConfirmForceAddDay.vue
            confirmForceActiveAccommodationTitle: 'Active accommodation booking',
            confirmForceActiveAccommodationBody: 'You have an active accommodation booking on these dates or on consecutive days in the itinerary.\n\nIf you continue, the accommodation dates will be automatically updated in the system display according to the changes you make.',
            noteLabel: 'Please note:',
            confirmForceAddDayWarning: 'This action is at your own risk!',
            confirmForceAddDayConfirm: 'Yes, I understand - continue',
            // src/components/Modals/ConfirmRemoveDayWithExtraInfo.vue
            confirmRemoveDayIrreversible: 'This action is irreversible!',
            confirmRemoveDayRiskConfirm: 'Yes, I understand the risks - continue',
            confirmRemoveDayWithExtraInfoTitle: 'Important warning',
            confirmRemoveDayWithExtraInfoBody: 'Deleting the day will cause permanent loss of all general information related to this day, including texts and accompanying explanations.',
            confirmRemoveDaySureQuestion: 'Are you sure you want to continue?',
            // src/components/Modals/ContactForm.vue
            contactFormTitle: 'Contact Us',
            contactFormSubtitle: 'We would love to hear from you and help you understand how TripPlanner can help your business',
            contactFormFullName: 'Full name',
            contactFormPhoneLabel: 'Phone number (required)',
            contactFormEmailLabel: 'Email address',
            contactFormHelpPlaceholder: 'How can we help you? Tell us about your needs...',
            contactFormSending: 'Sending...',
            contactFormSendMessage: 'Send message',
            // src/components/Modals/DynamicModal.vue
            dynamicModalCreditFinishedMessage: 'Hi, I started using TripPlanner and finished my initial credit.\nI would be glad to keep using the system and open my account for further use.',
            // src/components/Modals/InsufficientBalanceModal.vue
            insufficientBalanceTitle: 'Your initial credit has been used',
            insufficientWhatsapp: 'Contact us on WhatsApp',
            insufficientCallUs: 'Or call us: +972-52-686-7915',
            insufficientBalanceMessage: 'To keep sharing itineraries and open your account for further use, contact us and we will be happy to help you get started working continuously. You can keep building and editing itineraries without any limit.',
            // src/components/Modals/LoginForm.vue
            loginConnectViaEmail: 'Sign in with email',
            loginEmailLabel: 'Email',
            loginForgotPassword: 'Forgot?',
            loginPasswordLabel: 'Password',
            loginSubmitButton: 'Sign in',
            loginNoAccount: 'Don\'t have an account?',
            loginRegisterLink: 'Register',
            loginErrorMessage: 'Error in username or password',
            // src/components/Modals/MainRegistration.vue
            mainRegistrationEnterPassword: 'Please enter a password to register',
            mainRegistrationPasswordMismatch: 'Passwords do not match. Please make sure you entered the same password in both fields',
            // src/components/Modals/Modals.vue
            modalsPickTripBeforeEdit: 'Please choose a trip before editing it',
            modalsMustChooseDesiredTrip: 'In order to continue editing the trip, you must choose the desired trip',
            modalsChooseTheTrip: 'Choose the trip',
            modalsPleaseRegisterToContinue: 'Please register so we can continue',
            modalsRegisterVia: 'Register via',
            modalsOr: 'Or',
            modalsShareTrip: 'Share trip',
            modalsShareDescription: 'Anyone with the link can view your plan but will not see the events, notes, attached files and personalized bookings',
            modalsCopyPublicLink: 'Copy public link',
            modalsShareViaEmail: 'Share link via email',
            // src/components/Modals/OldSignup.vue
            oldSignupPrivacyAndTermsOf: 'to the terms of use and privacy policy of',
            oldSignupAgreeToTerms: 'I agree to the terms',
            // src/components/Modals/PleaseAddTheRideToYourList.vue
            pleaseAddRideToSaveChangesTitle: 'To save your changes for you',
            pleaseAddRideToListText: 'The trip must be added to my trips list',
            addThisRideToMyList: 'Add this trip to my trips',
            // src/components/Modals/Pop-ups/PopUpTemplate.vue
            popupTemplateResetKeyword: 'Reset',
            // src/components/Modals/ResetForm.vue
            resetFormPasswordReset: 'Password reset',
            resetFormEnterEmailDescription: 'Enter your email address and we will send you a link to reset your Tripplanner password.',
            resetFormSendLink: 'Send link',
            resetFormToRegister: 'To register',
            resetFormToSignIn: 'To sign in',
            // src/components/Modals/ResetPassword.vue
            resetPasswordTitle: 'Reset password',
            resetPasswordEmailPlaceholder: 'Enter your email address',
            resetPasswordSendLink: 'Send password reset link',
            resetPasswordBackToLogin: 'Back to login',
            // src/components/Modals/ShareRide.vue
            shareRideToFriendsTitle: 'Send the trip to friends',
            shareRideToFriendsBody: 'There is a cool trip here that you can copy to your account and then edit',
            shareRideFamilyTripTitle: 'Built a family trip.',
            shareRideFamilyTripDescription: 'There is a basis for a trip that can be adapted to our wishes',
            // src/components/Modals/SignupForm.vue
            signupRegisterViaEmail: 'Register with email',
            signupPasswordAgain: 'Password again',
            signupUsername: 'Username',
            signupRead: 'I have read',
            signupAlreadyHaveAccount: 'Already have an account?',
            // src/components/PartnershipSection.vue
            partnershipWith: 'In partnership with',
            // src/components/RideInformation.vue
            rideInformationTitle: 'Trip details',
            rideInformationTripTitle: 'Trip title',
            rideInformationFreeText: 'Free text about the trip',
            rideInformationAdultsCount: 'Number of adults',
            rideInformationTeensCount: 'Number of teens',
            rideInformationChildrenCount: 'Number of children',
            rideInformationAccessibility: 'Accessible for people with disabilities?',
            rideInformationDepartureDate: 'Departure date',
            rideInformationReturnDate: 'Return date',
            rideInformationCreateTrip: 'Create trip',
            rideInformationEditTrip: 'Edit trip',
            // src/components/SearchBar.vue
            searchBarEnterLocation: 'Enter location',
            searchBarSearchButton: 'Search trip',
            searchBarAccessible: 'Accessible for people with disabilities',
            searchBarDaysLabel: 'Days',
            searchBarPeopleLabel: 'People',
            // src/components/SearchBar.vue (dropdown, commented-out section)
            searchBarDefaultSelection: '2 adults 2 children',
            searchBarAdults: 'Adults',
            searchBarTeens: 'Teens',
            searchBarChildren: 'Children',
            // src/components/Cards/ResultOfSearchCard.vue
            resultCardDays: 'days',
            resultCardViewRoute: 'View vacation itinerary',
            // src/components/Modals/DoYouWantToAddThisPointToRide.vue
            doYouWantModalQuestion: 'Was the photo you took taken from the location you selected on the map?',
            doYouWantModalDescription: 'This action will add the photo you took as the point you selected on the map',
            doYouWantModalNo: 'No, this is not the place',
            doYouWantModalYes: 'Yes, this is the place',
            // src/components/SerchAttractionCategories.vue
            serchCategoriesFromGoogle: 'Recommended activities from Google',
            serchCategoriesFromOtherTrips: 'Recommended activities from other trips',
            // src/components/SingleRideChecklist.vue
            checklistViewBooking: 'View booking',
            checklistBookingRegistered: 'Booking registered in the system',
            checklistFindAccommodation: 'Find accommodation',
            // src/components/SingleRide.vue
            singleRideVideoFallback: 'Video',
            singleRideAudioFallback: 'Audio',
            // src/components/SingleRideSumary.vue
            singleRideSumaryOneTraveler: 'One traveler',
            singleRideSumaryTravelers: 'travelers',
            // src/components/UserRides.vue
            userRidesAddCompletedTrip: '+Enter details of a trip already taken+',
            userRidesMyRides: 'My trips',
            userRidesViewAndEdit: 'View and edit this trip',
            // src/views/About.vue
            aboutMetaDescription: 'Professional system for trip planners to build, manage, and share itineraries with clients',
            // src/views/AddAccommodationFromImage.vue
            addAccommodationPlaceTitle: 'Add accommodation',
            // src/views/AddAccommodationsImage.vue
            addAccommodationsImageInstructions: 'Let\'s start by uploading the photos. As in the previous process, upload one photo for each place where you stayed. If your hotel was not recommended, upload a photo from the area and note which area is recommended for sleeping instead of naming the hotel.',
            addAccommodationsImageSubtitle: 'Add an accommodation - so whoever copies your trip can know which area is recommended for sleeping and get a recommendation.',
            addAccommodationsImageButton: 'Add accommodation places',
            // src/views/AddAtractionsImage.vue
            addAttractionsImageHeroTitle: 'Create a trip automatically by uploading photos from the trip',
            addAttractionsImageAutoEntry: 'Automatic trip entry',
            addAttractionsImageRulesIntro: 'To create the trip, go to your phone\'s photo album and upload the trip photos according to the following rules:',
            addAttractionsImageRuleOnePhotoEach: 'Upload only one photo for each attraction.',
            addAttractionsImageRuleAllAtOnce: 'It is recommended to upload all photos at once.',
            addAttractionsImageRuleGps: 'The photos must contain location data (GPS).',
            addAttractionsImageRuleLocationOn: 'Make sure location sharing is enabled when uploading the photos.',
            addAttractionsImageRuleAnyPlace: 'Photos can include any place you want to recommend to future travelers: a restaurant, a lakeside, or any other interesting place.',
            addAttractionsImageAddAttractions: 'Add attractions',
            addAttractionsImageUploadAll: 'Upload all photos (one per attraction)',
            // src/views/Attraction.vue
            attractionFreeText: 'Free text about the activity',
            // src/views/DeleteUser.vue
            deleteUserTitle: 'Delete user',
            deleteUserPhone: 'Phone: +972-52-686-7915',
            deleteUserEmail: 'Email:     avshalom@tripplanner.co.il',
            deleteUserAddress: 'Address: Salit 4588500',
            // src/views/DeleteUser.vue (additional)
            deleteUserInstructionLine1: 'To delete a user, please send an email to',
            deleteUserInstructionLine2: 'and request to download and delete your data.',
            // src/views/DigitalGuideInfo.vue
            digitalGuideToRecommendedTrips: 'To recommended trips',
            digitalGuideMetaDescription: 'Digital itinerary on mobile with map and attractions',
            digitalGuideNavInterfaceAlt: 'Digital itinerary navigation interface',
            digitalGuideWhatIsTitle: 'What is a digital itinerary?',
            // src/views/EditingAtractionsUniqnes.vue
            editingAttractionsDisplayTitle: 'Edit activities for display',
            // src/views/FeaturedRideDetail.vue
            featuredRideDetailTripNumberLabel: 'Trip number:',
            featuredRideDetailTripNumberWithId: `Trip number: ${params.id || ''}`,
            featuredRideDetailDescriptionTitle: 'Trip description',
            featuredRideDetailDescriptionBinding: 'Trip description',
            featuredRideDetailPurchaseTrip: 'Purchase trip',
            featuredRideDetailBackToList: 'Back to itinerary list',
            featuredRideDetailNotFoundTitle: 'Trip not found',
            featuredRideDetailNotFoundBinding: 'Trip not found',
            featuredRideDetailNotFoundBody: 'The requested trip was not found.',
            featuredRideDetailNotFoundBodyBinding: 'The requested trip was not found.',
            featuredRideDetailBackShort: 'Back to list',
            featuredRideDetailMetaTitle: 'Trip itinerary - TripPlanner',
            featuredRideDetailMetaTitleShort: 'Trip itinerary',
            featuredRideDetailMetaDescription: 'Trip itinerary details on TripPlanner',
            // src/views/FeaturedRidesLanding.vue
            featuredRidesLandingHeaderBinding: 'Recommended trips',
            featuredRidesLandingSubtitle: 'Discover our trips - ready-made itineraries planned especially for you',
            featuredRidesLandingConsultingBinding: 'Personal trip consulting and planning',
            consultingAndPersonalPlanning: 'Personal trip consulting and planning',
            forMoreDetails: 'For more details',
            digitalItineraries: 'Digital itineraries',
            digitalItinerariesStrong: '<strong>Digital itineraries</strong>',
            managerWithIndex: `Manager ${params.index || ''}`,
            topDestinations: 'Top destinations',
            allDestinations: 'All destinations',
            // src/views/HomePage.vue
            homePageFamiliesShareTrips: 'Families share trips - you choose what suits you',
            homePageWhereTo: 'Where to?',
            homePageWhatYouCanDo: 'What you can do on Trip Planner',
            homePageShareTrip: 'Share a trip',
            homePagePlanTrip: 'Plan a trip',
            homePageRecentlySharedTrips: 'Recently shared trips',
            homePageWhyChoose: 'Why choose Trip Planner',
            homePageBreadcrumb: 'Home',
            homePageSharedByAvshalom: 'Shared by Avshalom Katz',
            homePageSharedByAshchar: 'Shared by Ashchar Arblich-Brifman',
            homePagePolandSlovakiaTrip: 'Two weeks in southern Poland and the Tatra Mountains in Slovakia',
            homePageSharedByAvshalomWithSpace: 'Shared by Avshalom Katz ',
            homePagePeopleReversed: 'People',
            homePageEnterLocationReversed: 'Enter location',
            homePageDaysReversed: 'Days',
            homePageDays: 'Days',
            homePageHeroTitle1: 'Flying abroad?',
            homePageHeroTitle2: 'Browse the trip database',
            homePageShareTripBtn: 'Share trip',
            homePageViewBtn: 'View',
            homePageGreatTripQuestion: 'Planned a great trip? Share it',
            homePageOthersBrokeHead: 'Others have already done the legwork - copy and edit',
            homePageSearchRoutes: 'Search routes',
            homePageRecommendationsBody: 'There is nothing like recommendations from travelers who have already done the route - all routes were done by travelers',
            homePageLargeRepoBody: 'A large base of trips and attractions that people did and chose to share',
            homePageEasyHotelBooking: 'Easy and convenient hotel booking',
            homePageEasyHotelBookingBody: 'Book hotels for the entire trip in one place',
            homePageEasyTripEditing: 'Easy trip editing',
            homePageEasyTripEditingBody: 'You can add or remove attractions after choosing a trip',
            homePageViewTripRoutes: 'View trip itineraries',
            homePageOpenTextAustria: 'After countless searches, readings and research, we managed to put together the perfect trip for our family in Austria. We chose a trip area (Salzburg region) and a place to stay from which we set out on a star trip. The weather was changeable. In Vienna it was hot during the day, cooler at night; in the Salzburg region and on trips up the mountains it was cold and sometimes rainy.',
            homePageOpenTextSalzburgTirol: "Hi, I'm Ashkar (Erblich-Brifman) and I'm a children and youth author and online writing workshop host for children. I'm also married and a mother of three daughters. Our family loves to travel. I chose to share our trip to Austria with you.",
            homePageOpenTextPolandSlovakia: 'A family trip we waited a long time for (the first trip since COVID). Two parents + four children ages 4-11. We love nature, attractions and easy routes, so after much thought we decided to travel in southern Poland and combine excursions to Slovakia (we were actually there for three days)...',
            homePageTravelersChooseSubtitle: 'Families share trips - you choose what suits you',
            homePageShareTripBtnSimple: 'Share a trip',
            homePageIconboxTravelersTitle: 'All trips were taken by other travelers',
            homePageIconboxLargeRepoTitle: 'Large database of attractions and trips',
            homePageFooterHome: 'Home',
            homePageFooterAbout: 'About',
            homePageFooterSearch: 'Search trips',
            homePageFooterTerms: 'Terms',
            homePageFooterContact: 'Contact us',
            // src/views/HomePageNew.vue
            homePageNewMetaTitle: 'TripPlanner | Plan trip itineraries',
            // src/views/InsertNewRideFromGooglePhotos.vue
            insertNewRideAddTitle: 'Add new trip',
            insertNewRideExplainerVideo: 'Explainer video',
            insertNewRideContinueToTrip: 'Continue to your trip',
            insertNewRideWelcomeLine1: 'We are happy that you chose to help our community plan a trip to another destination by adding your trip itinerary.',
            insertNewRideWelcomeLine2: 'Adding an itinerary to the site is a simple process done in three steps.',
            insertNewRideStep1: 'Create a photo album with one photo from each place on the trip -',
            insertNewRideStep2: 'Share the album with the location via email: avshalom@tripplanner.co.il or via -',
            insertNewRideStep3: 'The trip will be created automatically and you will be able to add your experiences',
            // src/views/LandingForPlanners.vue
            landingPlannersMetaTitle: 'Landing page for trip planners',
            landingPlannersHeroQuestion: 'Building trip itineraries for clients?',
            landingPlannersHowItLooks: 'This is how the itinerary your clients receive will look',
            landingPlannersPreviousImage: 'Previous image',
            landingPlannersNextImage: 'Next image',
            landingPlannersGoToImage: `Go to image ${params.index || ''}`,
            landingPlannersSampleItinerary: 'Sample itinerary',
            landingPlannersOpenSample: 'Open a sample itinerary',
            landingPlannersSendDetails: 'Submit details',
            landingPlannersAlternativeContact: 'Alternative contact option',
            landingPlannersOpenWhatsApp: 'Open WhatsApp to send a message',
            landingPlannersToSummary: 'To summarize',
            landingPlannersProtectYourContent: 'Protect your content',
            landingPlannersProtectYourContentBody: 'Each itinerary is protected and cannot be transferred to others - only to whoever you define.',
            landingPlannersProfessionalLook: 'Professional and branded look',
            landingPlannersProfessionalLookBody: 'The itinerary is displayed with a clean design featuring your business logo and colors.',
            landingPlannersAllInOnePlace: 'Everything in one place',
            landingPlannersAllInOnePlaceBody: 'Accommodation, attractions, maps, personal notes and links - all in one organized and clear place.',
            landingPlannersEasyClientAccess: 'Easy client access',
            landingPlannersEasyClientAccessBody: 'Send a link, the client opens it in their phone browser. No need to download an app.',
            landingPlannersRealTimeSaving: 'Real time savings',
            landingPlannersRealTimeSavingBody: 'Build an itinerary once, duplicate it with one click, and easily adapt it for each client.',
            landingPlannersOfflineConvenience: 'Offline convenience too',
            landingPlannersOfflineConvenienceBody: 'The information is stored so that everything remains available even during a trip with no signal.',
            landingPlannersFullViewAlt: 'Full itinerary view - the entire trip at a glance',
            landingPlannersDailyDetailAlt: 'Daily breakdown for each day - destinations on the map with one-tap navigation',
            landingPlannersAllActivitiesAlt: 'All trip activities - organized by day',
            landingPlannersDayMapAlt: 'Day map - all points of interest in one place',
            landingPlannersDirectNavAlt: 'Direct navigation to destinations via Google Maps',
            landingPlannersWhatsAppMessage: 'Hi! I\'d love to set up a short intro meeting about TripPlanner. When is convenient for you?',
            landingPlannersMessageSentSuccess: 'Thank you! Your message was sent successfully. We will get back to you shortly.',
            landingPlannersMessageSentError: 'An error occurred sending the message. Please try again later.',
            landingPlannersEnterName: 'Please enter your name',
            landingPlannersEnterPhone: 'Please enter a phone number',
            landingPlannersEnterValidPhone: 'Please enter a valid phone number (8-15 digits, international included)',
            landingPlannersConfirmPrivacy: 'Please confirm the privacy policy',
            landingPlannersEmailNoSpaces: 'Email address cannot contain spaces',
            landingPlannersEnterValidEmail: 'Please enter a valid email address',
            landingPlannersHeroSubtitle: 'TripPlanner is a system that lets you input the itineraries you build and present them to clients in a digital, interactive, and clear way, saving you hours of work on every plan.',
            landingPlannersWhatIsTitlePrefix: 'What is',
            landingPlannersWhatIsTitleSuffix: '?',
            landingPlannersWhatIsBody1: 'TripPlanner is a digital platform and work tool for trip planners, guides and agents that centralizes all trip details in one place and presents them to the client clearly and conveniently.',
            landingPlannersWhatIsBody2: 'The itinerary includes maps, navigation, opening hours, accommodation, activities and recommendations - all accessible from your phone during the trip.',
            landingPlannersHowItLooksSub: 'The entire trip is centralized in one place, clear and convenient to use from your phone',
            landingPlannersBenefitsTitle: 'The benefits you will gain from using TripPlanner',
            landingPlannersBenefitsIntro: 'The tools that will help you work faster, present itineraries more professionally, and give clients a clear and convenient trip experience.',
            landingPlannersLeaveDetails: 'Leave your details',
            landingPlannersDemoExplainer: 'This is how the itinerary your clients receive and use during the trip looks:',
            landingPlannersDemoFooter: 'Everything organized by days with map, navigation, and the activities for each day.',
            landingPlannersInterestedQuestion: 'Want to see if TripPlanner is right for you?',
            landingPlannersInterestedSub: 'Leave your details and we will get back to you to schedule a short intro meeting.',
            landingPlannersContactUsTitle: 'Contact us',
            landingPlannersContactUsSubtitle: 'We would love to hear from you and help you understand how TripPlanner can help your business',
            landingPlannersFormFullName: 'Full name',
            landingPlannersFormPhone: 'Phone number (required)',
            landingPlannersFormEmail: 'Email address',
            landingPlannersFormMessage: 'How can we help? Tell us about your needs...',
            landingPlannersFormAcceptPrefix: 'I have read and accept the',
            landingPlannersFormPrivacyPolicyLink: 'privacy policy',
            landingPlannersFormSending: 'Sending...',
            landingPlannersFormSubmit: 'Submit details',
            landingPlannersAlsoSendWhatsApp: 'You can also send us a message on WhatsApp',
            landingPlannersSendWhatsApp: 'Send on WhatsApp',
            landingPlannersClosingBody1: 'TripPlanner was built specifically for professional trip planners. It helps you look better, work smarter, and provide clients with a more accurate and pleasant experience. Your clients will feel the difference and you will feel it as you save time on every plan.',
            landingPlannersClosingBody2: 'TripPlanner does not build the itinerary for you. It is a work tool that clearly and conveniently displays your knowledge and professional experience.',
            // src/views/LandingForPlannersNoFlight.vue
            landingPlannersNoFlightHero: 'Building trip itineraries for clients but less busy right now?',
            landingPlannersNoFlightHeroSub1Line1: 'The security situation created a quieter period in calendars',
            landingPlannersNoFlightHeroSub1Line2: 'and this is exactly the opportunity to prepare smart infrastructure for your business for the day after',
            landingPlannersNoFlightHeroSub2Line1: 'When the skies open and demand returns',
            landingPlannersNoFlightHeroSub2Line2: 'those who are ready in advance will be able to deliver more itineraries, faster, and at higher quality',
            landingPlannersNoFlightHeroSub3Line1: 'TripPlanner lets you build your itineraries now',
            landingPlannersNoFlightHeroSub3Line2: 'and save hours of work when the workload arrives',
            landingPlannersNoFlightWhatIsBody1Line1: 'TripPlanner is a work system for trip planners, guides and agents',
            landingPlannersNoFlightWhatIsBody1Line2: 'that lets you build itineraries in an organized way now',
            landingPlannersNoFlightWhatIsBody1Line3: 'and use them again and again when clients return to flying',
            landingPlannersNoFlightWhatIsBody2Line1: 'The system centralizes all trip details in one place',
            landingPlannersNoFlightWhatIsBody2Line2: 'and presents them to the client digitally, clearly and conveniently from the phone',
            landingPlannersNoFlightCampaignWhyNowTitle: 'Why exactly now should you start working with TripPlanner?',
            landingPlannersNoFlightWhatsAppMessage: 'Hi, I read on your site about using the quieter season to prepare for when demand returns, and I wanted to hear more about TripPlanner. Could we set up a short call?',
            // src/views/OfflineRideRecovery.vue
            offlineRecoveryNotice: 'Offline view mode - the information may not be up to date',
            offlineRecoveryActivitiesLabel: 'Activities:',
            offlineRecoveryAccommodationLabel: 'Accommodation:',
            offlineCheckingConnectivity: 'Checking internet connection...',
            offlineDayLabel: 'Day',
            offlineNavigateGoogleMaps: 'Navigate in Google Maps',
            // src/views/PaymentPage.vue
            paymentPageSampleProduct: 'Sample product',
            paymentPageSampleProductDesc: 'Product description - this is a sample product for testing the payment flow',
            paymentPageCompletePayment: 'Complete payment',
            // src/views/PaymentSuccess.vue
            paymentStatusTitle: 'Payment status',
            // src/views/PrivateConsultingInfo.vue
            consultingHeroBinding: 'Personal trip consulting and planning',
            consultingBackToRecommended: 'Back to recommended trips',
            consultingCtaContactBinding: 'Contact us for personal trip consulting and planning',
            consultingCtaContactPlural: 'Contact us for personal trip consulting and planning',
            consultingCtaWhatsAppBinding: 'Contact us on WhatsApp for personal trip consulting and planning',
            consultingCtaWhatsApp: 'Contact us on WhatsApp for personal trip consulting and planning',
            consultingWhatsAppMessage: 'Hello! I\'m interested in personal trip consulting and planning',
            // src/views/RequestPasswordReset.vue
            requestPasswordResetTitle: 'Request password reset',
            requestPasswordResetSendLink: 'Send reset link',
            // src/views/ResetPasswordPage.vue
            resetPasswordPageEnterNew: 'Enter your new password',
            resetPasswordPageNewPassword: 'New password',
            resetPasswordPageConfirmPassword: 'Confirm password',
            resetPasswordPageUpdate: 'Update password',
            // src/views/RideChecklist.vue
            rideChecklistAccommodations: 'Accommodations',
            // src/views/SearchAccommodationWithMap.vue
            searchAccommodationMetaTitleWithLocation: `Accommodation in ${params.location || ''} | TripPlanner`,
            searchAccommodationMetaTitle: 'Accommodation search | TripPlanner',
            searchAccommodationMetaDescription: `Accommodations in ${params.location || ''} recommended by travelers on TripPlanner`,
            // src/views/SearchRide.vue
            searchRideFindPerfectTrip: 'Find the perfect vacation',
            searchRideAccessibilityFilter: 'Accessible for people with mobility limitations',
            searchRideChildren: 'Children',
            searchRideTeens: 'Teens',
            // src/views/SingleMapWithAllSearchOnMap.vue
            showPoints: 'Show points',
            searchRideAdults: 'Adults',
            searchRideAnd: ' and ',
            searchRideMetaTitleWithLocation: `Trip itineraries and attractions in ${params.location || ''} | TripPlanner`,
            searchRideMetaTitle: 'Search trip itineraries and attractions | TripPlanner',
            searchRideMetaDescriptionWithLocation: `Discover trip itineraries and attractions in ${params.location || ''} - itineraries that travelers uploaded to TripPlanner. Get inspiration for your next trip to ${params.location || ''}`,
            searchRideMetaDescription: 'Search trip itineraries and attractions - find itineraries other travelers shared on TripPlanner',
            searchRideSearchTitle: 'Search trip itineraries',
            searchRideHeaderWithLocation: `Trip itineraries and attractions in ${params.location || ''}`,
            searchRideMetaKeywordsWithLocation: `${params.location || ''}, trip itineraries, attractions, ${params.location || ''} trips, ${params.location || ''} attractions, TripPlanner`,
            searchRideMetaKeywords: 'trip itineraries, attractions, TripPlanner',
            searchRideNoResultsText: 'Sorry, we currently have no vacations that families have shared for this location. We would love your help enriching our shared vacation database — add your trip to the site when you return.',
            // src/views/SingleRideWithMap.vue
            singleRideMetaTitle: 'Trip itinerary | TripPlanner',
            singleRideMetaTitleSuffix: ' - Trip itinerary | TripPlanner',
            singleRideBreadcrumbTitle: 'Trip itinerary',
            // src/views/StoreForPlanners.vue
            storeForPlannersMetaTitle: 'Landing page for selling digital itineraries',
            storeForPlannersCustomItineraries: 'Create personalized itineraries for your clients',
            storeForPlannersShelfProduct: 'Or create itineraries for travelers who want to travel independently and purchase an itinerary as an off-the-shelf product',
            storeForPlannersWhatClientGets: 'What does the client get after purchase?',
            storeForPlannersAllInOneClear: 'The whole trip in one place, clear and easy to use from the phone',
            storeForPlannersWhatIsStore: 'What is the itinerary store?',
            storeForPlannersHowToSell: 'Here is how you can sell itineraries',
            storeForPlannersHowItLooksInPractice: 'Here is how it looks in practice',
            storeForPlannersSampleClientItinerary: 'Example of an itinerary the client receives:',
            storeForPlannersSampleStore: 'Example of an itinerary store:',
            storeForPlannersReadAndApprove: 'I have read and approve the',
            storeForPlannersWantToSeeFit: 'Want to see if TripPlanner suits you?',
            storeForPlannersWhatsAppCta: 'Send us a message on WhatsApp',
            storeForPlannersLeaveDetails: 'Leave your details',
            storeForPlannersFeatureDailyClear: 'Clear daily breakdown of the itinerary',
            storeForPlannersFeatureMap: 'All destinations shown on a map',
            storeForPlannersFeatureNav: 'One-tap direct navigation to every destination',
            storeForPlannersFeatureNoApp: 'Everything accessible from the phone, no need to download an app',
            storeForPlannersStepCreate: 'Create an itinerary in the system',
            storeForPlannersStepCreateBody: 'Build the itinerary once with all the points of interest, maps, and explanations.',
            storeForPlannersStepPublish: 'Publish it in your itinerary store',
            storeForPlannersStepPublishBody: 'The itinerary becomes a digital product that clients can purchase.',
            storeForPlannersStepClientAccess: 'The client gets immediate access to the itinerary',
            storeForPlannersStepClientAccessBody: 'After purchase the client receives a personal link to the itinerary and uses it throughout the trip.',
            storeForPlannersBenefitDigital: 'A digital itinerary instead of a file',
            storeForPlannersBenefitDigitalBody: 'Instead of sending documents or PDF files, the client gets a clear itinerary system that is easy to use during the trip.',
            storeForPlannersBenefitReusable: 'An itinerary built once and sold again and again',
            storeForPlannersBenefitReusableBody: 'Any itinerary you create in the system can become a digital product that can be sold over and over.',
            storeForPlannersBenefitClearExp: 'A clear trip experience for the client',
            storeForPlannersBenefitClearExpBody: 'The itinerary is organized by day with maps, navigation, and each day\'s activities.',
            storeForPlannersBenefitNoHassle: 'No hassle with sending the itinerary',
            storeForPlannersBenefitNoHassleBody: 'No need to send files or update each client separately. The client gets access to the itinerary right after purchase.',
            storeForPlannersBenefitYouControl: 'The content stays under your control',
            storeForPlannersBenefitYouControlBody: 'Each itinerary is sent through a personal link to the client and cannot be transferred to others.',
            storeForPlannersWhatsAppMessage: 'Hi! I\'d love to set up a short intro meeting about opening a digital itinerary store. When is convenient for you?',
            storeForPlannersMeetingRequestSubject: 'Meeting request - Digital itinerary store',
            storeForPlannersHeroTitle: 'Building travel itineraries for clients?',
            storeForPlannersHeroLead: 'TripPlanner is a system that lets you create digital travel itineraries and present them professionally and clearly.',
            storeForPlannersHeroTwoWays: 'You can use it in two ways:',
            storeForPlannersHeroAlsoSell: 'In addition, you can offer the itineraries you created for sale through your own itinerary store.',
            storeForPlannersHeroDisclaimer: 'TripPlanner is a work tool that lets you present your professional knowledge and experience clearly and impressively, so your clients know exactly how their trip looks.\nUnlike documents or PDF files, the itinerary is sent via a personal link to the client and stays under your control.',
            storeForPlannersClientEmphasis: 'The client does not receive a file or a list of recommendations.<br>They receive a complete trip system that accompanies them throughout the entire trip.',
            storeForPlannersClientConclusion: 'This way the client always knows where to go and what to do.',
            storeForPlannersClientConclusionSecondary: 'Every itinerary you create once can become a digital product that can be sold again and again, without sending files and without dealing with clients.',
            storeForPlannersIntroText1: 'TripPlanner lets you offer the itineraries you created for sale through your own itinerary store.',
            storeForPlannersIntroText2: 'Every itinerary you build in the system can become a digital product that clients purchase and immediately get access to.',
            storeForPlannersIntroText3: 'This way an itinerary built once can be sold again and again, without sending files and without dealing with sending the itinerary to each client.',
            storeForPlannersBenefitsCentralTitle: 'Key benefits',
            storeForPlannersContactSubtitle: 'We would love to hear from you and help you understand how TripPlanner can help your business',
            storeForPlannersContactFormAudience: 'This form is intended for tour planners, guides and travel agents who want to create digital itineraries for clients or independent travelers.',
            storeForPlannersCtaLead1: 'Leave your details and we will get back to you with a short explanation of the system to see how it can fit into your work.',
            storeForPlannersCtaLead2: 'Or send us a message on WhatsApp and we will be happy to help.',
            storeForPlannersContactTitle: 'Contact us',
            storeForPlannersFullName: 'Full name',
            storeForPlannersPhonePlaceholder: 'Phone number (required)',
            storeForPlannersEmailPlaceholder: 'Email address',
            storeForPlannersMessagePlaceholder: 'How can we help you? Tell us about your needs...',
            storeForPlannersSending: 'Sending...',
            storeForPlannersSendDetails: 'Send details',
            storeForPlannersPrevImage: 'Previous image',
            storeForPlannersNextImage: 'Next image',
            storeForPlannersSlideLabel: `Go to image ${params.slideNumber || ''}`,
            storeForPlannersScreenshot1: 'Full itinerary view - the whole trip at a glance',
            storeForPlannersScreenshot2: 'Daily breakdown for each day - destinations on a map with one-tap navigation',
            storeForPlannersScreenshot3: 'All activities in the trip - organized by day',
            storeForPlannersScreenshot4: "Day map - all points of interest in one place",
            storeForPlannersScreenshot5: 'Direct navigation to destinations via Google Maps',
            storeForPlannersContactSuccess: 'Thank you! Your message was sent successfully. We will get back to you shortly.',
            storeForPlannersContactError: 'An error occurred while sending the message. Please try again later.',
            storeForPlannersValidateName: 'Please enter your name',
            storeForPlannersValidatePhone: 'Please enter a phone number',
            storeForPlannersValidatePhoneFormat: 'Please enter a valid phone number (8-15 digits, international included)',
            storeForPlannersValidatePrivacy: 'Please approve the privacy policy',
            storeForPlannersValidateEmailSpaces: 'The email address cannot contain spaces',
            storeForPlannersValidateEmailFormat: 'Please enter a valid email address',
            // src/views/Tutorials.vue
            tutorialsAddActivity: 'How do I add an activity to the itinerary?',
            tutorialsAddAccommodation: 'How do I add accommodation to the itinerary?',
            tutorialsShareRide: 'How do I share the itinerary?',
            tutorialsCreateNewItinerary: 'How do I create a new itinerary in the system?',
            tutorialsAddActivityWithLocation: 'How do I add an activity with a precise location to the itinerary?',
            tutorialsInsertLinksInText: 'How do I insert links inside the text?',
            tutorialsAddDayInfo: 'How do I add general information about a specific day in the trip?',
            tutorialsReorderActivitiesInDay: 'How can I change the order of the activities within a specific day?',
            tutorialsAddTripGeneralInfo: 'How do I add general information details about the trip?',
            tutorialsCopyItineraryForClient: 'How do I copy an itinerary and adapt it for a new client?',
            tutorialsAddFromMyActivities: 'How do I add an activity from the collection of activities I have added to the system?',
            tutorialsEditDayInCalendar: 'Editing a day in the calendar view',
            tutorialsManageItinerariesFolders: 'How can I manage the itineraries in different folders?',
            tutorialsEditFromMyActivitiesRepo: 'How do I edit activities that are in my activities repository?',
            tutorialsGeneralExplanation: 'General explanation about the system',
            tutorialsPageMetaTitle: 'System tutorials - TripPlanner',
            tutorialsPageMetaDescription: 'Learn how to use the TripPlanner system - detailed tutorials for every feature',
            whatsappInviteTitle: 'WhatsApp invitation',
            whatsappInviteExplain: 'Share this link with your travellers. Tapping it opens WhatsApp with a ready message; once they send it they are added to the trip and get the link to it.',
            whatsappInviteCopy: 'Copy link',
            whatsappInviteCopied: 'Link copied',
            whatsappInviteCopyFailed: 'Could not copy the link',
            whatsappInviteCode: 'Join code',
            waConversationsTitle: 'WhatsApp conversations',
            waConversationsRefresh: 'Refresh',
            waConversationsRefreshing: 'Refreshing…',
            waConversationsSubtitle: 'The full exchange with a traveller — what they sent and what we sent back.',
            waConversationsSearchPlaceholder: 'Phone number, e.g. 972526867915',
            waConversationsSearchButton: 'Search',
            waConversationsLoading: 'Loading…',
            waConversationsNoContacts: 'No WhatsApp messages have been received yet.',
            waConversationsNoName: 'No name',
            waConversationsOptedOut: 'Opted out of messages',
            waConversationsPickOne: 'Pick a contact from the list, or search by phone number.',
            waConversationsEmptyThread: 'No messages with this number.',
            waConversationsError: 'We could not load this conversation.',
            waDemoSendButton: 'Send the demo daily plan',
            waDemoSendSending: 'Sending…',
            waDemoSendConfirm: 'Send this contact the demo daily-plan message — the same one they would get by tapping "Continue demo"?',
            waDemoSendSent: 'Message sent.',
            waDemoSendAlreadySent: 'This contact already received it — no second copy was sent.',
            waDemoSendNoActivities: 'The demo day has no activities, so nothing was sent. Add activities to that day in the demo ride.',
            waDemoSendNoDate: 'The demo ride has no dates, so nothing was sent.',
            waDemoSendOptedOut: 'This contact opted out of messages.',
            waDemoSendNoTemplate: 'There is no approved template for this day, so nothing was sent.',
            waDemoSendNotDemo: 'This number is not registered to a demo ride.',
            waDemoSendFailed: 'Sending failed.',
            whatsappInviteRegistered: 'Registered so far',
            whatsappInviteUnlimited: 'Unlimited',
            whatsappInviteNotConfigured: 'The system WhatsApp number is not configured. Please contact support.',
            whatsappInviteNeedsKey: 'Create a registration link for this trip first.',
            whatsappInviteError: 'Could not create the invitation',
            whatsappInviteNoticeTitle: 'Please note:',
            whatsappInviteBillingNotice: 'Every traveller who registers through WhatsApp counts and is billed exactly like a traveller who registers through the website.',
            whatsappInviteAccessNotice: 'The itinerary link does not require logging in, so anyone the link is forwarded to will be able to view the itinerary.',
            whatsappInvitePricingNotice: 'For now, WhatsApp services are included at no extra charge. This may become a paid service in the future.',
            whatsappLoginLoading: 'Signing you in to your trip…',
            whatsappLoginFailed: 'This link is no longer valid. Please contact your trip manager.',
            whatsappInviteGenerateButton: 'Create a WhatsApp invite link',
            whatsappInviteNotCreatedYet: 'No WhatsApp invite link has been created for this trip yet.',
            whatsappInviteUnsupportedKeyAction: 'This trip\'s registration link type is not supported over WhatsApp. Please contact support.',
            whatsappInviteShareNotApproved: 'Sharing this trip has not been paid for yet. Pay for sharing it first, then you can create a WhatsApp invite link.',
            whatsappInviteInactiveKey: 'This trip\'s registration link is blocked. Restore it first, then you can create a WhatsApp invite.',
            whatsappReminderTitle: 'Automatic WhatsApp messages',
            whatsappReminderExplain: 'These messages are sent automatically to travellers who registered over WhatsApp.',
            managerAlertTitle: 'Linking your WhatsApp',
            managerAlertExplain: 'To receive messages from the system, link your WhatsApp once. The link works for all of your trips.',
            managerAlertLinkExplain: 'Press the button and send the message that opens in WhatsApp.',
            managerAlertLinkButton: 'Link to WhatsApp',
            managerAlertOpenWhatsapp: 'Link my WhatsApp',
            managerAlertCodeLabel: 'Your linking code',
            managerAlertManualTitle: 'Or link manually',
            managerAlertManualExplain: "Send this code in a WhatsApp message to the system's number:",
            managerAlertSystemNumber: "The system's WhatsApp number:",
            managerAlertCopy: 'Copy the message',
            managerAlertCopied: 'Message copied',
            managerAlertCopyFailed: 'Could not copy. Send the code shown here in an ordinary message.',
            managerAlertRecheck: "I've sent it — check again",
            managerAlertLinkedAs: 'Linked to',
            managerAlertUnlink: 'Unlink',
            managerAlertChangeNumber: 'Change number',
            managerAlertError: 'That did not work. Please try again.',
            managerAlertOptedOut: 'A STOP request was sent to the business number, so WhatsApp is not delivering these messages.',
            managerAlertOptedOutResume: 'Sending any message to the business number on WhatsApp resumes them.',
            managerAlertUnlinkConfirm: 'Unlink? The messages you scheduled are kept, but they will not reach you until you link again.',
            managerAlertUnlinkConfirmYes: 'Yes, unlink',
            managerAlertUnlinkCancel: 'Keep it linked',
            whatsappReminderPreviewToggle: 'Show an example reminder',
            whatsappReminderEnable: 'Send a reminder the day before the trip',
            whatsappDailyItineraryEnable: 'Send the next day\'s plan, every evening of the trip',
            whatsappDailyItineraryExplain: 'Every evening travellers receive their plan for the next day on WhatsApp – the planned activities and a navigation link for each place.\n\nThe message is sent to each traveller separately, every evening during the trip.',
            whatsappDailyItineraryPreviewToggle: 'Show an example daily plan',
            whatsappDailyItineraryPreview: 'Example of what this message looks like:',
            // Each '⁦...⁩' pair wrapping a "1." / "2." / "3." below is an
            // LRI/PDI isolate pair (invisible -- do not delete as stray
            // characters). English does not actually flip here (this block's
            // base direction is already left-to-right, so there is nothing for
            // Unicode bidi to reorder) -- these are kept only for parity with
            // the 'he' block's whatsappDailyItineraryPreviewBody above, which
            // does need them; see the long comment there for the full story.
            whatsappDailyItineraryPreviewBody: 'Hello Dana,\n\nHere is your plan for tomorrow, Tuesday 13.10:\n\n⁦1.⁩ 09:00 – Colosseum\n📍 Navigation: https://www.google.com/maps/dir/?api=1&destination=41.89,12.49\n\n⁦2.⁩ 11:30 – Roman Forum\n📍 Navigation: https://www.google.com/maps/dir/?api=1&destination=41.89,12.48\n\n⁦3.⁩ 13:00 – Lunch in Trastevere\n📍 Navigation: https://www.google.com/maps/dir/?api=1&destination=41.88,12.46\n\nView the full itinerary:\nhttps://tripplanner.co.il/wa_login/...\n\nWould you like to receive all the details about tomorrow\'s activities here on WhatsApp? Reply to this message.',
            whatsappDailyItineraryPreviewNote: 'This is only an example — the real message lists that day\'s own activities. Up to six activities are shown; a day with more than six will say so and show the first six.',
            whatsappReminderHour: 'Send at',
            whatsappReminderTimezone: 'Timezone',
            whatsappReminderTimezoneAuto: "By each day's location",
            whatsappReminderTimezoneAutoExample: 'on day one: {zone}',
            whatsappReminderTimezoneGroup_common: 'Common',
            whatsappReminderTimezoneGroup_europe: 'Europe',
            whatsappReminderTimezoneGroup_asia: 'Asia',
            whatsappReminderTimezoneGroup_americas: 'Americas',
            whatsappReminderTimezoneGroup_africaOceania: 'Africa & Oceania',
            whatsappReminderPreview: 'This is what travellers receive:',
            whatsappReminderPreviewBody: 'Hi {name}, your trip {title} starts tomorrow 🎒 Full itinerary and details here: {link} Have a great trip!',
            whatsappReminderPreviewNote: 'The wording is pre-approved by WhatsApp and cannot be changed.',
            whatsappReminderNoTemplate: 'There is no approved template for this trip\'s language yet, so reminders will not be sent.',
            whatsappReminderError: 'We could not save the settings',
            whatsappReminderBadTimezone: 'Unknown timezone',
            organizerMessageAddButton: 'Schedule a WhatsApp message',
            organizerMessageBeforeTripTitle: 'Scheduled messages before the trip',
            organizerMessageAfterTripTitle: 'Scheduled messages after the trip',
            organizerMessageCreateButton: 'Create a scheduled message',
            organizerMessageDateLabel: 'Message date',
            organizerMessageDateHelp: 'You can choose any date from today until a week after the trip.',
            organizerMessageAddTitle: 'Add a message for travellers',
            organizerMessageEditTitle: 'Edit message',
            organizerMessageBodyLabel: 'Message text',
            organizerMessageBodyPlaceholder: 'Write the message travellers will receive on WhatsApp',
            organizerMessageTimeLabel: 'Send time',
            organizerMessageTimeHelp: 'The message goes out within about 10 minutes of the chosen time',
            organizerMessageTimezoneLabel: 'Timezone',
            organizerMessageTimezoneDefault: "This day's local time",
            organizerMessageTimezoneManagerHelp: 'A message to you is sent on Israel time unless you choose another zone.',
            whatsappDemoReturnButton: 'Back to WhatsApp to continue the demo',
            whatsappDemoReturnHint: "We'll carry on in the chat and send you the trip's daily message",
            organizerMessageSaveButton: 'Save',
            organizerMessageCancelButton: 'Cancel',
            organizerMessageEditAction: 'Edit message',
            organizerMessageDeleteAction: 'Delete message',
            organizerMessageDeleteConfirm: 'Remove this message? It cannot be sent again after deletion.',
            organizerMessageSaveError: 'We could not save the message',
            organizerMessageDeleteError: 'We could not remove the message',
            organizerMessageErrorEmptyBody: 'Please write the message text',
            organizerMessageErrorBodyTooLong: 'The message is too long (4096 characters max)',
            organizerMessageErrorInvalidSendTime: 'The send time is not valid',
            organizerMessageErrorInvalidTargetDate: 'The date for this day is not valid',
            organizerMessageErrorDateOutsideWindow: "This date is outside this trip's allowed messaging window",
            organizerMessageErrorInvalidTimezone: 'The selected timezone is not recognized',
            organizerMessageErrorForbidden: 'You are not allowed to do this',
            organizerMessageErrorNotFound: 'This message was not found, it may already be deleted',
            organizerRecipientLabel: 'Send to',
            organizerRecipientTravellers: 'All registered travellers',
            organizerRecipientManager: 'Only me (the trip manager)',
            organizerRecipientTravellersShort: 'All travellers',
            organizerRecipientManagerShort: 'Only me',
            organizerRecipientHelp: 'The recipient cannot be changed after saving.',
            organizerRecipientFixedHelp: 'The recipient is fixed when the message is created and cannot be changed.',
            organizerRecipientFixedError: "A saved message's recipient cannot be changed.",
            organizerRecipientNotLinkedHint: "Your WhatsApp is not linked yet, so a message to you will not be sent.",
            organizerRecipientLinkNowLink: 'Link my WhatsApp',
            organizerRecipientNotLinkedError: 'To send a message to yourself, link your WhatsApp first in the trip\'s WhatsApp settings.',
            organizerRecipientNotManagerError: 'Only the trip manager can schedule a message to himself, and you are not the manager of this trip.',
            organizerMessageDateRequiredError: 'Choose a date for this message.',
            organizerMessageWasSent: 'Sent',
            organizerMessageMissed: 'Not sent – the time has passed',
            whatsappLoginAlreadySignedIn: `You are currently signed in as ${params.email || ''}`,
            whatsappLoginSwitchExplain: 'Opening this trip will sign you out of that account and sign you in as the traveller who received this link.',
            whatsappLoginOpenTrip: 'Open the trip',
            whatsappLoginStaySignedIn: 'Stay signed in to my current account',
            sharedImagesTitle: 'Shared place images',
            sharedImagesLoading: 'Loading images...',
            sharedImagesLoadError: 'Could not load the images, please try again',
            sharedImagesRetry: 'Retry',
            sharedImagesEmpty: 'No images to review',
            sharedImagesLoadMore: 'Load more',
            sharedImagesApprove: 'Approve',
            sharedImagesReject: 'Reject',
            sharedImagesApproved: 'Approved',
            sharedImagesPending: 'Pending',
            sharedImagesRejected: 'Rejected',
            sharedImagesActionFailed: 'The action failed, please try again'
          }
        };
        
        return translations[this.getCurrentLanguage]?.[key] || key;
      };
    }
  },
  methods: {
    getPaymentTexts() {
      if (this.isHebrew) {
        return {
          metaTitle: 'תשלום - TripPlanner',
          headerTitle: 'תשלום',
          productTitle: 'רכישת מסלול דיגיטלי',
          productIntro:
            'לאחר ההרשמה תקבלו לכתובת המייל שלכם לינק שתוכלו להיכנס ולראות את המסלול הדיגיטלי שלכם. לשימוש מלא במסלול נדרש חיבור אינטרנט פעיל, כיוון שהניווט נשען על Google Maps וחלק מההסברים כוללים סטרימינג של סרטוני YouTube.',
          productDetailsTitle: 'פרטי המוצר',
          quantityLabel: 'כמות',
          unitPriceLabel: 'מחיר יחידה',
          backHome: 'חזרה לעמוד הראשי',
          missingSumitConfigLine1: 'חסרות הגדרות COMPANY ID או API PUBLIC KEY. הגדירו את המשתנים',
          andConnector: 'ו-',
          missingSumitConfigLine2: 'לפני הרצה בסביבת אמת.',
          fullNameLabel: 'שם פרטי ומשפחה של בעל הכרטיס',
          fullNamePlaceholder: 'לדוגמה: ישראל ישראלי',
          emailLabel: 'אימייל',
          emailPlaceholder: 'name@example.com',
          phoneLabel: 'טלפון',
          phonePlaceholder: '050-0000000',
          cardNumberLabel: 'מספר כרטיס אשראי',
          cardNumberPlaceholder: 'XXXX XXXX XXXX XXXX',
          expirationLabel: 'תוקף הכרטיס',
          expirationMonthLabel: 'חודש',
          expirationMonthPlaceholder: 'MM',
          expirationYearLabel: 'שנה',
          expirationYearPlaceholder: 'YYYY',
          citizenIdLabel: 'תעודת זהות',
          citizenIdPlaceholder: '123456789',
          policyToggle: 'מדיניות החזרה וביטולים',
          payButton: 'תשלום',
          processingPayment: 'מעבד תשלום...',
          processingHint: 'מעבד את התשלום... אנא המתינו מספר שניות.',
          securityNote: 'מערכת סאמיט מוסמכת בדרגה המחמירה ביותר של תקן האבטחה העולמי להצפנת כרטיסי אשראי PCI.',
          securedByPrefix: 'מאובטח על ידי',
          sumitName: 'סאמיט',
          securedBySuffix: '.',
          errors: {
            loadPaymentsScript: 'שגיאה בטעינת מערכת התשלומים. אנא נסה שוב מאוחר יותר.',
            loadJquery: 'שגיאה בטעינת jQuery. אנא רענן את הדף.',
            missingApiDetails: 'חסרים פרטי API של SUMIT - לא ניתן לבצע חיוב',
            formNotFound: 'הטופס לא נמצא. אנא רענן את הדף.',
            initPayments: 'שגיאה באתחול מערכת התשלומים. אנא נסה שוב.',
            tokenFailed: 'יצירת הטוקן נכשלה',
            tokenMissing: 'לא התקבל טוקן מהספריה. אנא נסה שוב.',
            invalidToken: 'טוקן לא תקין. אנא נסה שוב.',
            requestFailed: 'שגיאה בשליחת הבקשה',
            genericContactManager: 'אירעה שגיאה, אנא צרו קשר עם מנהל המסלול.',
            fillFullName: 'נא למלא שם מלא לפני התשלום.',
            enterEmail: 'נא להזין כתובת אימייל.',
            invalidEmail: 'כתובת האימייל אינה תקינה.',
            phoneTooShort: 'מספר הטלפון קצר מדי. נא להזין לפחות 8 ספרות (כולל קידומת בינלאומית אם נדרש).',
            phoneTooLong: 'מספר הטלפון ארוך מדי. נא להזין עד 15 ספרות (גבול בינלאומי).'
          }
        };
      }

      return {
        metaTitle: 'Payment - TripPlanner',
        headerTitle: 'Payment',
        productTitle: 'Purchase a digital itinerary',
        productIntro:
          'After purchase, you will receive an email with a personal link to view your digital itinerary. Full use requires an active internet connection, since navigation relies on Google Maps and some explanations may include streaming YouTube videos.',
        productDetailsTitle: 'Product details',
        quantityLabel: 'Quantity',
        unitPriceLabel: 'Unit price',
        backHome: 'Back to home',
        missingSumitConfigLine1: 'Missing COMPANY ID or API PUBLIC KEY. Please configure',
        andConnector: 'and',
        missingSumitConfigLine2: 'before running in production.',
        fullNameLabel: 'Cardholder full name',
        fullNamePlaceholder: 'For example: John Doe',
        emailLabel: 'Email',
        emailPlaceholder: 'name@example.com',
        phoneLabel: 'Phone',
        phonePlaceholder: '+1 555 000 0000',
        cardNumberLabel: 'Credit card number',
        cardNumberPlaceholder: 'XXXX XXXX XXXX XXXX',
        expirationLabel: 'Card expiration',
        expirationMonthLabel: 'Month',
        expirationMonthPlaceholder: 'MM',
        expirationYearLabel: 'Year',
        expirationYearPlaceholder: 'YYYY',
        citizenIdLabel: 'ID number',
        citizenIdPlaceholder: '123456789',
        policyToggle: 'Cancellation & refund policy',
        payButton: 'Pay',
        processingPayment: 'Processing payment...',
        processingHint: 'Processing your payment... please wait a few seconds.',
        securityNote:
          'SUMIT is certified at the strictest level of the global PCI security standard for credit-card encryption.',
        securedByPrefix: 'Secured by',
        sumitName: 'SUMIT',
        securedBySuffix: '.',
        errors: {
          loadPaymentsScript: 'Failed to load the payment system. Please try again later.',
          loadJquery: 'Failed to load jQuery. Please refresh the page.',
          missingApiDetails: 'Missing SUMIT API details — cannot process payment',
          formNotFound: 'Payment form not found. Please refresh the page.',
          initPayments: 'Failed to initialize the payment system. Please try again.',
          tokenFailed: 'Token creation failed',
          tokenMissing: 'No token was received from the library. Please try again.',
          invalidToken: 'Invalid token. Please try again.',
          requestFailed: 'Failed to send the request',
          genericContactManager: 'An error occurred. Please contact the itinerary manager.',
          fillFullName: 'Please enter your full name before paying.',
          enterEmail: 'Please enter an email address.',
          invalidEmail: 'Invalid email address.',
          phoneTooShort: 'Phone number is too short. Enter at least 8 digits (include country code if needed).',
          phoneTooLong: 'Phone number is too long. Enter at most 15 digits (international limit).'
        }
      };
    },
    getPaymentPolicyContent() {
      if (this.isHebrew) {
        return {
          title: 'מדיניות ביטולים והחזרים - מוצרים דיגיטליים (TripPlanner)',
          intro: [
            'מסלול טיול הנרכש באתר TripPlanner הוא מוצר דיגיטלי הנמסר ללקוח באופן מיידי לאחר ביצוע התשלום, ולכן אינו ניתן להחזרה לפי חוק הגנת הצרכן.'
          ],
          sections: [
            {
              title: '1. מוצר דיגיטלי שאינו ניתן להחזרה',
              paragraphs: [
                'עם השלמת הרכישה וקבלת הגישה למסלול הדיגיטלי, העסקה נחשבת "אספקת מידע דיגיטלי" שאינו ניתן להשבה. לכן, לאחר שהמסלול נפתח או נשלח ללקוח - לא ניתן לבטל את העסקה ולא ניתן לקבל החזר כספי.'
              ]
            },
            {
              title: '2. תקלה טכנית בקבלת הגישה',
              paragraphs: ['במקרה שבו התעוררה תקלה טכנית, כגון:'],
              list: [
                'הלקוח לא קיבל קישור למסלול',
                'קיימת בעיית גישה למסלול',
                'שגיאה בעת פתיחת הלינק'
              ],
              paragraphsAfterList: [
                'אנחנו נעניק תמיכה מלאה עד לקבלת גישה תקינה למוצר. במקרים חריגים בלבד, ועל פי שיקול דעת החברה, ייתכן שיוצעו פתרונות נוספים.'
              ]
            },
            {
              title: '3. ביטול לפני אספקת המוצר',
              paragraphs: [
                'אם מסיבה כלשהי טרם נמסר קישור למסלול (כלומר: הלקוח עדיין לא קיבל גישה), ניתן לבטל את העסקה עד 14 יום מהתשלום. במקרה זה יוחזר הסכום ששולם בניכוי עלויות עיבוד (אם קיימות).'
              ]
            },
            {
              title: '4. מוצר שסופק כמתואר',
              paragraphs: ['מכיוון שמדובר בתוכן דיגיטלי הנמסר כפי שהוא, אין החזר בגין:'],
              list: [
                'אי שביעות רצון מהתוכן שהתקבל',
                'שינוי תוכניות של הלקוח',
                'רכישת מסלול לא נכון',
                'שימוש שאינו תואם את ציפיות הלקוח'
              ],
              paragraphsAfterList: ['אחריות הלקוח לוודא כי המוצר תואם את צרכיו בטרם הרכישה.']
            },
            {
              title: '5. תמיכה ושירות ללקוח',
              paragraphs: ['אנו מתחייבים לספק ללקוחותינו חוויית שירות מצוינת ועמידה מלאה בהתחייבויות:'],
              list: [
                'תמיכה בהפעלת המסלול',
                'הבהרות לגבי השימוש',
                'סיוע במקרה של חוסר התאמה טכנית',
                'מענה מהיר לפניות'
              ]
            },
            {
              title: '6. יצירת קשר בנוגע לביטולים',
              email: 'support@tripplanner.co.il',
              emailPrefix: 'לכל שאלה או בקשה ניתן לפנות ל- ',
              emailSuffix: ' ונשמח לסייע.'
            },
            {
              title: '7. דרישות שימוש וחיבור לאינטרנט',
              paragraphs: [
                'לצורך שימוש מלא בכל אפשרויות המסלול הדיגיטלי—כולל טעינת מפות, ניווט, הצגת מידע ועדכונים—נדרש חיבור לאינטרנט במהלך הטיול, בהתאם לזמינות הרשת באזור שבו אתם נמצאים. ייתכן שחלק מהפונקציות לא יהיו זמינות ללא חיבור פעיל לאינטרנט.'
              ]
            }
          ]
        };
      }

      return {
        title: 'Cancellation & Refund Policy — Digital Products (TripPlanner)',
        intro: [
          'A travel itinerary purchased on TripPlanner is a digital product delivered immediately after payment. Therefore, it is generally non-refundable once access is provided.'
        ],
        sections: [
          {
            title: '1. Digital product (non-refundable after delivery)',
            paragraphs: [
              'Once the purchase is completed and access to the digital itinerary is delivered (opened or sent), the transaction is considered delivery of digital content and cannot be cancelled or refunded.'
            ]
          },
          {
            title: '2. Technical issue receiving access',
            paragraphs: ['If you experience a technical issue such as:'],
            list: [
              'You did not receive the itinerary link',
              'You cannot access the itinerary',
              'An error occurs when opening the link'
            ],
            paragraphsAfterList: [
              'We will provide full support until access is working. In rare cases, and at the company’s discretion, alternative solutions may be offered.'
            ]
          },
          {
            title: '3. Cancellation before delivery',
            paragraphs: [
              'If, for any reason, the itinerary link has not been delivered yet (i.e., you have not received access), you can request cancellation within 14 days from payment. In this case, a refund may be issued minus processing costs (if applicable).'
            ]
          },
          {
            title: '4. Product delivered as described',
            paragraphs: ['Because this is digital content delivered “as is”, refunds are not provided due to:'],
            list: [
              'Dissatisfaction with the content',
              'Changes in your plans',
              'Purchasing the wrong itinerary',
              'Use that does not meet your expectations'
            ],
            paragraphsAfterList: ['It is the customer’s responsibility to ensure the product fits their needs before purchasing.']
          },
          {
            title: '5. Customer support',
            paragraphs: ['We are committed to excellent service and will assist with:'],
            list: [
              'Help activating and using the itinerary',
              'Clarifications about usage',
              'Assistance in case of technical incompatibility',
              'Fast support responses'
            ]
          },
          {
            title: '6. Contact regarding cancellations',
            email: 'support@tripplanner.co.il',
            emailPrefix: 'For any question or request, contact ',
            emailSuffix: '.'
          },
          {
            title: '7. Internet requirement',
            paragraphs: [
              'To use all itinerary features—maps loading, navigation, information display, and updates—an internet connection is required during the trip, depending on network availability in your area. Some features may not be available without an active connection.'
            ]
          }
        ]
      };
    },
    getPaymentSuccessTexts() {
      if (this.isHebrew) {
        return {
          metaTitle: 'תשלום הושלם - TripPlanner',
          headerTitle: 'תשלום הושלם בהצלחה',
          successTitle: 'תשלום הושלם בהצלחה!',
          successThanks: 'תודה על הרכישה.',
          successReadyLine1: 'המסלול שלכם מוכן וזמין לצפייה.',
          successReadyLine2: 'אתם מוזמנים להיכנס ולהתחיל את המסלול שלכם, בקצב ובזמן שלכם.',
          successEmailSent: 'שלחנו גם את הקישור למסלול אל תיבת המייל שהזנתם, כדי שתוכלו לגשת אליו בכל רגע בקלות.',
          successClosing: 'מאחלים לכם שימוש נעים וחופשה מהנה!',
          rideLinkLabel: 'זה הקישור למסלול שלכם:',
          defaultRideTitle: 'המסלול הדיגיטלי שלכם',
          openRideButton: 'פתיחה בלשונית חדשה והתחלת הטיול',
          buyMoreButton: 'לרכישת מסלולים נוספים',
          failureTitle: 'התשלום לא הושלם',
          failureMessage: 'לצערנו לא הצלחנו לחייב את הכרטיס. אנא בדקו את הפרטים ונסו שוב.',
          failureReasonPrefix: 'סיבה:',
          failureHint: 'אם הבעיה נמשכת, צרו קשר עם התמיכה שלנו ונשמח לעזור.',
          retryButton: 'חזרה למסך התשלום'
        };
      }

      return {
        metaTitle: 'Payment completed - TripPlanner',
        headerTitle: 'Payment completed',
        successTitle: 'Payment completed successfully!',
        successThanks: 'Thank you for your purchase.',
        successReadyLine1: 'Your itinerary is ready and available to view.',
        successReadyLine2: 'You can open it and start your trip at your own pace.',
        successEmailSent: 'We also sent the itinerary link to the email address you entered, so you can access it anytime.',
        successClosing: 'Have a great trip!',
        rideLinkLabel: 'Here is your itinerary link:',
        defaultRideTitle: 'Your digital itinerary',
        openRideButton: 'Open in a new tab and start',
        buyMoreButton: 'Buy more itineraries',
        failureTitle: 'Payment not completed',
        failureMessage: 'We could not charge your card. Please check your details and try again.',
        failureReasonPrefix: 'Reason:',
        failureHint: 'If the problem persists, contact our support and we’ll be happy to help.',
        retryButton: 'Back to payment'
      };
    }
  }
};

 